export const useBrazilCities = () => {
  const loading = false;
  const cities = [
  {
    "value": "abadia_de_goiás_go",
    "label": "Abadia de Goiás - GO"
  },
  {
    "value": "abadia_dos_dourados_mg",
    "label": "Abadia dos Dourados - MG"
  },
  {
    "value": "abadiânia_go",
    "label": "Abadiânia - GO"
  },
  {
    "value": "abaetetuba_pa",
    "label": "Abaetetuba - PA"
  },
  {
    "value": "abaeté_mg",
    "label": "Abaeté - MG"
  },
  {
    "value": "abaiara_ce",
    "label": "Abaiara - CE"
  },
  {
    "value": "abaré_ba",
    "label": "Abaré - BA"
  },
  {
    "value": "abatiá_pr",
    "label": "Abatiá - PR"
  },
  {
    "value": "abaíra_ba",
    "label": "Abaíra - BA"
  },
  {
    "value": "abdon_batista_sc",
    "label": "Abdon Batista - SC"
  },
  {
    "value": "abel_figueiredo_pa",
    "label": "Abel Figueiredo - PA"
  },
  {
    "value": "abelardo_luz_sc",
    "label": "Abelardo Luz - SC"
  },
  {
    "value": "abre_campo_mg",
    "label": "Abre Campo - MG"
  },
  {
    "value": "abreu_e_lima_pe",
    "label": "Abreu e Lima - PE"
  },
  {
    "value": "abreulândia_to",
    "label": "Abreulândia - TO"
  },
  {
    "value": "acaiaca_mg",
    "label": "Acaiaca - MG"
  },
  {
    "value": "acajutiba_ba",
    "label": "Acajutiba - BA"
  },
  {
    "value": "acarapé_ce",
    "label": "Acarapé - CE"
  },
  {
    "value": "acaraú_ce",
    "label": "Acaraú - CE"
  },
  {
    "value": "acari_rn",
    "label": "Acari - RN"
  },
  {
    "value": "acará_pa",
    "label": "Acará - PA"
  },
  {
    "value": "acauã_pi",
    "label": "Acauã - PI"
  },
  {
    "value": "aceguá_rs",
    "label": "Aceguá - RS"
  },
  {
    "value": "acopiara_ce",
    "label": "Acopiara - CE"
  },
  {
    "value": "acorizal_mt",
    "label": "Acorizal - MT"
  },
  {
    "value": "acrelândia_ac",
    "label": "Acrelândia - AC"
  },
  {
    "value": "acreúna_go",
    "label": "Acreúna - GO"
  },
  {
    "value": "adamantina_sp",
    "label": "Adamantina - SP"
  },
  {
    "value": "adelândia_go",
    "label": "Adelândia - GO"
  },
  {
    "value": "adolfo_sp",
    "label": "Adolfo - SP"
  },
  {
    "value": "adrianópolis_pr",
    "label": "Adrianópolis - PR"
  },
  {
    "value": "adustina_ba",
    "label": "Adustina - BA"
  },
  {
    "value": "afogados_da_ingazeira_pe",
    "label": "Afogados da Ingazeira - PE"
  },
  {
    "value": "afonso_bezerra_rn",
    "label": "Afonso Bezerra - RN"
  },
  {
    "value": "afonso_cláudio_es",
    "label": "Afonso Cláudio - ES"
  },
  {
    "value": "afonso_cunha_ma",
    "label": "Afonso Cunha - MA"
  },
  {
    "value": "afrânio_pe",
    "label": "Afrânio - PE"
  },
  {
    "value": "afuá_pa",
    "label": "Afuá - PA"
  },
  {
    "value": "agrestina_pe",
    "label": "Agrestina - PE"
  },
  {
    "value": "agricolândia_pi",
    "label": "Agricolândia - PI"
  },
  {
    "value": "agrolândia_sc",
    "label": "Agrolândia - SC"
  },
  {
    "value": "agronômica_sc",
    "label": "Agronômica - SC"
  },
  {
    "value": "aguanil_mg",
    "label": "Aguanil - MG"
  },
  {
    "value": "aguaí_sp",
    "label": "Aguaí - SP"
  },
  {
    "value": "agudo_rs",
    "label": "Agudo - RS"
  },
  {
    "value": "agudos_sp",
    "label": "Agudos - SP"
  },
  {
    "value": "agudos_do_sul_pr",
    "label": "Agudos do Sul - PR"
  },
  {
    "value": "aguiar_pb",
    "label": "Aguiar - PB"
  },
  {
    "value": "aguiarnópolis_to",
    "label": "Aguiarnópolis - TO"
  },
  {
    "value": "aimorés_mg",
    "label": "Aimorés - MG"
  },
  {
    "value": "aiquara_ba",
    "label": "Aiquara - BA"
  },
  {
    "value": "aiuaba_ce",
    "label": "Aiuaba - CE"
  },
  {
    "value": "aiuruoca_mg",
    "label": "Aiuruoca - MG"
  },
  {
    "value": "ajuricaba_rs",
    "label": "Ajuricaba - RS"
  },
  {
    "value": "alagoa_mg",
    "label": "Alagoa - MG"
  },
  {
    "value": "alagoa_grande_pb",
    "label": "Alagoa Grande - PB"
  },
  {
    "value": "alagoa_nova_pb",
    "label": "Alagoa Nova - PB"
  },
  {
    "value": "alagoinha_pb",
    "label": "Alagoinha - PB"
  },
  {
    "value": "alagoinha_pe",
    "label": "Alagoinha - PE"
  },
  {
    "value": "alagoinha_do_piauí_pi",
    "label": "Alagoinha do Piauí - PI"
  },
  {
    "value": "alagoinhas_ba",
    "label": "Alagoinhas - BA"
  },
  {
    "value": "alambari_sp",
    "label": "Alambari - SP"
  },
  {
    "value": "albertina_mg",
    "label": "Albertina - MG"
  },
  {
    "value": "alcantil_pb",
    "label": "Alcantil - PB"
  },
  {
    "value": "alcinópolis_ms",
    "label": "Alcinópolis - MS"
  },
  {
    "value": "alcobaça_ba",
    "label": "Alcobaça - BA"
  },
  {
    "value": "alcântara_ma",
    "label": "Alcântara - MA"
  },
  {
    "value": "alcântaras_ce",
    "label": "Alcântaras - CE"
  },
  {
    "value": "aldeias_altas_ma",
    "label": "Aldeias Altas - MA"
  },
  {
    "value": "alecrim_rs",
    "label": "Alecrim - RS"
  },
  {
    "value": "alegre_es",
    "label": "Alegre - ES"
  },
  {
    "value": "alegrete_rs",
    "label": "Alegrete - RS"
  },
  {
    "value": "alegrete_do_piauí_pi",
    "label": "Alegrete do Piauí - PI"
  },
  {
    "value": "alegria_rs",
    "label": "Alegria - RS"
  },
  {
    "value": "alenquer_pa",
    "label": "Alenquer - PA"
  },
  {
    "value": "alexandria_rn",
    "label": "Alexandria - RN"
  },
  {
    "value": "alexânia_go",
    "label": "Alexânia - GO"
  },
  {
    "value": "alfenas_mg",
    "label": "Alfenas - MG"
  },
  {
    "value": "alfredo_chaves_es",
    "label": "Alfredo Chaves - ES"
  },
  {
    "value": "alfredo_marcondes_sp",
    "label": "Alfredo Marcondes - SP"
  },
  {
    "value": "alfredo_vasconcelos_mg",
    "label": "Alfredo Vasconcelos - MG"
  },
  {
    "value": "alfredo_wagner_sc",
    "label": "Alfredo Wagner - SC"
  },
  {
    "value": "algodão_de_jandaíra_pb",
    "label": "Algodão de Jandaíra - PB"
  },
  {
    "value": "alhandra_pb",
    "label": "Alhandra - PB"
  },
  {
    "value": "aliança_pe",
    "label": "Aliança - PE"
  },
  {
    "value": "aliança_do_tocantins_to",
    "label": "Aliança do Tocantins - TO"
  },
  {
    "value": "almadina_ba",
    "label": "Almadina - BA"
  },
  {
    "value": "almas_to",
    "label": "Almas - TO"
  },
  {
    "value": "almeirim_pa",
    "label": "Almeirim - PA"
  },
  {
    "value": "almenara_mg",
    "label": "Almenara - MG"
  },
  {
    "value": "almino_afonso_rn",
    "label": "Almino Afonso - RN"
  },
  {
    "value": "almirante_tamandaré_pr",
    "label": "Almirante Tamandaré - PR"
  },
  {
    "value": "almirante_tamandaré_do_sul_rs",
    "label": "Almirante Tamandaré do Sul - RS"
  },
  {
    "value": "aloândia_go",
    "label": "Aloândia - GO"
  },
  {
    "value": "alpercata_mg",
    "label": "Alpercata - MG"
  },
  {
    "value": "alpestre_rs",
    "label": "Alpestre - RS"
  },
  {
    "value": "alpinópolis_mg",
    "label": "Alpinópolis - MG"
  },
  {
    "value": "alta_floresta_mt",
    "label": "Alta Floresta - MT"
  },
  {
    "value": "alta_floresta_d'oeste_ro",
    "label": "Alta Floresta d'Oeste - RO"
  },
  {
    "value": "altair_sp",
    "label": "Altair - SP"
  },
  {
    "value": "altamira_pa",
    "label": "Altamira - PA"
  },
  {
    "value": "altamira_do_maranhão_ma",
    "label": "Altamira do Maranhão - MA"
  },
  {
    "value": "altamira_do_paraná_pr",
    "label": "Altamira do Paraná - PR"
  },
  {
    "value": "altaneira_ce",
    "label": "Altaneira - CE"
  },
  {
    "value": "alterosa_mg",
    "label": "Alterosa - MG"
  },
  {
    "value": "altinho_pe",
    "label": "Altinho - PE"
  },
  {
    "value": "altinópolis_sp",
    "label": "Altinópolis - SP"
  },
  {
    "value": "alto_alegre_rr",
    "label": "Alto Alegre - RR"
  },
  {
    "value": "alto_alegre_rs",
    "label": "Alto Alegre - RS"
  },
  {
    "value": "alto_alegre_sp",
    "label": "Alto Alegre - SP"
  },
  {
    "value": "alto_alegre_do_maranhão_ma",
    "label": "Alto Alegre do Maranhão - MA"
  },
  {
    "value": "alto_alegre_do_parecis_ro",
    "label": "Alto Alegre do Parecis - RO"
  },
  {
    "value": "alto_alegre_do_pindaré_ma",
    "label": "Alto Alegre do Pindaré - MA"
  },
  {
    "value": "alto_araguaia_mt",
    "label": "Alto Araguaia - MT"
  },
  {
    "value": "alto_bela_vista_sc",
    "label": "Alto Bela Vista - SC"
  },
  {
    "value": "alto_boa_vista_mt",
    "label": "Alto Boa Vista - MT"
  },
  {
    "value": "alto_caparaó_mg",
    "label": "Alto Caparaó - MG"
  },
  {
    "value": "alto_feliz_rs",
    "label": "Alto Feliz - RS"
  },
  {
    "value": "alto_garças_mt",
    "label": "Alto Garças - MT"
  },
  {
    "value": "alto_horizonte_go",
    "label": "Alto Horizonte - GO"
  },
  {
    "value": "alto_jequitibá_mg",
    "label": "Alto Jequitibá - MG"
  },
  {
    "value": "alto_longá_pi",
    "label": "Alto Longá - PI"
  },
  {
    "value": "alto_paraguai_mt",
    "label": "Alto Paraguai - MT"
  },
  {
    "value": "alto_paraná_pr",
    "label": "Alto Paraná - PR"
  },
  {
    "value": "alto_paraíso_ro",
    "label": "Alto Paraíso - RO"
  },
  {
    "value": "alto_paraíso_de_goiás_go",
    "label": "Alto Paraíso de Goiás - GO"
  },
  {
    "value": "alto_parnaíba_ma",
    "label": "Alto Parnaíba - MA"
  },
  {
    "value": "alto_piquiri_pr",
    "label": "Alto Piquiri - PR"
  },
  {
    "value": "alto_rio_doce_mg",
    "label": "Alto Rio Doce - MG"
  },
  {
    "value": "alto_rio_novo_es",
    "label": "Alto Rio Novo - ES"
  },
  {
    "value": "alto_santo_ce",
    "label": "Alto Santo - CE"
  },
  {
    "value": "alto_taquari_mt",
    "label": "Alto Taquari - MT"
  },
  {
    "value": "alto_do_rodrigues_rn",
    "label": "Alto do Rodrigues - RN"
  },
  {
    "value": "altos_pi",
    "label": "Altos - PI"
  },
  {
    "value": "altônia_pr",
    "label": "Altônia - PR"
  },
  {
    "value": "alumínio_sp",
    "label": "Alumínio - SP"
  },
  {
    "value": "alvarenga_mg",
    "label": "Alvarenga - MG"
  },
  {
    "value": "alvarães_am",
    "label": "Alvarães - AM"
  },
  {
    "value": "alvinlândia_sp",
    "label": "Alvinlândia - SP"
  },
  {
    "value": "alvinópolis_mg",
    "label": "Alvinópolis - MG"
  },
  {
    "value": "alvorada_rs",
    "label": "Alvorada - RS"
  },
  {
    "value": "alvorada_to",
    "label": "Alvorada - TO"
  },
  {
    "value": "alvorada_d'oeste_ro",
    "label": "Alvorada d'Oeste - RO"
  },
  {
    "value": "alvorada_de_minas_mg",
    "label": "Alvorada de Minas - MG"
  },
  {
    "value": "alvorada_do_gurguéia_pi",
    "label": "Alvorada do Gurguéia - PI"
  },
  {
    "value": "alvorada_do_norte_go",
    "label": "Alvorada do Norte - GO"
  },
  {
    "value": "alvorada_do_sul_pr",
    "label": "Alvorada do Sul - PR"
  },
  {
    "value": "além_paraíba_mg",
    "label": "Além Paraíba - MG"
  },
  {
    "value": "amajari_rr",
    "label": "Amajari - RR"
  },
  {
    "value": "amambaí_ms",
    "label": "Amambaí - MS"
  },
  {
    "value": "amaporã_pr",
    "label": "Amaporã - PR"
  },
  {
    "value": "amapá_ap",
    "label": "Amapá - AP"
  },
  {
    "value": "amapá_do_maranhão_ma",
    "label": "Amapá do Maranhão - MA"
  },
  {
    "value": "amaraji_pe",
    "label": "Amaraji - PE"
  },
  {
    "value": "amaral_ferrador_rs",
    "label": "Amaral Ferrador - RS"
  },
  {
    "value": "amaralina_go",
    "label": "Amaralina - GO"
  },
  {
    "value": "amarante_pi",
    "label": "Amarante - PI"
  },
  {
    "value": "amarante_do_maranhão_ma",
    "label": "Amarante do Maranhão - MA"
  },
  {
    "value": "amargosa_ba",
    "label": "Amargosa - BA"
  },
  {
    "value": "amaturá_am",
    "label": "Amaturá - AM"
  },
  {
    "value": "americana_sp",
    "label": "Americana - SP"
  },
  {
    "value": "americano_do_brasil_go",
    "label": "Americano do Brasil - GO"
  },
  {
    "value": "ametista_do_sul_rs",
    "label": "Ametista do Sul - RS"
  },
  {
    "value": "amontada_ce",
    "label": "Amontada - CE"
  },
  {
    "value": "amorinópolis_go",
    "label": "Amorinópolis - GO"
  },
  {
    "value": "amparo_pb",
    "label": "Amparo - PB"
  },
  {
    "value": "amparo_sp",
    "label": "Amparo - SP"
  },
  {
    "value": "amparo_de_são_francisco_se",
    "label": "Amparo de São Francisco - SE"
  },
  {
    "value": "amparo_do_serra_mg",
    "label": "Amparo do Serra - MG"
  },
  {
    "value": "ampére_pr",
    "label": "Ampére - PR"
  },
  {
    "value": "amélia_rodrigues_ba",
    "label": "Amélia Rodrigues - BA"
  },
  {
    "value": "américa_dourada_ba",
    "label": "América Dourada - BA"
  },
  {
    "value": "américo_brasiliense_sp",
    "label": "Américo Brasiliense - SP"
  },
  {
    "value": "américo_de_campos_sp",
    "label": "Américo de Campos - SP"
  },
  {
    "value": "anadia_al",
    "label": "Anadia - AL"
  },
  {
    "value": "anagé_ba",
    "label": "Anagé - BA"
  },
  {
    "value": "anahy_pr",
    "label": "Anahy - PR"
  },
  {
    "value": "anajatuba_ma",
    "label": "Anajatuba - MA"
  },
  {
    "value": "anajás_pa",
    "label": "Anajás - PA"
  },
  {
    "value": "analândia_sp",
    "label": "Analândia - SP"
  },
  {
    "value": "anamã_am",
    "label": "Anamã - AM"
  },
  {
    "value": "ananindeua_pa",
    "label": "Ananindeua - PA"
  },
  {
    "value": "ananás_to",
    "label": "Ananás - TO"
  },
  {
    "value": "anapu_pa",
    "label": "Anapu - PA"
  },
  {
    "value": "anapurus_ma",
    "label": "Anapurus - MA"
  },
  {
    "value": "anastácio_ms",
    "label": "Anastácio - MS"
  },
  {
    "value": "anaurilândia_ms",
    "label": "Anaurilândia - MS"
  },
  {
    "value": "anchieta_es",
    "label": "Anchieta - ES"
  },
  {
    "value": "anchieta_sc",
    "label": "Anchieta - SC"
  },
  {
    "value": "andaraí_ba",
    "label": "Andaraí - BA"
  },
  {
    "value": "andirá_pr",
    "label": "Andirá - PR"
  },
  {
    "value": "andorinha_ba",
    "label": "Andorinha - BA"
  },
  {
    "value": "andradas_mg",
    "label": "Andradas - MG"
  },
  {
    "value": "andradina_sp",
    "label": "Andradina - SP"
  },
  {
    "value": "andrelândia_mg",
    "label": "Andrelândia - MG"
  },
  {
    "value": "andré_da_rocha_rs",
    "label": "André da Rocha - RS"
  },
  {
    "value": "angatuba_sp",
    "label": "Angatuba - SP"
  },
  {
    "value": "angelim_pe",
    "label": "Angelim - PE"
  },
  {
    "value": "angelina_sc",
    "label": "Angelina - SC"
  },
  {
    "value": "angelândia_mg",
    "label": "Angelândia - MG"
  },
  {
    "value": "angical_ba",
    "label": "Angical - BA"
  },
  {
    "value": "angical_do_piauí_pi",
    "label": "Angical do Piauí - PI"
  },
  {
    "value": "angico_to",
    "label": "Angico - TO"
  },
  {
    "value": "angicos_rn",
    "label": "Angicos - RN"
  },
  {
    "value": "angra_dos_reis_rj",
    "label": "Angra dos Reis - RJ"
  },
  {
    "value": "anguera_ba",
    "label": "Anguera - BA"
  },
  {
    "value": "angélica_ms",
    "label": "Angélica - MS"
  },
  {
    "value": "anhanguera_go",
    "label": "Anhanguera - GO"
  },
  {
    "value": "anhembi_sp",
    "label": "Anhembi - SP"
  },
  {
    "value": "anhumas_sp",
    "label": "Anhumas - SP"
  },
  {
    "value": "anicuns_go",
    "label": "Anicuns - GO"
  },
  {
    "value": "anita_garibaldi_sc",
    "label": "Anita Garibaldi - SC"
  },
  {
    "value": "anitápolis_sc",
    "label": "Anitápolis - SC"
  },
  {
    "value": "anori_am",
    "label": "Anori - AM"
  },
  {
    "value": "anta_gorda_rs",
    "label": "Anta Gorda - RS"
  },
  {
    "value": "antas_ba",
    "label": "Antas - BA"
  },
  {
    "value": "antonina_pr",
    "label": "Antonina - PR"
  },
  {
    "value": "antonina_do_norte_ce",
    "label": "Antonina do Norte - CE"
  },
  {
    "value": "antônio_almeida_pi",
    "label": "Antônio Almeida - PI"
  },
  {
    "value": "antônio_cardoso_ba",
    "label": "Antônio Cardoso - BA"
  },
  {
    "value": "antônio_carlos_mg",
    "label": "Antônio Carlos - MG"
  },
  {
    "value": "antônio_carlos_sc",
    "label": "Antônio Carlos - SC"
  },
  {
    "value": "antônio_dias_mg",
    "label": "Antônio Dias - MG"
  },
  {
    "value": "antônio_gonçalves_ba",
    "label": "Antônio Gonçalves - BA"
  },
  {
    "value": "antônio_joão_ms",
    "label": "Antônio João - MS"
  },
  {
    "value": "antônio_martins_rn",
    "label": "Antônio Martins - RN"
  },
  {
    "value": "antônio_olinto_pr",
    "label": "Antônio Olinto - PR"
  },
  {
    "value": "antônio_prado_rs",
    "label": "Antônio Prado - RS"
  },
  {
    "value": "antônio_prado_de_minas_mg",
    "label": "Antônio Prado de Minas - MG"
  },
  {
    "value": "anápolis_go",
    "label": "Anápolis - GO"
  },
  {
    "value": "anísio_de_abreu_pi",
    "label": "Anísio de Abreu - PI"
  },
  {
    "value": "aparecida_pb",
    "label": "Aparecida - PB"
  },
  {
    "value": "aparecida_sp",
    "label": "Aparecida - SP"
  },
  {
    "value": "aparecida_d'oeste_sp",
    "label": "Aparecida d'Oeste - SP"
  },
  {
    "value": "aparecida_de_goiânia_go",
    "label": "Aparecida de Goiânia - GO"
  },
  {
    "value": "aparecida_do_rio_doce_go",
    "label": "Aparecida do Rio Doce - GO"
  },
  {
    "value": "aparecida_do_rio_negro_to",
    "label": "Aparecida do Rio Negro - TO"
  },
  {
    "value": "aparecida_do_taboado_ms",
    "label": "Aparecida do Taboado - MS"
  },
  {
    "value": "aperibé_rj",
    "label": "Aperibé - RJ"
  },
  {
    "value": "apiacá_es",
    "label": "Apiacá - ES"
  },
  {
    "value": "apiacás_mt",
    "label": "Apiacás - MT"
  },
  {
    "value": "apiaí_sp",
    "label": "Apiaí - SP"
  },
  {
    "value": "apicum-açu_ma",
    "label": "Apicum-Açu - MA"
  },
  {
    "value": "apiúna_sc",
    "label": "Apiúna - SC"
  },
  {
    "value": "apodi_rn",
    "label": "Apodi - RN"
  },
  {
    "value": "aporá_ba",
    "label": "Aporá - BA"
  },
  {
    "value": "aporé_go",
    "label": "Aporé - GO"
  },
  {
    "value": "apuarema_ba",
    "label": "Apuarema - BA"
  },
  {
    "value": "apucarana_pr",
    "label": "Apucarana - PR"
  },
  {
    "value": "apuiarés_ce",
    "label": "Apuiarés - CE"
  },
  {
    "value": "apuí_am",
    "label": "Apuí - AM"
  },
  {
    "value": "aquidabã_se",
    "label": "Aquidabã - SE"
  },
  {
    "value": "aquidauana_ms",
    "label": "Aquidauana - MS"
  },
  {
    "value": "aquiraz_ce",
    "label": "Aquiraz - CE"
  },
  {
    "value": "arabutã_sc",
    "label": "Arabutã - SC"
  },
  {
    "value": "aracaju_se",
    "label": "Aracaju - SE"
  },
  {
    "value": "aracati_ce",
    "label": "Aracati - CE"
  },
  {
    "value": "aracatu_ba",
    "label": "Aracatu - BA"
  },
  {
    "value": "araci_ba",
    "label": "Araci - BA"
  },
  {
    "value": "aracitaba_mg",
    "label": "Aracitaba - MG"
  },
  {
    "value": "aracoiaba_ce",
    "label": "Aracoiaba - CE"
  },
  {
    "value": "aracruz_es",
    "label": "Aracruz - ES"
  },
  {
    "value": "aragarças_go",
    "label": "Aragarças - GO"
  },
  {
    "value": "aragoiânia_go",
    "label": "Aragoiânia - GO"
  },
  {
    "value": "aragominas_to",
    "label": "Aragominas - TO"
  },
  {
    "value": "araguacema_to",
    "label": "Araguacema - TO"
  },
  {
    "value": "araguaiana_mt",
    "label": "Araguaiana - MT"
  },
  {
    "value": "araguainha_mt",
    "label": "Araguainha - MT"
  },
  {
    "value": "araguanã_ma",
    "label": "Araguanã - MA"
  },
  {
    "value": "araguanã_to",
    "label": "Araguanã - TO"
  },
  {
    "value": "araguapaz_go",
    "label": "Araguapaz - GO"
  },
  {
    "value": "araguari_mg",
    "label": "Araguari - MG"
  },
  {
    "value": "araguatins_to",
    "label": "Araguatins - TO"
  },
  {
    "value": "araguaçu_to",
    "label": "Araguaçu - TO"
  },
  {
    "value": "araguaína_to",
    "label": "Araguaína - TO"
  },
  {
    "value": "araioses_ma",
    "label": "Araioses - MA"
  },
  {
    "value": "aral_moreira_ms",
    "label": "Aral Moreira - MS"
  },
  {
    "value": "aramari_ba",
    "label": "Aramari - BA"
  },
  {
    "value": "arambaré_rs",
    "label": "Arambaré - RS"
  },
  {
    "value": "arame_ma",
    "label": "Arame - MA"
  },
  {
    "value": "aramina_sp",
    "label": "Aramina - SP"
  },
  {
    "value": "arandu_sp",
    "label": "Arandu - SP"
  },
  {
    "value": "arantina_mg",
    "label": "Arantina - MG"
  },
  {
    "value": "arapeí_sp",
    "label": "Arapeí - SP"
  },
  {
    "value": "arapiraca_al",
    "label": "Arapiraca - AL"
  },
  {
    "value": "arapoema_to",
    "label": "Arapoema - TO"
  },
  {
    "value": "araponga_mg",
    "label": "Araponga - MG"
  },
  {
    "value": "arapongas_pr",
    "label": "Arapongas - PR"
  },
  {
    "value": "araporã_mg",
    "label": "Araporã - MG"
  },
  {
    "value": "arapoti_pr",
    "label": "Arapoti - PR"
  },
  {
    "value": "araputanga_mt",
    "label": "Araputanga - MT"
  },
  {
    "value": "arapuá_mg",
    "label": "Arapuá - MG"
  },
  {
    "value": "arapuã_pr",
    "label": "Arapuã - PR"
  },
  {
    "value": "araquari_sc",
    "label": "Araquari - SC"
  },
  {
    "value": "arara_pb",
    "label": "Arara - PB"
  },
  {
    "value": "araranguá_sc",
    "label": "Araranguá - SC"
  },
  {
    "value": "araraquara_sp",
    "label": "Araraquara - SP"
  },
  {
    "value": "araras_sp",
    "label": "Araras - SP"
  },
  {
    "value": "ararendá_ce",
    "label": "Ararendá - CE"
  },
  {
    "value": "arari_ma",
    "label": "Arari - MA"
  },
  {
    "value": "araricá_rs",
    "label": "Araricá - RS"
  },
  {
    "value": "araripe_ce",
    "label": "Araripe - CE"
  },
  {
    "value": "araripina_pe",
    "label": "Araripina - PE"
  },
  {
    "value": "araruama_rj",
    "label": "Araruama - RJ"
  },
  {
    "value": "araruna_pb",
    "label": "Araruna - PB"
  },
  {
    "value": "araruna_pr",
    "label": "Araruna - PR"
  },
  {
    "value": "arataca_ba",
    "label": "Arataca - BA"
  },
  {
    "value": "aratiba_rs",
    "label": "Aratiba - RS"
  },
  {
    "value": "aratuba_ce",
    "label": "Aratuba - CE"
  },
  {
    "value": "aratuípe_ba",
    "label": "Aratuípe - BA"
  },
  {
    "value": "araucária_pr",
    "label": "Araucária - PR"
  },
  {
    "value": "arauá_se",
    "label": "Arauá - SE"
  },
  {
    "value": "araxá_mg",
    "label": "Araxá - MG"
  },
  {
    "value": "araçagi_pb",
    "label": "Araçagi - PB"
  },
  {
    "value": "araçariguama_sp",
    "label": "Araçariguama - SP"
  },
  {
    "value": "araças_ba",
    "label": "Araças - BA"
  },
  {
    "value": "araçatuba_sp",
    "label": "Araçatuba - SP"
  },
  {
    "value": "araçaí_mg",
    "label": "Araçaí - MG"
  },
  {
    "value": "araçoiaba_pe",
    "label": "Araçoiaba - PE"
  },
  {
    "value": "araçoiaba_da_serra_sp",
    "label": "Araçoiaba da Serra - SP"
  },
  {
    "value": "araçu_go",
    "label": "Araçu - GO"
  },
  {
    "value": "araçuaí_mg",
    "label": "Araçuaí - MG"
  },
  {
    "value": "araújos_mg",
    "label": "Araújos - MG"
  },
  {
    "value": "arceburgo_mg",
    "label": "Arceburgo - MG"
  },
  {
    "value": "arco-íris_sp",
    "label": "Arco-Íris - SP"
  },
  {
    "value": "arcos_mg",
    "label": "Arcos - MG"
  },
  {
    "value": "arcoverde_pe",
    "label": "Arcoverde - PE"
  },
  {
    "value": "areado_mg",
    "label": "Areado - MG"
  },
  {
    "value": "areal_rj",
    "label": "Areal - RJ"
  },
  {
    "value": "arealva_sp",
    "label": "Arealva - SP"
  },
  {
    "value": "areia_pb",
    "label": "Areia - PB"
  },
  {
    "value": "areia_branca_rn",
    "label": "Areia Branca - RN"
  },
  {
    "value": "areia_branca_se",
    "label": "Areia Branca - SE"
  },
  {
    "value": "areia_de_baraúnas_pb",
    "label": "Areia de Baraúnas - PB"
  },
  {
    "value": "areial_pb",
    "label": "Areial - PB"
  },
  {
    "value": "areias_sp",
    "label": "Areias - SP"
  },
  {
    "value": "areiópolis_sp",
    "label": "Areiópolis - SP"
  },
  {
    "value": "arenápolis_mt",
    "label": "Arenápolis - MT"
  },
  {
    "value": "arenópolis_go",
    "label": "Arenópolis - GO"
  },
  {
    "value": "argirita_mg",
    "label": "Argirita - MG"
  },
  {
    "value": "aricanduva_mg",
    "label": "Aricanduva - MG"
  },
  {
    "value": "arinos_mg",
    "label": "Arinos - MG"
  },
  {
    "value": "aripuanã_mt",
    "label": "Aripuanã - MT"
  },
  {
    "value": "ariquemes_ro",
    "label": "Ariquemes - RO"
  },
  {
    "value": "ariranha_sp",
    "label": "Ariranha - SP"
  },
  {
    "value": "ariranha_do_ivaí_pr",
    "label": "Ariranha do Ivaí - PR"
  },
  {
    "value": "armazém_sc",
    "label": "Armazém - SC"
  },
  {
    "value": "armação_de_búzios_rj",
    "label": "Armação de Búzios - RJ"
  },
  {
    "value": "arneiroz_ce",
    "label": "Arneiroz - CE"
  },
  {
    "value": "aroazes_pi",
    "label": "Aroazes - PI"
  },
  {
    "value": "aroeiras_pb",
    "label": "Aroeiras - PB"
  },
  {
    "value": "arraial_pi",
    "label": "Arraial - PI"
  },
  {
    "value": "arraial_do_cabo_rj",
    "label": "Arraial do Cabo - RJ"
  },
  {
    "value": "arraias_to",
    "label": "Arraias - TO"
  },
  {
    "value": "arroio_grande_rs",
    "label": "Arroio Grande - RS"
  },
  {
    "value": "arroio_trinta_sc",
    "label": "Arroio Trinta - SC"
  },
  {
    "value": "arroio_do_meio_rs",
    "label": "Arroio do Meio - RS"
  },
  {
    "value": "arroio_do_padre_rs",
    "label": "Arroio do Padre - RS"
  },
  {
    "value": "arroio_do_sal_rs",
    "label": "Arroio do Sal - RS"
  },
  {
    "value": "arroio_do_tigre_rs",
    "label": "Arroio do Tigre - RS"
  },
  {
    "value": "arroio_dos_ratos_rs",
    "label": "Arroio dos Ratos - RS"
  },
  {
    "value": "artur_nogueira_sp",
    "label": "Artur Nogueira - SP"
  },
  {
    "value": "aruanã_go",
    "label": "Aruanã - GO"
  },
  {
    "value": "arujá_sp",
    "label": "Arujá - SP"
  },
  {
    "value": "arvoredo_sc",
    "label": "Arvoredo - SC"
  },
  {
    "value": "arvorezinha_rs",
    "label": "Arvorezinha - RS"
  },
  {
    "value": "arês_rn",
    "label": "Arês - RN"
  },
  {
    "value": "ascurra_sc",
    "label": "Ascurra - SC"
  },
  {
    "value": "aspásia_sp",
    "label": "Aspásia - SP"
  },
  {
    "value": "assaré_ce",
    "label": "Assaré - CE"
  },
  {
    "value": "assaí_pr",
    "label": "Assaí - PR"
  },
  {
    "value": "assis_sp",
    "label": "Assis - SP"
  },
  {
    "value": "assis_brasil_ac",
    "label": "Assis Brasil - AC"
  },
  {
    "value": "assis_chateaubriand_pr",
    "label": "Assis Chateaubriand - PR"
  },
  {
    "value": "assunção_pb",
    "label": "Assunção - PB"
  },
  {
    "value": "assunção_do_piauí_pi",
    "label": "Assunção do Piauí - PI"
  },
  {
    "value": "astolfo_dutra_mg",
    "label": "Astolfo Dutra - MG"
  },
  {
    "value": "astorga_pr",
    "label": "Astorga - PR"
  },
  {
    "value": "atalaia_al",
    "label": "Atalaia - AL"
  },
  {
    "value": "atalaia_pr",
    "label": "Atalaia - PR"
  },
  {
    "value": "atalaia_do_norte_am",
    "label": "Atalaia do Norte - AM"
  },
  {
    "value": "atalanta_sc",
    "label": "Atalanta - SC"
  },
  {
    "value": "ataléia_mg",
    "label": "Ataléia - MG"
  },
  {
    "value": "atibaia_sp",
    "label": "Atibaia - SP"
  },
  {
    "value": "atilio_vivacqua_es",
    "label": "Atilio Vivacqua - ES"
  },
  {
    "value": "augustinópolis_to",
    "label": "Augustinópolis - TO"
  },
  {
    "value": "augusto_corrêa_pa",
    "label": "Augusto Corrêa - PA"
  },
  {
    "value": "augusto_pestana_rs",
    "label": "Augusto Pestana - RS"
  },
  {
    "value": "augusto_severo_rn",
    "label": "Augusto Severo - RN"
  },
  {
    "value": "augusto_de_lima_mg",
    "label": "Augusto de Lima - MG"
  },
  {
    "value": "aurelino_leal_ba",
    "label": "Aurelino Leal - BA"
  },
  {
    "value": "auriflama_sp",
    "label": "Auriflama - SP"
  },
  {
    "value": "aurilândia_go",
    "label": "Aurilândia - GO"
  },
  {
    "value": "aurora_ce",
    "label": "Aurora - CE"
  },
  {
    "value": "aurora_sc",
    "label": "Aurora - SC"
  },
  {
    "value": "aurora_do_pará_pa",
    "label": "Aurora do Pará - PA"
  },
  {
    "value": "aurora_do_tocantins_to",
    "label": "Aurora do Tocantins - TO"
  },
  {
    "value": "autazes_am",
    "label": "Autazes - AM"
  },
  {
    "value": "avanhandava_sp",
    "label": "Avanhandava - SP"
  },
  {
    "value": "avaré_sp",
    "label": "Avaré - SP"
  },
  {
    "value": "avaí_sp",
    "label": "Avaí - SP"
  },
  {
    "value": "aveiro_pa",
    "label": "Aveiro - PA"
  },
  {
    "value": "avelino_lopes_pi",
    "label": "Avelino Lopes - PI"
  },
  {
    "value": "avelinópolis_go",
    "label": "Avelinópolis - GO"
  },
  {
    "value": "axixá_ma",
    "label": "Axixá - MA"
  },
  {
    "value": "axixá_do_tocantins_to",
    "label": "Axixá do Tocantins - TO"
  },
  {
    "value": "açailândia_ma",
    "label": "Açailândia - MA"
  },
  {
    "value": "açu_rn",
    "label": "Açu - RN"
  },
  {
    "value": "açucena_mg",
    "label": "Açucena - MG"
  },
  {
    "value": "babaçulândia_to",
    "label": "Babaçulândia - TO"
  },
  {
    "value": "bacabal_ma",
    "label": "Bacabal - MA"
  },
  {
    "value": "bacabeira_ma",
    "label": "Bacabeira - MA"
  },
  {
    "value": "bacuri_ma",
    "label": "Bacuri - MA"
  },
  {
    "value": "bacurituba_ma",
    "label": "Bacurituba - MA"
  },
  {
    "value": "bady_bassitt_sp",
    "label": "Bady Bassitt - SP"
  },
  {
    "value": "baependi_mg",
    "label": "Baependi - MG"
  },
  {
    "value": "bagre_pa",
    "label": "Bagre - PA"
  },
  {
    "value": "bagé_rs",
    "label": "Bagé - RS"
  },
  {
    "value": "baianópolis_ba",
    "label": "Baianópolis - BA"
  },
  {
    "value": "baixa_grande_ba",
    "label": "Baixa Grande - BA"
  },
  {
    "value": "baixa_grande_do_ribeiro_pi",
    "label": "Baixa Grande do Ribeiro - PI"
  },
  {
    "value": "baixio_ce",
    "label": "Baixio - CE"
  },
  {
    "value": "baixo_guandu_es",
    "label": "Baixo Guandu - ES"
  },
  {
    "value": "baião_pa",
    "label": "Baião - PA"
  },
  {
    "value": "balbinos_sp",
    "label": "Balbinos - SP"
  },
  {
    "value": "baldim_mg",
    "label": "Baldim - MG"
  },
  {
    "value": "baliza_go",
    "label": "Baliza - GO"
  },
  {
    "value": "balneário_arroio_do_silva_sc",
    "label": "Balneário Arroio do Silva - SC"
  },
  {
    "value": "balneário_barra_do_sul_sc",
    "label": "Balneário Barra do Sul - SC"
  },
  {
    "value": "balneário_camboriú_sc",
    "label": "Balneário Camboriú - SC"
  },
  {
    "value": "balneário_gaivota_sc",
    "label": "Balneário Gaivota - SC"
  },
  {
    "value": "balneário_pinhal_rs",
    "label": "Balneário Pinhal - RS"
  },
  {
    "value": "balsa_nova_pr",
    "label": "Balsa Nova - PR"
  },
  {
    "value": "balsas_ma",
    "label": "Balsas - MA"
  },
  {
    "value": "bambuí_mg",
    "label": "Bambuí - MG"
  },
  {
    "value": "banabuiú_ce",
    "label": "Banabuiú - CE"
  },
  {
    "value": "bananal_sp",
    "label": "Bananal - SP"
  },
  {
    "value": "bananeiras_pb",
    "label": "Bananeiras - PB"
  },
  {
    "value": "bandeira_mg",
    "label": "Bandeira - MG"
  },
  {
    "value": "bandeira_do_sul_mg",
    "label": "Bandeira do Sul - MG"
  },
  {
    "value": "bandeirante_sc",
    "label": "Bandeirante - SC"
  },
  {
    "value": "bandeirantes_ms",
    "label": "Bandeirantes - MS"
  },
  {
    "value": "bandeirantes_pr",
    "label": "Bandeirantes - PR"
  },
  {
    "value": "bandeirantes_do_tocantins_to",
    "label": "Bandeirantes do Tocantins - TO"
  },
  {
    "value": "bannach_pa",
    "label": "Bannach - PA"
  },
  {
    "value": "banzaê_ba",
    "label": "Banzaê - BA"
  },
  {
    "value": "baraúna_pb",
    "label": "Baraúna - PB"
  },
  {
    "value": "baraúna_rn",
    "label": "Baraúna - RN"
  },
  {
    "value": "barbacena_mg",
    "label": "Barbacena - MG"
  },
  {
    "value": "barbalha_ce",
    "label": "Barbalha - CE"
  },
  {
    "value": "barbosa_sp",
    "label": "Barbosa - SP"
  },
  {
    "value": "barbosa_ferraz_pr",
    "label": "Barbosa Ferraz - PR"
  },
  {
    "value": "barcarena_pa",
    "label": "Barcarena - PA"
  },
  {
    "value": "barcelona_rn",
    "label": "Barcelona - RN"
  },
  {
    "value": "barcelos_am",
    "label": "Barcelos - AM"
  },
  {
    "value": "bariri_sp",
    "label": "Bariri - SP"
  },
  {
    "value": "barra_ba",
    "label": "Barra - BA"
  },
  {
    "value": "barra_bonita_sc",
    "label": "Barra Bonita - SC"
  },
  {
    "value": "barra_bonita_sp",
    "label": "Barra Bonita - SP"
  },
  {
    "value": "barra_funda_rs",
    "label": "Barra Funda - RS"
  },
  {
    "value": "barra_longa_mg",
    "label": "Barra Longa - MG"
  },
  {
    "value": "barra_mansa_rj",
    "label": "Barra Mansa - RJ"
  },
  {
    "value": "barra_velha_sc",
    "label": "Barra Velha - SC"
  },
  {
    "value": "barra_d'alcântara_pi",
    "label": "Barra d'Alcântara - PI"
  },
  {
    "value": "barra_da_estiva_ba",
    "label": "Barra da Estiva - BA"
  },
  {
    "value": "barra_de_guabiraba_pe",
    "label": "Barra de Guabiraba - PE"
  },
  {
    "value": "barra_de_santa_rosa_pb",
    "label": "Barra de Santa Rosa - PB"
  },
  {
    "value": "barra_de_santana_pb",
    "label": "Barra de Santana - PB"
  },
  {
    "value": "barra_de_santo_antônio_al",
    "label": "Barra de Santo Antônio - AL"
  },
  {
    "value": "barra_de_são_francisco_es",
    "label": "Barra de São Francisco - ES"
  },
  {
    "value": "barra_de_são_miguel_al",
    "label": "Barra de São Miguel - AL"
  },
  {
    "value": "barra_de_são_miguel_pb",
    "label": "Barra de São Miguel - PB"
  },
  {
    "value": "barra_do_bugres_mt",
    "label": "Barra do Bugres - MT"
  },
  {
    "value": "barra_do_chapéu_sp",
    "label": "Barra do Chapéu - SP"
  },
  {
    "value": "barra_do_choça_ba",
    "label": "Barra do Choça - BA"
  },
  {
    "value": "barra_do_corda_ma",
    "label": "Barra do Corda - MA"
  },
  {
    "value": "barra_do_garças_mt",
    "label": "Barra do Garças - MT"
  },
  {
    "value": "barra_do_guarita_rs",
    "label": "Barra do Guarita - RS"
  },
  {
    "value": "barra_do_jacaré_pr",
    "label": "Barra do Jacaré - PR"
  },
  {
    "value": "barra_do_mendes_ba",
    "label": "Barra do Mendes - BA"
  },
  {
    "value": "barra_do_ouro_to",
    "label": "Barra do Ouro - TO"
  },
  {
    "value": "barra_do_piraí_rj",
    "label": "Barra do Piraí - RJ"
  },
  {
    "value": "barra_do_quaraí_rs",
    "label": "Barra do Quaraí - RS"
  },
  {
    "value": "barra_do_ribeiro_rs",
    "label": "Barra do Ribeiro - RS"
  },
  {
    "value": "barra_do_rio_azul_rs",
    "label": "Barra do Rio Azul - RS"
  },
  {
    "value": "barra_do_rocha_ba",
    "label": "Barra do Rocha - BA"
  },
  {
    "value": "barra_do_turvo_sp",
    "label": "Barra do Turvo - SP"
  },
  {
    "value": "barra_dos_coqueiros_se",
    "label": "Barra dos Coqueiros - SE"
  },
  {
    "value": "barracão_pr",
    "label": "Barracão - PR"
  },
  {
    "value": "barracão_rs",
    "label": "Barracão - RS"
  },
  {
    "value": "barras_pi",
    "label": "Barras - PI"
  },
  {
    "value": "barreira_ce",
    "label": "Barreira - CE"
  },
  {
    "value": "barreiras_ba",
    "label": "Barreiras - BA"
  },
  {
    "value": "barreiras_do_piauí_pi",
    "label": "Barreiras do Piauí - PI"
  },
  {
    "value": "barreirinha_am",
    "label": "Barreirinha - AM"
  },
  {
    "value": "barreirinhas_ma",
    "label": "Barreirinhas - MA"
  },
  {
    "value": "barreiros_pe",
    "label": "Barreiros - PE"
  },
  {
    "value": "barretos_sp",
    "label": "Barretos - SP"
  },
  {
    "value": "barrinha_sp",
    "label": "Barrinha - SP"
  },
  {
    "value": "barro_ce",
    "label": "Barro - CE"
  },
  {
    "value": "barro_alto_ba",
    "label": "Barro Alto - BA"
  },
  {
    "value": "barro_alto_go",
    "label": "Barro Alto - GO"
  },
  {
    "value": "barro_duro_pi",
    "label": "Barro Duro - PI"
  },
  {
    "value": "barro_preto_ba",
    "label": "Barro Preto - BA"
  },
  {
    "value": "barrocas_ba",
    "label": "Barrocas - BA"
  },
  {
    "value": "barrolândia_to",
    "label": "Barrolândia - TO"
  },
  {
    "value": "barroquinha_ce",
    "label": "Barroquinha - CE"
  },
  {
    "value": "barros_cassal_rs",
    "label": "Barros Cassal - RS"
  },
  {
    "value": "barroso_mg",
    "label": "Barroso - MG"
  },
  {
    "value": "barueri_sp",
    "label": "Barueri - SP"
  },
  {
    "value": "barão_rs",
    "label": "Barão - RS"
  },
  {
    "value": "barão_de_antonina_sp",
    "label": "Barão de Antonina - SP"
  },
  {
    "value": "barão_de_cocais_mg",
    "label": "Barão de Cocais - MG"
  },
  {
    "value": "barão_de_cotegipe_rs",
    "label": "Barão de Cotegipe - RS"
  },
  {
    "value": "barão_de_grajaú_ma",
    "label": "Barão de Grajaú - MA"
  },
  {
    "value": "barão_de_melgaço_mt",
    "label": "Barão de Melgaço - MT"
  },
  {
    "value": "barão_de_monte_alto_mg",
    "label": "Barão de Monte Alto - MG"
  },
  {
    "value": "barão_do_triunfo_rs",
    "label": "Barão do Triunfo - RS"
  },
  {
    "value": "bastos_sp",
    "label": "Bastos - SP"
  },
  {
    "value": "bataguassu_ms",
    "label": "Bataguassu - MS"
  },
  {
    "value": "bataiporã_ms",
    "label": "Bataiporã - MS"
  },
  {
    "value": "batalha_al",
    "label": "Batalha - AL"
  },
  {
    "value": "batalha_pi",
    "label": "Batalha - PI"
  },
  {
    "value": "batatais_sp",
    "label": "Batatais - SP"
  },
  {
    "value": "baturité_ce",
    "label": "Baturité - CE"
  },
  {
    "value": "bauru_sp",
    "label": "Bauru - SP"
  },
  {
    "value": "bayeux_pb",
    "label": "Bayeux - PB"
  },
  {
    "value": "baía_formosa_rn",
    "label": "Baía Formosa - RN"
  },
  {
    "value": "baía_da_traição_pb",
    "label": "Baía da Traição - PB"
  },
  {
    "value": "bebedouro_sp",
    "label": "Bebedouro - SP"
  },
  {
    "value": "beberibe_ce",
    "label": "Beberibe - CE"
  },
  {
    "value": "bela_cruz_ce",
    "label": "Bela Cruz - CE"
  },
  {
    "value": "bela_vista_ms",
    "label": "Bela Vista - MS"
  },
  {
    "value": "bela_vista_da_caroba_pr",
    "label": "Bela Vista da Caroba - PR"
  },
  {
    "value": "bela_vista_de_goiás_go",
    "label": "Bela Vista de Goiás - GO"
  },
  {
    "value": "bela_vista_de_minas_mg",
    "label": "Bela Vista de Minas - MG"
  },
  {
    "value": "bela_vista_do_maranhão_ma",
    "label": "Bela Vista do Maranhão - MA"
  },
  {
    "value": "bela_vista_do_paraíso_pr",
    "label": "Bela Vista do Paraíso - PR"
  },
  {
    "value": "bela_vista_do_piauí_pi",
    "label": "Bela Vista do Piauí - PI"
  },
  {
    "value": "bela_vista_do_toldo_sc",
    "label": "Bela Vista do Toldo - SC"
  },
  {
    "value": "belford_roxo_rj",
    "label": "Belford Roxo - RJ"
  },
  {
    "value": "belmiro_braga_mg",
    "label": "Belmiro Braga - MG"
  },
  {
    "value": "belmonte_ba",
    "label": "Belmonte - BA"
  },
  {
    "value": "belmonte_sc",
    "label": "Belmonte - SC"
  },
  {
    "value": "belo_campo_ba",
    "label": "Belo Campo - BA"
  },
  {
    "value": "belo_horizonte_mg",
    "label": "Belo Horizonte - MG"
  },
  {
    "value": "belo_jardim_pe",
    "label": "Belo Jardim - PE"
  },
  {
    "value": "belo_monte_al",
    "label": "Belo Monte - AL"
  },
  {
    "value": "belo_oriente_mg",
    "label": "Belo Oriente - MG"
  },
  {
    "value": "belo_vale_mg",
    "label": "Belo Vale - MG"
  },
  {
    "value": "belterra_pa",
    "label": "Belterra - PA"
  },
  {
    "value": "belágua_ma",
    "label": "Belágua - MA"
  },
  {
    "value": "belém_al",
    "label": "Belém - AL"
  },
  {
    "value": "belém_pa",
    "label": "Belém - PA"
  },
  {
    "value": "belém_pb",
    "label": "Belém - PB"
  },
  {
    "value": "belém_de_maria_pe",
    "label": "Belém de Maria - PE"
  },
  {
    "value": "belém_de_são_francisco_pe",
    "label": "Belém de São Francisco - PE"
  },
  {
    "value": "belém_do_brejo_do_cruz_pb",
    "label": "Belém do Brejo do Cruz - PB"
  },
  {
    "value": "belém_do_piauí_pi",
    "label": "Belém do Piauí - PI"
  },
  {
    "value": "beneditinos_pi",
    "label": "Beneditinos - PI"
  },
  {
    "value": "benedito_leite_ma",
    "label": "Benedito Leite - MA"
  },
  {
    "value": "benedito_novo_sc",
    "label": "Benedito Novo - SC"
  },
  {
    "value": "benevides_pa",
    "label": "Benevides - PA"
  },
  {
    "value": "benjamin_constan_do_sul_rs",
    "label": "Benjamin Constan do Sul - RS"
  },
  {
    "value": "benjamin_constant_am",
    "label": "Benjamin Constant - AM"
  },
  {
    "value": "bento_fernandes_rn",
    "label": "Bento Fernandes - RN"
  },
  {
    "value": "bento_gonçalves_rs",
    "label": "Bento Gonçalves - RS"
  },
  {
    "value": "bento_de_abreu_sp",
    "label": "Bento de Abreu - SP"
  },
  {
    "value": "bequimão_ma",
    "label": "Bequimão - MA"
  },
  {
    "value": "berilo_mg",
    "label": "Berilo - MG"
  },
  {
    "value": "berizal_mg",
    "label": "Berizal - MG"
  },
  {
    "value": "bernardino_batista_pb",
    "label": "Bernardino Batista - PB"
  },
  {
    "value": "bernardino_de_campos_sp",
    "label": "Bernardino de Campos - SP"
  },
  {
    "value": "bernardo_sayão_to",
    "label": "Bernardo Sayão - TO"
  },
  {
    "value": "bernardo_do_mearim_ma",
    "label": "Bernardo do Mearim - MA"
  },
  {
    "value": "bertioga_sp",
    "label": "Bertioga - SP"
  },
  {
    "value": "bertolínia_pi",
    "label": "Bertolínia - PI"
  },
  {
    "value": "bertópolis_mg",
    "label": "Bertópolis - MG"
  },
  {
    "value": "beruri_am",
    "label": "Beruri - AM"
  },
  {
    "value": "betim_mg",
    "label": "Betim - MG"
  },
  {
    "value": "betânia_pe",
    "label": "Betânia - PE"
  },
  {
    "value": "betânia_do_piauí_pi",
    "label": "Betânia do Piauí - PI"
  },
  {
    "value": "bezerros_pe",
    "label": "Bezerros - PE"
  },
  {
    "value": "bias_fortes_mg",
    "label": "Bias Fortes - MG"
  },
  {
    "value": "bicas_mg",
    "label": "Bicas - MG"
  },
  {
    "value": "biguaçu_sc",
    "label": "Biguaçu - SC"
  },
  {
    "value": "bilac_sp",
    "label": "Bilac - SP"
  },
  {
    "value": "biquinhas_mg",
    "label": "Biquinhas - MG"
  },
  {
    "value": "birigui_sp",
    "label": "Birigui - SP"
  },
  {
    "value": "biritiba-mirim_sp",
    "label": "Biritiba-Mirim - SP"
  },
  {
    "value": "biritinga_ba",
    "label": "Biritinga - BA"
  },
  {
    "value": "bituruna_pr",
    "label": "Bituruna - PR"
  },
  {
    "value": "blumenau_sc",
    "label": "Blumenau - SC"
  },
  {
    "value": "boa_esperança_es",
    "label": "Boa Esperança - ES"
  },
  {
    "value": "boa_esperança_mg",
    "label": "Boa Esperança - MG"
  },
  {
    "value": "boa_esperança_pr",
    "label": "Boa Esperança - PR"
  },
  {
    "value": "boa_esperança_do_iguaçu_pr",
    "label": "Boa Esperança do Iguaçu - PR"
  },
  {
    "value": "boa_esperança_do_sul_sp",
    "label": "Boa Esperança do Sul - SP"
  },
  {
    "value": "boa_hora_pi",
    "label": "Boa Hora - PI"
  },
  {
    "value": "boa_nova_ba",
    "label": "Boa Nova - BA"
  },
  {
    "value": "boa_ventura_pb",
    "label": "Boa Ventura - PB"
  },
  {
    "value": "boa_ventura_de_são_roque_pr",
    "label": "Boa Ventura de São Roque - PR"
  },
  {
    "value": "boa_viagem_ce",
    "label": "Boa Viagem - CE"
  },
  {
    "value": "boa_vista_pb",
    "label": "Boa Vista - PB"
  },
  {
    "value": "boa_vista_rr",
    "label": "Boa Vista - RR"
  },
  {
    "value": "boa_vista_da_aparecida_pr",
    "label": "Boa Vista da Aparecida - PR"
  },
  {
    "value": "boa_vista_das_missões_rs",
    "label": "Boa Vista das Missões - RS"
  },
  {
    "value": "boa_vista_do_buricá_rs",
    "label": "Boa Vista do Buricá - RS"
  },
  {
    "value": "boa_vista_do_cadeado_rs",
    "label": "Boa Vista do Cadeado - RS"
  },
  {
    "value": "boa_vista_do_gurupi_ma",
    "label": "Boa Vista do Gurupi - MA"
  },
  {
    "value": "boa_vista_do_incra_rs",
    "label": "Boa Vista do Incra - RS"
  },
  {
    "value": "boa_vista_do_ramos_am",
    "label": "Boa Vista do Ramos - AM"
  },
  {
    "value": "boa_vista_do_sul_rs",
    "label": "Boa Vista do Sul - RS"
  },
  {
    "value": "boa_vista_do_tupim_ba",
    "label": "Boa Vista do Tupim - BA"
  },
  {
    "value": "boca_da_mata_al",
    "label": "Boca da Mata - AL"
  },
  {
    "value": "boca_do_acre_am",
    "label": "Boca do Acre - AM"
  },
  {
    "value": "bocaina_pi",
    "label": "Bocaina - PI"
  },
  {
    "value": "bocaina_sp",
    "label": "Bocaina - SP"
  },
  {
    "value": "bocaina_de_minas_mg",
    "label": "Bocaina de Minas - MG"
  },
  {
    "value": "bocaina_do_sul_sc",
    "label": "Bocaina do Sul - SC"
  },
  {
    "value": "bocaiúva_mg",
    "label": "Bocaiúva - MG"
  },
  {
    "value": "bocaiúva_do_sul_pr",
    "label": "Bocaiúva do Sul - PR"
  },
  {
    "value": "bodocó_pe",
    "label": "Bodocó - PE"
  },
  {
    "value": "bodoquena_ms",
    "label": "Bodoquena - MS"
  },
  {
    "value": "bodó_rn",
    "label": "Bodó - RN"
  },
  {
    "value": "bofete_sp",
    "label": "Bofete - SP"
  },
  {
    "value": "boituva_sp",
    "label": "Boituva - SP"
  },
  {
    "value": "bom_conselho_pe",
    "label": "Bom Conselho - PE"
  },
  {
    "value": "bom_despacho_mg",
    "label": "Bom Despacho - MG"
  },
  {
    "value": "bom_jardim_ma",
    "label": "Bom Jardim - MA"
  },
  {
    "value": "bom_jardim_pe",
    "label": "Bom Jardim - PE"
  },
  {
    "value": "bom_jardim_rj",
    "label": "Bom Jardim - RJ"
  },
  {
    "value": "bom_jardim_da_serra_sc",
    "label": "Bom Jardim da Serra - SC"
  },
  {
    "value": "bom_jardim_de_goiás_go",
    "label": "Bom Jardim de Goiás - GO"
  },
  {
    "value": "bom_jardim_de_minas_mg",
    "label": "Bom Jardim de Minas - MG"
  },
  {
    "value": "bom_jesus_pb",
    "label": "Bom Jesus - PB"
  },
  {
    "value": "bom_jesus_pi",
    "label": "Bom Jesus - PI"
  },
  {
    "value": "bom_jesus_rn",
    "label": "Bom Jesus - RN"
  },
  {
    "value": "bom_jesus_rs",
    "label": "Bom Jesus - RS"
  },
  {
    "value": "bom_jesus_sc",
    "label": "Bom Jesus - SC"
  },
  {
    "value": "bom_jesus_da_lapa_ba",
    "label": "Bom Jesus da Lapa - BA"
  },
  {
    "value": "bom_jesus_da_penha_mg",
    "label": "Bom Jesus da Penha - MG"
  },
  {
    "value": "bom_jesus_da_serra_ba",
    "label": "Bom Jesus da Serra - BA"
  },
  {
    "value": "bom_jesus_das_selvas_ma",
    "label": "Bom Jesus das Selvas - MA"
  },
  {
    "value": "bom_jesus_de_goiás_go",
    "label": "Bom Jesus de Goiás - GO"
  },
  {
    "value": "bom_jesus_do_amparo_mg",
    "label": "Bom Jesus do Amparo - MG"
  },
  {
    "value": "bom_jesus_do_araguaia_mt",
    "label": "Bom Jesus do Araguaia - MT"
  },
  {
    "value": "bom_jesus_do_galho_mg",
    "label": "Bom Jesus do Galho - MG"
  },
  {
    "value": "bom_jesus_do_itabapoana_rj",
    "label": "Bom Jesus do Itabapoana - RJ"
  },
  {
    "value": "bom_jesus_do_norte_es",
    "label": "Bom Jesus do Norte - ES"
  },
  {
    "value": "bom_jesus_do_oeste_sc",
    "label": "Bom Jesus do Oeste - SC"
  },
  {
    "value": "bom_jesus_do_sul_pr",
    "label": "Bom Jesus do Sul - PR"
  },
  {
    "value": "bom_jesus_do_tocantins_pa",
    "label": "Bom Jesus do Tocantins - PA"
  },
  {
    "value": "bom_jesus_do_tocantins_to",
    "label": "Bom Jesus do Tocantins - TO"
  },
  {
    "value": "bom_jesus_dos_perdões_sp",
    "label": "Bom Jesus dos Perdões - SP"
  },
  {
    "value": "bom_lugar_ma",
    "label": "Bom Lugar - MA"
  },
  {
    "value": "bom_princípio_rs",
    "label": "Bom Princípio - RS"
  },
  {
    "value": "bom_princípio_do_piauí_pi",
    "label": "Bom Princípio do Piauí - PI"
  },
  {
    "value": "bom_progresso_rs",
    "label": "Bom Progresso - RS"
  },
  {
    "value": "bom_repouso_mg",
    "label": "Bom Repouso - MG"
  },
  {
    "value": "bom_retiro_sc",
    "label": "Bom Retiro - SC"
  },
  {
    "value": "bom_retiro_do_sul_rs",
    "label": "Bom Retiro do Sul - RS"
  },
  {
    "value": "bom_sucesso_mg",
    "label": "Bom Sucesso - MG"
  },
  {
    "value": "bom_sucesso_pb",
    "label": "Bom Sucesso - PB"
  },
  {
    "value": "bom_sucesso_pr",
    "label": "Bom Sucesso - PR"
  },
  {
    "value": "bom_sucesso_de_itararé_sp",
    "label": "Bom Sucesso de Itararé - SP"
  },
  {
    "value": "bom_sucesso_do_sul_pr",
    "label": "Bom Sucesso do Sul - PR"
  },
  {
    "value": "bombinhas_sc",
    "label": "Bombinhas - SC"
  },
  {
    "value": "bonfim_mg",
    "label": "Bonfim - MG"
  },
  {
    "value": "bonfim_rr",
    "label": "Bonfim - RR"
  },
  {
    "value": "bonfim_do_piauí_pi",
    "label": "Bonfim do Piauí - PI"
  },
  {
    "value": "bonfinópolis_go",
    "label": "Bonfinópolis - GO"
  },
  {
    "value": "bonfinópolis_de_minas_mg",
    "label": "Bonfinópolis de Minas - MG"
  },
  {
    "value": "boninal_ba",
    "label": "Boninal - BA"
  },
  {
    "value": "bonito_ba",
    "label": "Bonito - BA"
  },
  {
    "value": "bonito_ms",
    "label": "Bonito - MS"
  },
  {
    "value": "bonito_pa",
    "label": "Bonito - PA"
  },
  {
    "value": "bonito_pe",
    "label": "Bonito - PE"
  },
  {
    "value": "bonito_de_minas_mg",
    "label": "Bonito de Minas - MG"
  },
  {
    "value": "bonito_de_santa_fé_pb",
    "label": "Bonito de Santa Fé - PB"
  },
  {
    "value": "bonópolis_go",
    "label": "Bonópolis - GO"
  },
  {
    "value": "boqueirão_pb",
    "label": "Boqueirão - PB"
  },
  {
    "value": "boqueirão_do_leão_rs",
    "label": "Boqueirão do Leão - RS"
  },
  {
    "value": "boqueirão_do_piauí_pi",
    "label": "Boqueirão do Piauí - PI"
  },
  {
    "value": "boquim_se",
    "label": "Boquim - SE"
  },
  {
    "value": "boquira_ba",
    "label": "Boquira - BA"
  },
  {
    "value": "boracéia_sp",
    "label": "Boracéia - SP"
  },
  {
    "value": "borba_am",
    "label": "Borba - AM"
  },
  {
    "value": "borborema_pb",
    "label": "Borborema - PB"
  },
  {
    "value": "borborema_sp",
    "label": "Borborema - SP"
  },
  {
    "value": "borda_da_mata_mg",
    "label": "Borda da Mata - MG"
  },
  {
    "value": "borebi_sp",
    "label": "Borebi - SP"
  },
  {
    "value": "borrazópolis_pr",
    "label": "Borrazópolis - PR"
  },
  {
    "value": "borá_sp",
    "label": "Borá - SP"
  },
  {
    "value": "bossoroca_rs",
    "label": "Bossoroca - RS"
  },
  {
    "value": "botelhos_mg",
    "label": "Botelhos - MG"
  },
  {
    "value": "botucatu_sp",
    "label": "Botucatu - SP"
  },
  {
    "value": "botumirim_mg",
    "label": "Botumirim - MG"
  },
  {
    "value": "botuporã_ba",
    "label": "Botuporã - BA"
  },
  {
    "value": "botuverá_sc",
    "label": "Botuverá - SC"
  },
  {
    "value": "bozano_rs",
    "label": "Bozano - RS"
  },
  {
    "value": "braga_rs",
    "label": "Braga - RS"
  },
  {
    "value": "braganey_pr",
    "label": "Braganey - PR"
  },
  {
    "value": "bragança_pa",
    "label": "Bragança - PA"
  },
  {
    "value": "bragança_paulista_sp",
    "label": "Bragança Paulista - SP"
  },
  {
    "value": "branquinha_al",
    "label": "Branquinha - AL"
  },
  {
    "value": "brasil_novo_pa",
    "label": "Brasil Novo - PA"
  },
  {
    "value": "brasileira_pi",
    "label": "Brasileira - PI"
  },
  {
    "value": "brasilândia_ms",
    "label": "Brasilândia - MS"
  },
  {
    "value": "brasilândia_de_minas_mg",
    "label": "Brasilândia de Minas - MG"
  },
  {
    "value": "brasilândia_do_sul_pr",
    "label": "Brasilândia do Sul - PR"
  },
  {
    "value": "brasilândia_do_tocantins_to",
    "label": "Brasilândia do Tocantins - TO"
  },
  {
    "value": "brasiléia_ac",
    "label": "Brasiléia - AC"
  },
  {
    "value": "brasnorte_mt",
    "label": "Brasnorte - MT"
  },
  {
    "value": "brasília_df",
    "label": "Brasília - DF"
  },
  {
    "value": "brasília_de_minas_mg",
    "label": "Brasília de Minas - MG"
  },
  {
    "value": "brasópolis_mg",
    "label": "Brasópolis - MG"
  },
  {
    "value": "brazabrantes_go",
    "label": "Brazabrantes - GO"
  },
  {
    "value": "braço_do_norte_sc",
    "label": "Braço do Norte - SC"
  },
  {
    "value": "braço_do_trombudo_sc",
    "label": "Braço do Trombudo - SC"
  },
  {
    "value": "braúna_sp",
    "label": "Braúna - SP"
  },
  {
    "value": "braúnas_mg",
    "label": "Braúnas - MG"
  },
  {
    "value": "brejetuba_es",
    "label": "Brejetuba - ES"
  },
  {
    "value": "brejinho_pe",
    "label": "Brejinho - PE"
  },
  {
    "value": "brejinho_rn",
    "label": "Brejinho - RN"
  },
  {
    "value": "brejinho_de_nazaré_to",
    "label": "Brejinho de Nazaré - TO"
  },
  {
    "value": "brejo_ma",
    "label": "Brejo - MA"
  },
  {
    "value": "brejo_alegre_sp",
    "label": "Brejo Alegre - SP"
  },
  {
    "value": "brejo_grande_se",
    "label": "Brejo Grande - SE"
  },
  {
    "value": "brejo_grande_do_araguaia_pa",
    "label": "Brejo Grande do Araguaia - PA"
  },
  {
    "value": "brejo_santo_ce",
    "label": "Brejo Santo - CE"
  },
  {
    "value": "brejo_da_madre_de_deus_pe",
    "label": "Brejo da Madre de Deus - PE"
  },
  {
    "value": "brejo_de_areia_ma",
    "label": "Brejo de Areia - MA"
  },
  {
    "value": "brejo_do_cruz_pb",
    "label": "Brejo do Cruz - PB"
  },
  {
    "value": "brejo_do_piauí_pi",
    "label": "Brejo do Piauí - PI"
  },
  {
    "value": "brejo_dos_santos_pb",
    "label": "Brejo dos Santos - PB"
  },
  {
    "value": "brejolândia_ba",
    "label": "Brejolândia - BA"
  },
  {
    "value": "brejão_pe",
    "label": "Brejão - PE"
  },
  {
    "value": "brejões_ba",
    "label": "Brejões - BA"
  },
  {
    "value": "breu_branco_pa",
    "label": "Breu Branco - PA"
  },
  {
    "value": "breves_pa",
    "label": "Breves - PA"
  },
  {
    "value": "britânia_go",
    "label": "Britânia - GO"
  },
  {
    "value": "brochier_rs",
    "label": "Brochier - RS"
  },
  {
    "value": "brodowski_sp",
    "label": "Brodowski - SP"
  },
  {
    "value": "brotas_sp",
    "label": "Brotas - SP"
  },
  {
    "value": "brotas_de_macaúbas_ba",
    "label": "Brotas de Macaúbas - BA"
  },
  {
    "value": "brumadinho_mg",
    "label": "Brumadinho - MG"
  },
  {
    "value": "brumado_ba",
    "label": "Brumado - BA"
  },
  {
    "value": "brunópolis_sc",
    "label": "Brunópolis - SC"
  },
  {
    "value": "brusque_sc",
    "label": "Brusque - SC"
  },
  {
    "value": "brás_pires_mg",
    "label": "Brás Pires - MG"
  },
  {
    "value": "bueno_brandão_mg",
    "label": "Bueno Brandão - MG"
  },
  {
    "value": "buenos_aires_pe",
    "label": "Buenos Aires - PE"
  },
  {
    "value": "buenópolis_mg",
    "label": "Buenópolis - MG"
  },
  {
    "value": "buerarema_ba",
    "label": "Buerarema - BA"
  },
  {
    "value": "bugre_mg",
    "label": "Bugre - MG"
  },
  {
    "value": "bujari_ac",
    "label": "Bujari - AC"
  },
  {
    "value": "bujaru_pa",
    "label": "Bujaru - PA"
  },
  {
    "value": "buri_sp",
    "label": "Buri - SP"
  },
  {
    "value": "buritama_sp",
    "label": "Buritama - SP"
  },
  {
    "value": "buriti_ma",
    "label": "Buriti - MA"
  },
  {
    "value": "buriti_alegre_go",
    "label": "Buriti Alegre - GO"
  },
  {
    "value": "buriti_bravo_ma",
    "label": "Buriti Bravo - MA"
  },
  {
    "value": "buriti_de_goiás_go",
    "label": "Buriti de Goiás - GO"
  },
  {
    "value": "buriti_do_tocantins_to",
    "label": "Buriti do Tocantins - TO"
  },
  {
    "value": "buriti_dos_lopes_pi",
    "label": "Buriti dos Lopes - PI"
  },
  {
    "value": "buriti_dos_montes_pi",
    "label": "Buriti dos Montes - PI"
  },
  {
    "value": "buriticupu_ma",
    "label": "Buriticupu - MA"
  },
  {
    "value": "buritinópolis_go",
    "label": "Buritinópolis - GO"
  },
  {
    "value": "buritirama_ba",
    "label": "Buritirama - BA"
  },
  {
    "value": "buritirana_ma",
    "label": "Buritirana - MA"
  },
  {
    "value": "buritis_mg",
    "label": "Buritis - MG"
  },
  {
    "value": "buritis_ro",
    "label": "Buritis - RO"
  },
  {
    "value": "buritizal_sp",
    "label": "Buritizal - SP"
  },
  {
    "value": "buritizeiro_mg",
    "label": "Buritizeiro - MG"
  },
  {
    "value": "butiá_rs",
    "label": "Butiá - RS"
  },
  {
    "value": "buíque_pe",
    "label": "Buíque - PE"
  },
  {
    "value": "bálsamo_sp",
    "label": "Bálsamo - SP"
  },
  {
    "value": "caapiranga_am",
    "label": "Caapiranga - AM"
  },
  {
    "value": "caaporã_pb",
    "label": "Caaporã - PB"
  },
  {
    "value": "caarapó_ms",
    "label": "Caarapó - MS"
  },
  {
    "value": "caatiba_ba",
    "label": "Caatiba - BA"
  },
  {
    "value": "cabaceiras_pb",
    "label": "Cabaceiras - PB"
  },
  {
    "value": "cabaceiras_do_paraguaçu_ba",
    "label": "Cabaceiras do Paraguaçu - BA"
  },
  {
    "value": "cabeceira_grande_mg",
    "label": "Cabeceira Grande - MG"
  },
  {
    "value": "cabeceiras_go",
    "label": "Cabeceiras - GO"
  },
  {
    "value": "cabeceiras_do_piauí_pi",
    "label": "Cabeceiras do Piauí - PI"
  },
  {
    "value": "cabedelo_pb",
    "label": "Cabedelo - PB"
  },
  {
    "value": "cabixi_ro",
    "label": "Cabixi - RO"
  },
  {
    "value": "cabo_frio_rj",
    "label": "Cabo Frio - RJ"
  },
  {
    "value": "cabo_verde_mg",
    "label": "Cabo Verde - MG"
  },
  {
    "value": "cabo_de_santo_agostinho_pe",
    "label": "Cabo de Santo Agostinho - PE"
  },
  {
    "value": "cabreúva_sp",
    "label": "Cabreúva - SP"
  },
  {
    "value": "cabrobó_pe",
    "label": "Cabrobó - PE"
  },
  {
    "value": "cabrália_paulista_sp",
    "label": "Cabrália Paulista - SP"
  },
  {
    "value": "cacaulândia_ro",
    "label": "Cacaulândia - RO"
  },
  {
    "value": "cacequi_rs",
    "label": "Cacequi - RS"
  },
  {
    "value": "cachoeira_ba",
    "label": "Cachoeira - BA"
  },
  {
    "value": "cachoeira_alta_go",
    "label": "Cachoeira Alta - GO"
  },
  {
    "value": "cachoeira_dourada_go",
    "label": "Cachoeira Dourada - GO"
  },
  {
    "value": "cachoeira_dourada_mg",
    "label": "Cachoeira Dourada - MG"
  },
  {
    "value": "cachoeira_grande_ma",
    "label": "Cachoeira Grande - MA"
  },
  {
    "value": "cachoeira_paulista_sp",
    "label": "Cachoeira Paulista - SP"
  },
  {
    "value": "cachoeira_da_prata_mg",
    "label": "Cachoeira da Prata - MG"
  },
  {
    "value": "cachoeira_de_goiás_go",
    "label": "Cachoeira de Goiás - GO"
  },
  {
    "value": "cachoeira_de_minas_mg",
    "label": "Cachoeira de Minas - MG"
  },
  {
    "value": "cachoeira_de_pajeú_mg",
    "label": "Cachoeira de Pajeú - MG"
  },
  {
    "value": "cachoeira_do_arari_pa",
    "label": "Cachoeira do Arari - PA"
  },
  {
    "value": "cachoeira_do_piriá_pa",
    "label": "Cachoeira do Piriá - PA"
  },
  {
    "value": "cachoeira_do_sul_rs",
    "label": "Cachoeira do Sul - RS"
  },
  {
    "value": "cachoeira_dos_índios_pb",
    "label": "Cachoeira dos Índios - PB"
  },
  {
    "value": "cachoeiras_de_macacu_rj",
    "label": "Cachoeiras de Macacu - RJ"
  },
  {
    "value": "cachoeirinha_pe",
    "label": "Cachoeirinha - PE"
  },
  {
    "value": "cachoeirinha_rs",
    "label": "Cachoeirinha - RS"
  },
  {
    "value": "cachoeirinha_to",
    "label": "Cachoeirinha - TO"
  },
  {
    "value": "cachoeiro_de_itapemirim_es",
    "label": "Cachoeiro de Itapemirim - ES"
  },
  {
    "value": "cacimba_de_areia_pb",
    "label": "Cacimba de Areia - PB"
  },
  {
    "value": "cacimba_de_dentro_pb",
    "label": "Cacimba de Dentro - PB"
  },
  {
    "value": "cacimbas_pb",
    "label": "Cacimbas - PB"
  },
  {
    "value": "cacimbinhas_al",
    "label": "Cacimbinhas - AL"
  },
  {
    "value": "cacique_doble_rs",
    "label": "Cacique Doble - RS"
  },
  {
    "value": "cacoal_ro",
    "label": "Cacoal - RO"
  },
  {
    "value": "caconde_sp",
    "label": "Caconde - SP"
  },
  {
    "value": "caculé_ba",
    "label": "Caculé - BA"
  },
  {
    "value": "caetanos_ba",
    "label": "Caetanos - BA"
  },
  {
    "value": "caetanópolis_mg",
    "label": "Caetanópolis - MG"
  },
  {
    "value": "caetité_ba",
    "label": "Caetité - BA"
  },
  {
    "value": "caeté_mg",
    "label": "Caeté - MG"
  },
  {
    "value": "caetés_pe",
    "label": "Caetés - PE"
  },
  {
    "value": "cafarnaum_ba",
    "label": "Cafarnaum - BA"
  },
  {
    "value": "cafeara_pr",
    "label": "Cafeara - PR"
  },
  {
    "value": "cafelândia_pr",
    "label": "Cafelândia - PR"
  },
  {
    "value": "cafelândia_sp",
    "label": "Cafelândia - SP"
  },
  {
    "value": "cafezal_do_sul_pr",
    "label": "Cafezal do Sul - PR"
  },
  {
    "value": "caiabu_sp",
    "label": "Caiabu - SP"
  },
  {
    "value": "caiana_mg",
    "label": "Caiana - MG"
  },
  {
    "value": "caiapônia_go",
    "label": "Caiapônia - GO"
  },
  {
    "value": "caibaté_rs",
    "label": "Caibaté - RS"
  },
  {
    "value": "caibi_sc",
    "label": "Caibi - SC"
  },
  {
    "value": "caicó_rn",
    "label": "Caicó - RN"
  },
  {
    "value": "caieiras_sp",
    "label": "Caieiras - SP"
  },
  {
    "value": "cairu_ba",
    "label": "Cairu - BA"
  },
  {
    "value": "caiuá_sp",
    "label": "Caiuá - SP"
  },
  {
    "value": "caiçara_pb",
    "label": "Caiçara - PB"
  },
  {
    "value": "caiçara_rs",
    "label": "Caiçara - RS"
  },
  {
    "value": "caiçara_do_norte_rn",
    "label": "Caiçara do Norte - RN"
  },
  {
    "value": "caiçara_do_rio_do_vento_rn",
    "label": "Caiçara do Rio do Vento - RN"
  },
  {
    "value": "cajamar_sp",
    "label": "Cajamar - SP"
  },
  {
    "value": "cajapió_ma",
    "label": "Cajapió - MA"
  },
  {
    "value": "cajari_ma",
    "label": "Cajari - MA"
  },
  {
    "value": "cajati_sp",
    "label": "Cajati - SP"
  },
  {
    "value": "cajazeiras_pb",
    "label": "Cajazeiras - PB"
  },
  {
    "value": "cajazeiras_do_piauí_pi",
    "label": "Cajazeiras do Piauí - PI"
  },
  {
    "value": "cajazeirinhas_pb",
    "label": "Cajazeirinhas - PB"
  },
  {
    "value": "cajobi_sp",
    "label": "Cajobi - SP"
  },
  {
    "value": "cajueiro_al",
    "label": "Cajueiro - AL"
  },
  {
    "value": "cajueiro_da_praia_pi",
    "label": "Cajueiro da Praia - PI"
  },
  {
    "value": "cajuri_mg",
    "label": "Cajuri - MG"
  },
  {
    "value": "cajuru_sp",
    "label": "Cajuru - SP"
  },
  {
    "value": "caldas_mg",
    "label": "Caldas - MG"
  },
  {
    "value": "caldas_brandão_pb",
    "label": "Caldas Brandão - PB"
  },
  {
    "value": "caldas_novas_go",
    "label": "Caldas Novas - GO"
  },
  {
    "value": "caldazinha_go",
    "label": "Caldazinha - GO"
  },
  {
    "value": "caldeirão_grande_ba",
    "label": "Caldeirão Grande - BA"
  },
  {
    "value": "caldeirão_grande_do_piauí_pi",
    "label": "Caldeirão Grande do Piauí - PI"
  },
  {
    "value": "califórnia_pr",
    "label": "Califórnia - PR"
  },
  {
    "value": "calmon_sc",
    "label": "Calmon - SC"
  },
  {
    "value": "calumbi_pe",
    "label": "Calumbi - PE"
  },
  {
    "value": "calçado_pe",
    "label": "Calçado - PE"
  },
  {
    "value": "calçoene_ap",
    "label": "Calçoene - AP"
  },
  {
    "value": "camacan_ba",
    "label": "Camacan - BA"
  },
  {
    "value": "camacho_mg",
    "label": "Camacho - MG"
  },
  {
    "value": "camalaú_pb",
    "label": "Camalaú - PB"
  },
  {
    "value": "camamu_ba",
    "label": "Camamu - BA"
  },
  {
    "value": "camanducaia_mg",
    "label": "Camanducaia - MG"
  },
  {
    "value": "camapuã_ms",
    "label": "Camapuã - MS"
  },
  {
    "value": "camaquã_rs",
    "label": "Camaquã - RS"
  },
  {
    "value": "camaragibe_pe",
    "label": "Camaragibe - PE"
  },
  {
    "value": "camargo_rs",
    "label": "Camargo - RS"
  },
  {
    "value": "camaçari_ba",
    "label": "Camaçari - BA"
  },
  {
    "value": "cambará_pr",
    "label": "Cambará - PR"
  },
  {
    "value": "cambará_do_sul_rs",
    "label": "Cambará do Sul - RS"
  },
  {
    "value": "cambira_pr",
    "label": "Cambira - PR"
  },
  {
    "value": "camboriú_sc",
    "label": "Camboriú - SC"
  },
  {
    "value": "cambuci_rj",
    "label": "Cambuci - RJ"
  },
  {
    "value": "cambuquira_mg",
    "label": "Cambuquira - MG"
  },
  {
    "value": "cambuí_mg",
    "label": "Cambuí - MG"
  },
  {
    "value": "cambé_pr",
    "label": "Cambé - PR"
  },
  {
    "value": "cametá_pa",
    "label": "Cametá - PA"
  },
  {
    "value": "camocim_ce",
    "label": "Camocim - CE"
  },
  {
    "value": "camocim_de_são_félix_pe",
    "label": "Camocim de São Félix - PE"
  },
  {
    "value": "campanha_mg",
    "label": "Campanha - MG"
  },
  {
    "value": "campanário_mg",
    "label": "Campanário - MG"
  },
  {
    "value": "campestre_al",
    "label": "Campestre - AL"
  },
  {
    "value": "campestre_mg",
    "label": "Campestre - MG"
  },
  {
    "value": "campestre_da_serra_rs",
    "label": "Campestre da Serra - RS"
  },
  {
    "value": "campestre_de_goiás_go",
    "label": "Campestre de Goiás - GO"
  },
  {
    "value": "campestre_do_maranhão_ma",
    "label": "Campestre do Maranhão - MA"
  },
  {
    "value": "campina_grande_pb",
    "label": "Campina Grande - PB"
  },
  {
    "value": "campina_grande_do_sul_pr",
    "label": "Campina Grande do Sul - PR"
  },
  {
    "value": "campina_verde_mg",
    "label": "Campina Verde - MG"
  },
  {
    "value": "campina_da_lagoa_pr",
    "label": "Campina da Lagoa - PR"
  },
  {
    "value": "campina_das_missões_rs",
    "label": "Campina das Missões - RS"
  },
  {
    "value": "campina_do_monte_alegre_sp",
    "label": "Campina do Monte Alegre - SP"
  },
  {
    "value": "campina_do_simão_pr",
    "label": "Campina do Simão - PR"
  },
  {
    "value": "campinas_sp",
    "label": "Campinas - SP"
  },
  {
    "value": "campinas_do_piauí_pi",
    "label": "Campinas do Piauí - PI"
  },
  {
    "value": "campinas_do_sul_rs",
    "label": "Campinas do Sul - RS"
  },
  {
    "value": "campinaçu_go",
    "label": "Campinaçu - GO"
  },
  {
    "value": "campinorte_go",
    "label": "Campinorte - GO"
  },
  {
    "value": "campinápolis_mt",
    "label": "Campinápolis - MT"
  },
  {
    "value": "campo_alegre_al",
    "label": "Campo Alegre - AL"
  },
  {
    "value": "campo_alegre_sc",
    "label": "Campo Alegre - SC"
  },
  {
    "value": "campo_alegre_de_goiás_go",
    "label": "Campo Alegre de Goiás - GO"
  },
  {
    "value": "campo_alegre_de_lourdes_ba",
    "label": "Campo Alegre de Lourdes - BA"
  },
  {
    "value": "campo_alegre_do_fidalgo_pi",
    "label": "Campo Alegre do Fidalgo - PI"
  },
  {
    "value": "campo_azul_mg",
    "label": "Campo Azul - MG"
  },
  {
    "value": "campo_belo_mg",
    "label": "Campo Belo - MG"
  },
  {
    "value": "campo_belo_do_sul_sc",
    "label": "Campo Belo do Sul - SC"
  },
  {
    "value": "campo_bom_rs",
    "label": "Campo Bom - RS"
  },
  {
    "value": "campo_bonito_pr",
    "label": "Campo Bonito - PR"
  },
  {
    "value": "campo_erê_sc",
    "label": "Campo Erê - SC"
  },
  {
    "value": "campo_florido_mg",
    "label": "Campo Florido - MG"
  },
  {
    "value": "campo_formoso_ba",
    "label": "Campo Formoso - BA"
  },
  {
    "value": "campo_grande_al",
    "label": "Campo Grande - AL"
  },
  {
    "value": "campo_grande_ms",
    "label": "Campo Grande - MS"
  },
  {
    "value": "campo_grande_do_piauí_pi",
    "label": "Campo Grande do Piauí - PI"
  },
  {
    "value": "campo_largo_pr",
    "label": "Campo Largo - PR"
  },
  {
    "value": "campo_largo_do_piauí_pi",
    "label": "Campo Largo do Piauí - PI"
  },
  {
    "value": "campo_limpo_paulista_sp",
    "label": "Campo Limpo Paulista - SP"
  },
  {
    "value": "campo_magro_pr",
    "label": "Campo Magro - PR"
  },
  {
    "value": "campo_maior_pi",
    "label": "Campo Maior - PI"
  },
  {
    "value": "campo_mourão_pr",
    "label": "Campo Mourão - PR"
  },
  {
    "value": "campo_novo_rs",
    "label": "Campo Novo - RS"
  },
  {
    "value": "campo_novo_de_rondônia_ro",
    "label": "Campo Novo de Rondônia - RO"
  },
  {
    "value": "campo_novo_do_parecis_mt",
    "label": "Campo Novo do Parecis - MT"
  },
  {
    "value": "campo_redondo_rn",
    "label": "Campo Redondo - RN"
  },
  {
    "value": "campo_verde_mt",
    "label": "Campo Verde - MT"
  },
  {
    "value": "campo_de_santana_pb",
    "label": "Campo de Santana - PB"
  },
  {
    "value": "campo_do_brito_se",
    "label": "Campo do Brito - SE"
  },
  {
    "value": "campo_do_meio_mg",
    "label": "Campo do Meio - MG"
  },
  {
    "value": "campo_do_tenente_pr",
    "label": "Campo do Tenente - PR"
  },
  {
    "value": "campos_altos_mg",
    "label": "Campos Altos - MG"
  },
  {
    "value": "campos_belos_go",
    "label": "Campos Belos - GO"
  },
  {
    "value": "campos_borges_rs",
    "label": "Campos Borges - RS"
  },
  {
    "value": "campos_gerais_mg",
    "label": "Campos Gerais - MG"
  },
  {
    "value": "campos_limpo_de_goiás_go",
    "label": "Campos Limpo de Goiás - GO"
  },
  {
    "value": "campos_lindos_to",
    "label": "Campos Lindos - TO"
  },
  {
    "value": "campos_novos_sc",
    "label": "Campos Novos - SC"
  },
  {
    "value": "campos_novos_paulista_sp",
    "label": "Campos Novos Paulista - SP"
  },
  {
    "value": "campos_sales_ce",
    "label": "Campos Sales - CE"
  },
  {
    "value": "campos_verdes_go",
    "label": "Campos Verdes - GO"
  },
  {
    "value": "campos_de_júlio_mt",
    "label": "Campos de Júlio - MT"
  },
  {
    "value": "campos_do_jordão_sp",
    "label": "Campos do Jordão - SP"
  },
  {
    "value": "campos_dos_goytacazes_rj",
    "label": "Campos dos Goytacazes - RJ"
  },
  {
    "value": "camutanga_pe",
    "label": "Camutanga - PE"
  },
  {
    "value": "cana_verde_mg",
    "label": "Cana Verde - MG"
  },
  {
    "value": "canabrava_do_norte_mt",
    "label": "Canabrava do Norte - MT"
  },
  {
    "value": "cananéia_sp",
    "label": "Cananéia - SP"
  },
  {
    "value": "canapi_al",
    "label": "Canapi - AL"
  },
  {
    "value": "canarana_ba",
    "label": "Canarana - BA"
  },
  {
    "value": "canarana_mt",
    "label": "Canarana - MT"
  },
  {
    "value": "canas_sp",
    "label": "Canas - SP"
  },
  {
    "value": "canavieira_pi",
    "label": "Canavieira - PI"
  },
  {
    "value": "canavieiras_ba",
    "label": "Canavieiras - BA"
  },
  {
    "value": "canaã_mg",
    "label": "Canaã - MG"
  },
  {
    "value": "canaã_dos_carajás_pa",
    "label": "Canaã dos Carajás - PA"
  },
  {
    "value": "candeal_ba",
    "label": "Candeal - BA"
  },
  {
    "value": "candeias_ba",
    "label": "Candeias - BA"
  },
  {
    "value": "candeias_mg",
    "label": "Candeias - MG"
  },
  {
    "value": "candeias_do_jamari_ro",
    "label": "Candeias do Jamari - RO"
  },
  {
    "value": "candelária_rs",
    "label": "Candelária - RS"
  },
  {
    "value": "candiba_ba",
    "label": "Candiba - BA"
  },
  {
    "value": "candiota_rs",
    "label": "Candiota - RS"
  },
  {
    "value": "candói_pr",
    "label": "Candói - PR"
  },
  {
    "value": "canela_rs",
    "label": "Canela - RS"
  },
  {
    "value": "canelinha_sc",
    "label": "Canelinha - SC"
  },
  {
    "value": "canguaretama_rn",
    "label": "Canguaretama - RN"
  },
  {
    "value": "canguçu_rs",
    "label": "Canguçu - RS"
  },
  {
    "value": "canhoba_se",
    "label": "Canhoba - SE"
  },
  {
    "value": "canhotinho_pe",
    "label": "Canhotinho - PE"
  },
  {
    "value": "canindé_ce",
    "label": "Canindé - CE"
  },
  {
    "value": "canindé_de_são_francisco_se",
    "label": "Canindé de São Francisco - SE"
  },
  {
    "value": "canitar_sp",
    "label": "Canitar - SP"
  },
  {
    "value": "canoas_rs",
    "label": "Canoas - RS"
  },
  {
    "value": "canoinhas_sc",
    "label": "Canoinhas - SC"
  },
  {
    "value": "cansanção_ba",
    "label": "Cansanção - BA"
  },
  {
    "value": "cantagalo_mg",
    "label": "Cantagalo - MG"
  },
  {
    "value": "cantagalo_pr",
    "label": "Cantagalo - PR"
  },
  {
    "value": "cantagalo_rj",
    "label": "Cantagalo - RJ"
  },
  {
    "value": "cantanhede_ma",
    "label": "Cantanhede - MA"
  },
  {
    "value": "canto_do_buriti_pi",
    "label": "Canto do Buriti - PI"
  },
  {
    "value": "cantá_rr",
    "label": "Cantá - RR"
  },
  {
    "value": "canudos_ba",
    "label": "Canudos - BA"
  },
  {
    "value": "canudos_do_vale_rs",
    "label": "Canudos do Vale - RS"
  },
  {
    "value": "canutama_am",
    "label": "Canutama - AM"
  },
  {
    "value": "canápolis_ba",
    "label": "Canápolis - BA"
  },
  {
    "value": "canápolis_mg",
    "label": "Canápolis - MG"
  },
  {
    "value": "capanema_pa",
    "label": "Capanema - PA"
  },
  {
    "value": "capanema_pr",
    "label": "Capanema - PR"
  },
  {
    "value": "caparaó_mg",
    "label": "Caparaó - MG"
  },
  {
    "value": "capela_al",
    "label": "Capela - AL"
  },
  {
    "value": "capela_se",
    "label": "Capela - SE"
  },
  {
    "value": "capela_nova_mg",
    "label": "Capela Nova - MG"
  },
  {
    "value": "capela_de_santana_rs",
    "label": "Capela de Santana - RS"
  },
  {
    "value": "capela_do_alto_sp",
    "label": "Capela do Alto - SP"
  },
  {
    "value": "capela_do_alto_alegre_ba",
    "label": "Capela do Alto Alegre - BA"
  },
  {
    "value": "capelinha_mg",
    "label": "Capelinha - MG"
  },
  {
    "value": "capetinga_mg",
    "label": "Capetinga - MG"
  },
  {
    "value": "capim_pb",
    "label": "Capim - PB"
  },
  {
    "value": "capim_branco_mg",
    "label": "Capim Branco - MG"
  },
  {
    "value": "capim_grosso_ba",
    "label": "Capim Grosso - BA"
  },
  {
    "value": "capinzal_sc",
    "label": "Capinzal - SC"
  },
  {
    "value": "capinzal_do_norte_ma",
    "label": "Capinzal do Norte - MA"
  },
  {
    "value": "capinópolis_mg",
    "label": "Capinópolis - MG"
  },
  {
    "value": "capistrano_ce",
    "label": "Capistrano - CE"
  },
  {
    "value": "capitão_rs",
    "label": "Capitão - RS"
  },
  {
    "value": "capitão_andrade_mg",
    "label": "Capitão Andrade - MG"
  },
  {
    "value": "capitão_enéas_mg",
    "label": "Capitão Enéas - MG"
  },
  {
    "value": "capitão_gervásio_oliveira_pi",
    "label": "Capitão Gervásio Oliveira - PI"
  },
  {
    "value": "capitão_leônidas_marques_pr",
    "label": "Capitão Leônidas Marques - PR"
  },
  {
    "value": "capitão_poço_pa",
    "label": "Capitão Poço - PA"
  },
  {
    "value": "capitão_de_campos_pi",
    "label": "Capitão de Campos - PI"
  },
  {
    "value": "capitólio_mg",
    "label": "Capitólio - MG"
  },
  {
    "value": "capivari_sp",
    "label": "Capivari - SP"
  },
  {
    "value": "capivari_de_baixo_sc",
    "label": "Capivari de Baixo - SC"
  },
  {
    "value": "capivari_do_sul_rs",
    "label": "Capivari do Sul - RS"
  },
  {
    "value": "capixaba_ac",
    "label": "Capixaba - AC"
  },
  {
    "value": "capoeiras_pe",
    "label": "Capoeiras - PE"
  },
  {
    "value": "caputira_mg",
    "label": "Caputira - MG"
  },
  {
    "value": "capão_alto_sc",
    "label": "Capão Alto - SC"
  },
  {
    "value": "capão_bonito_sp",
    "label": "Capão Bonito - SP"
  },
  {
    "value": "capão_bonito_do_sul_rs",
    "label": "Capão Bonito do Sul - RS"
  },
  {
    "value": "capão_da_canoa_rs",
    "label": "Capão da Canoa - RS"
  },
  {
    "value": "capão_do_cipó_rs",
    "label": "Capão do Cipó - RS"
  },
  {
    "value": "capão_do_leão_rs",
    "label": "Capão do Leão - RS"
  },
  {
    "value": "caracaraí_rr",
    "label": "Caracaraí - RR"
  },
  {
    "value": "caracol_ms",
    "label": "Caracol - MS"
  },
  {
    "value": "caracol_pi",
    "label": "Caracol - PI"
  },
  {
    "value": "caraguatatuba_sp",
    "label": "Caraguatatuba - SP"
  },
  {
    "value": "carambeí_pr",
    "label": "Carambeí - PR"
  },
  {
    "value": "caranaíba_mg",
    "label": "Caranaíba - MG"
  },
  {
    "value": "carandaí_mg",
    "label": "Carandaí - MG"
  },
  {
    "value": "carangola_mg",
    "label": "Carangola - MG"
  },
  {
    "value": "carapebus_rj",
    "label": "Carapebus - RJ"
  },
  {
    "value": "carapicuíba_sp",
    "label": "Carapicuíba - SP"
  },
  {
    "value": "caratinga_mg",
    "label": "Caratinga - MG"
  },
  {
    "value": "carauari_am",
    "label": "Carauari - AM"
  },
  {
    "value": "caravelas_ba",
    "label": "Caravelas - BA"
  },
  {
    "value": "carazinho_rs",
    "label": "Carazinho - RS"
  },
  {
    "value": "caraá_rs",
    "label": "Caraá - RS"
  },
  {
    "value": "caraí_mg",
    "label": "Caraí - MG"
  },
  {
    "value": "caraíbas_ba",
    "label": "Caraíbas - BA"
  },
  {
    "value": "caraúbas_pb",
    "label": "Caraúbas - PB"
  },
  {
    "value": "caraúbas_rn",
    "label": "Caraúbas - RN"
  },
  {
    "value": "caraúbas_do_piauí_pi",
    "label": "Caraúbas do Piauí - PI"
  },
  {
    "value": "carbonita_mg",
    "label": "Carbonita - MG"
  },
  {
    "value": "cardeal_da_silva_ba",
    "label": "Cardeal da Silva - BA"
  },
  {
    "value": "cardoso_sp",
    "label": "Cardoso - SP"
  },
  {
    "value": "cardoso_moreira_rj",
    "label": "Cardoso Moreira - RJ"
  },
  {
    "value": "careaçu_mg",
    "label": "Careaçu - MG"
  },
  {
    "value": "careiro_am",
    "label": "Careiro - AM"
  },
  {
    "value": "careiro_da_várzea_am",
    "label": "Careiro da Várzea - AM"
  },
  {
    "value": "cariacica_es",
    "label": "Cariacica - ES"
  },
  {
    "value": "caridade_ce",
    "label": "Caridade - CE"
  },
  {
    "value": "caridade_do_piauí_pi",
    "label": "Caridade do Piauí - PI"
  },
  {
    "value": "carinhanha_ba",
    "label": "Carinhanha - BA"
  },
  {
    "value": "carira_se",
    "label": "Carira - SE"
  },
  {
    "value": "cariri_do_tocantins_to",
    "label": "Cariri do Tocantins - TO"
  },
  {
    "value": "caririaçu_ce",
    "label": "Caririaçu - CE"
  },
  {
    "value": "cariré_ce",
    "label": "Cariré - CE"
  },
  {
    "value": "cariús_ce",
    "label": "Cariús - CE"
  },
  {
    "value": "carlinda_mt",
    "label": "Carlinda - MT"
  },
  {
    "value": "carlos_barbosa_rs",
    "label": "Carlos Barbosa - RS"
  },
  {
    "value": "carlos_chagas_mg",
    "label": "Carlos Chagas - MG"
  },
  {
    "value": "carlos_gomes_rs",
    "label": "Carlos Gomes - RS"
  },
  {
    "value": "carlópolis_pr",
    "label": "Carlópolis - PR"
  },
  {
    "value": "carmo_rj",
    "label": "Carmo - RJ"
  },
  {
    "value": "carmo_da_cachoeira_mg",
    "label": "Carmo da Cachoeira - MG"
  },
  {
    "value": "carmo_da_mata_mg",
    "label": "Carmo da Mata - MG"
  },
  {
    "value": "carmo_de_minas_mg",
    "label": "Carmo de Minas - MG"
  },
  {
    "value": "carmo_do_cajuru_mg",
    "label": "Carmo do Cajuru - MG"
  },
  {
    "value": "carmo_do_paranaíba_mg",
    "label": "Carmo do Paranaíba - MG"
  },
  {
    "value": "carmo_do_rio_claro_mg",
    "label": "Carmo do Rio Claro - MG"
  },
  {
    "value": "carmo_do_rio_verde_go",
    "label": "Carmo do Rio Verde - GO"
  },
  {
    "value": "carmolândia_to",
    "label": "Carmolândia - TO"
  },
  {
    "value": "carmésia_mg",
    "label": "Carmésia - MG"
  },
  {
    "value": "carmópolis_se",
    "label": "Carmópolis - SE"
  },
  {
    "value": "carmópolis_de_minas_mg",
    "label": "Carmópolis de Minas - MG"
  },
  {
    "value": "carnaubais_rn",
    "label": "Carnaubais - RN"
  },
  {
    "value": "carnaubal_ce",
    "label": "Carnaubal - CE"
  },
  {
    "value": "carnaubeira_da_penha_pe",
    "label": "Carnaubeira da Penha - PE"
  },
  {
    "value": "carnaíba_pe",
    "label": "Carnaíba - PE"
  },
  {
    "value": "carnaúba_dos_dantas_rn",
    "label": "Carnaúba dos Dantas - RN"
  },
  {
    "value": "carneirinho_mg",
    "label": "Carneirinho - MG"
  },
  {
    "value": "carneiros_al",
    "label": "Carneiros - AL"
  },
  {
    "value": "caroebe_rr",
    "label": "Caroebe - RR"
  },
  {
    "value": "carolina_ma",
    "label": "Carolina - MA"
  },
  {
    "value": "carpina_pe",
    "label": "Carpina - PE"
  },
  {
    "value": "carrancas_mg",
    "label": "Carrancas - MG"
  },
  {
    "value": "carrapateira_pb",
    "label": "Carrapateira - PB"
  },
  {
    "value": "carrasco_bonito_to",
    "label": "Carrasco Bonito - TO"
  },
  {
    "value": "caruaru_pe",
    "label": "Caruaru - PE"
  },
  {
    "value": "carutapera_ma",
    "label": "Carutapera - MA"
  },
  {
    "value": "carvalhos_mg",
    "label": "Carvalhos - MG"
  },
  {
    "value": "carvalhópolis_mg",
    "label": "Carvalhópolis - MG"
  },
  {
    "value": "casa_branca_sp",
    "label": "Casa Branca - SP"
  },
  {
    "value": "casa_grande_mg",
    "label": "Casa Grande - MG"
  },
  {
    "value": "casa_nova_ba",
    "label": "Casa Nova - BA"
  },
  {
    "value": "casca_rs",
    "label": "Casca - RS"
  },
  {
    "value": "cascalho_rico_mg",
    "label": "Cascalho Rico - MG"
  },
  {
    "value": "cascavel_ce",
    "label": "Cascavel - CE"
  },
  {
    "value": "cascavel_pr",
    "label": "Cascavel - PR"
  },
  {
    "value": "caseara_to",
    "label": "Caseara - TO"
  },
  {
    "value": "caseiros_rs",
    "label": "Caseiros - RS"
  },
  {
    "value": "casimiro_de_abreu_rj",
    "label": "Casimiro de Abreu - RJ"
  },
  {
    "value": "casinhas_pe",
    "label": "Casinhas - PE"
  },
  {
    "value": "casserengue_pb",
    "label": "Casserengue - PB"
  },
  {
    "value": "cassilândia_ms",
    "label": "Cassilândia - MS"
  },
  {
    "value": "castanhal_pa",
    "label": "Castanhal - PA"
  },
  {
    "value": "castanheira_mt",
    "label": "Castanheira - MT"
  },
  {
    "value": "castanheiras_ro",
    "label": "Castanheiras - RO"
  },
  {
    "value": "castelo_es",
    "label": "Castelo - ES"
  },
  {
    "value": "castelo_do_piauí_pi",
    "label": "Castelo do Piauí - PI"
  },
  {
    "value": "castelândia_go",
    "label": "Castelândia - GO"
  },
  {
    "value": "castilho_sp",
    "label": "Castilho - SP"
  },
  {
    "value": "castro_pr",
    "label": "Castro - PR"
  },
  {
    "value": "castro_alves_ba",
    "label": "Castro Alves - BA"
  },
  {
    "value": "cataguases_mg",
    "label": "Cataguases - MG"
  },
  {
    "value": "catalão_go",
    "label": "Catalão - GO"
  },
  {
    "value": "catanduva_sp",
    "label": "Catanduva - SP"
  },
  {
    "value": "catanduvas_pr",
    "label": "Catanduvas - PR"
  },
  {
    "value": "catanduvas_sc",
    "label": "Catanduvas - SC"
  },
  {
    "value": "catarina_ce",
    "label": "Catarina - CE"
  },
  {
    "value": "catas_altas_mg",
    "label": "Catas Altas - MG"
  },
  {
    "value": "catas_altas_da_noruega_mg",
    "label": "Catas Altas da Noruega - MG"
  },
  {
    "value": "catende_pe",
    "label": "Catende - PE"
  },
  {
    "value": "catiguá_sp",
    "label": "Catiguá - SP"
  },
  {
    "value": "catingueira_pb",
    "label": "Catingueira - PB"
  },
  {
    "value": "catolândia_ba",
    "label": "Catolândia - BA"
  },
  {
    "value": "catolé_do_rocha_pb",
    "label": "Catolé do Rocha - PB"
  },
  {
    "value": "catu_ba",
    "label": "Catu - BA"
  },
  {
    "value": "catuji_mg",
    "label": "Catuji - MG"
  },
  {
    "value": "catunda_ce",
    "label": "Catunda - CE"
  },
  {
    "value": "caturama_ba",
    "label": "Caturama - BA"
  },
  {
    "value": "caturaí_go",
    "label": "Caturaí - GO"
  },
  {
    "value": "caturité_pb",
    "label": "Caturité - PB"
  },
  {
    "value": "catuti_mg",
    "label": "Catuti - MG"
  },
  {
    "value": "catuípe_rs",
    "label": "Catuípe - RS"
  },
  {
    "value": "caucaia_ce",
    "label": "Caucaia - CE"
  },
  {
    "value": "cavalcante_go",
    "label": "Cavalcante - GO"
  },
  {
    "value": "caxambu_mg",
    "label": "Caxambu - MG"
  },
  {
    "value": "caxambu_do_sul_sc",
    "label": "Caxambu do Sul - SC"
  },
  {
    "value": "caxias_ma",
    "label": "Caxias - MA"
  },
  {
    "value": "caxias_do_sul_rs",
    "label": "Caxias do Sul - RS"
  },
  {
    "value": "caxingó_pi",
    "label": "Caxingó - PI"
  },
  {
    "value": "caçador_sc",
    "label": "Caçador - SC"
  },
  {
    "value": "caçapava_sp",
    "label": "Caçapava - SP"
  },
  {
    "value": "caçapava_do_sul_rs",
    "label": "Caçapava do Sul - RS"
  },
  {
    "value": "caçu_go",
    "label": "Caçu - GO"
  },
  {
    "value": "caém_ba",
    "label": "Caém - BA"
  },
  {
    "value": "ceará-mirim_rn",
    "label": "Ceará-Mirim - RN"
  },
  {
    "value": "cedral_ma",
    "label": "Cedral - MA"
  },
  {
    "value": "cedral_sp",
    "label": "Cedral - SP"
  },
  {
    "value": "cedro_ce",
    "label": "Cedro - CE"
  },
  {
    "value": "cedro_pe",
    "label": "Cedro - PE"
  },
  {
    "value": "cedro_de_são_joão_se",
    "label": "Cedro de São João - SE"
  },
  {
    "value": "cedro_do_abaeté_mg",
    "label": "Cedro do Abaeté - MG"
  },
  {
    "value": "celso_ramos_sc",
    "label": "Celso Ramos - SC"
  },
  {
    "value": "centenário_rs",
    "label": "Centenário - RS"
  },
  {
    "value": "centenário_to",
    "label": "Centenário - TO"
  },
  {
    "value": "centenário_do_sul_pr",
    "label": "Centenário do Sul - PR"
  },
  {
    "value": "central_ba",
    "label": "Central - BA"
  },
  {
    "value": "central_de_minas_mg",
    "label": "Central de Minas - MG"
  },
  {
    "value": "central_do_maranhão_ma",
    "label": "Central do Maranhão - MA"
  },
  {
    "value": "centralina_mg",
    "label": "Centralina - MG"
  },
  {
    "value": "centro_novo_do_maranhão_ma",
    "label": "Centro Novo do Maranhão - MA"
  },
  {
    "value": "centro_do_guilherme_ma",
    "label": "Centro do Guilherme - MA"
  },
  {
    "value": "cerejeiras_ro",
    "label": "Cerejeiras - RO"
  },
  {
    "value": "ceres_go",
    "label": "Ceres - GO"
  },
  {
    "value": "cerqueira_césar_sp",
    "label": "Cerqueira César - SP"
  },
  {
    "value": "cerquilho_sp",
    "label": "Cerquilho - SP"
  },
  {
    "value": "cerrito_rs",
    "label": "Cerrito - RS"
  },
  {
    "value": "cerro_azul_pr",
    "label": "Cerro Azul - PR"
  },
  {
    "value": "cerro_branco_rs",
    "label": "Cerro Branco - RS"
  },
  {
    "value": "cerro_corá_rn",
    "label": "Cerro Corá - RN"
  },
  {
    "value": "cerro_grande_rs",
    "label": "Cerro Grande - RS"
  },
  {
    "value": "cerro_grande_do_sul_rs",
    "label": "Cerro Grande do Sul - RS"
  },
  {
    "value": "cerro_largo_rs",
    "label": "Cerro Largo - RS"
  },
  {
    "value": "cerro_negro_sc",
    "label": "Cerro Negro - SC"
  },
  {
    "value": "cesário_lange_sp",
    "label": "Cesário Lange - SP"
  },
  {
    "value": "cezarina_go",
    "label": "Cezarina - GO"
  },
  {
    "value": "chalé_mg",
    "label": "Chalé - MG"
  },
  {
    "value": "chapada_rs",
    "label": "Chapada - RS"
  },
  {
    "value": "chapada_gaúcha_mg",
    "label": "Chapada Gaúcha - MG"
  },
  {
    "value": "chapada_da_natividade_to",
    "label": "Chapada da Natividade - TO"
  },
  {
    "value": "chapada_de_areia_to",
    "label": "Chapada de Areia - TO"
  },
  {
    "value": "chapada_do_norte_mg",
    "label": "Chapada do Norte - MG"
  },
  {
    "value": "chapada_dos_guimarães_mt",
    "label": "Chapada dos Guimarães - MT"
  },
  {
    "value": "chapadinha_ma",
    "label": "Chapadinha - MA"
  },
  {
    "value": "chapadão_do_céu_go",
    "label": "Chapadão do Céu - GO"
  },
  {
    "value": "chapadão_do_lageado_sc",
    "label": "Chapadão do Lageado - SC"
  },
  {
    "value": "chapadão_do_sul_ms",
    "label": "Chapadão do Sul - MS"
  },
  {
    "value": "chapecó_sc",
    "label": "Chapecó - SC"
  },
  {
    "value": "charqueada_sp",
    "label": "Charqueada - SP"
  },
  {
    "value": "charqueadas_rs",
    "label": "Charqueadas - RS"
  },
  {
    "value": "charrua_rs",
    "label": "Charrua - RS"
  },
  {
    "value": "chaval_ce",
    "label": "Chaval - CE"
  },
  {
    "value": "chavantes_sp",
    "label": "Chavantes - SP"
  },
  {
    "value": "chaves_pa",
    "label": "Chaves - PA"
  },
  {
    "value": "chiador_mg",
    "label": "Chiador - MG"
  },
  {
    "value": "chiapeta_rs",
    "label": "Chiapeta - RS"
  },
  {
    "value": "chopinzinho_pr",
    "label": "Chopinzinho - PR"
  },
  {
    "value": "chorozinho_ce",
    "label": "Chorozinho - CE"
  },
  {
    "value": "chorrochó_ba",
    "label": "Chorrochó - BA"
  },
  {
    "value": "choró_ce",
    "label": "Choró - CE"
  },
  {
    "value": "chupinguaia_ro",
    "label": "Chupinguaia - RO"
  },
  {
    "value": "chuvisca_rs",
    "label": "Chuvisca - RS"
  },
  {
    "value": "chuí_rs",
    "label": "Chuí - RS"
  },
  {
    "value": "chácara_mg",
    "label": "Chácara - MG"
  },
  {
    "value": "chã_grande_pe",
    "label": "Chã Grande - PE"
  },
  {
    "value": "chã_preta_al",
    "label": "Chã Preta - AL"
  },
  {
    "value": "chã_de_alegria_pe",
    "label": "Chã de Alegria - PE"
  },
  {
    "value": "cianorte_pr",
    "label": "Cianorte - PR"
  },
  {
    "value": "cidade_gaúcha_pr",
    "label": "Cidade Gaúcha - PR"
  },
  {
    "value": "cidade_ocidental_go",
    "label": "Cidade Ocidental - GO"
  },
  {
    "value": "cidelândia_ma",
    "label": "Cidelândia - MA"
  },
  {
    "value": "cidreira_rs",
    "label": "Cidreira - RS"
  },
  {
    "value": "cipotânea_mg",
    "label": "Cipotânea - MG"
  },
  {
    "value": "cipó_ba",
    "label": "Cipó - BA"
  },
  {
    "value": "ciríaco_rs",
    "label": "Ciríaco - RS"
  },
  {
    "value": "claraval_mg",
    "label": "Claraval - MG"
  },
  {
    "value": "claro_dos_poções_mg",
    "label": "Claro dos Poções - MG"
  },
  {
    "value": "clementina_sp",
    "label": "Clementina - SP"
  },
  {
    "value": "clevelândia_pr",
    "label": "Clevelândia - PR"
  },
  {
    "value": "cláudia_mt",
    "label": "Cláudia - MT"
  },
  {
    "value": "cláudio_mg",
    "label": "Cláudio - MG"
  },
  {
    "value": "coaraci_ba",
    "label": "Coaraci - BA"
  },
  {
    "value": "coari_am",
    "label": "Coari - AM"
  },
  {
    "value": "cocal_pi",
    "label": "Cocal - PI"
  },
  {
    "value": "cocal_de_telha_pi",
    "label": "Cocal de Telha - PI"
  },
  {
    "value": "cocal_do_sul_sc",
    "label": "Cocal do Sul - SC"
  },
  {
    "value": "cocal_dos_alves_pi",
    "label": "Cocal dos Alves - PI"
  },
  {
    "value": "cocalinho_mt",
    "label": "Cocalinho - MT"
  },
  {
    "value": "cocalzinho_de_goiás_go",
    "label": "Cocalzinho de Goiás - GO"
  },
  {
    "value": "cocos_ba",
    "label": "Cocos - BA"
  },
  {
    "value": "codajás_am",
    "label": "Codajás - AM"
  },
  {
    "value": "codó_ma",
    "label": "Codó - MA"
  },
  {
    "value": "coelho_neto_ma",
    "label": "Coelho Neto - MA"
  },
  {
    "value": "coimbra_mg",
    "label": "Coimbra - MG"
  },
  {
    "value": "coité_do_nóia_al",
    "label": "Coité do Nóia - AL"
  },
  {
    "value": "coivaras_pi",
    "label": "Coivaras - PI"
  },
  {
    "value": "colares_pa",
    "label": "Colares - PA"
  },
  {
    "value": "colatina_es",
    "label": "Colatina - ES"
  },
  {
    "value": "colina_sp",
    "label": "Colina - SP"
  },
  {
    "value": "colinas_ma",
    "label": "Colinas - MA"
  },
  {
    "value": "colinas_rs",
    "label": "Colinas - RS"
  },
  {
    "value": "colinas_do_sul_go",
    "label": "Colinas do Sul - GO"
  },
  {
    "value": "colinas_do_tocantins_to",
    "label": "Colinas do Tocantins - TO"
  },
  {
    "value": "colméia_to",
    "label": "Colméia - TO"
  },
  {
    "value": "colniza_mt",
    "label": "Colniza - MT"
  },
  {
    "value": "colombo_pr",
    "label": "Colombo - PR"
  },
  {
    "value": "colorado_pr",
    "label": "Colorado - PR"
  },
  {
    "value": "colorado_rs",
    "label": "Colorado - RS"
  },
  {
    "value": "colorado_do_oeste_ro",
    "label": "Colorado do Oeste - RO"
  },
  {
    "value": "coluna_mg",
    "label": "Coluna - MG"
  },
  {
    "value": "colíder_mt",
    "label": "Colíder - MT"
  },
  {
    "value": "colômbia_sp",
    "label": "Colômbia - SP"
  },
  {
    "value": "colônia_leopoldina_al",
    "label": "Colônia Leopoldina - AL"
  },
  {
    "value": "colônia_do_gurguéia_pi",
    "label": "Colônia do Gurguéia - PI"
  },
  {
    "value": "colônia_do_piauí_pi",
    "label": "Colônia do Piauí - PI"
  },
  {
    "value": "combinado_to",
    "label": "Combinado - TO"
  },
  {
    "value": "comendador_gomes_mg",
    "label": "Comendador Gomes - MG"
  },
  {
    "value": "comendador_levy_gasparian_rj",
    "label": "Comendador Levy Gasparian - RJ"
  },
  {
    "value": "comercinho_mg",
    "label": "Comercinho - MG"
  },
  {
    "value": "comodoro_mt",
    "label": "Comodoro - MT"
  },
  {
    "value": "conceição_pb",
    "label": "Conceição - PB"
  },
  {
    "value": "conceição_da_aparecida_mg",
    "label": "Conceição da Aparecida - MG"
  },
  {
    "value": "conceição_da_barra_es",
    "label": "Conceição da Barra - ES"
  },
  {
    "value": "conceição_da_barra_de_minas_mg",
    "label": "Conceição da Barra de Minas - MG"
  },
  {
    "value": "conceição_da_feira_ba",
    "label": "Conceição da Feira - BA"
  },
  {
    "value": "conceição_das_alagoas_mg",
    "label": "Conceição das Alagoas - MG"
  },
  {
    "value": "conceição_das_pedras_mg",
    "label": "Conceição das Pedras - MG"
  },
  {
    "value": "conceição_de_ipanema_mg",
    "label": "Conceição de Ipanema - MG"
  },
  {
    "value": "conceição_de_macabu_rj",
    "label": "Conceição de Macabu - RJ"
  },
  {
    "value": "conceição_do_almeida_ba",
    "label": "Conceição do Almeida - BA"
  },
  {
    "value": "conceição_do_araguaia_pa",
    "label": "Conceição do Araguaia - PA"
  },
  {
    "value": "conceição_do_canindé_pi",
    "label": "Conceição do Canindé - PI"
  },
  {
    "value": "conceição_do_castelo_es",
    "label": "Conceição do Castelo - ES"
  },
  {
    "value": "conceição_do_coité_ba",
    "label": "Conceição do Coité - BA"
  },
  {
    "value": "conceição_do_jacuípe_ba",
    "label": "Conceição do Jacuípe - BA"
  },
  {
    "value": "conceição_do_lago-açu_ma",
    "label": "Conceição do Lago-Açu - MA"
  },
  {
    "value": "conceição_do_mato_dentro_mg",
    "label": "Conceição do Mato Dentro - MG"
  },
  {
    "value": "conceição_do_pará_mg",
    "label": "Conceição do Pará - MG"
  },
  {
    "value": "conceição_do_rio_verde_mg",
    "label": "Conceição do Rio Verde - MG"
  },
  {
    "value": "conceição_do_tocantins_to",
    "label": "Conceição do Tocantins - TO"
  },
  {
    "value": "conceição_dos_ouros_mg",
    "label": "Conceição dos Ouros - MG"
  },
  {
    "value": "conchal_sp",
    "label": "Conchal - SP"
  },
  {
    "value": "conchas_sp",
    "label": "Conchas - SP"
  },
  {
    "value": "concórdia_sc",
    "label": "Concórdia - SC"
  },
  {
    "value": "concórdia_do_pará_pa",
    "label": "Concórdia do Pará - PA"
  },
  {
    "value": "condado_pb",
    "label": "Condado - PB"
  },
  {
    "value": "condado_pe",
    "label": "Condado - PE"
  },
  {
    "value": "conde_ba",
    "label": "Conde - BA"
  },
  {
    "value": "conde_pb",
    "label": "Conde - PB"
  },
  {
    "value": "condeúba_ba",
    "label": "Condeúba - BA"
  },
  {
    "value": "condor_rs",
    "label": "Condor - RS"
  },
  {
    "value": "confins_mg",
    "label": "Confins - MG"
  },
  {
    "value": "confresa_mt",
    "label": "Confresa - MT"
  },
  {
    "value": "congo_pb",
    "label": "Congo - PB"
  },
  {
    "value": "congonhal_mg",
    "label": "Congonhal - MG"
  },
  {
    "value": "congonhas_mg",
    "label": "Congonhas - MG"
  },
  {
    "value": "congonhas_do_norte_mg",
    "label": "Congonhas do Norte - MG"
  },
  {
    "value": "congonhinhas_pr",
    "label": "Congonhinhas - PR"
  },
  {
    "value": "conquista_mg",
    "label": "Conquista - MG"
  },
  {
    "value": "conquista_d'oeste_mt",
    "label": "Conquista d'Oeste - MT"
  },
  {
    "value": "conselheiro_lafaiete_mg",
    "label": "Conselheiro Lafaiete - MG"
  },
  {
    "value": "conselheiro_mairinck_pr",
    "label": "Conselheiro Mairinck - PR"
  },
  {
    "value": "conselheiro_pena_mg",
    "label": "Conselheiro Pena - MG"
  },
  {
    "value": "consolação_mg",
    "label": "Consolação - MG"
  },
  {
    "value": "constantina_rs",
    "label": "Constantina - RS"
  },
  {
    "value": "contagem_mg",
    "label": "Contagem - MG"
  },
  {
    "value": "contenda_pr",
    "label": "Contenda - PR"
  },
  {
    "value": "contendas_do_sincorá_ba",
    "label": "Contendas do Sincorá - BA"
  },
  {
    "value": "coqueiral_mg",
    "label": "Coqueiral - MG"
  },
  {
    "value": "coqueiro_baixo_rs",
    "label": "Coqueiro Baixo - RS"
  },
  {
    "value": "coqueiro_seco_al",
    "label": "Coqueiro Seco - AL"
  },
  {
    "value": "coqueiros_do_sul_rs",
    "label": "Coqueiros do Sul - RS"
  },
  {
    "value": "coração_de_jesus_mg",
    "label": "Coração de Jesus - MG"
  },
  {
    "value": "coração_de_maria_ba",
    "label": "Coração de Maria - BA"
  },
  {
    "value": "corbélia_pr",
    "label": "Corbélia - PR"
  },
  {
    "value": "cordeiro_rj",
    "label": "Cordeiro - RJ"
  },
  {
    "value": "cordeiros_ba",
    "label": "Cordeiros - BA"
  },
  {
    "value": "cordeirópolis_sp",
    "label": "Cordeirópolis - SP"
  },
  {
    "value": "cordilheira_alta_sc",
    "label": "Cordilheira Alta - SC"
  },
  {
    "value": "cordisburgo_mg",
    "label": "Cordisburgo - MG"
  },
  {
    "value": "cordislândia_mg",
    "label": "Cordislândia - MG"
  },
  {
    "value": "coreaú_ce",
    "label": "Coreaú - CE"
  },
  {
    "value": "coremas_pb",
    "label": "Coremas - PB"
  },
  {
    "value": "corguinho_ms",
    "label": "Corguinho - MS"
  },
  {
    "value": "coribe_ba",
    "label": "Coribe - BA"
  },
  {
    "value": "corinto_mg",
    "label": "Corinto - MG"
  },
  {
    "value": "cornélio_procópio_pr",
    "label": "Cornélio Procópio - PR"
  },
  {
    "value": "coroaci_mg",
    "label": "Coroaci - MG"
  },
  {
    "value": "coroados_sp",
    "label": "Coroados - SP"
  },
  {
    "value": "coroatá_ma",
    "label": "Coroatá - MA"
  },
  {
    "value": "coromandel_mg",
    "label": "Coromandel - MG"
  },
  {
    "value": "coronel_barros_rs",
    "label": "Coronel Barros - RS"
  },
  {
    "value": "coronel_bicaco_rs",
    "label": "Coronel Bicaco - RS"
  },
  {
    "value": "coronel_domingos_soares_pr",
    "label": "Coronel Domingos Soares - PR"
  },
  {
    "value": "coronel_ezequiel_rn",
    "label": "Coronel Ezequiel - RN"
  },
  {
    "value": "coronel_fabriciano_mg",
    "label": "Coronel Fabriciano - MG"
  },
  {
    "value": "coronel_freitas_sc",
    "label": "Coronel Freitas - SC"
  },
  {
    "value": "coronel_josé_dias_pi",
    "label": "Coronel José Dias - PI"
  },
  {
    "value": "coronel_joão_pessoa_rn",
    "label": "Coronel João Pessoa - RN"
  },
  {
    "value": "coronel_joão_sá_ba",
    "label": "Coronel João Sá - BA"
  },
  {
    "value": "coronel_macedo_sp",
    "label": "Coronel Macedo - SP"
  },
  {
    "value": "coronel_martins_sc",
    "label": "Coronel Martins - SC"
  },
  {
    "value": "coronel_murta_mg",
    "label": "Coronel Murta - MG"
  },
  {
    "value": "coronel_pacheco_mg",
    "label": "Coronel Pacheco - MG"
  },
  {
    "value": "coronel_pilar_rs",
    "label": "Coronel Pilar - RS"
  },
  {
    "value": "coronel_sapucaia_ms",
    "label": "Coronel Sapucaia - MS"
  },
  {
    "value": "coronel_vivida_pr",
    "label": "Coronel Vivida - PR"
  },
  {
    "value": "coronel_xavier_chaves_mg",
    "label": "Coronel Xavier Chaves - MG"
  },
  {
    "value": "correia_pinto_sc",
    "label": "Correia Pinto - SC"
  },
  {
    "value": "corrente_pi",
    "label": "Corrente - PI"
  },
  {
    "value": "correntes_pe",
    "label": "Correntes - PE"
  },
  {
    "value": "correntina_ba",
    "label": "Correntina - BA"
  },
  {
    "value": "cortês_pe",
    "label": "Cortês - PE"
  },
  {
    "value": "corumbataí_sp",
    "label": "Corumbataí - SP"
  },
  {
    "value": "corumbataí_do_sul_pr",
    "label": "Corumbataí do Sul - PR"
  },
  {
    "value": "corumbaíba_go",
    "label": "Corumbaíba - GO"
  },
  {
    "value": "corumbiara_ro",
    "label": "Corumbiara - RO"
  },
  {
    "value": "corumbá_ms",
    "label": "Corumbá - MS"
  },
  {
    "value": "corumbá_de_goiás_go",
    "label": "Corumbá de Goiás - GO"
  },
  {
    "value": "corupá_sc",
    "label": "Corupá - SC"
  },
  {
    "value": "coruripe_al",
    "label": "Coruripe - AL"
  },
  {
    "value": "cosmorama_sp",
    "label": "Cosmorama - SP"
  },
  {
    "value": "cosmópolis_sp",
    "label": "Cosmópolis - SP"
  },
  {
    "value": "costa_marques_ro",
    "label": "Costa Marques - RO"
  },
  {
    "value": "costa_rica_ms",
    "label": "Costa Rica - MS"
  },
  {
    "value": "cotegipe_ba",
    "label": "Cotegipe - BA"
  },
  {
    "value": "cotia_sp",
    "label": "Cotia - SP"
  },
  {
    "value": "cotiporã_rs",
    "label": "Cotiporã - RS"
  },
  {
    "value": "cotriguaçu_mt",
    "label": "Cotriguaçu - MT"
  },
  {
    "value": "couto_de_magalhães_to",
    "label": "Couto de Magalhães - TO"
  },
  {
    "value": "couto_de_magalhães_de_minas_mg",
    "label": "Couto de Magalhães de Minas - MG"
  },
  {
    "value": "coxilha_rs",
    "label": "Coxilha - RS"
  },
  {
    "value": "coxim_ms",
    "label": "Coxim - MS"
  },
  {
    "value": "coxixola_pb",
    "label": "Coxixola - PB"
  },
  {
    "value": "crateús_ce",
    "label": "Crateús - CE"
  },
  {
    "value": "crato_ce",
    "label": "Crato - CE"
  },
  {
    "value": "cravinhos_sp",
    "label": "Cravinhos - SP"
  },
  {
    "value": "cravolândia_ba",
    "label": "Cravolândia - BA"
  },
  {
    "value": "craíbas',__'delmiro_gouveia_al",
    "label": "Craíbas',  'Delmiro Gouveia - AL"
  },
  {
    "value": "criciúma_sc",
    "label": "Criciúma - SC"
  },
  {
    "value": "crissiumal_rs",
    "label": "Crissiumal - RS"
  },
  {
    "value": "cristais_mg",
    "label": "Cristais - MG"
  },
  {
    "value": "cristais_paulista_sp",
    "label": "Cristais Paulista - SP"
  },
  {
    "value": "cristal_rs",
    "label": "Cristal - RS"
  },
  {
    "value": "cristal_do_sul_rs",
    "label": "Cristal do Sul - RS"
  },
  {
    "value": "cristalina_go",
    "label": "Cristalina - GO"
  },
  {
    "value": "cristalândia_to",
    "label": "Cristalândia - TO"
  },
  {
    "value": "cristalândia_do_piauí_pi",
    "label": "Cristalândia do Piauí - PI"
  },
  {
    "value": "cristiano_otoni_mg",
    "label": "Cristiano Otoni - MG"
  },
  {
    "value": "cristianópolis_go",
    "label": "Cristianópolis - GO"
  },
  {
    "value": "cristina_mg",
    "label": "Cristina - MG"
  },
  {
    "value": "cristino_castro_pi",
    "label": "Cristino Castro - PI"
  },
  {
    "value": "cristinápolis_se",
    "label": "Cristinápolis - SE"
  },
  {
    "value": "cristália_mg",
    "label": "Cristália - MG"
  },
  {
    "value": "cristópolis_ba",
    "label": "Cristópolis - BA"
  },
  {
    "value": "crisólita_mg",
    "label": "Crisólita - MG"
  },
  {
    "value": "crisópolis_ba",
    "label": "Crisópolis - BA"
  },
  {
    "value": "crixás_go",
    "label": "Crixás - GO"
  },
  {
    "value": "crixás_do_tocantins_to",
    "label": "Crixás do Tocantins - TO"
  },
  {
    "value": "croatá_ce",
    "label": "Croatá - CE"
  },
  {
    "value": "cromínia_go",
    "label": "Cromínia - GO"
  },
  {
    "value": "crucilândia_mg",
    "label": "Crucilândia - MG"
  },
  {
    "value": "cruz_ce",
    "label": "Cruz - CE"
  },
  {
    "value": "cruz_alta_rs",
    "label": "Cruz Alta - RS"
  },
  {
    "value": "cruz_machado_pr",
    "label": "Cruz Machado - PR"
  },
  {
    "value": "cruz_das_almas_ba",
    "label": "Cruz das Almas - BA"
  },
  {
    "value": "cruz_do_espírito_santo_pb",
    "label": "Cruz do Espírito Santo - PB"
  },
  {
    "value": "cruzaltense_rs",
    "label": "Cruzaltense - RS"
  },
  {
    "value": "cruzeiro_sp",
    "label": "Cruzeiro - SP"
  },
  {
    "value": "cruzeiro_da_fortaleza_mg",
    "label": "Cruzeiro da Fortaleza - MG"
  },
  {
    "value": "cruzeiro_do_iguaçu_pr",
    "label": "Cruzeiro do Iguaçu - PR"
  },
  {
    "value": "cruzeiro_do_oeste_pr",
    "label": "Cruzeiro do Oeste - PR"
  },
  {
    "value": "cruzeiro_do_sul_ac",
    "label": "Cruzeiro do Sul - AC"
  },
  {
    "value": "cruzeiro_do_sul_pr",
    "label": "Cruzeiro do Sul - PR"
  },
  {
    "value": "cruzeiro_do_sul_rs",
    "label": "Cruzeiro do Sul - RS"
  },
  {
    "value": "cruzeta_rn",
    "label": "Cruzeta - RN"
  },
  {
    "value": "cruzmaltina_pr",
    "label": "Cruzmaltina - PR"
  },
  {
    "value": "cruzália_sp",
    "label": "Cruzália - SP"
  },
  {
    "value": "cruzília_mg",
    "label": "Cruzília - MG"
  },
  {
    "value": "cubati_pb",
    "label": "Cubati - PB"
  },
  {
    "value": "cubatão_sp",
    "label": "Cubatão - SP"
  },
  {
    "value": "cuiabá_mt",
    "label": "Cuiabá - MT"
  },
  {
    "value": "cuitegi_pb",
    "label": "Cuitegi - PB"
  },
  {
    "value": "cuité_pb",
    "label": "Cuité - PB"
  },
  {
    "value": "cuité_de_mamanguape_pb",
    "label": "Cuité de Mamanguape - PB"
  },
  {
    "value": "cujubim_ro",
    "label": "Cujubim - RO"
  },
  {
    "value": "cumari_go",
    "label": "Cumari - GO"
  },
  {
    "value": "cumaru_pe",
    "label": "Cumaru - PE"
  },
  {
    "value": "cumaru_do_norte_pa",
    "label": "Cumaru do Norte - PA"
  },
  {
    "value": "cumbe_se",
    "label": "Cumbe - SE"
  },
  {
    "value": "cunha_sp",
    "label": "Cunha - SP"
  },
  {
    "value": "cunha_porã_sc",
    "label": "Cunha Porã - SC"
  },
  {
    "value": "cunhataí_sc",
    "label": "Cunhataí - SC"
  },
  {
    "value": "cuparaque_mg",
    "label": "Cuparaque - MG"
  },
  {
    "value": "cupira_pe",
    "label": "Cupira - PE"
  },
  {
    "value": "curaçá_ba",
    "label": "Curaçá - BA"
  },
  {
    "value": "curimatá_pi",
    "label": "Curimatá - PI"
  },
  {
    "value": "curionópolis_pa",
    "label": "Curionópolis - PA"
  },
  {
    "value": "curitiba_pr",
    "label": "Curitiba - PR"
  },
  {
    "value": "curitibanos_sc",
    "label": "Curitibanos - SC"
  },
  {
    "value": "curiúva_pr",
    "label": "Curiúva - PR"
  },
  {
    "value": "currais_pi",
    "label": "Currais - PI"
  },
  {
    "value": "currais_novos_rn",
    "label": "Currais Novos - RN"
  },
  {
    "value": "curral_novo_do_piauí_pi",
    "label": "Curral Novo do Piauí - PI"
  },
  {
    "value": "curral_velho_pb",
    "label": "Curral Velho - PB"
  },
  {
    "value": "curral_de_cima_pb",
    "label": "Curral de Cima - PB"
  },
  {
    "value": "curral_de_dentro_mg",
    "label": "Curral de Dentro - MG"
  },
  {
    "value": "curralinho_pa",
    "label": "Curralinho - PA"
  },
  {
    "value": "curralinhos_pi",
    "label": "Curralinhos - PI"
  },
  {
    "value": "cururupu_ma",
    "label": "Cururupu - MA"
  },
  {
    "value": "curuá_pa",
    "label": "Curuá - PA"
  },
  {
    "value": "curuçá_pa",
    "label": "Curuçá - PA"
  },
  {
    "value": "curvelo_mg",
    "label": "Curvelo - MG"
  },
  {
    "value": "curvelândia_mt",
    "label": "Curvelândia - MT"
  },
  {
    "value": "custódia_pe",
    "label": "Custódia - PE"
  },
  {
    "value": "cutias_ap",
    "label": "Cutias - AP"
  },
  {
    "value": "cáceres_mt",
    "label": "Cáceres - MT"
  },
  {
    "value": "cássia_mg",
    "label": "Cássia - MG"
  },
  {
    "value": "cássia_dos_coqueiros_sp",
    "label": "Cássia dos Coqueiros - SP"
  },
  {
    "value": "cândido_godói_rs",
    "label": "Cândido Godói - RS"
  },
  {
    "value": "cândido_mendes_ma",
    "label": "Cândido Mendes - MA"
  },
  {
    "value": "cândido_mota_sp",
    "label": "Cândido Mota - SP"
  },
  {
    "value": "cândido_rodrigues_sp",
    "label": "Cândido Rodrigues - SP"
  },
  {
    "value": "cândido_sales_ba",
    "label": "Cândido Sales - BA"
  },
  {
    "value": "cândido_de_abreu_pr",
    "label": "Cândido de Abreu - PR"
  },
  {
    "value": "céu_azul_pr",
    "label": "Céu Azul - PR"
  },
  {
    "value": "cícero_dantas_ba",
    "label": "Cícero Dantas - BA"
  },
  {
    "value": "córrego_danta_mg",
    "label": "Córrego Danta - MG"
  },
  {
    "value": "córrego_fundo_mg",
    "label": "Córrego Fundo - MG"
  },
  {
    "value": "córrego_novo_mg",
    "label": "Córrego Novo - MG"
  },
  {
    "value": "córrego_do_bom_jesus_mg",
    "label": "Córrego do Bom Jesus - MG"
  },
  {
    "value": "córrego_do_ouro_go",
    "label": "Córrego do Ouro - GO"
  },
  {
    "value": "cônego_marinho_mg",
    "label": "Cônego Marinho - MG"
  },
  {
    "value": "damianópolis_go",
    "label": "Damianópolis - GO"
  },
  {
    "value": "damião_pb",
    "label": "Damião - PB"
  },
  {
    "value": "damolândia_go",
    "label": "Damolândia - GO"
  },
  {
    "value": "darcinópolis_to",
    "label": "Darcinópolis - TO"
  },
  {
    "value": "datas_mg",
    "label": "Datas - MG"
  },
  {
    "value": "david_canabarro_rs",
    "label": "David Canabarro - RS"
  },
  {
    "value": "davinópolis_go",
    "label": "Davinópolis - GO"
  },
  {
    "value": "davinópolis_ma",
    "label": "Davinópolis - MA"
  },
  {
    "value": "delfim_moreira_mg",
    "label": "Delfim Moreira - MG"
  },
  {
    "value": "delfinópolis_mg",
    "label": "Delfinópolis - MG"
  },
  {
    "value": "delta_mg",
    "label": "Delta - MG"
  },
  {
    "value": "demerval_lobão_pi",
    "label": "Demerval Lobão - PI"
  },
  {
    "value": "denise_mt",
    "label": "Denise - MT"
  },
  {
    "value": "deodápolis_ms",
    "label": "Deodápolis - MS"
  },
  {
    "value": "deputado_irapuan_pinheiro_ce",
    "label": "Deputado Irapuan Pinheiro - CE"
  },
  {
    "value": "derrubadas_rs",
    "label": "Derrubadas - RS"
  },
  {
    "value": "descalvado_sp",
    "label": "Descalvado - SP"
  },
  {
    "value": "descanso_sc",
    "label": "Descanso - SC"
  },
  {
    "value": "descoberto_mg",
    "label": "Descoberto - MG"
  },
  {
    "value": "desterro_pb",
    "label": "Desterro - PB"
  },
  {
    "value": "desterro_de_entre_rios_mg",
    "label": "Desterro de Entre Rios - MG"
  },
  {
    "value": "desterro_do_melo_mg",
    "label": "Desterro do Melo - MG"
  },
  {
    "value": "dezesseis_de_novembro_rs",
    "label": "Dezesseis de Novembro - RS"
  },
  {
    "value": "diadema_sp",
    "label": "Diadema - SP"
  },
  {
    "value": "diamante_pb",
    "label": "Diamante - PB"
  },
  {
    "value": "diamante_d'oeste_pr",
    "label": "Diamante d'Oeste - PR"
  },
  {
    "value": "diamante_do_norte_pr",
    "label": "Diamante do Norte - PR"
  },
  {
    "value": "diamante_do_sul_pr",
    "label": "Diamante do Sul - PR"
  },
  {
    "value": "diamantina_mg",
    "label": "Diamantina - MG"
  },
  {
    "value": "diamantino_mt",
    "label": "Diamantino - MT"
  },
  {
    "value": "dianópolis_to",
    "label": "Dianópolis - TO"
  },
  {
    "value": "dias_d'ávila_ba",
    "label": "Dias d'Ávila - BA"
  },
  {
    "value": "dilermando_de_aguiar_rs",
    "label": "Dilermando de Aguiar - RS"
  },
  {
    "value": "diogo_de_vasconcelos_mg",
    "label": "Diogo de Vasconcelos - MG"
  },
  {
    "value": "dionísio_mg",
    "label": "Dionísio - MG"
  },
  {
    "value": "dionísio_cerqueira_sc",
    "label": "Dionísio Cerqueira - SC"
  },
  {
    "value": "diorama_go",
    "label": "Diorama - GO"
  },
  {
    "value": "dirce_reis_sp",
    "label": "Dirce Reis - SP"
  },
  {
    "value": "dirceu_arcoverde_pi",
    "label": "Dirceu Arcoverde - PI"
  },
  {
    "value": "divina_pastora_se",
    "label": "Divina Pastora - SE"
  },
  {
    "value": "divino_mg",
    "label": "Divino - MG"
  },
  {
    "value": "divino_das_laranjeiras_mg",
    "label": "Divino das Laranjeiras - MG"
  },
  {
    "value": "divino_de_são_lourenço_es",
    "label": "Divino de São Lourenço - ES"
  },
  {
    "value": "divinolândia_sp",
    "label": "Divinolândia - SP"
  },
  {
    "value": "divinolândia_de_minas_mg",
    "label": "Divinolândia de Minas - MG"
  },
  {
    "value": "divinésia_mg",
    "label": "Divinésia - MG"
  },
  {
    "value": "divinópolis_mg",
    "label": "Divinópolis - MG"
  },
  {
    "value": "divinópolis_de_goiás_go",
    "label": "Divinópolis de Goiás - GO"
  },
  {
    "value": "divinópolis_do_tocantins_to",
    "label": "Divinópolis do Tocantins - TO"
  },
  {
    "value": "divisa_alegre_mg",
    "label": "Divisa Alegre - MG"
  },
  {
    "value": "divisa_nova_mg",
    "label": "Divisa Nova - MG"
  },
  {
    "value": "divisópolis_mg",
    "label": "Divisópolis - MG"
  },
  {
    "value": "dobrada_sp",
    "label": "Dobrada - SP"
  },
  {
    "value": "dois_córregos_sp",
    "label": "Dois Córregos - SP"
  },
  {
    "value": "dois_irmãos_rs",
    "label": "Dois Irmãos - RS"
  },
  {
    "value": "dois_irmãos_das_missões_rs",
    "label": "Dois Irmãos das Missões - RS"
  },
  {
    "value": "dois_irmãos_do_buriti_ms",
    "label": "Dois Irmãos do Buriti - MS"
  },
  {
    "value": "dois_irmãos_do_tocantins_to",
    "label": "Dois Irmãos do Tocantins - TO"
  },
  {
    "value": "dois_lajeados_rs",
    "label": "Dois Lajeados - RS"
  },
  {
    "value": "dois_riachos_al",
    "label": "Dois Riachos - AL"
  },
  {
    "value": "dois_vizinhos_pr",
    "label": "Dois Vizinhos - PR"
  },
  {
    "value": "dolcinópolis_sp",
    "label": "Dolcinópolis - SP"
  },
  {
    "value": "dom_aquino_mt",
    "label": "Dom Aquino - MT"
  },
  {
    "value": "dom_basílio_ba",
    "label": "Dom Basílio - BA"
  },
  {
    "value": "dom_bosco_mg",
    "label": "Dom Bosco - MG"
  },
  {
    "value": "dom_cavati_mg",
    "label": "Dom Cavati - MG"
  },
  {
    "value": "dom_eliseu_pa",
    "label": "Dom Eliseu - PA"
  },
  {
    "value": "dom_expedito_lopes_pi",
    "label": "Dom Expedito Lopes - PI"
  },
  {
    "value": "dom_feliciano_rs",
    "label": "Dom Feliciano - RS"
  },
  {
    "value": "dom_inocêncio_pi",
    "label": "Dom Inocêncio - PI"
  },
  {
    "value": "dom_joaquim_mg",
    "label": "Dom Joaquim - MG"
  },
  {
    "value": "dom_macedo_costa_ba",
    "label": "Dom Macedo Costa - BA"
  },
  {
    "value": "dom_pedrito_rs",
    "label": "Dom Pedrito - RS"
  },
  {
    "value": "dom_pedro_ma",
    "label": "Dom Pedro - MA"
  },
  {
    "value": "dom_pedro_de_alcântara_rs",
    "label": "Dom Pedro de Alcântara - RS"
  },
  {
    "value": "dom_silvério_mg",
    "label": "Dom Silvério - MG"
  },
  {
    "value": "dom_viçoso_mg",
    "label": "Dom Viçoso - MG"
  },
  {
    "value": "domingos_martins_es",
    "label": "Domingos Martins - ES"
  },
  {
    "value": "domingos_mourão_pi",
    "label": "Domingos Mourão - PI"
  },
  {
    "value": "dona_emma_sc",
    "label": "Dona Emma - SC"
  },
  {
    "value": "dona_euzébia_mg",
    "label": "Dona Euzébia - MG"
  },
  {
    "value": "dona_francisca_rs",
    "label": "Dona Francisca - RS"
  },
  {
    "value": "dona_inês_pb",
    "label": "Dona Inês - PB"
  },
  {
    "value": "dores_de_campos_mg",
    "label": "Dores de Campos - MG"
  },
  {
    "value": "dores_de_guanhães_mg",
    "label": "Dores de Guanhães - MG"
  },
  {
    "value": "dores_do_indaiá_mg",
    "label": "Dores do Indaiá - MG"
  },
  {
    "value": "dores_do_rio_preto_es",
    "label": "Dores do Rio Preto - ES"
  },
  {
    "value": "dores_do_turvo_mg",
    "label": "Dores do Turvo - MG"
  },
  {
    "value": "doresópolis_mg",
    "label": "Doresópolis - MG"
  },
  {
    "value": "dormentes_pe",
    "label": "Dormentes - PE"
  },
  {
    "value": "douradina_ms",
    "label": "Douradina - MS"
  },
  {
    "value": "douradina_pr",
    "label": "Douradina - PR"
  },
  {
    "value": "dourado_sp",
    "label": "Dourado - SP"
  },
  {
    "value": "douradoquara_mg",
    "label": "Douradoquara - MG"
  },
  {
    "value": "dourados_ms",
    "label": "Dourados - MS"
  },
  {
    "value": "doutor_camargo_pr",
    "label": "Doutor Camargo - PR"
  },
  {
    "value": "doutor_maurício_cardoso_rs",
    "label": "Doutor Maurício Cardoso - RS"
  },
  {
    "value": "doutor_pedrinho_sc",
    "label": "Doutor Pedrinho - SC"
  },
  {
    "value": "doutor_ricardo_rs",
    "label": "Doutor Ricardo - RS"
  },
  {
    "value": "doutor_severiano_rn",
    "label": "Doutor Severiano - RN"
  },
  {
    "value": "doutor_ulysses_pr",
    "label": "Doutor Ulysses - PR"
  },
  {
    "value": "doverlândia_go",
    "label": "Doverlândia - GO"
  },
  {
    "value": "dracena_sp",
    "label": "Dracena - SP"
  },
  {
    "value": "duartina_sp",
    "label": "Duartina - SP"
  },
  {
    "value": "duas_barras_rj",
    "label": "Duas Barras - RJ"
  },
  {
    "value": "duas_estradas_pb",
    "label": "Duas Estradas - PB"
  },
  {
    "value": "dueré_to",
    "label": "Dueré - TO"
  },
  {
    "value": "dumont_sp",
    "label": "Dumont - SP"
  },
  {
    "value": "duque_bacelar_ma",
    "label": "Duque Bacelar - MA"
  },
  {
    "value": "duque_de_caxias_rj",
    "label": "Duque de Caxias - RJ"
  },
  {
    "value": "durandé_mg",
    "label": "Durandé - MG"
  },
  {
    "value": "dário_meira_ba",
    "label": "Dário Meira - BA"
  },
  {
    "value": "echaporã_sp",
    "label": "Echaporã - SP"
  },
  {
    "value": "ecoporanga_es",
    "label": "Ecoporanga - ES"
  },
  {
    "value": "edealina_go",
    "label": "Edealina - GO"
  },
  {
    "value": "edéia_go",
    "label": "Edéia - GO"
  },
  {
    "value": "eirunepé_am",
    "label": "Eirunepé - AM"
  },
  {
    "value": "eldorado_ms",
    "label": "Eldorado - MS"
  },
  {
    "value": "eldorado_sp",
    "label": "Eldorado - SP"
  },
  {
    "value": "eldorado_do_sul_rs",
    "label": "Eldorado do Sul - RS"
  },
  {
    "value": "eldorado_dos_carajás_pa",
    "label": "Eldorado dos Carajás - PA"
  },
  {
    "value": "elesbão_veloso_pi",
    "label": "Elesbão Veloso - PI"
  },
  {
    "value": "elias_fausto_sp",
    "label": "Elias Fausto - SP"
  },
  {
    "value": "eliseu_martins_pi",
    "label": "Eliseu Martins - PI"
  },
  {
    "value": "elisiário_sp",
    "label": "Elisiário - SP"
  },
  {
    "value": "elísio_medrado_ba",
    "label": "Elísio Medrado - BA"
  },
  {
    "value": "elói_mendes_mg",
    "label": "Elói Mendes - MG"
  },
  {
    "value": "emas_pb",
    "label": "Emas - PB"
  },
  {
    "value": "embaúba_sp",
    "label": "Embaúba - SP"
  },
  {
    "value": "embu_sp",
    "label": "Embu - SP"
  },
  {
    "value": "embu_das_artes_sp",
    "label": "Embu das Artes - SP"
  },
  {
    "value": "embu-guaçu_sp",
    "label": "Embu-Guaçu - SP"
  },
  {
    "value": "emilianópolis_sp",
    "label": "Emilianópolis - SP"
  },
  {
    "value": "encantado_rs",
    "label": "Encantado - RS"
  },
  {
    "value": "encanto_rn",
    "label": "Encanto - RN"
  },
  {
    "value": "encruzilhada_ba",
    "label": "Encruzilhada - BA"
  },
  {
    "value": "encruzilhada_do_sul_rs",
    "label": "Encruzilhada do Sul - RS"
  },
  {
    "value": "engenheiro_beltrão_pr",
    "label": "Engenheiro Beltrão - PR"
  },
  {
    "value": "engenheiro_caldas_mg",
    "label": "Engenheiro Caldas - MG"
  },
  {
    "value": "engenheiro_coelho_sp",
    "label": "Engenheiro Coelho - SP"
  },
  {
    "value": "engenheiro_navarro_mg",
    "label": "Engenheiro Navarro - MG"
  },
  {
    "value": "engenheiro_paulo_de_frontin_rj",
    "label": "Engenheiro Paulo de Frontin - RJ"
  },
  {
    "value": "engenho_velho_rs",
    "label": "Engenho Velho - RS"
  },
  {
    "value": "entre_folhas_mg",
    "label": "Entre Folhas - MG"
  },
  {
    "value": "entre_rios_ba",
    "label": "Entre Rios - BA"
  },
  {
    "value": "entre_rios_sc",
    "label": "Entre Rios - SC"
  },
  {
    "value": "entre_rios_de_minas_mg",
    "label": "Entre Rios de Minas - MG"
  },
  {
    "value": "entre_rios_do_oeste_pr",
    "label": "Entre Rios do Oeste - PR"
  },
  {
    "value": "entre_rios_do_sul_rs",
    "label": "Entre Rios do Sul - RS"
  },
  {
    "value": "entre-ijuís_rs",
    "label": "Entre-Ijuís - RS"
  },
  {
    "value": "envira_am",
    "label": "Envira - AM"
  },
  {
    "value": "enéas_marques_pr",
    "label": "Enéas Marques - PR"
  },
  {
    "value": "epitaciolândia_ac",
    "label": "Epitaciolândia - AC"
  },
  {
    "value": "equador_rn",
    "label": "Equador - RN"
  },
  {
    "value": "erebango_rs",
    "label": "Erebango - RS"
  },
  {
    "value": "erechim_rs",
    "label": "Erechim - RS"
  },
  {
    "value": "ererê_ce",
    "label": "Ererê - CE"
  },
  {
    "value": "ermo_sc",
    "label": "Ermo - SC"
  },
  {
    "value": "ernestina_rs",
    "label": "Ernestina - RS"
  },
  {
    "value": "erval_grande_rs",
    "label": "Erval Grande - RS"
  },
  {
    "value": "erval_seco_rs",
    "label": "Erval Seco - RS"
  },
  {
    "value": "erval_velho_sc",
    "label": "Erval Velho - SC"
  },
  {
    "value": "ervália_mg",
    "label": "Ervália - MG"
  },
  {
    "value": "escada_pe",
    "label": "Escada - PE"
  },
  {
    "value": "esmeralda_rs",
    "label": "Esmeralda - RS"
  },
  {
    "value": "esmeraldas_mg",
    "label": "Esmeraldas - MG"
  },
  {
    "value": "espera_feliz_mg",
    "label": "Espera Feliz - MG"
  },
  {
    "value": "esperantina_pi",
    "label": "Esperantina - PI"
  },
  {
    "value": "esperantina_to",
    "label": "Esperantina - TO"
  },
  {
    "value": "esperantinópolis_ma",
    "label": "Esperantinópolis - MA"
  },
  {
    "value": "esperança_pb",
    "label": "Esperança - PB"
  },
  {
    "value": "esperança_nova_pr",
    "label": "Esperança Nova - PR"
  },
  {
    "value": "esperança_do_sul_rs",
    "label": "Esperança do Sul - RS"
  },
  {
    "value": "espigão_alto_do_iguaçu_pr",
    "label": "Espigão Alto do Iguaçu - PR"
  },
  {
    "value": "espigão_d'oeste_ro",
    "label": "Espigão d'Oeste - RO"
  },
  {
    "value": "espinosa_mg",
    "label": "Espinosa - MG"
  },
  {
    "value": "esplanada_ba",
    "label": "Esplanada - BA"
  },
  {
    "value": "espumoso_rs",
    "label": "Espumoso - RS"
  },
  {
    "value": "espírito_santo_rn",
    "label": "Espírito Santo - RN"
  },
  {
    "value": "espírito_santo_do_dourado_mg",
    "label": "Espírito Santo do Dourado - MG"
  },
  {
    "value": "espírito_santo_do_pinhal_sp",
    "label": "Espírito Santo do Pinhal - SP"
  },
  {
    "value": "espírito_santo_do_turvo_sp",
    "label": "Espírito Santo do Turvo - SP"
  },
  {
    "value": "estação_rs",
    "label": "Estação - RS"
  },
  {
    "value": "esteio_rs",
    "label": "Esteio - RS"
  },
  {
    "value": "estiva_mg",
    "label": "Estiva - MG"
  },
  {
    "value": "estiva_gerbi_sp",
    "label": "Estiva Gerbi - SP"
  },
  {
    "value": "estreito_ma",
    "label": "Estreito - MA"
  },
  {
    "value": "estrela_rs",
    "label": "Estrela - RS"
  },
  {
    "value": "estrela_dalva_mg",
    "label": "Estrela Dalva - MG"
  },
  {
    "value": "estrela_velha_rs",
    "label": "Estrela Velha - RS"
  },
  {
    "value": "estrela_d'oeste_sp",
    "label": "Estrela d'Oeste - SP"
  },
  {
    "value": "estrela_de_alagoas_al",
    "label": "Estrela de Alagoas - AL"
  },
  {
    "value": "estrela_do_indaiá_mg",
    "label": "Estrela do Indaiá - MG"
  },
  {
    "value": "estrela_do_norte_go",
    "label": "Estrela do Norte - GO"
  },
  {
    "value": "estrela_do_norte_sp",
    "label": "Estrela do Norte - SP"
  },
  {
    "value": "estrela_do_sul_mg",
    "label": "Estrela do Sul - MG"
  },
  {
    "value": "estância_se",
    "label": "Estância - SE"
  },
  {
    "value": "estância_velha_rs",
    "label": "Estância Velha - RS"
  },
  {
    "value": "euclides_da_cunha_ba",
    "label": "Euclides da Cunha - BA"
  },
  {
    "value": "euclides_da_cunha_paulista_sp",
    "label": "Euclides da Cunha Paulista - SP"
  },
  {
    "value": "eugenópolis_mg",
    "label": "Eugenópolis - MG"
  },
  {
    "value": "eugênio_de_castro_rs",
    "label": "Eugênio de Castro - RS"
  },
  {
    "value": "eunápolis_ba",
    "label": "Eunápolis - BA"
  },
  {
    "value": "eusébio_ce",
    "label": "Eusébio - CE"
  },
  {
    "value": "ewbank_da_câmara_mg",
    "label": "Ewbank da Câmara - MG"
  },
  {
    "value": "extrema_mg",
    "label": "Extrema - MG"
  },
  {
    "value": "extremoz_rn",
    "label": "Extremoz - RN"
  },
  {
    "value": "exu_pe",
    "label": "Exu - PE"
  },
  {
    "value": "fagundes_pb",
    "label": "Fagundes - PB"
  },
  {
    "value": "fagundes_varela_rs",
    "label": "Fagundes Varela - RS"
  },
  {
    "value": "faina_go",
    "label": "Faina - GO"
  },
  {
    "value": "fama_mg",
    "label": "Fama - MG"
  },
  {
    "value": "faria_lemos_mg",
    "label": "Faria Lemos - MG"
  },
  {
    "value": "farias_brito_ce",
    "label": "Farias Brito - CE"
  },
  {
    "value": "faro_pa",
    "label": "Faro - PA"
  },
  {
    "value": "farol_pr",
    "label": "Farol - PR"
  },
  {
    "value": "farroupilha_rs",
    "label": "Farroupilha - RS"
  },
  {
    "value": "fartura_sp",
    "label": "Fartura - SP"
  },
  {
    "value": "fartura_do_piauí_pi",
    "label": "Fartura do Piauí - PI"
  },
  {
    "value": "faxinal_pr",
    "label": "Faxinal - PR"
  },
  {
    "value": "faxinal_do_soturno_rs",
    "label": "Faxinal do Soturno - RS"
  },
  {
    "value": "faxinal_dos_guedes_sc",
    "label": "Faxinal dos Guedes - SC"
  },
  {
    "value": "faxinalzinho_rs",
    "label": "Faxinalzinho - RS"
  },
  {
    "value": "fazenda_nova_go",
    "label": "Fazenda Nova - GO"
  },
  {
    "value": "fazenda_rio_grande_pr",
    "label": "Fazenda Rio Grande - PR"
  },
  {
    "value": "fazenda_vilanova_rs",
    "label": "Fazenda Vilanova - RS"
  },
  {
    "value": "feijó_ac",
    "label": "Feijó - AC"
  },
  {
    "value": "feira_grande_al",
    "label": "Feira Grande - AL"
  },
  {
    "value": "feira_nova_pe",
    "label": "Feira Nova - PE"
  },
  {
    "value": "feira_nova_se",
    "label": "Feira Nova - SE"
  },
  {
    "value": "feira_nova_do_maranhão_ma",
    "label": "Feira Nova do Maranhão - MA"
  },
  {
    "value": "feira_da_mata_ba",
    "label": "Feira da Mata - BA"
  },
  {
    "value": "feira_de_santana_ba",
    "label": "Feira de Santana - BA"
  },
  {
    "value": "felipe_guerra_rn",
    "label": "Felipe Guerra - RN"
  },
  {
    "value": "felisburgo_mg",
    "label": "Felisburgo - MG"
  },
  {
    "value": "felixlândia_mg",
    "label": "Felixlândia - MG"
  },
  {
    "value": "feliz_rs",
    "label": "Feliz - RS"
  },
  {
    "value": "feliz_deserto_al",
    "label": "Feliz Deserto - AL"
  },
  {
    "value": "feliz_natal_mt",
    "label": "Feliz Natal - MT"
  },
  {
    "value": "felício_dos_santos_mg",
    "label": "Felício dos Santos - MG"
  },
  {
    "value": "fernandes_pinheiro_pr",
    "label": "Fernandes Pinheiro - PR"
  },
  {
    "value": "fernandes_tourinho_mg",
    "label": "Fernandes Tourinho - MG"
  },
  {
    "value": "fernando_falcão_ma",
    "label": "Fernando Falcão - MA"
  },
  {
    "value": "fernando_pedroza_rn",
    "label": "Fernando Pedroza - RN"
  },
  {
    "value": "fernando_prestes_sp",
    "label": "Fernando Prestes - SP"
  },
  {
    "value": "fernando_de_noronha_pe",
    "label": "Fernando de Noronha - PE"
  },
  {
    "value": "fernandópolis_sp",
    "label": "Fernandópolis - SP"
  },
  {
    "value": "fernão_sp",
    "label": "Fernão - SP"
  },
  {
    "value": "ferraz_de_vasconcelos_sp",
    "label": "Ferraz de Vasconcelos - SP"
  },
  {
    "value": "ferreira_gomes_ap",
    "label": "Ferreira Gomes - AP"
  },
  {
    "value": "ferreiros_pe",
    "label": "Ferreiros - PE"
  },
  {
    "value": "ferros_mg",
    "label": "Ferros - MG"
  },
  {
    "value": "fervedouro_mg",
    "label": "Fervedouro - MG"
  },
  {
    "value": "figueira_pr",
    "label": "Figueira - PR"
  },
  {
    "value": "figueirópolis_to",
    "label": "Figueirópolis - TO"
  },
  {
    "value": "figueirópolis_d'oeste_mt",
    "label": "Figueirópolis d'Oeste - MT"
  },
  {
    "value": "filadélfia_ba",
    "label": "Filadélfia - BA"
  },
  {
    "value": "filadélfia_to",
    "label": "Filadélfia - TO"
  },
  {
    "value": "firmino_alves_ba",
    "label": "Firmino Alves - BA"
  },
  {
    "value": "firminópolis_go",
    "label": "Firminópolis - GO"
  },
  {
    "value": "flexeiras_al",
    "label": "Flexeiras - AL"
  },
  {
    "value": "flor_da_serra_do_sul_pr",
    "label": "Flor da Serra do Sul - PR"
  },
  {
    "value": "flor_do_sertão_sc",
    "label": "Flor do Sertão - SC"
  },
  {
    "value": "flora_rica_sp",
    "label": "Flora Rica - SP"
  },
  {
    "value": "floraí_pr",
    "label": "Floraí - PR"
  },
  {
    "value": "floreal_sp",
    "label": "Floreal - SP"
  },
  {
    "value": "flores_pe",
    "label": "Flores - PE"
  },
  {
    "value": "flores_da_cunha_rs",
    "label": "Flores da Cunha - RS"
  },
  {
    "value": "flores_de_goiás_go",
    "label": "Flores de Goiás - GO"
  },
  {
    "value": "flores_do_piauí_pi",
    "label": "Flores do Piauí - PI"
  },
  {
    "value": "floresta_pe",
    "label": "Floresta - PE"
  },
  {
    "value": "floresta_pr",
    "label": "Floresta - PR"
  },
  {
    "value": "floresta_azul_ba",
    "label": "Floresta Azul - BA"
  },
  {
    "value": "floresta_do_araguaia_pa",
    "label": "Floresta do Araguaia - PA"
  },
  {
    "value": "floresta_do_piauí_pi",
    "label": "Floresta do Piauí - PI"
  },
  {
    "value": "florestal_mg",
    "label": "Florestal - MG"
  },
  {
    "value": "florestópolis_pr",
    "label": "Florestópolis - PR"
  },
  {
    "value": "floriano_pi",
    "label": "Floriano - PI"
  },
  {
    "value": "floriano_peixoto_rs",
    "label": "Floriano Peixoto - RS"
  },
  {
    "value": "florianópolis_sc",
    "label": "Florianópolis - SC"
  },
  {
    "value": "florânia_rn",
    "label": "Florânia - RN"
  },
  {
    "value": "florínia_sp",
    "label": "Florínia - SP"
  },
  {
    "value": "flórida_pr",
    "label": "Flórida - PR"
  },
  {
    "value": "flórida_paulista_sp",
    "label": "Flórida Paulista - SP"
  },
  {
    "value": "fonte_boa_am",
    "label": "Fonte Boa - AM"
  },
  {
    "value": "fontoura_xavier_rs",
    "label": "Fontoura Xavier - RS"
  },
  {
    "value": "formiga_mg",
    "label": "Formiga - MG"
  },
  {
    "value": "formigueiro_rs",
    "label": "Formigueiro - RS"
  },
  {
    "value": "formosa_go",
    "label": "Formosa - GO"
  },
  {
    "value": "formosa_da_serra_negra_ma",
    "label": "Formosa da Serra Negra - MA"
  },
  {
    "value": "formosa_do_oeste_pr",
    "label": "Formosa do Oeste - PR"
  },
  {
    "value": "formosa_do_rio_preto_ba",
    "label": "Formosa do Rio Preto - BA"
  },
  {
    "value": "formosa_do_sul_sc",
    "label": "Formosa do Sul - SC"
  },
  {
    "value": "formoso_go",
    "label": "Formoso - GO"
  },
  {
    "value": "formoso_mg",
    "label": "Formoso - MG"
  },
  {
    "value": "formoso_do_araguaia_to",
    "label": "Formoso do Araguaia - TO"
  },
  {
    "value": "forquetinha_rs",
    "label": "Forquetinha - RS"
  },
  {
    "value": "forquilha_ce",
    "label": "Forquilha - CE"
  },
  {
    "value": "forquilhinha_sc",
    "label": "Forquilhinha - SC"
  },
  {
    "value": "fortaleza_ce",
    "label": "Fortaleza - CE"
  },
  {
    "value": "fortaleza_de_minas_mg",
    "label": "Fortaleza de Minas - MG"
  },
  {
    "value": "fortaleza_do_tabocão_to",
    "label": "Fortaleza do Tabocão - TO"
  },
  {
    "value": "fortaleza_dos_nogueiras_ma",
    "label": "Fortaleza dos Nogueiras - MA"
  },
  {
    "value": "fortaleza_dos_valos_rs",
    "label": "Fortaleza dos Valos - RS"
  },
  {
    "value": "fortim_ce",
    "label": "Fortim - CE"
  },
  {
    "value": "fortuna_ma",
    "label": "Fortuna - MA"
  },
  {
    "value": "fortuna_de_minas_mg",
    "label": "Fortuna de Minas - MG"
  },
  {
    "value": "foz_do_iguaçu_pr",
    "label": "Foz do Iguaçu - PR"
  },
  {
    "value": "foz_do_jordão_pr",
    "label": "Foz do Jordão - PR"
  },
  {
    "value": "fraiburgo_sc",
    "label": "Fraiburgo - SC"
  },
  {
    "value": "franca_sp",
    "label": "Franca - SP"
  },
  {
    "value": "francinópolis_pi",
    "label": "Francinópolis - PI"
  },
  {
    "value": "francisco_alves_pr",
    "label": "Francisco Alves - PR"
  },
  {
    "value": "francisco_ayres_pi",
    "label": "Francisco Ayres - PI"
  },
  {
    "value": "francisco_badaró_mg",
    "label": "Francisco Badaró - MG"
  },
  {
    "value": "francisco_beltrão_pr",
    "label": "Francisco Beltrão - PR"
  },
  {
    "value": "francisco_dantas_rn",
    "label": "Francisco Dantas - RN"
  },
  {
    "value": "francisco_dumont_mg",
    "label": "Francisco Dumont - MG"
  },
  {
    "value": "francisco_macedo_pi",
    "label": "Francisco Macedo - PI"
  },
  {
    "value": "francisco_morato_sp",
    "label": "Francisco Morato - SP"
  },
  {
    "value": "francisco_santos_pi",
    "label": "Francisco Santos - PI"
  },
  {
    "value": "francisco_sá_mg",
    "label": "Francisco Sá - MG"
  },
  {
    "value": "franciscópolis_mg",
    "label": "Franciscópolis - MG"
  },
  {
    "value": "franco_da_rocha_sp",
    "label": "Franco da Rocha - SP"
  },
  {
    "value": "frecheirinha_ce",
    "label": "Frecheirinha - CE"
  },
  {
    "value": "frederico_westphalen_rs",
    "label": "Frederico Westphalen - RS"
  },
  {
    "value": "frei_gaspar_mg",
    "label": "Frei Gaspar - MG"
  },
  {
    "value": "frei_inocêncio_mg",
    "label": "Frei Inocêncio - MG"
  },
  {
    "value": "frei_lagonegro_mg",
    "label": "Frei Lagonegro - MG"
  },
  {
    "value": "frei_martinho_pb",
    "label": "Frei Martinho - PB"
  },
  {
    "value": "frei_miguelinho_pe",
    "label": "Frei Miguelinho - PE"
  },
  {
    "value": "frei_paulo_se",
    "label": "Frei Paulo - SE"
  },
  {
    "value": "frei_rogério_sc",
    "label": "Frei Rogério - SC"
  },
  {
    "value": "fronteira_mg",
    "label": "Fronteira - MG"
  },
  {
    "value": "fronteira_dos_vales_mg",
    "label": "Fronteira dos Vales - MG"
  },
  {
    "value": "fronteiras_pi",
    "label": "Fronteiras - PI"
  },
  {
    "value": "fruta_de_leite_mg",
    "label": "Fruta de Leite - MG"
  },
  {
    "value": "frutal_mg",
    "label": "Frutal - MG"
  },
  {
    "value": "frutuoso_gomes_rn",
    "label": "Frutuoso Gomes - RN"
  },
  {
    "value": "fundão_es",
    "label": "Fundão - ES"
  },
  {
    "value": "funilândia_mg",
    "label": "Funilândia - MG"
  },
  {
    "value": "fátima_ba",
    "label": "Fátima - BA"
  },
  {
    "value": "fátima_to",
    "label": "Fátima - TO"
  },
  {
    "value": "fátima_do_sul_ms",
    "label": "Fátima do Sul - MS"
  },
  {
    "value": "fênix_pr",
    "label": "Fênix - PR"
  },
  {
    "value": "gabriel_monteiro_sp",
    "label": "Gabriel Monteiro - SP"
  },
  {
    "value": "gado_bravo_pb",
    "label": "Gado Bravo - PB"
  },
  {
    "value": "galiléia_mg",
    "label": "Galiléia - MG"
  },
  {
    "value": "galinhos_rn",
    "label": "Galinhos - RN"
  },
  {
    "value": "galvão_sc",
    "label": "Galvão - SC"
  },
  {
    "value": "gameleira_pe",
    "label": "Gameleira - PE"
  },
  {
    "value": "gameleira_de_goiás_go",
    "label": "Gameleira de Goiás - GO"
  },
  {
    "value": "gameleiras_mg",
    "label": "Gameleiras - MG"
  },
  {
    "value": "gandu_ba",
    "label": "Gandu - BA"
  },
  {
    "value": "garanhuns_pe",
    "label": "Garanhuns - PE"
  },
  {
    "value": "gararu_se",
    "label": "Gararu - SE"
  },
  {
    "value": "garibaldi_rs",
    "label": "Garibaldi - RS"
  },
  {
    "value": "garopaba_sc",
    "label": "Garopaba - SC"
  },
  {
    "value": "garrafão_do_norte_pa",
    "label": "Garrafão do Norte - PA"
  },
  {
    "value": "garruchos_rs",
    "label": "Garruchos - RS"
  },
  {
    "value": "garuva_sc",
    "label": "Garuva - SC"
  },
  {
    "value": "garça_sp",
    "label": "Garça - SP"
  },
  {
    "value": "gaspar_sc",
    "label": "Gaspar - SC"
  },
  {
    "value": "gastão_vidigal_sp",
    "label": "Gastão Vidigal - SP"
  },
  {
    "value": "gaurama_rs",
    "label": "Gaurama - RS"
  },
  {
    "value": "gavião_ba",
    "label": "Gavião - BA"
  },
  {
    "value": "gavião_peixoto_sp",
    "label": "Gavião Peixoto - SP"
  },
  {
    "value": "gaúcha_do_norte_mt",
    "label": "Gaúcha do Norte - MT"
  },
  {
    "value": "geminiano_pi",
    "label": "Geminiano - PI"
  },
  {
    "value": "general_carneiro_mt",
    "label": "General Carneiro - MT"
  },
  {
    "value": "general_carneiro_pr",
    "label": "General Carneiro - PR"
  },
  {
    "value": "general_câmara_rs",
    "label": "General Câmara - RS"
  },
  {
    "value": "general_maynard_se",
    "label": "General Maynard - SE"
  },
  {
    "value": "general_salgado_sp",
    "label": "General Salgado - SP"
  },
  {
    "value": "general_sampaio_ce",
    "label": "General Sampaio - CE"
  },
  {
    "value": "gentil_rs",
    "label": "Gentil - RS"
  },
  {
    "value": "gentio_do_ouro_ba",
    "label": "Gentio do Ouro - BA"
  },
  {
    "value": "getulina_sp",
    "label": "Getulina - SP"
  },
  {
    "value": "getúlio_vargas_rs",
    "label": "Getúlio Vargas - RS"
  },
  {
    "value": "gilbués_pi",
    "label": "Gilbués - PI"
  },
  {
    "value": "girau_do_ponciano_al",
    "label": "Girau do Ponciano - AL"
  },
  {
    "value": "giruá_rs",
    "label": "Giruá - RS"
  },
  {
    "value": "glaucilândia_mg",
    "label": "Glaucilândia - MG"
  },
  {
    "value": "glicério_sp",
    "label": "Glicério - SP"
  },
  {
    "value": "glorinha_rs",
    "label": "Glorinha - RS"
  },
  {
    "value": "glória_ba",
    "label": "Glória - BA"
  },
  {
    "value": "glória_d'oeste_mt",
    "label": "Glória d'Oeste - MT"
  },
  {
    "value": "glória_de_dourados_ms",
    "label": "Glória de Dourados - MS"
  },
  {
    "value": "glória_do_goitá_pe",
    "label": "Glória do Goitá - PE"
  },
  {
    "value": "godofredo_viana_ma",
    "label": "Godofredo Viana - MA"
  },
  {
    "value": "godoy_moreira_pr",
    "label": "Godoy Moreira - PR"
  },
  {
    "value": "goiabeira_mg",
    "label": "Goiabeira - MG"
  },
  {
    "value": "goiana_pe",
    "label": "Goiana - PE"
  },
  {
    "value": "goiandira_go",
    "label": "Goiandira - GO"
  },
  {
    "value": "goianinha_rn",
    "label": "Goianinha - RN"
  },
  {
    "value": "goianira_go",
    "label": "Goianira - GO"
  },
  {
    "value": "goianorte_to",
    "label": "Goianorte - TO"
  },
  {
    "value": "goianá_mg",
    "label": "Goianá - MG"
  },
  {
    "value": "goianápolis_go",
    "label": "Goianápolis - GO"
  },
  {
    "value": "goianésia_go",
    "label": "Goianésia - GO"
  },
  {
    "value": "goianésia_do_pará_pa",
    "label": "Goianésia do Pará - PA"
  },
  {
    "value": "goiatins_to",
    "label": "Goiatins - TO"
  },
  {
    "value": "goiatuba_go",
    "label": "Goiatuba - GO"
  },
  {
    "value": "goioerê_pr",
    "label": "Goioerê - PR"
  },
  {
    "value": "goioxim_pr",
    "label": "Goioxim - PR"
  },
  {
    "value": "goiás_go",
    "label": "Goiás - GO"
  },
  {
    "value": "goiânia_go",
    "label": "Goiânia - GO"
  },
  {
    "value": "gongogi_ba",
    "label": "Gongogi - BA"
  },
  {
    "value": "gonzaga_mg",
    "label": "Gonzaga - MG"
  },
  {
    "value": "gonçalves_mg",
    "label": "Gonçalves - MG"
  },
  {
    "value": "gonçalves_dias_ma",
    "label": "Gonçalves Dias - MA"
  },
  {
    "value": "gouveia_mg",
    "label": "Gouveia - MG"
  },
  {
    "value": "gouvelândia_go",
    "label": "Gouvelândia - GO"
  },
  {
    "value": "governador_archer_ma",
    "label": "Governador Archer - MA"
  },
  {
    "value": "governador_celso_ramos_sc",
    "label": "Governador Celso Ramos - SC"
  },
  {
    "value": "governador_dix-sept_rosado_rn",
    "label": "Governador Dix-Sept Rosado - RN"
  },
  {
    "value": "governador_edison_lobão_ma",
    "label": "Governador Edison Lobão - MA"
  },
  {
    "value": "governador_eugênio_barros_ma",
    "label": "Governador Eugênio Barros - MA"
  },
  {
    "value": "governador_jorge_teixeira_ro",
    "label": "Governador Jorge Teixeira - RO"
  },
  {
    "value": "governador_lindenberg_es",
    "label": "Governador Lindenberg - ES"
  },
  {
    "value": "governador_luiz_rocha_ma",
    "label": "Governador Luiz Rocha - MA"
  },
  {
    "value": "governador_mangabeira_ba",
    "label": "Governador Mangabeira - BA"
  },
  {
    "value": "governador_newton_bello_ma",
    "label": "Governador Newton Bello - MA"
  },
  {
    "value": "governador_nunes_freire_ma",
    "label": "Governador Nunes Freire - MA"
  },
  {
    "value": "governador_valadares_mg",
    "label": "Governador Valadares - MG"
  },
  {
    "value": "gracho_cardoso_se",
    "label": "Gracho Cardoso - SE"
  },
  {
    "value": "grajaú_ma",
    "label": "Grajaú - MA"
  },
  {
    "value": "gramado_rs",
    "label": "Gramado - RS"
  },
  {
    "value": "gramado_xavier_rs",
    "label": "Gramado Xavier - RS"
  },
  {
    "value": "gramado_dos_loureiros_rs",
    "label": "Gramado dos Loureiros - RS"
  },
  {
    "value": "grandes_rios_pr",
    "label": "Grandes Rios - PR"
  },
  {
    "value": "granito_pe",
    "label": "Granito - PE"
  },
  {
    "value": "granja_ce",
    "label": "Granja - CE"
  },
  {
    "value": "granjeiro_ce",
    "label": "Granjeiro - CE"
  },
  {
    "value": "gravatal_sc",
    "label": "Gravatal - SC"
  },
  {
    "value": "gravataí_rs",
    "label": "Gravataí - RS"
  },
  {
    "value": "gravatá_pe",
    "label": "Gravatá - PE"
  },
  {
    "value": "graça_ce",
    "label": "Graça - CE"
  },
  {
    "value": "graça_aranha_ma",
    "label": "Graça Aranha - MA"
  },
  {
    "value": "groaíras_ce",
    "label": "Groaíras - CE"
  },
  {
    "value": "grossos_rn",
    "label": "Grossos - RN"
  },
  {
    "value": "grupiara_mg",
    "label": "Grupiara - MG"
  },
  {
    "value": "grão_mogol_mg",
    "label": "Grão Mogol - MG"
  },
  {
    "value": "grão_pará_sc",
    "label": "Grão Pará - SC"
  },
  {
    "value": "guabiju_rs",
    "label": "Guabiju - RS"
  },
  {
    "value": "guabiruba_sc",
    "label": "Guabiruba - SC"
  },
  {
    "value": "guadalupe_pi",
    "label": "Guadalupe - PI"
  },
  {
    "value": "guaimbê_sp",
    "label": "Guaimbê - SP"
  },
  {
    "value": "guairaçá_pr",
    "label": "Guairaçá - PR"
  },
  {
    "value": "guaiçara_sp",
    "label": "Guaiçara - SP"
  },
  {
    "value": "guaiúba_ce",
    "label": "Guaiúba - CE"
  },
  {
    "value": "guajará_am",
    "label": "Guajará - AM"
  },
  {
    "value": "guajará-mirim_ro",
    "label": "Guajará-Mirim - RO"
  },
  {
    "value": "guajeru_ba",
    "label": "Guajeru - BA"
  },
  {
    "value": "guamaré_rn",
    "label": "Guamaré - RN"
  },
  {
    "value": "guamiranga_pr",
    "label": "Guamiranga - PR"
  },
  {
    "value": "guanambi_ba",
    "label": "Guanambi - BA"
  },
  {
    "value": "guanhães_mg",
    "label": "Guanhães - MG"
  },
  {
    "value": "guapiara_sp",
    "label": "Guapiara - SP"
  },
  {
    "value": "guapiaçu_sp",
    "label": "Guapiaçu - SP"
  },
  {
    "value": "guapimirim_rj",
    "label": "Guapimirim - RJ"
  },
  {
    "value": "guapirama_pr",
    "label": "Guapirama - PR"
  },
  {
    "value": "guaporema_pr",
    "label": "Guaporema - PR"
  },
  {
    "value": "guaporé_rs",
    "label": "Guaporé - RS"
  },
  {
    "value": "guapé_mg",
    "label": "Guapé - MG"
  },
  {
    "value": "guapó_go",
    "label": "Guapó - GO"
  },
  {
    "value": "guarabira_pb",
    "label": "Guarabira - PB"
  },
  {
    "value": "guaraci_pr",
    "label": "Guaraci - PR"
  },
  {
    "value": "guaraci_sp",
    "label": "Guaraci - SP"
  },
  {
    "value": "guaraciaba_mg",
    "label": "Guaraciaba - MG"
  },
  {
    "value": "guaraciaba_sc",
    "label": "Guaraciaba - SC"
  },
  {
    "value": "guaraciaba_do_norte_ce",
    "label": "Guaraciaba do Norte - CE"
  },
  {
    "value": "guaraciama_mg",
    "label": "Guaraciama - MG"
  },
  {
    "value": "guaramiranga_ce",
    "label": "Guaramiranga - CE"
  },
  {
    "value": "guaramirim_sc",
    "label": "Guaramirim - SC"
  },
  {
    "value": "guarani_mg",
    "label": "Guarani - MG"
  },
  {
    "value": "guarani_d'oeste_sp",
    "label": "Guarani d'Oeste - SP"
  },
  {
    "value": "guarani_das_missões_rs",
    "label": "Guarani das Missões - RS"
  },
  {
    "value": "guarani_de_goiás_go",
    "label": "Guarani de Goiás - GO"
  },
  {
    "value": "guaraniaçu_pr",
    "label": "Guaraniaçu - PR"
  },
  {
    "value": "guarantã_sp",
    "label": "Guarantã - SP"
  },
  {
    "value": "guarantã_do_norte_mt",
    "label": "Guarantã do Norte - MT"
  },
  {
    "value": "guaranésia_mg",
    "label": "Guaranésia - MG"
  },
  {
    "value": "guarapari_es",
    "label": "Guarapari - ES"
  },
  {
    "value": "guarapuava_pr",
    "label": "Guarapuava - PR"
  },
  {
    "value": "guaraqueçaba_pr",
    "label": "Guaraqueçaba - PR"
  },
  {
    "value": "guararapes_sp",
    "label": "Guararapes - SP"
  },
  {
    "value": "guararema_sp",
    "label": "Guararema - SP"
  },
  {
    "value": "guarará_mg",
    "label": "Guarará - MG"
  },
  {
    "value": "guaratinga_ba",
    "label": "Guaratinga - BA"
  },
  {
    "value": "guaratinguetá_sp",
    "label": "Guaratinguetá - SP"
  },
  {
    "value": "guaratuba_pr",
    "label": "Guaratuba - PR"
  },
  {
    "value": "guaraçaí_sp",
    "label": "Guaraçaí - SP"
  },
  {
    "value": "guaraí_to",
    "label": "Guaraí - TO"
  },
  {
    "value": "guaraíta_go",
    "label": "Guaraíta - GO"
  },
  {
    "value": "guarda-mor_mg",
    "label": "Guarda-Mor - MG"
  },
  {
    "value": "guareí_sp",
    "label": "Guareí - SP"
  },
  {
    "value": "guariba_sp",
    "label": "Guariba - SP"
  },
  {
    "value": "guaribas_pi",
    "label": "Guaribas - PI"
  },
  {
    "value": "guarinos_go",
    "label": "Guarinos - GO"
  },
  {
    "value": "guarujá_sp",
    "label": "Guarujá - SP"
  },
  {
    "value": "guarujá_do_sul_sc",
    "label": "Guarujá do Sul - SC"
  },
  {
    "value": "guarulhos_sp",
    "label": "Guarulhos - SP"
  },
  {
    "value": "guará_sp",
    "label": "Guará - SP"
  },
  {
    "value": "guatambú_sc",
    "label": "Guatambú - SC"
  },
  {
    "value": "guatapará_sp",
    "label": "Guatapará - SP"
  },
  {
    "value": "guaxupé_mg",
    "label": "Guaxupé - MG"
  },
  {
    "value": "guaçuí_es",
    "label": "Guaçuí - ES"
  },
  {
    "value": "guaíba_rs",
    "label": "Guaíba - RS"
  },
  {
    "value": "guaíra_pr",
    "label": "Guaíra - PR"
  },
  {
    "value": "guaíra_sp",
    "label": "Guaíra - SP"
  },
  {
    "value": "guia_lopes_da_laguna_ms",
    "label": "Guia Lopes da Laguna - MS"
  },
  {
    "value": "guidoval_mg",
    "label": "Guidoval - MG"
  },
  {
    "value": "guimarânia_mg",
    "label": "Guimarânia - MG"
  },
  {
    "value": "guimarães_ma",
    "label": "Guimarães - MA"
  },
  {
    "value": "guiratinga_mt",
    "label": "Guiratinga - MT"
  },
  {
    "value": "guiricema_mg",
    "label": "Guiricema - MG"
  },
  {
    "value": "gurinhatã_mg",
    "label": "Gurinhatã - MG"
  },
  {
    "value": "gurinhém_pb",
    "label": "Gurinhém - PB"
  },
  {
    "value": "gurjão_pb",
    "label": "Gurjão - PB"
  },
  {
    "value": "gurupi_to",
    "label": "Gurupi - TO"
  },
  {
    "value": "gurupá_pa",
    "label": "Gurupá - PA"
  },
  {
    "value": "guzolândia_sp",
    "label": "Guzolândia - SP"
  },
  {
    "value": "gália_sp",
    "label": "Gália - SP"
  },
  {
    "value": "harmonia_rs",
    "label": "Harmonia - RS"
  },
  {
    "value": "heitoraí_go",
    "label": "Heitoraí - GO"
  },
  {
    "value": "heliodora_mg",
    "label": "Heliodora - MG"
  },
  {
    "value": "heliópolis_ba",
    "label": "Heliópolis - BA"
  },
  {
    "value": "herculândia_sp",
    "label": "Herculândia - SP"
  },
  {
    "value": "herval_rs",
    "label": "Herval - RS"
  },
  {
    "value": "herval_d'oeste_sc",
    "label": "Herval d'Oeste - SC"
  },
  {
    "value": "herveiras_rs",
    "label": "Herveiras - RS"
  },
  {
    "value": "hidrolina_go",
    "label": "Hidrolina - GO"
  },
  {
    "value": "hidrolândia_ce",
    "label": "Hidrolândia - CE"
  },
  {
    "value": "hidrolândia_go",
    "label": "Hidrolândia - GO"
  },
  {
    "value": "holambra_sp",
    "label": "Holambra - SP"
  },
  {
    "value": "honório_serpa_pr",
    "label": "Honório Serpa - PR"
  },
  {
    "value": "horizonte_ce",
    "label": "Horizonte - CE"
  },
  {
    "value": "horizontina_rs",
    "label": "Horizontina - RS"
  },
  {
    "value": "hortolândia_sp",
    "label": "Hortolândia - SP"
  },
  {
    "value": "hugo_napoleão_pi",
    "label": "Hugo Napoleão - PI"
  },
  {
    "value": "hulha_negra_rs",
    "label": "Hulha Negra - RS"
  },
  {
    "value": "humaitá_am",
    "label": "Humaitá - AM"
  },
  {
    "value": "humaitá_rs",
    "label": "Humaitá - RS"
  },
  {
    "value": "humberto_de_campos_ma",
    "label": "Humberto de Campos - MA"
  },
  {
    "value": "iacanga_sp",
    "label": "Iacanga - SP"
  },
  {
    "value": "iaciara_go",
    "label": "Iaciara - GO"
  },
  {
    "value": "iacri_sp",
    "label": "Iacri - SP"
  },
  {
    "value": "iapu_mg",
    "label": "Iapu - MG"
  },
  {
    "value": "iaras_sp",
    "label": "Iaras - SP"
  },
  {
    "value": "iati_pe",
    "label": "Iati - PE"
  },
  {
    "value": "iaçu_ba",
    "label": "Iaçu - BA"
  },
  {
    "value": "ibaiti_pr",
    "label": "Ibaiti - PR"
  },
  {
    "value": "ibarama_rs",
    "label": "Ibarama - RS"
  },
  {
    "value": "ibaretama_ce",
    "label": "Ibaretama - CE"
  },
  {
    "value": "ibateguara_al",
    "label": "Ibateguara - AL"
  },
  {
    "value": "ibatiba_es",
    "label": "Ibatiba - ES"
  },
  {
    "value": "ibaté_sp",
    "label": "Ibaté - SP"
  },
  {
    "value": "ibema_pr",
    "label": "Ibema - PR"
  },
  {
    "value": "ibertioga_mg",
    "label": "Ibertioga - MG"
  },
  {
    "value": "ibiam_sc",
    "label": "Ibiam - SC"
  },
  {
    "value": "ibiapina_ce",
    "label": "Ibiapina - CE"
  },
  {
    "value": "ibiara_pb",
    "label": "Ibiara - PB"
  },
  {
    "value": "ibiassucê_ba",
    "label": "Ibiassucê - BA"
  },
  {
    "value": "ibiaçá_rs",
    "label": "Ibiaçá - RS"
  },
  {
    "value": "ibiaí_mg",
    "label": "Ibiaí - MG"
  },
  {
    "value": "ibicaraí_ba",
    "label": "Ibicaraí - BA"
  },
  {
    "value": "ibicaré_sc",
    "label": "Ibicaré - SC"
  },
  {
    "value": "ibicoara_ba",
    "label": "Ibicoara - BA"
  },
  {
    "value": "ibicuitinga_ce",
    "label": "Ibicuitinga - CE"
  },
  {
    "value": "ibicuí_ba",
    "label": "Ibicuí - BA"
  },
  {
    "value": "ibimirim_pe",
    "label": "Ibimirim - PE"
  },
  {
    "value": "ibipeba_ba",
    "label": "Ibipeba - BA"
  },
  {
    "value": "ibipitanga_ba",
    "label": "Ibipitanga - BA"
  },
  {
    "value": "ibiporã_pr",
    "label": "Ibiporã - PR"
  },
  {
    "value": "ibiquera_ba",
    "label": "Ibiquera - BA"
  },
  {
    "value": "ibiracatu_mg",
    "label": "Ibiracatu - MG"
  },
  {
    "value": "ibiraci_mg",
    "label": "Ibiraci - MG"
  },
  {
    "value": "ibiraiaras_rs",
    "label": "Ibiraiaras - RS"
  },
  {
    "value": "ibirajuba_pe",
    "label": "Ibirajuba - PE"
  },
  {
    "value": "ibirama_sc",
    "label": "Ibirama - SC"
  },
  {
    "value": "ibirapitanga_ba",
    "label": "Ibirapitanga - BA"
  },
  {
    "value": "ibirapuitã_rs",
    "label": "Ibirapuitã - RS"
  },
  {
    "value": "ibirapuã_ba",
    "label": "Ibirapuã - BA"
  },
  {
    "value": "ibirarema_sp",
    "label": "Ibirarema - SP"
  },
  {
    "value": "ibirataia_ba",
    "label": "Ibirataia - BA"
  },
  {
    "value": "ibiraçu_es",
    "label": "Ibiraçu - ES"
  },
  {
    "value": "ibirité_mg",
    "label": "Ibirité - MG"
  },
  {
    "value": "ibirubá_rs",
    "label": "Ibirubá - RS"
  },
  {
    "value": "ibirá_sp",
    "label": "Ibirá - SP"
  },
  {
    "value": "ibitiara_ba",
    "label": "Ibitiara - BA"
  },
  {
    "value": "ibitinga_sp",
    "label": "Ibitinga - SP"
  },
  {
    "value": "ibitirama_es",
    "label": "Ibitirama - ES"
  },
  {
    "value": "ibititá_ba",
    "label": "Ibititá - BA"
  },
  {
    "value": "ibitiúra_de_minas_mg",
    "label": "Ibitiúra de Minas - MG"
  },
  {
    "value": "ibituruna_mg",
    "label": "Ibituruna - MG"
  },
  {
    "value": "ibiá_mg",
    "label": "Ibiá - MG"
  },
  {
    "value": "ibiúna_sp",
    "label": "Ibiúna - SP"
  },
  {
    "value": "ibotirama_ba",
    "label": "Ibotirama - BA"
  },
  {
    "value": "icapuí_ce",
    "label": "Icapuí - CE"
  },
  {
    "value": "icaraí_de_minas_mg",
    "label": "Icaraí de Minas - MG"
  },
  {
    "value": "icaraíma_pr",
    "label": "Icaraíma - PR"
  },
  {
    "value": "icatu_ma",
    "label": "Icatu - MA"
  },
  {
    "value": "ichu_ba",
    "label": "Ichu - BA"
  },
  {
    "value": "iconha_es",
    "label": "Iconha - ES"
  },
  {
    "value": "icém_sp",
    "label": "Icém - SP"
  },
  {
    "value": "icó_ce",
    "label": "Icó - CE"
  },
  {
    "value": "ielmo_marinho_rn",
    "label": "Ielmo Marinho - RN"
  },
  {
    "value": "iepê_sp",
    "label": "Iepê - SP"
  },
  {
    "value": "igaci_al",
    "label": "Igaci - AL"
  },
  {
    "value": "igaporã_ba",
    "label": "Igaporã - BA"
  },
  {
    "value": "igaracy_pb",
    "label": "Igaracy - PB"
  },
  {
    "value": "igarapava_sp",
    "label": "Igarapava - SP"
  },
  {
    "value": "igarapé_mg",
    "label": "Igarapé - MG"
  },
  {
    "value": "igarapé_grande_ma",
    "label": "Igarapé Grande - MA"
  },
  {
    "value": "igarapé_do_meio_ma",
    "label": "Igarapé do Meio - MA"
  },
  {
    "value": "igarapé-açu_pa",
    "label": "Igarapé-Açu - PA"
  },
  {
    "value": "igarapé-miri_pa",
    "label": "Igarapé-Miri - PA"
  },
  {
    "value": "igarassu_pe",
    "label": "Igarassu - PE"
  },
  {
    "value": "igaratinga_mg",
    "label": "Igaratinga - MG"
  },
  {
    "value": "igaratá_sp",
    "label": "Igaratá - SP"
  },
  {
    "value": "igaraçu_do_tietê_sp",
    "label": "Igaraçu do Tietê - SP"
  },
  {
    "value": "igrapiúna_ba",
    "label": "Igrapiúna - BA"
  },
  {
    "value": "igreja_nova_al",
    "label": "Igreja Nova - AL"
  },
  {
    "value": "igrejinha_rs",
    "label": "Igrejinha - RS"
  },
  {
    "value": "iguaba_grande_rj",
    "label": "Iguaba Grande - RJ"
  },
  {
    "value": "iguape_sp",
    "label": "Iguape - SP"
  },
  {
    "value": "iguaraci_pe",
    "label": "Iguaraci - PE"
  },
  {
    "value": "iguaraçu_pr",
    "label": "Iguaraçu - PR"
  },
  {
    "value": "iguatama_mg",
    "label": "Iguatama - MG"
  },
  {
    "value": "iguatemi_ms",
    "label": "Iguatemi - MS"
  },
  {
    "value": "iguatu_ce",
    "label": "Iguatu - CE"
  },
  {
    "value": "iguatu_pr",
    "label": "Iguatu - PR"
  },
  {
    "value": "iguaí_ba",
    "label": "Iguaí - BA"
  },
  {
    "value": "ijaci_mg",
    "label": "Ijaci - MG"
  },
  {
    "value": "ijuí_rs",
    "label": "Ijuí - RS"
  },
  {
    "value": "ilha_comprida_sp",
    "label": "Ilha Comprida - SP"
  },
  {
    "value": "ilha_grande_pi",
    "label": "Ilha Grande - PI"
  },
  {
    "value": "ilha_solteira_sp",
    "label": "Ilha Solteira - SP"
  },
  {
    "value": "ilha_das_flores_se",
    "label": "Ilha das Flores - SE"
  },
  {
    "value": "ilhabela_sp",
    "label": "Ilhabela - SP"
  },
  {
    "value": "ilhota_sc",
    "label": "Ilhota - SC"
  },
  {
    "value": "ilhéus_ba",
    "label": "Ilhéus - BA"
  },
  {
    "value": "ilicínea_mg",
    "label": "Ilicínea - MG"
  },
  {
    "value": "ilópolis_rs",
    "label": "Ilópolis - RS"
  },
  {
    "value": "imaculada_pb",
    "label": "Imaculada - PB"
  },
  {
    "value": "imaruí_sc",
    "label": "Imaruí - SC"
  },
  {
    "value": "imbaú_pr",
    "label": "Imbaú - PR"
  },
  {
    "value": "imbituba_sc",
    "label": "Imbituba - SC"
  },
  {
    "value": "imbituva_pr",
    "label": "Imbituva - PR"
  },
  {
    "value": "imbuia_sc",
    "label": "Imbuia - SC"
  },
  {
    "value": "imbé_rs",
    "label": "Imbé - RS"
  },
  {
    "value": "imbé_de_minas_mg",
    "label": "Imbé de Minas - MG"
  },
  {
    "value": "imigrante_rs",
    "label": "Imigrante - RS"
  },
  {
    "value": "imperatriz_ma",
    "label": "Imperatriz - MA"
  },
  {
    "value": "inaciolândia_go",
    "label": "Inaciolândia - GO"
  },
  {
    "value": "inajá_pe",
    "label": "Inajá - PE"
  },
  {
    "value": "inajá_pr",
    "label": "Inajá - PR"
  },
  {
    "value": "inconfidentes_mg",
    "label": "Inconfidentes - MG"
  },
  {
    "value": "indaiabira_mg",
    "label": "Indaiabira - MG"
  },
  {
    "value": "indaial_sc",
    "label": "Indaial - SC"
  },
  {
    "value": "indaiatuba_sp",
    "label": "Indaiatuba - SP"
  },
  {
    "value": "independência_ce",
    "label": "Independência - CE"
  },
  {
    "value": "independência_rs",
    "label": "Independência - RS"
  },
  {
    "value": "indiana_sp",
    "label": "Indiana - SP"
  },
  {
    "value": "indianópolis_mg",
    "label": "Indianópolis - MG"
  },
  {
    "value": "indianópolis_pr",
    "label": "Indianópolis - PR"
  },
  {
    "value": "indiaporã_sp",
    "label": "Indiaporã - SP"
  },
  {
    "value": "indiara_go",
    "label": "Indiara - GO"
  },
  {
    "value": "indiaroba_se",
    "label": "Indiaroba - SE"
  },
  {
    "value": "indiavaí_mt",
    "label": "Indiavaí - MT"
  },
  {
    "value": "ingazeira_pe",
    "label": "Ingazeira - PE"
  },
  {
    "value": "ingaí_mg",
    "label": "Ingaí - MG"
  },
  {
    "value": "ingá_pb",
    "label": "Ingá - PB"
  },
  {
    "value": "inhacorá_rs",
    "label": "Inhacorá - RS"
  },
  {
    "value": "inhambupe_ba",
    "label": "Inhambupe - BA"
  },
  {
    "value": "inhangapi_pa",
    "label": "Inhangapi - PA"
  },
  {
    "value": "inhapi_al",
    "label": "Inhapi - AL"
  },
  {
    "value": "inhapim_mg",
    "label": "Inhapim - MG"
  },
  {
    "value": "inhaúma_mg",
    "label": "Inhaúma - MG"
  },
  {
    "value": "inhuma_pi",
    "label": "Inhuma - PI"
  },
  {
    "value": "inhumas_go",
    "label": "Inhumas - GO"
  },
  {
    "value": "inimutaba_mg",
    "label": "Inimutaba - MG"
  },
  {
    "value": "inocência_ms",
    "label": "Inocência - MS"
  },
  {
    "value": "inácio_martins_pr",
    "label": "Inácio Martins - PR"
  },
  {
    "value": "inúbia_paulista_sp",
    "label": "Inúbia Paulista - SP"
  },
  {
    "value": "iomerê_sc",
    "label": "Iomerê - SC"
  },
  {
    "value": "ipaba_mg",
    "label": "Ipaba - MG"
  },
  {
    "value": "ipameri_go",
    "label": "Ipameri - GO"
  },
  {
    "value": "ipanema_mg",
    "label": "Ipanema - MG"
  },
  {
    "value": "ipanguaçu_rn",
    "label": "Ipanguaçu - RN"
  },
  {
    "value": "ipaporanga_ce",
    "label": "Ipaporanga - CE"
  },
  {
    "value": "ipatinga_mg",
    "label": "Ipatinga - MG"
  },
  {
    "value": "ipaumirim_ce",
    "label": "Ipaumirim - CE"
  },
  {
    "value": "ipauçu_sp",
    "label": "Ipauçu - SP"
  },
  {
    "value": "ipecaetá_ba",
    "label": "Ipecaetá - BA"
  },
  {
    "value": "iperó_sp",
    "label": "Iperó - SP"
  },
  {
    "value": "ipeúna_sp",
    "label": "Ipeúna - SP"
  },
  {
    "value": "ipiaçu_mg",
    "label": "Ipiaçu - MG"
  },
  {
    "value": "ipiaú_ba",
    "label": "Ipiaú - BA"
  },
  {
    "value": "ipiguá_sp",
    "label": "Ipiguá - SP"
  },
  {
    "value": "ipira_sc",
    "label": "Ipira - SC"
  },
  {
    "value": "ipiranga_pr",
    "label": "Ipiranga - PR"
  },
  {
    "value": "ipiranga_de_goiás_go",
    "label": "Ipiranga de Goiás - GO"
  },
  {
    "value": "ipiranga_do_piauí_pi",
    "label": "Ipiranga do Piauí - PI"
  },
  {
    "value": "ipiranga_do_sul_rs",
    "label": "Ipiranga do Sul - RS"
  },
  {
    "value": "ipirá_ba",
    "label": "Ipirá - BA"
  },
  {
    "value": "ipixuna_am",
    "label": "Ipixuna - AM"
  },
  {
    "value": "ipixuna_do_pará_pa",
    "label": "Ipixuna do Pará - PA"
  },
  {
    "value": "ipojuca_pe",
    "label": "Ipojuca - PE"
  },
  {
    "value": "iporanga_sp",
    "label": "Iporanga - SP"
  },
  {
    "value": "iporá_go",
    "label": "Iporá - GO"
  },
  {
    "value": "iporã_pr",
    "label": "Iporã - PR"
  },
  {
    "value": "iporã_do_oeste_sc",
    "label": "Iporã do Oeste - SC"
  },
  {
    "value": "ipu_ce",
    "label": "Ipu - CE"
  },
  {
    "value": "ipuaçu_sc",
    "label": "Ipuaçu - SC"
  },
  {
    "value": "ipubi_pe",
    "label": "Ipubi - PE"
  },
  {
    "value": "ipueira_rn",
    "label": "Ipueira - RN"
  },
  {
    "value": "ipueiras_ce",
    "label": "Ipueiras - CE"
  },
  {
    "value": "ipueiras_to",
    "label": "Ipueiras - TO"
  },
  {
    "value": "ipuiúna_mg",
    "label": "Ipuiúna - MG"
  },
  {
    "value": "ipumirim_sc",
    "label": "Ipumirim - SC"
  },
  {
    "value": "ipupiara_ba",
    "label": "Ipupiara - BA"
  },
  {
    "value": "ipuã_sp",
    "label": "Ipuã - SP"
  },
  {
    "value": "ipê_rs",
    "label": "Ipê - RS"
  },
  {
    "value": "iracema_ce",
    "label": "Iracema - CE"
  },
  {
    "value": "iracema_rr",
    "label": "Iracema - RR"
  },
  {
    "value": "iracema_do_oeste_pr",
    "label": "Iracema do Oeste - PR"
  },
  {
    "value": "iraceminha_sc",
    "label": "Iraceminha - SC"
  },
  {
    "value": "iracemápolis_sp",
    "label": "Iracemápolis - SP"
  },
  {
    "value": "irajuba_ba",
    "label": "Irajuba - BA"
  },
  {
    "value": "iramaia_ba",
    "label": "Iramaia - BA"
  },
  {
    "value": "iranduba_am",
    "label": "Iranduba - AM"
  },
  {
    "value": "irani_sc",
    "label": "Irani - SC"
  },
  {
    "value": "irapuru_sp",
    "label": "Irapuru - SP"
  },
  {
    "value": "irapuã_sp",
    "label": "Irapuã - SP"
  },
  {
    "value": "iraquara_ba",
    "label": "Iraquara - BA"
  },
  {
    "value": "irará_ba",
    "label": "Irará - BA"
  },
  {
    "value": "irati_pr",
    "label": "Irati - PR"
  },
  {
    "value": "irati_sc",
    "label": "Irati - SC"
  },
  {
    "value": "irauçuba_ce",
    "label": "Irauçuba - CE"
  },
  {
    "value": "iraí_rs",
    "label": "Iraí - RS"
  },
  {
    "value": "iraí_de_minas_mg",
    "label": "Iraí de Minas - MG"
  },
  {
    "value": "irecê_ba",
    "label": "Irecê - BA"
  },
  {
    "value": "iretama_pr",
    "label": "Iretama - PR"
  },
  {
    "value": "irineópolis_sc",
    "label": "Irineópolis - SC"
  },
  {
    "value": "irituia_pa",
    "label": "Irituia - PA"
  },
  {
    "value": "irupi_es",
    "label": "Irupi - ES"
  },
  {
    "value": "isaías_coelho_pi",
    "label": "Isaías Coelho - PI"
  },
  {
    "value": "israelândia_go",
    "label": "Israelândia - GO"
  },
  {
    "value": "itaara_rs",
    "label": "Itaara - RS"
  },
  {
    "value": "itabaiana_pb",
    "label": "Itabaiana - PB"
  },
  {
    "value": "itabaiana_se",
    "label": "Itabaiana - SE"
  },
  {
    "value": "itabaianinha_se",
    "label": "Itabaianinha - SE"
  },
  {
    "value": "itabela_ba",
    "label": "Itabela - BA"
  },
  {
    "value": "itaberaba_ba",
    "label": "Itaberaba - BA"
  },
  {
    "value": "itaberaí_go",
    "label": "Itaberaí - GO"
  },
  {
    "value": "itaberá_sp",
    "label": "Itaberá - SP"
  },
  {
    "value": "itabi_se",
    "label": "Itabi - SE"
  },
  {
    "value": "itabira_mg",
    "label": "Itabira - MG"
  },
  {
    "value": "itabirinha_de_mantena_mg",
    "label": "Itabirinha de Mantena - MG"
  },
  {
    "value": "itabirito_mg",
    "label": "Itabirito - MG"
  },
  {
    "value": "itaboraí_rj",
    "label": "Itaboraí - RJ"
  },
  {
    "value": "itabuna_ba",
    "label": "Itabuna - BA"
  },
  {
    "value": "itacajá_to",
    "label": "Itacajá - TO"
  },
  {
    "value": "itacambira_mg",
    "label": "Itacambira - MG"
  },
  {
    "value": "itacarambi_mg",
    "label": "Itacarambi - MG"
  },
  {
    "value": "itacaré_ba",
    "label": "Itacaré - BA"
  },
  {
    "value": "itacoatiara_am",
    "label": "Itacoatiara - AM"
  },
  {
    "value": "itacuruba_pe",
    "label": "Itacuruba - PE"
  },
  {
    "value": "itacurubi_rs",
    "label": "Itacurubi - RS"
  },
  {
    "value": "itaeté_ba",
    "label": "Itaeté - BA"
  },
  {
    "value": "itagi_ba",
    "label": "Itagi - BA"
  },
  {
    "value": "itagibá_ba",
    "label": "Itagibá - BA"
  },
  {
    "value": "itagimirim_ba",
    "label": "Itagimirim - BA"
  },
  {
    "value": "itaguajé_pr",
    "label": "Itaguajé - PR"
  },
  {
    "value": "itaguara_mg",
    "label": "Itaguara - MG"
  },
  {
    "value": "itaguari_go",
    "label": "Itaguari - GO"
  },
  {
    "value": "itaguaru_go",
    "label": "Itaguaru - GO"
  },
  {
    "value": "itaguatins_to",
    "label": "Itaguatins - TO"
  },
  {
    "value": "itaguaçu_es",
    "label": "Itaguaçu - ES"
  },
  {
    "value": "itaguaçu_da_bahia_ba",
    "label": "Itaguaçu da Bahia - BA"
  },
  {
    "value": "itaguaí_rj",
    "label": "Itaguaí - RJ"
  },
  {
    "value": "itainópolis_pi",
    "label": "Itainópolis - PI"
  },
  {
    "value": "itaipava_do_grajaú_ma",
    "label": "Itaipava do Grajaú - MA"
  },
  {
    "value": "itaipulândia_pr",
    "label": "Itaipulândia - PR"
  },
  {
    "value": "itaipé_mg",
    "label": "Itaipé - MG"
  },
  {
    "value": "itaitinga_ce",
    "label": "Itaitinga - CE"
  },
  {
    "value": "itaituba_pa",
    "label": "Itaituba - PA"
  },
  {
    "value": "itaiçaba_ce",
    "label": "Itaiçaba - CE"
  },
  {
    "value": "itaiópolis_sc",
    "label": "Itaiópolis - SC"
  },
  {
    "value": "itajaí_sc",
    "label": "Itajaí - SC"
  },
  {
    "value": "itajobi_sp",
    "label": "Itajobi - SP"
  },
  {
    "value": "itaju_sp",
    "label": "Itaju - SP"
  },
  {
    "value": "itaju_do_colônia_ba",
    "label": "Itaju do Colônia - BA"
  },
  {
    "value": "itajubá_mg",
    "label": "Itajubá - MG"
  },
  {
    "value": "itajuípe_ba",
    "label": "Itajuípe - BA"
  },
  {
    "value": "itajá_go",
    "label": "Itajá - GO"
  },
  {
    "value": "itajá_rn",
    "label": "Itajá - RN"
  },
  {
    "value": "italva_rj",
    "label": "Italva - RJ"
  },
  {
    "value": "itamaracá_pe",
    "label": "Itamaracá - PE"
  },
  {
    "value": "itamaraju_ba",
    "label": "Itamaraju - BA"
  },
  {
    "value": "itamarandiba_mg",
    "label": "Itamarandiba - MG"
  },
  {
    "value": "itamarati_am",
    "label": "Itamarati - AM"
  },
  {
    "value": "itamarati_de_minas_mg",
    "label": "Itamarati de Minas - MG"
  },
  {
    "value": "itamari_ba",
    "label": "Itamari - BA"
  },
  {
    "value": "itambacuri_mg",
    "label": "Itambacuri - MG"
  },
  {
    "value": "itambaracá_pr",
    "label": "Itambaracá - PR"
  },
  {
    "value": "itambé_ba",
    "label": "Itambé - BA"
  },
  {
    "value": "itambé_pe",
    "label": "Itambé - PE"
  },
  {
    "value": "itambé_pr",
    "label": "Itambé - PR"
  },
  {
    "value": "itambé_do_mato_dentro_mg",
    "label": "Itambé do Mato Dentro - MG"
  },
  {
    "value": "itamogi_mg",
    "label": "Itamogi - MG"
  },
  {
    "value": "itamonte_mg",
    "label": "Itamonte - MG"
  },
  {
    "value": "itanagra_ba",
    "label": "Itanagra - BA"
  },
  {
    "value": "itanhandu_mg",
    "label": "Itanhandu - MG"
  },
  {
    "value": "itanhaém_sp",
    "label": "Itanhaém - SP"
  },
  {
    "value": "itanhomi_mg",
    "label": "Itanhomi - MG"
  },
  {
    "value": "itanhém_ba",
    "label": "Itanhém - BA"
  },
  {
    "value": "itaobim_mg",
    "label": "Itaobim - MG"
  },
  {
    "value": "itaocara_rj",
    "label": "Itaocara - RJ"
  },
  {
    "value": "itapaci_go",
    "label": "Itapaci - GO"
  },
  {
    "value": "itapagipe_mg",
    "label": "Itapagipe - MG"
  },
  {
    "value": "itapagé_ce",
    "label": "Itapagé - CE"
  },
  {
    "value": "itaparica_ba",
    "label": "Itaparica - BA"
  },
  {
    "value": "itapebi_ba",
    "label": "Itapebi - BA"
  },
  {
    "value": "itapecerica_mg",
    "label": "Itapecerica - MG"
  },
  {
    "value": "itapecerica_da_serra_sp",
    "label": "Itapecerica da Serra - SP"
  },
  {
    "value": "itapecuru_mirim_ma",
    "label": "Itapecuru Mirim - MA"
  },
  {
    "value": "itapejara_d'oeste_pr",
    "label": "Itapejara d'Oeste - PR"
  },
  {
    "value": "itapema_sc",
    "label": "Itapema - SC"
  },
  {
    "value": "itapemirim_es",
    "label": "Itapemirim - ES"
  },
  {
    "value": "itaperuna_rj",
    "label": "Itaperuna - RJ"
  },
  {
    "value": "itaperuçu_pr",
    "label": "Itaperuçu - PR"
  },
  {
    "value": "itapetim_pe",
    "label": "Itapetim - PE"
  },
  {
    "value": "itapetinga_ba",
    "label": "Itapetinga - BA"
  },
  {
    "value": "itapetininga_sp",
    "label": "Itapetininga - SP"
  },
  {
    "value": "itapeva_mg",
    "label": "Itapeva - MG"
  },
  {
    "value": "itapeva_sp",
    "label": "Itapeva - SP"
  },
  {
    "value": "itapevi_sp",
    "label": "Itapevi - SP"
  },
  {
    "value": "itapicuru_ba",
    "label": "Itapicuru - BA"
  },
  {
    "value": "itapipoca_ce",
    "label": "Itapipoca - CE"
  },
  {
    "value": "itapira_sp",
    "label": "Itapira - SP"
  },
  {
    "value": "itapiranga_am",
    "label": "Itapiranga - AM"
  },
  {
    "value": "itapiranga_sc",
    "label": "Itapiranga - SC"
  },
  {
    "value": "itapirapuã_go",
    "label": "Itapirapuã - GO"
  },
  {
    "value": "itapirapuã_paulista_sp",
    "label": "Itapirapuã Paulista - SP"
  },
  {
    "value": "itapiratins_to",
    "label": "Itapiratins - TO"
  },
  {
    "value": "itapissuma_pe",
    "label": "Itapissuma - PE"
  },
  {
    "value": "itapitanga_ba",
    "label": "Itapitanga - BA"
  },
  {
    "value": "itapiúna_ce",
    "label": "Itapiúna - CE"
  },
  {
    "value": "itaporanga_pb",
    "label": "Itaporanga - PB"
  },
  {
    "value": "itaporanga_sp",
    "label": "Itaporanga - SP"
  },
  {
    "value": "itaporanga_d'ajuda_se",
    "label": "Itaporanga d'Ajuda - SE"
  },
  {
    "value": "itapororoca_pb",
    "label": "Itapororoca - PB"
  },
  {
    "value": "itaporã_ms",
    "label": "Itaporã - MS"
  },
  {
    "value": "itaporã_do_tocantins_to",
    "label": "Itaporã do Tocantins - TO"
  },
  {
    "value": "itapoá_sc",
    "label": "Itapoá - SC"
  },
  {
    "value": "itapuca_rs",
    "label": "Itapuca - RS"
  },
  {
    "value": "itapura_sp",
    "label": "Itapura - SP"
  },
  {
    "value": "itapuranga_go",
    "label": "Itapuranga - GO"
  },
  {
    "value": "itapuã_do_oeste_ro",
    "label": "Itapuã do Oeste - RO"
  },
  {
    "value": "itapuí_sp",
    "label": "Itapuí - SP"
  },
  {
    "value": "itapé_ba",
    "label": "Itapé - BA"
  },
  {
    "value": "itaquaquecetuba_sp",
    "label": "Itaquaquecetuba - SP"
  },
  {
    "value": "itaquara_ba",
    "label": "Itaquara - BA"
  },
  {
    "value": "itaqui_rs",
    "label": "Itaqui - RS"
  },
  {
    "value": "itaquiraí_ms",
    "label": "Itaquiraí - MS"
  },
  {
    "value": "itaquitinga_pe",
    "label": "Itaquitinga - PE"
  },
  {
    "value": "itarana_es",
    "label": "Itarana - ES"
  },
  {
    "value": "itarantim_ba",
    "label": "Itarantim - BA"
  },
  {
    "value": "itararé_sp",
    "label": "Itararé - SP"
  },
  {
    "value": "itarema_ce",
    "label": "Itarema - CE"
  },
  {
    "value": "itariri_sp",
    "label": "Itariri - SP"
  },
  {
    "value": "itarumã_go",
    "label": "Itarumã - GO"
  },
  {
    "value": "itati_rs",
    "label": "Itati - RS"
  },
  {
    "value": "itatiaia_rj",
    "label": "Itatiaia - RJ"
  },
  {
    "value": "itatiaiuçu_mg",
    "label": "Itatiaiuçu - MG"
  },
  {
    "value": "itatiba_sp",
    "label": "Itatiba - SP"
  },
  {
    "value": "itatiba_do_sul_rs",
    "label": "Itatiba do Sul - RS"
  },
  {
    "value": "itatim_ba",
    "label": "Itatim - BA"
  },
  {
    "value": "itatinga_sp",
    "label": "Itatinga - SP"
  },
  {
    "value": "itatira_ce",
    "label": "Itatira - CE"
  },
  {
    "value": "itatuba_pb",
    "label": "Itatuba - PB"
  },
  {
    "value": "itaubal_ap",
    "label": "Itaubal - AP"
  },
  {
    "value": "itaueira_pi",
    "label": "Itaueira - PI"
  },
  {
    "value": "itauçu_go",
    "label": "Itauçu - GO"
  },
  {
    "value": "itaverava_mg",
    "label": "Itaverava - MG"
  },
  {
    "value": "itaí_sp",
    "label": "Itaí - SP"
  },
  {
    "value": "itaíba_pe",
    "label": "Itaíba - PE"
  },
  {
    "value": "itaóca_sp",
    "label": "Itaóca - SP"
  },
  {
    "value": "itaú_rn",
    "label": "Itaú - RN"
  },
  {
    "value": "itaú_de_minas_mg",
    "label": "Itaú de Minas - MG"
  },
  {
    "value": "itaúba_mt",
    "label": "Itaúba - MT"
  },
  {
    "value": "itaúna_mg",
    "label": "Itaúna - MG"
  },
  {
    "value": "itaúna_do_sul_pr",
    "label": "Itaúna do Sul - PR"
  },
  {
    "value": "itinga_mg",
    "label": "Itinga - MG"
  },
  {
    "value": "itinga_do_maranhão_ma",
    "label": "Itinga do Maranhão - MA"
  },
  {
    "value": "itiquira_mt",
    "label": "Itiquira - MT"
  },
  {
    "value": "itirapina_sp",
    "label": "Itirapina - SP"
  },
  {
    "value": "itirapuã_sp",
    "label": "Itirapuã - SP"
  },
  {
    "value": "itiruçu_ba",
    "label": "Itiruçu - BA"
  },
  {
    "value": "itiúba_ba",
    "label": "Itiúba - BA"
  },
  {
    "value": "itobi_sp",
    "label": "Itobi - SP"
  },
  {
    "value": "itororó_ba",
    "label": "Itororó - BA"
  },
  {
    "value": "itu_sp",
    "label": "Itu - SP"
  },
  {
    "value": "ituaçu_ba",
    "label": "Ituaçu - BA"
  },
  {
    "value": "ituberá_ba",
    "label": "Ituberá - BA"
  },
  {
    "value": "itueta_mg",
    "label": "Itueta - MG"
  },
  {
    "value": "ituiutaba_mg",
    "label": "Ituiutaba - MG"
  },
  {
    "value": "itumbiara_go",
    "label": "Itumbiara - GO"
  },
  {
    "value": "itumirim_mg",
    "label": "Itumirim - MG"
  },
  {
    "value": "itupeva_sp",
    "label": "Itupeva - SP"
  },
  {
    "value": "itupiranga_pa",
    "label": "Itupiranga - PA"
  },
  {
    "value": "ituporanga_sc",
    "label": "Ituporanga - SC"
  },
  {
    "value": "iturama_mg",
    "label": "Iturama - MG"
  },
  {
    "value": "itutinga_mg",
    "label": "Itutinga - MG"
  },
  {
    "value": "ituverava_sp",
    "label": "Ituverava - SP"
  },
  {
    "value": "itá_sc",
    "label": "Itá - SC"
  },
  {
    "value": "itápolis_sp",
    "label": "Itápolis - SP"
  },
  {
    "value": "iuiú_ba",
    "label": "Iuiú - BA"
  },
  {
    "value": "ivaiporã_pr",
    "label": "Ivaiporã - PR"
  },
  {
    "value": "ivatuba_pr",
    "label": "Ivatuba - PR"
  },
  {
    "value": "ivaté_pr",
    "label": "Ivaté - PR"
  },
  {
    "value": "ivaí_pr",
    "label": "Ivaí - PR"
  },
  {
    "value": "ivinhema_ms",
    "label": "Ivinhema - MS"
  },
  {
    "value": "ivolândia_go",
    "label": "Ivolândia - GO"
  },
  {
    "value": "ivorá_rs",
    "label": "Ivorá - RS"
  },
  {
    "value": "ivoti_rs",
    "label": "Ivoti - RS"
  },
  {
    "value": "içara_sc",
    "label": "Içara - SC"
  },
  {
    "value": "iúna_es",
    "label": "Iúna - ES"
  },
  {
    "value": "jaboatão_dos_guararapes_pe",
    "label": "Jaboatão dos Guararapes - PE"
  },
  {
    "value": "jaborandi_ba",
    "label": "Jaborandi - BA"
  },
  {
    "value": "jaborandi_sp",
    "label": "Jaborandi - SP"
  },
  {
    "value": "jaborá_sc",
    "label": "Jaborá - SC"
  },
  {
    "value": "jaboti_pr",
    "label": "Jaboti - PR"
  },
  {
    "value": "jaboticaba_rs",
    "label": "Jaboticaba - RS"
  },
  {
    "value": "jaboticabal_sp",
    "label": "Jaboticabal - SP"
  },
  {
    "value": "jaboticatubas_mg",
    "label": "Jaboticatubas - MG"
  },
  {
    "value": "jacaraci_ba",
    "label": "Jacaraci - BA"
  },
  {
    "value": "jacaraú_pb",
    "label": "Jacaraú - PB"
  },
  {
    "value": "jacareacanga_pa",
    "label": "Jacareacanga - PA"
  },
  {
    "value": "jacarezinho_pr",
    "label": "Jacarezinho - PR"
  },
  {
    "value": "jacareí_sp",
    "label": "Jacareí - SP"
  },
  {
    "value": "jacaré_dos_homens_al",
    "label": "Jacaré dos Homens - AL"
  },
  {
    "value": "jaci_sp",
    "label": "Jaci - SP"
  },
  {
    "value": "jaciara_mt",
    "label": "Jaciara - MT"
  },
  {
    "value": "jacinto_mg",
    "label": "Jacinto - MG"
  },
  {
    "value": "jacinto_machado_sc",
    "label": "Jacinto Machado - SC"
  },
  {
    "value": "jacobina_ba",
    "label": "Jacobina - BA"
  },
  {
    "value": "jacobina_do_piauí_pi",
    "label": "Jacobina do Piauí - PI"
  },
  {
    "value": "jacuizinho_rs",
    "label": "Jacuizinho - RS"
  },
  {
    "value": "jacundá_pa",
    "label": "Jacundá - PA"
  },
  {
    "value": "jacupiranga_sp",
    "label": "Jacupiranga - SP"
  },
  {
    "value": "jacutinga_mg",
    "label": "Jacutinga - MG"
  },
  {
    "value": "jacutinga_rs",
    "label": "Jacutinga - RS"
  },
  {
    "value": "jacuí_mg",
    "label": "Jacuí - MG"
  },
  {
    "value": "jacuípe_al",
    "label": "Jacuípe - AL"
  },
  {
    "value": "jaguapitã_pr",
    "label": "Jaguapitã - PR"
  },
  {
    "value": "jaguaquara_ba",
    "label": "Jaguaquara - BA"
  },
  {
    "value": "jaguarari_ba",
    "label": "Jaguarari - BA"
  },
  {
    "value": "jaguaraçu_mg",
    "label": "Jaguaraçu - MG"
  },
  {
    "value": "jaguaretama_ce",
    "label": "Jaguaretama - CE"
  },
  {
    "value": "jaguari_rs",
    "label": "Jaguari - RS"
  },
  {
    "value": "jaguariaíva_pr",
    "label": "Jaguariaíva - PR"
  },
  {
    "value": "jaguaribara_ce",
    "label": "Jaguaribara - CE"
  },
  {
    "value": "jaguaribe_ce",
    "label": "Jaguaribe - CE"
  },
  {
    "value": "jaguaripe_ba",
    "label": "Jaguaripe - BA"
  },
  {
    "value": "jaguariúna_sp",
    "label": "Jaguariúna - SP"
  },
  {
    "value": "jaguaruana_ce",
    "label": "Jaguaruana - CE"
  },
  {
    "value": "jaguaruna_sc",
    "label": "Jaguaruna - SC"
  },
  {
    "value": "jaguarão_rs",
    "label": "Jaguarão - RS"
  },
  {
    "value": "jaguaré_es",
    "label": "Jaguaré - ES"
  },
  {
    "value": "jaicós_pi",
    "label": "Jaicós - PI"
  },
  {
    "value": "jales_sp",
    "label": "Jales - SP"
  },
  {
    "value": "jambeiro_sp",
    "label": "Jambeiro - SP"
  },
  {
    "value": "jampruca_mg",
    "label": "Jampruca - MG"
  },
  {
    "value": "janaúba_mg",
    "label": "Janaúba - MG"
  },
  {
    "value": "jandaia_go",
    "label": "Jandaia - GO"
  },
  {
    "value": "jandaia_do_sul_pr",
    "label": "Jandaia do Sul - PR"
  },
  {
    "value": "jandaíra_ba",
    "label": "Jandaíra - BA"
  },
  {
    "value": "jandaíra_rn",
    "label": "Jandaíra - RN"
  },
  {
    "value": "jandira_sp",
    "label": "Jandira - SP"
  },
  {
    "value": "janduís_rn",
    "label": "Janduís - RN"
  },
  {
    "value": "jangada_mt",
    "label": "Jangada - MT"
  },
  {
    "value": "janiópolis_pr",
    "label": "Janiópolis - PR"
  },
  {
    "value": "januária_mg",
    "label": "Januária - MG"
  },
  {
    "value": "januário_cicco_rn",
    "label": "Januário Cicco - RN"
  },
  {
    "value": "japaratinga_al",
    "label": "Japaratinga - AL"
  },
  {
    "value": "japaratuba_se",
    "label": "Japaratuba - SE"
  },
  {
    "value": "japaraíba_mg",
    "label": "Japaraíba - MG"
  },
  {
    "value": "japeri_rj",
    "label": "Japeri - RJ"
  },
  {
    "value": "japi_rn",
    "label": "Japi - RN"
  },
  {
    "value": "japira_pr",
    "label": "Japira - PR"
  },
  {
    "value": "japoatã_se",
    "label": "Japoatã - SE"
  },
  {
    "value": "japonvar_mg",
    "label": "Japonvar - MG"
  },
  {
    "value": "japorã_ms",
    "label": "Japorã - MS"
  },
  {
    "value": "japurá_am",
    "label": "Japurá - AM"
  },
  {
    "value": "japurá_pr",
    "label": "Japurá - PR"
  },
  {
    "value": "jaqueira_pe",
    "label": "Jaqueira - PE"
  },
  {
    "value": "jaquirana_rs",
    "label": "Jaquirana - RS"
  },
  {
    "value": "jaraguari_ms",
    "label": "Jaraguari - MS"
  },
  {
    "value": "jaraguá_go",
    "label": "Jaraguá - GO"
  },
  {
    "value": "jaraguá_do_sul_sc",
    "label": "Jaraguá do Sul - SC"
  },
  {
    "value": "jaramataia_al",
    "label": "Jaramataia - AL"
  },
  {
    "value": "jardim_ce",
    "label": "Jardim - CE"
  },
  {
    "value": "jardim_ms",
    "label": "Jardim - MS"
  },
  {
    "value": "jardim_alegre_pr",
    "label": "Jardim Alegre - PR"
  },
  {
    "value": "jardim_olinda_pr",
    "label": "Jardim Olinda - PR"
  },
  {
    "value": "jardim_de_angicos_rn",
    "label": "Jardim de Angicos - RN"
  },
  {
    "value": "jardim_de_piranhas_rn",
    "label": "Jardim de Piranhas - RN"
  },
  {
    "value": "jardim_do_mulato_pi",
    "label": "Jardim do Mulato - PI"
  },
  {
    "value": "jardim_do_seridó_rn",
    "label": "Jardim do Seridó - RN"
  },
  {
    "value": "jardinópolis_sc",
    "label": "Jardinópolis - SC"
  },
  {
    "value": "jardinópolis_sp",
    "label": "Jardinópolis - SP"
  },
  {
    "value": "jari_rs",
    "label": "Jari - RS"
  },
  {
    "value": "jarinu_sp",
    "label": "Jarinu - SP"
  },
  {
    "value": "jaru_ro",
    "label": "Jaru - RO"
  },
  {
    "value": "jataizinho_pr",
    "label": "Jataizinho - PR"
  },
  {
    "value": "jataí_go",
    "label": "Jataí - GO"
  },
  {
    "value": "jataúba_pe",
    "label": "Jataúba - PE"
  },
  {
    "value": "jateí_ms",
    "label": "Jateí - MS"
  },
  {
    "value": "jati_ce",
    "label": "Jati - CE"
  },
  {
    "value": "jatobá_ma",
    "label": "Jatobá - MA"
  },
  {
    "value": "jatobá_pe",
    "label": "Jatobá - PE"
  },
  {
    "value": "jatobá_do_piauí_pi",
    "label": "Jatobá do Piauí - PI"
  },
  {
    "value": "jaupaci_go",
    "label": "Jaupaci - GO"
  },
  {
    "value": "jauru_mt",
    "label": "Jauru - MT"
  },
  {
    "value": "jaçanã_rn",
    "label": "Jaçanã - RN"
  },
  {
    "value": "jaíba_mg",
    "label": "Jaíba - MG"
  },
  {
    "value": "jaú_sp",
    "label": "Jaú - SP"
  },
  {
    "value": "jaú_do_tocantins_to",
    "label": "Jaú do Tocantins - TO"
  },
  {
    "value": "jeceaba_mg",
    "label": "Jeceaba - MG"
  },
  {
    "value": "jenipapo_de_minas_mg",
    "label": "Jenipapo de Minas - MG"
  },
  {
    "value": "jenipapo_dos_vieiras_ma",
    "label": "Jenipapo dos Vieiras - MA"
  },
  {
    "value": "jequeri_mg",
    "label": "Jequeri - MG"
  },
  {
    "value": "jequitaí_mg",
    "label": "Jequitaí - MG"
  },
  {
    "value": "jequitibá_mg",
    "label": "Jequitibá - MG"
  },
  {
    "value": "jequitinhonha_mg",
    "label": "Jequitinhonha - MG"
  },
  {
    "value": "jequiá_da_praia_al",
    "label": "Jequiá da Praia - AL"
  },
  {
    "value": "jequié_ba",
    "label": "Jequié - BA"
  },
  {
    "value": "jeremoabo_ba",
    "label": "Jeremoabo - BA"
  },
  {
    "value": "jericó_pb",
    "label": "Jericó - PB"
  },
  {
    "value": "jeriquara_sp",
    "label": "Jeriquara - SP"
  },
  {
    "value": "jerumenha_pi",
    "label": "Jerumenha - PI"
  },
  {
    "value": "jerônimo_monteiro_es",
    "label": "Jerônimo Monteiro - ES"
  },
  {
    "value": "jesuânia_mg",
    "label": "Jesuânia - MG"
  },
  {
    "value": "jesuítas_pr",
    "label": "Jesuítas - PR"
  },
  {
    "value": "jesúpolis_go",
    "label": "Jesúpolis - GO"
  },
  {
    "value": "ji-paraná_ro",
    "label": "Ji-Paraná - RO"
  },
  {
    "value": "jijoca_de_jericoaroara_ce",
    "label": "Jijoca de Jericoaroara - CE"
  },
  {
    "value": "jiquiriçá_ba",
    "label": "Jiquiriçá - BA"
  },
  {
    "value": "jitaúna_ba",
    "label": "Jitaúna - BA"
  },
  {
    "value": "joanésia_mg",
    "label": "Joanésia - MG"
  },
  {
    "value": "joanópolis_sp",
    "label": "Joanópolis - SP"
  },
  {
    "value": "joaquim_felício_mg",
    "label": "Joaquim Felício - MG"
  },
  {
    "value": "joaquim_gomes_al",
    "label": "Joaquim Gomes - AL"
  },
  {
    "value": "joaquim_nabuco_pe",
    "label": "Joaquim Nabuco - PE"
  },
  {
    "value": "joaquim_pires_pi",
    "label": "Joaquim Pires - PI"
  },
  {
    "value": "joaquim_távora_pr",
    "label": "Joaquim Távora - PR"
  },
  {
    "value": "joaçaba_sc",
    "label": "Joaçaba - SC"
  },
  {
    "value": "joaíma_mg",
    "label": "Joaíma - MG"
  },
  {
    "value": "joca_marques_pi",
    "label": "Joca Marques - PI"
  },
  {
    "value": "joinville_sc",
    "label": "Joinville - SC"
  },
  {
    "value": "jordânia_mg",
    "label": "Jordânia - MG"
  },
  {
    "value": "jordão_ac",
    "label": "Jordão - AC"
  },
  {
    "value": "joselândia_ma",
    "label": "Joselândia - MA"
  },
  {
    "value": "josenópolis_mg",
    "label": "Josenópolis - MG"
  },
  {
    "value": "josé_boiteux_sc",
    "label": "José Boiteux - SC"
  },
  {
    "value": "josé_bonifácio_sp",
    "label": "José Bonifácio - SP"
  },
  {
    "value": "josé_gonçalves_de_minas_mg",
    "label": "José Gonçalves de Minas - MG"
  },
  {
    "value": "josé_raydan_mg",
    "label": "José Raydan - MG"
  },
  {
    "value": "josé_da_penha_rn",
    "label": "José da Penha - RN"
  },
  {
    "value": "josé_de_freitas_pi",
    "label": "José de Freitas - PI"
  },
  {
    "value": "joviânia_go",
    "label": "Joviânia - GO"
  },
  {
    "value": "joão_alfredo_pe",
    "label": "João Alfredo - PE"
  },
  {
    "value": "joão_costa_pi",
    "label": "João Costa - PI"
  },
  {
    "value": "joão_câmara_rn",
    "label": "João Câmara - RN"
  },
  {
    "value": "joão_dias_rn",
    "label": "João Dias - RN"
  },
  {
    "value": "joão_dourado_ba",
    "label": "João Dourado - BA"
  },
  {
    "value": "joão_lisboa_ma",
    "label": "João Lisboa - MA"
  },
  {
    "value": "joão_monlevade_mg",
    "label": "João Monlevade - MG"
  },
  {
    "value": "joão_neiva_es",
    "label": "João Neiva - ES"
  },
  {
    "value": "joão_pessoa_pb",
    "label": "João Pessoa - PB"
  },
  {
    "value": "joão_pinheiro_mg",
    "label": "João Pinheiro - MG"
  },
  {
    "value": "joão_ramalho_sp",
    "label": "João Ramalho - SP"
  },
  {
    "value": "juara_mt",
    "label": "Juara - MT"
  },
  {
    "value": "juarez_távora_pb",
    "label": "Juarez Távora - PB"
  },
  {
    "value": "juarina_to",
    "label": "Juarina - TO"
  },
  {
    "value": "juatuba_mg",
    "label": "Juatuba - MG"
  },
  {
    "value": "juazeirinho_pb",
    "label": "Juazeirinho - PB"
  },
  {
    "value": "juazeiro_ba",
    "label": "Juazeiro - BA"
  },
  {
    "value": "juazeiro_do_norte_ce",
    "label": "Juazeiro do Norte - CE"
  },
  {
    "value": "juazeiro_do_piauí_pi",
    "label": "Juazeiro do Piauí - PI"
  },
  {
    "value": "jucati_pe",
    "label": "Jucati - PE"
  },
  {
    "value": "jucurutu_rn",
    "label": "Jucurutu - RN"
  },
  {
    "value": "jucuruçu_ba",
    "label": "Jucuruçu - BA"
  },
  {
    "value": "jucás_ce",
    "label": "Jucás - CE"
  },
  {
    "value": "juiz_de_fora_mg",
    "label": "Juiz de Fora - MG"
  },
  {
    "value": "jumirim_sp",
    "label": "Jumirim - SP"
  },
  {
    "value": "junco_do_maranhão_ma",
    "label": "Junco do Maranhão - MA"
  },
  {
    "value": "junco_do_seridó_pb",
    "label": "Junco do Seridó - PB"
  },
  {
    "value": "jundiaí_sp",
    "label": "Jundiaí - SP"
  },
  {
    "value": "jundiaí_do_sul_pr",
    "label": "Jundiaí do Sul - PR"
  },
  {
    "value": "jundiá_al",
    "label": "Jundiá - AL"
  },
  {
    "value": "jundiá_rn",
    "label": "Jundiá - RN"
  },
  {
    "value": "junqueiro_al",
    "label": "Junqueiro - AL"
  },
  {
    "value": "junqueirópolis_sp",
    "label": "Junqueirópolis - SP"
  },
  {
    "value": "jupi_pe",
    "label": "Jupi - PE"
  },
  {
    "value": "jupiá_sc",
    "label": "Jupiá - SC"
  },
  {
    "value": "juquitiba_sp",
    "label": "Juquitiba - SP"
  },
  {
    "value": "juquiá_sp",
    "label": "Juquiá - SP"
  },
  {
    "value": "juramento_mg",
    "label": "Juramento - MG"
  },
  {
    "value": "juranda_pr",
    "label": "Juranda - PR"
  },
  {
    "value": "jurema_pe",
    "label": "Jurema - PE"
  },
  {
    "value": "jurema_pi",
    "label": "Jurema - PI"
  },
  {
    "value": "juripiranga_pb",
    "label": "Juripiranga - PB"
  },
  {
    "value": "juru_pb",
    "label": "Juru - PB"
  },
  {
    "value": "juruaia_mg",
    "label": "Juruaia - MG"
  },
  {
    "value": "juruena_mt",
    "label": "Juruena - MT"
  },
  {
    "value": "juruti_pa",
    "label": "Juruti - PA"
  },
  {
    "value": "juruá_am",
    "label": "Juruá - AM"
  },
  {
    "value": "juscimeira_mt",
    "label": "Juscimeira - MT"
  },
  {
    "value": "jussara_ba",
    "label": "Jussara - BA"
  },
  {
    "value": "jussara_go",
    "label": "Jussara - GO"
  },
  {
    "value": "jussara_pr",
    "label": "Jussara - PR"
  },
  {
    "value": "jussari_ba",
    "label": "Jussari - BA"
  },
  {
    "value": "jussiape_ba",
    "label": "Jussiape - BA"
  },
  {
    "value": "jutaí_am",
    "label": "Jutaí - AM"
  },
  {
    "value": "juti_ms",
    "label": "Juti - MS"
  },
  {
    "value": "juvenília_mg",
    "label": "Juvenília - MG"
  },
  {
    "value": "juína_mt",
    "label": "Juína - MT"
  },
  {
    "value": "jóia_rs",
    "label": "Jóia - RS"
  },
  {
    "value": "júlio_borges_pi",
    "label": "Júlio Borges - PI"
  },
  {
    "value": "júlio_mesquita_sp",
    "label": "Júlio Mesquita - SP"
  },
  {
    "value": "júlio_de_castilhos_rs",
    "label": "Júlio de Castilhos - RS"
  },
  {
    "value": "kaloré_pr",
    "label": "Kaloré - PR"
  },
  {
    "value": "lacerdópolis_sc",
    "label": "Lacerdópolis - SC"
  },
  {
    "value": "ladainha_mg",
    "label": "Ladainha - MG"
  },
  {
    "value": "ladário_ms",
    "label": "Ladário - MS"
  },
  {
    "value": "lafaiete_coutinho_ba",
    "label": "Lafaiete Coutinho - BA"
  },
  {
    "value": "lagamar_mg",
    "label": "Lagamar - MG"
  },
  {
    "value": "lagarto_se",
    "label": "Lagarto - SE"
  },
  {
    "value": "lages_sc",
    "label": "Lages - SC"
  },
  {
    "value": "lago_verde_ma",
    "label": "Lago Verde - MA"
  },
  {
    "value": "lago_da_pedra_ma",
    "label": "Lago da Pedra - MA"
  },
  {
    "value": "lago_do_junco_ma",
    "label": "Lago do Junco - MA"
  },
  {
    "value": "lago_dos_rodrigues_ma",
    "label": "Lago dos Rodrigues - MA"
  },
  {
    "value": "lagoa_pb",
    "label": "Lagoa - PB"
  },
  {
    "value": "lagoa_alegre_pi",
    "label": "Lagoa Alegre - PI"
  },
  {
    "value": "lagoa_bonita_do_sul_rs",
    "label": "Lagoa Bonita do Sul - RS"
  },
  {
    "value": "lagoa_dourada_mg",
    "label": "Lagoa Dourada - MG"
  },
  {
    "value": "lagoa_formosa_mg",
    "label": "Lagoa Formosa - MG"
  },
  {
    "value": "lagoa_grande_mg",
    "label": "Lagoa Grande - MG"
  },
  {
    "value": "lagoa_grande_pe",
    "label": "Lagoa Grande - PE"
  },
  {
    "value": "lagoa_grande_do_maranhão_ma",
    "label": "Lagoa Grande do Maranhão - MA"
  },
  {
    "value": "lagoa_nova_rn",
    "label": "Lagoa Nova - RN"
  },
  {
    "value": "lagoa_real_ba",
    "label": "Lagoa Real - BA"
  },
  {
    "value": "lagoa_salgada_rn",
    "label": "Lagoa Salgada - RN"
  },
  {
    "value": "lagoa_santa_go",
    "label": "Lagoa Santa - GO"
  },
  {
    "value": "lagoa_santa_mg",
    "label": "Lagoa Santa - MG"
  },
  {
    "value": "lagoa_seca_pb",
    "label": "Lagoa Seca - PB"
  },
  {
    "value": "lagoa_vermelha_rs",
    "label": "Lagoa Vermelha - RS"
  },
  {
    "value": "lagoa_d'anta_rn",
    "label": "Lagoa d'Anta - RN"
  },
  {
    "value": "lagoa_da_canoa_al",
    "label": "Lagoa da Canoa - AL"
  },
  {
    "value": "lagoa_da_confusão_to",
    "label": "Lagoa da Confusão - TO"
  },
  {
    "value": "lagoa_da_prata_mg",
    "label": "Lagoa da Prata - MG"
  },
  {
    "value": "lagoa_de_dentro_pb",
    "label": "Lagoa de Dentro - PB"
  },
  {
    "value": "lagoa_de_pedras_rn",
    "label": "Lagoa de Pedras - RN"
  },
  {
    "value": "lagoa_de_são_francisco_pi",
    "label": "Lagoa de São Francisco - PI"
  },
  {
    "value": "lagoa_de_velhos_rn",
    "label": "Lagoa de Velhos - RN"
  },
  {
    "value": "lagoa_do_barro_do_piauí_pi",
    "label": "Lagoa do Barro do Piauí - PI"
  },
  {
    "value": "lagoa_do_carro_pe",
    "label": "Lagoa do Carro - PE"
  },
  {
    "value": "lagoa_do_itaenga_pe",
    "label": "Lagoa do Itaenga - PE"
  },
  {
    "value": "lagoa_do_mato_ma",
    "label": "Lagoa do Mato - MA"
  },
  {
    "value": "lagoa_do_ouro_pe",
    "label": "Lagoa do Ouro - PE"
  },
  {
    "value": "lagoa_do_piauí_pi",
    "label": "Lagoa do Piauí - PI"
  },
  {
    "value": "lagoa_do_sítio_pi",
    "label": "Lagoa do Sítio - PI"
  },
  {
    "value": "lagoa_do_tocantins_to",
    "label": "Lagoa do Tocantins - TO"
  },
  {
    "value": "lagoa_dos_gatos_pe",
    "label": "Lagoa dos Gatos - PE"
  },
  {
    "value": "lagoa_dos_patos_mg",
    "label": "Lagoa dos Patos - MG"
  },
  {
    "value": "lagoa_dos_três_cantos_rs",
    "label": "Lagoa dos Três Cantos - RS"
  },
  {
    "value": "lagoinha_sp",
    "label": "Lagoinha - SP"
  },
  {
    "value": "lagoinha_do_piauí_pi",
    "label": "Lagoinha do Piauí - PI"
  },
  {
    "value": "lagoão_rs",
    "label": "Lagoão - RS"
  },
  {
    "value": "laguna_sc",
    "label": "Laguna - SC"
  },
  {
    "value": "laguna_carapã_ms",
    "label": "Laguna Carapã - MS"
  },
  {
    "value": "laje_ba",
    "label": "Laje - BA"
  },
  {
    "value": "laje_do_muriaé_rj",
    "label": "Laje do Muriaé - RJ"
  },
  {
    "value": "lajeado_rs",
    "label": "Lajeado - RS"
  },
  {
    "value": "lajeado_to",
    "label": "Lajeado - TO"
  },
  {
    "value": "lajeado_grande_sc",
    "label": "Lajeado Grande - SC"
  },
  {
    "value": "lajeado_novo_ma",
    "label": "Lajeado Novo - MA"
  },
  {
    "value": "lajeado_do_bugre_rs",
    "label": "Lajeado do Bugre - RS"
  },
  {
    "value": "lajedinho_ba",
    "label": "Lajedinho - BA"
  },
  {
    "value": "lajedo_pe",
    "label": "Lajedo - PE"
  },
  {
    "value": "lajedo_do_tabocal_ba",
    "label": "Lajedo do Tabocal - BA"
  },
  {
    "value": "lajedão_ba",
    "label": "Lajedão - BA"
  },
  {
    "value": "lajes_rn",
    "label": "Lajes - RN"
  },
  {
    "value": "lajes_pintadas_rn",
    "label": "Lajes Pintadas - RN"
  },
  {
    "value": "lajinha_mg",
    "label": "Lajinha - MG"
  },
  {
    "value": "lamarão_ba",
    "label": "Lamarão - BA"
  },
  {
    "value": "lambari_mg",
    "label": "Lambari - MG"
  },
  {
    "value": "lambari_d'oeste_mt",
    "label": "Lambari d'Oeste - MT"
  },
  {
    "value": "lamim_mg",
    "label": "Lamim - MG"
  },
  {
    "value": "landri_sales_pi",
    "label": "Landri Sales - PI"
  },
  {
    "value": "lapa_pr",
    "label": "Lapa - PR"
  },
  {
    "value": "lapão_ba",
    "label": "Lapão - BA"
  },
  {
    "value": "laranja_da_terra_es",
    "label": "Laranja da Terra - ES"
  },
  {
    "value": "laranjal_mg",
    "label": "Laranjal - MG"
  },
  {
    "value": "laranjal_pr",
    "label": "Laranjal - PR"
  },
  {
    "value": "laranjal_paulista_sp",
    "label": "Laranjal Paulista - SP"
  },
  {
    "value": "laranjal_do_jari_ap",
    "label": "Laranjal do Jari - AP"
  },
  {
    "value": "laranjeiras_se",
    "label": "Laranjeiras - SE"
  },
  {
    "value": "laranjeiras_do_sul_pr",
    "label": "Laranjeiras do Sul - PR"
  },
  {
    "value": "lassance_mg",
    "label": "Lassance - MG"
  },
  {
    "value": "lastro_pb",
    "label": "Lastro - PB"
  },
  {
    "value": "laurentino_sc",
    "label": "Laurentino - SC"
  },
  {
    "value": "lauro_muller_sc",
    "label": "Lauro Muller - SC"
  },
  {
    "value": "lauro_de_freitas_ba",
    "label": "Lauro de Freitas - BA"
  },
  {
    "value": "lavandeira_to",
    "label": "Lavandeira - TO"
  },
  {
    "value": "lavras_mg",
    "label": "Lavras - MG"
  },
  {
    "value": "lavras_da_mangabeira_ce",
    "label": "Lavras da Mangabeira - CE"
  },
  {
    "value": "lavras_do_sul_rs",
    "label": "Lavras do Sul - RS"
  },
  {
    "value": "lavrinhas_sp",
    "label": "Lavrinhas - SP"
  },
  {
    "value": "lavínia_sp",
    "label": "Lavínia - SP"
  },
  {
    "value": "leandro_ferreira_mg",
    "label": "Leandro Ferreira - MG"
  },
  {
    "value": "lebon_régis_sc",
    "label": "Lebon Régis - SC"
  },
  {
    "value": "leme_sp",
    "label": "Leme - SP"
  },
  {
    "value": "leme_do_prado_mg",
    "label": "Leme do Prado - MG"
  },
  {
    "value": "lençóis_ba",
    "label": "Lençóis - BA"
  },
  {
    "value": "lençóis_paulista_sp",
    "label": "Lençóis Paulista - SP"
  },
  {
    "value": "leoberto_leal_sc",
    "label": "Leoberto Leal - SC"
  },
  {
    "value": "leopoldina_mg",
    "label": "Leopoldina - MG"
  },
  {
    "value": "leopoldo_de_bulhões_go",
    "label": "Leopoldo de Bulhões - GO"
  },
  {
    "value": "leópolis_pr",
    "label": "Leópolis - PR"
  },
  {
    "value": "liberato_salzano_rs",
    "label": "Liberato Salzano - RS"
  },
  {
    "value": "liberdade_mg",
    "label": "Liberdade - MG"
  },
  {
    "value": "licínio_de_almeida_ba",
    "label": "Licínio de Almeida - BA"
  },
  {
    "value": "lidianópolis_pr",
    "label": "Lidianópolis - PR"
  },
  {
    "value": "lima_campos_ma",
    "label": "Lima Campos - MA"
  },
  {
    "value": "lima_duarte_mg",
    "label": "Lima Duarte - MG"
  },
  {
    "value": "limeira_sp",
    "label": "Limeira - SP"
  },
  {
    "value": "limeira_do_oeste_mg",
    "label": "Limeira do Oeste - MG"
  },
  {
    "value": "limoeiro_pe",
    "label": "Limoeiro - PE"
  },
  {
    "value": "limoeiro_de_anadia_al",
    "label": "Limoeiro de Anadia - AL"
  },
  {
    "value": "limoeiro_do_ajuru_pa",
    "label": "Limoeiro do Ajuru - PA"
  },
  {
    "value": "limoeiro_do_norte_ce",
    "label": "Limoeiro do Norte - CE"
  },
  {
    "value": "lindoeste_pr",
    "label": "Lindoeste - PR"
  },
  {
    "value": "lindolfo_collor_rs",
    "label": "Lindolfo Collor - RS"
  },
  {
    "value": "lindóia_sp",
    "label": "Lindóia - SP"
  },
  {
    "value": "lindóia_do_sul_sc",
    "label": "Lindóia do Sul - SC"
  },
  {
    "value": "linha_nova_rs",
    "label": "Linha Nova - RS"
  },
  {
    "value": "linhares_es",
    "label": "Linhares - ES"
  },
  {
    "value": "lins_sp",
    "label": "Lins - SP"
  },
  {
    "value": "livramento_pb",
    "label": "Livramento - PB"
  },
  {
    "value": "livramento_de_nossa_senhora_ba",
    "label": "Livramento de Nossa Senhora - BA"
  },
  {
    "value": "lizarda_to",
    "label": "Lizarda - TO"
  },
  {
    "value": "loanda_pr",
    "label": "Loanda - PR"
  },
  {
    "value": "lobato_pr",
    "label": "Lobato - PR"
  },
  {
    "value": "logradouro_pb",
    "label": "Logradouro - PB"
  },
  {
    "value": "londrina_pr",
    "label": "Londrina - PR"
  },
  {
    "value": "lontra_mg",
    "label": "Lontra - MG"
  },
  {
    "value": "lontras_sc",
    "label": "Lontras - SC"
  },
  {
    "value": "lorena_sp",
    "label": "Lorena - SP"
  },
  {
    "value": "loreto_ma",
    "label": "Loreto - MA"
  },
  {
    "value": "lourdes_sp",
    "label": "Lourdes - SP"
  },
  {
    "value": "louveira_sp",
    "label": "Louveira - SP"
  },
  {
    "value": "lucas_do_rio_verde_mt",
    "label": "Lucas do Rio Verde - MT"
  },
  {
    "value": "lucena_pb",
    "label": "Lucena - PB"
  },
  {
    "value": "lucianópolis_sp",
    "label": "Lucianópolis - SP"
  },
  {
    "value": "luciára_mt",
    "label": "Luciára - MT"
  },
  {
    "value": "lucrécia_rn",
    "label": "Lucrécia - RN"
  },
  {
    "value": "lucélia_sp",
    "label": "Lucélia - SP"
  },
  {
    "value": "luisburgo_mg",
    "label": "Luisburgo - MG"
  },
  {
    "value": "luislândia_mg",
    "label": "Luislândia - MG"
  },
  {
    "value": "luiz_alves_sc",
    "label": "Luiz Alves - SC"
  },
  {
    "value": "luiziana_pr",
    "label": "Luiziana - PR"
  },
  {
    "value": "luiziânia_sp",
    "label": "Luiziânia - SP"
  },
  {
    "value": "luminárias_mg",
    "label": "Luminárias - MG"
  },
  {
    "value": "lunardelli_pr",
    "label": "Lunardelli - PR"
  },
  {
    "value": "lupionópolis_pr",
    "label": "Lupionópolis - PR"
  },
  {
    "value": "lupércio_sp",
    "label": "Lupércio - SP"
  },
  {
    "value": "lutécia_sp",
    "label": "Lutécia - SP"
  },
  {
    "value": "luz_mg",
    "label": "Luz - MG"
  },
  {
    "value": "luzerna_sc",
    "label": "Luzerna - SC"
  },
  {
    "value": "luzilândia_pi",
    "label": "Luzilândia - PI"
  },
  {
    "value": "luzinópolis_to",
    "label": "Luzinópolis - TO"
  },
  {
    "value": "luziânia_go",
    "label": "Luziânia - GO"
  },
  {
    "value": "luís_antônio_sp",
    "label": "Luís Antônio - SP"
  },
  {
    "value": "luís_correia_pi",
    "label": "Luís Correia - PI"
  },
  {
    "value": "luís_domingues_ma",
    "label": "Luís Domingues - MA"
  },
  {
    "value": "luís_eduardo_magalhães_ba",
    "label": "Luís Eduardo Magalhães - BA"
  },
  {
    "value": "luís_gomes_rn",
    "label": "Luís Gomes - RN"
  },
  {
    "value": "lábrea_am",
    "label": "Lábrea - AM"
  },
  {
    "value": "macajuba_ba",
    "label": "Macajuba - BA"
  },
  {
    "value": "macambira_se",
    "label": "Macambira - SE"
  },
  {
    "value": "macaparana_pe",
    "label": "Macaparana - PE"
  },
  {
    "value": "macapá_ap",
    "label": "Macapá - AP"
  },
  {
    "value": "macarani_ba",
    "label": "Macarani - BA"
  },
  {
    "value": "macatuba_sp",
    "label": "Macatuba - SP"
  },
  {
    "value": "macau_rn",
    "label": "Macau - RN"
  },
  {
    "value": "macaubal_sp",
    "label": "Macaubal - SP"
  },
  {
    "value": "macaé_rj",
    "label": "Macaé - RJ"
  },
  {
    "value": "macaíba_rn",
    "label": "Macaíba - RN"
  },
  {
    "value": "macaúbas_ba",
    "label": "Macaúbas - BA"
  },
  {
    "value": "macedônia_sp",
    "label": "Macedônia - SP"
  },
  {
    "value": "maceió_al",
    "label": "Maceió - AL"
  },
  {
    "value": "machacalis_mg",
    "label": "Machacalis - MG"
  },
  {
    "value": "machadinho_rs",
    "label": "Machadinho - RS"
  },
  {
    "value": "machadinho_d'oeste_ro",
    "label": "Machadinho d'Oeste - RO"
  },
  {
    "value": "machado_mg",
    "label": "Machado - MG"
  },
  {
    "value": "machados_pe",
    "label": "Machados - PE"
  },
  {
    "value": "macieira_sc",
    "label": "Macieira - SC"
  },
  {
    "value": "macuco_rj",
    "label": "Macuco - RJ"
  },
  {
    "value": "macururé_ba",
    "label": "Macururé - BA"
  },
  {
    "value": "madalena_ce",
    "label": "Madalena - CE"
  },
  {
    "value": "madeiro_pi",
    "label": "Madeiro - PI"
  },
  {
    "value": "madre_de_deus_ba",
    "label": "Madre de Deus - BA"
  },
  {
    "value": "madre_de_deus_de_minas_mg",
    "label": "Madre de Deus de Minas - MG"
  },
  {
    "value": "maetinga_ba",
    "label": "Maetinga - BA"
  },
  {
    "value": "mafra_sc",
    "label": "Mafra - SC"
  },
  {
    "value": "magalhães_barata_pa",
    "label": "Magalhães Barata - PA"
  },
  {
    "value": "magalhães_de_almeida_ma",
    "label": "Magalhães de Almeida - MA"
  },
  {
    "value": "magda_sp",
    "label": "Magda - SP"
  },
  {
    "value": "magé_rj",
    "label": "Magé - RJ"
  },
  {
    "value": "maiquinique_ba",
    "label": "Maiquinique - BA"
  },
  {
    "value": "mairi_ba",
    "label": "Mairi - BA"
  },
  {
    "value": "mairinque_sp",
    "label": "Mairinque - SP"
  },
  {
    "value": "mairiporã_sp",
    "label": "Mairiporã - SP"
  },
  {
    "value": "mairipotaba_go",
    "label": "Mairipotaba - GO"
  },
  {
    "value": "major_gercino_sc",
    "label": "Major Gercino - SC"
  },
  {
    "value": "major_isidoro_al",
    "label": "Major Isidoro - AL"
  },
  {
    "value": "major_sales_rn",
    "label": "Major Sales - RN"
  },
  {
    "value": "major_vieira_sc",
    "label": "Major Vieira - SC"
  },
  {
    "value": "malacacheta_mg",
    "label": "Malacacheta - MG"
  },
  {
    "value": "malhada_ba",
    "label": "Malhada - BA"
  },
  {
    "value": "malhada_de_pedras_ba",
    "label": "Malhada de Pedras - BA"
  },
  {
    "value": "malhada_dos_bois_se",
    "label": "Malhada dos Bois - SE"
  },
  {
    "value": "malhador_se",
    "label": "Malhador - SE"
  },
  {
    "value": "mallet_pr",
    "label": "Mallet - PR"
  },
  {
    "value": "malta_pb",
    "label": "Malta - PB"
  },
  {
    "value": "mamanguape_pb",
    "label": "Mamanguape - PB"
  },
  {
    "value": "mambaí_go",
    "label": "Mambaí - GO"
  },
  {
    "value": "mamborê_pr",
    "label": "Mamborê - PR"
  },
  {
    "value": "mamonas_mg",
    "label": "Mamonas - MG"
  },
  {
    "value": "mampituba_rs",
    "label": "Mampituba - RS"
  },
  {
    "value": "manacapuru_am",
    "label": "Manacapuru - AM"
  },
  {
    "value": "manaquiri_am",
    "label": "Manaquiri - AM"
  },
  {
    "value": "manari_pe",
    "label": "Manari - PE"
  },
  {
    "value": "manaus_am",
    "label": "Manaus - AM"
  },
  {
    "value": "manaíra_pb",
    "label": "Manaíra - PB"
  },
  {
    "value": "mandaguari_pr",
    "label": "Mandaguari - PR"
  },
  {
    "value": "mandaguaçu_pr",
    "label": "Mandaguaçu - PR"
  },
  {
    "value": "mandirituba_pr",
    "label": "Mandirituba - PR"
  },
  {
    "value": "manduri_sp",
    "label": "Manduri - SP"
  },
  {
    "value": "manfrinópolis_pr",
    "label": "Manfrinópolis - PR"
  },
  {
    "value": "manga_mg",
    "label": "Manga - MG"
  },
  {
    "value": "mangaratiba_rj",
    "label": "Mangaratiba - RJ"
  },
  {
    "value": "mangueirinha_pr",
    "label": "Mangueirinha - PR"
  },
  {
    "value": "manhuaçu_mg",
    "label": "Manhuaçu - MG"
  },
  {
    "value": "manhumirim_mg",
    "label": "Manhumirim - MG"
  },
  {
    "value": "manicoré_am",
    "label": "Manicoré - AM"
  },
  {
    "value": "manoel_emídio_pi",
    "label": "Manoel Emídio - PI"
  },
  {
    "value": "manoel_ribas_pr",
    "label": "Manoel Ribas - PR"
  },
  {
    "value": "manoel_urbano_ac",
    "label": "Manoel Urbano - AC"
  },
  {
    "value": "manoel_viana_rs",
    "label": "Manoel Viana - RS"
  },
  {
    "value": "manoel_vitorino_ba",
    "label": "Manoel Vitorino - BA"
  },
  {
    "value": "mansidão_ba",
    "label": "Mansidão - BA"
  },
  {
    "value": "mantena_mg",
    "label": "Mantena - MG"
  },
  {
    "value": "mantenópolis_es",
    "label": "Mantenópolis - ES"
  },
  {
    "value": "maquiné_rs",
    "label": "Maquiné - RS"
  },
  {
    "value": "mar_vermelho_al",
    "label": "Mar Vermelho - AL"
  },
  {
    "value": "mar_de_espanha_mg",
    "label": "Mar de Espanha - MG"
  },
  {
    "value": "mara_rosa_go",
    "label": "Mara Rosa - GO"
  },
  {
    "value": "marabá_pa",
    "label": "Marabá - PA"
  },
  {
    "value": "marabá_paulista_sp",
    "label": "Marabá Paulista - SP"
  },
  {
    "value": "maracaju_ms",
    "label": "Maracaju - MS"
  },
  {
    "value": "maracajá_sc",
    "label": "Maracajá - SC"
  },
  {
    "value": "maracanaú_ce",
    "label": "Maracanaú - CE"
  },
  {
    "value": "maracanã_pa",
    "label": "Maracanã - PA"
  },
  {
    "value": "maracaçumé_ma",
    "label": "Maracaçumé - MA"
  },
  {
    "value": "maracaí_sp",
    "label": "Maracaí - SP"
  },
  {
    "value": "maracás_ba",
    "label": "Maracás - BA"
  },
  {
    "value": "maragogi_al",
    "label": "Maragogi - AL"
  },
  {
    "value": "maragogipe_ba",
    "label": "Maragogipe - BA"
  },
  {
    "value": "maraial_pe",
    "label": "Maraial - PE"
  },
  {
    "value": "marajá_do_sena_ma",
    "label": "Marajá do Sena - MA"
  },
  {
    "value": "maranguape_ce",
    "label": "Maranguape - CE"
  },
  {
    "value": "maranhãozinho_ma",
    "label": "Maranhãozinho - MA"
  },
  {
    "value": "marapanim_pa",
    "label": "Marapanim - PA"
  },
  {
    "value": "marapoama_sp",
    "label": "Marapoama - SP"
  },
  {
    "value": "marataizes_es",
    "label": "Marataizes - ES"
  },
  {
    "value": "maratá_rs",
    "label": "Maratá - RS"
  },
  {
    "value": "marau_rs",
    "label": "Marau - RS"
  },
  {
    "value": "maravilha_al",
    "label": "Maravilha - AL"
  },
  {
    "value": "maravilha_sc",
    "label": "Maravilha - SC"
  },
  {
    "value": "maravilhas_mg",
    "label": "Maravilhas - MG"
  },
  {
    "value": "maraã_am",
    "label": "Maraã - AM"
  },
  {
    "value": "maraú_ba",
    "label": "Maraú - BA"
  },
  {
    "value": "marcação_pb",
    "label": "Marcação - PB"
  },
  {
    "value": "marcelino_ramos_rs",
    "label": "Marcelino Ramos - RS"
  },
  {
    "value": "marcelino_vieira_rn",
    "label": "Marcelino Vieira - RN"
  },
  {
    "value": "marcelândia_mt",
    "label": "Marcelândia - MT"
  },
  {
    "value": "marcionílio_souza_ba",
    "label": "Marcionílio Souza - BA"
  },
  {
    "value": "marco_ce",
    "label": "Marco - CE"
  },
  {
    "value": "marcolândia_pi",
    "label": "Marcolândia - PI"
  },
  {
    "value": "marcos_parente_pi",
    "label": "Marcos Parente - PI"
  },
  {
    "value": "marechal_cândido_rondon_pr",
    "label": "Marechal Cândido Rondon - PR"
  },
  {
    "value": "marechal_deodoro_al",
    "label": "Marechal Deodoro - AL"
  },
  {
    "value": "marechal_floriano_es",
    "label": "Marechal Floriano - ES"
  },
  {
    "value": "marechal_thaumaturgo_ac",
    "label": "Marechal Thaumaturgo - AC"
  },
  {
    "value": "marema_sc",
    "label": "Marema - SC"
  },
  {
    "value": "mari_pb",
    "label": "Mari - PB"
  },
  {
    "value": "maria_helena_pr",
    "label": "Maria Helena - PR"
  },
  {
    "value": "maria_da_fé_mg",
    "label": "Maria da Fé - MG"
  },
  {
    "value": "marialva_pr",
    "label": "Marialva - PR"
  },
  {
    "value": "mariana_mg",
    "label": "Mariana - MG"
  },
  {
    "value": "mariana_pimentel_rs",
    "label": "Mariana Pimentel - RS"
  },
  {
    "value": "mariano_moro_rs",
    "label": "Mariano Moro - RS"
  },
  {
    "value": "marianópolis_do_tocantins_to",
    "label": "Marianópolis do Tocantins - TO"
  },
  {
    "value": "maribondo_al",
    "label": "Maribondo - AL"
  },
  {
    "value": "maricá_rj",
    "label": "Maricá - RJ"
  },
  {
    "value": "marilac_mg",
    "label": "Marilac - MG"
  },
  {
    "value": "marilena_pr",
    "label": "Marilena - PR"
  },
  {
    "value": "mariluz_pr",
    "label": "Mariluz - PR"
  },
  {
    "value": "marilândia_es",
    "label": "Marilândia - ES"
  },
  {
    "value": "marilândia_do_sul_pr",
    "label": "Marilândia do Sul - PR"
  },
  {
    "value": "maringá_pr",
    "label": "Maringá - PR"
  },
  {
    "value": "marinópolis_sp",
    "label": "Marinópolis - SP"
  },
  {
    "value": "maripá_pr",
    "label": "Maripá - PR"
  },
  {
    "value": "maripá_de_minas_mg",
    "label": "Maripá de Minas - MG"
  },
  {
    "value": "marituba_pa",
    "label": "Marituba - PA"
  },
  {
    "value": "marizópolis_pb",
    "label": "Marizópolis - PB"
  },
  {
    "value": "mariápolis_sp",
    "label": "Mariápolis - SP"
  },
  {
    "value": "mariópolis_pr",
    "label": "Mariópolis - PR"
  },
  {
    "value": "marliéria_mg",
    "label": "Marliéria - MG"
  },
  {
    "value": "marmeleiro_pr",
    "label": "Marmeleiro - PR"
  },
  {
    "value": "marmelópolis_mg",
    "label": "Marmelópolis - MG"
  },
  {
    "value": "marques_de_souza_rs",
    "label": "Marques de Souza - RS"
  },
  {
    "value": "marquinho_pr",
    "label": "Marquinho - PR"
  },
  {
    "value": "martinho_campos_mg",
    "label": "Martinho Campos - MG"
  },
  {
    "value": "martins_rn",
    "label": "Martins - RN"
  },
  {
    "value": "martins_soares_mg",
    "label": "Martins Soares - MG"
  },
  {
    "value": "martinópole_ce",
    "label": "Martinópole - CE"
  },
  {
    "value": "martinópolis_sp",
    "label": "Martinópolis - SP"
  },
  {
    "value": "maruim_se",
    "label": "Maruim - SE"
  },
  {
    "value": "marumbi_pr",
    "label": "Marumbi - PR"
  },
  {
    "value": "marzagão_go",
    "label": "Marzagão - GO"
  },
  {
    "value": "marília_sp",
    "label": "Marília - SP"
  },
  {
    "value": "mascote_ba",
    "label": "Mascote - BA"
  },
  {
    "value": "massapê_ce",
    "label": "Massapê - CE"
  },
  {
    "value": "massapê_do_piauí_pi",
    "label": "Massapê do Piauí - PI"
  },
  {
    "value": "massaranduba_pb",
    "label": "Massaranduba - PB"
  },
  {
    "value": "massaranduba_sc",
    "label": "Massaranduba - SC"
  },
  {
    "value": "mata_rs",
    "label": "Mata - RS"
  },
  {
    "value": "mata_grande_al",
    "label": "Mata Grande - AL"
  },
  {
    "value": "mata_roma_ma",
    "label": "Mata Roma - MA"
  },
  {
    "value": "mata_verde_mg",
    "label": "Mata Verde - MG"
  },
  {
    "value": "mata_de_são_joão_ba",
    "label": "Mata de São João - BA"
  },
  {
    "value": "mataraca_pb",
    "label": "Mataraca - PB"
  },
  {
    "value": "mateiros_to",
    "label": "Mateiros - TO"
  },
  {
    "value": "matelândia_pr",
    "label": "Matelândia - PR"
  },
  {
    "value": "materlândia_mg",
    "label": "Materlândia - MG"
  },
  {
    "value": "mateus_leme_mg",
    "label": "Mateus Leme - MG"
  },
  {
    "value": "mathias_lobato_mg",
    "label": "Mathias Lobato - MG"
  },
  {
    "value": "matias_barbosa_mg",
    "label": "Matias Barbosa - MG"
  },
  {
    "value": "matias_cardoso_mg",
    "label": "Matias Cardoso - MG"
  },
  {
    "value": "matias_olímpio_pi",
    "label": "Matias Olímpio - PI"
  },
  {
    "value": "matina_ba",
    "label": "Matina - BA"
  },
  {
    "value": "matinha_ma",
    "label": "Matinha - MA"
  },
  {
    "value": "matinhas_pb",
    "label": "Matinhas - PB"
  },
  {
    "value": "matinhos_pr",
    "label": "Matinhos - PR"
  },
  {
    "value": "matipó_mg",
    "label": "Matipó - MG"
  },
  {
    "value": "mato_castelhano_rs",
    "label": "Mato Castelhano - RS"
  },
  {
    "value": "mato_grosso_pb",
    "label": "Mato Grosso - PB"
  },
  {
    "value": "mato_leitão_rs",
    "label": "Mato Leitão - RS"
  },
  {
    "value": "mato_queimado_rs",
    "label": "Mato Queimado - RS"
  },
  {
    "value": "mato_rico_pr",
    "label": "Mato Rico - PR"
  },
  {
    "value": "mato_verde_mg",
    "label": "Mato Verde - MG"
  },
  {
    "value": "matos_costa_sc",
    "label": "Matos Costa - SC"
  },
  {
    "value": "matozinhos_mg",
    "label": "Matozinhos - MG"
  },
  {
    "value": "matrinchã_go",
    "label": "Matrinchã - GO"
  },
  {
    "value": "matriz_de_camaragibe_al",
    "label": "Matriz de Camaragibe - AL"
  },
  {
    "value": "matupá_mt",
    "label": "Matupá - MT"
  },
  {
    "value": "maturéia_pb",
    "label": "Maturéia - PB"
  },
  {
    "value": "matutina_mg",
    "label": "Matutina - MG"
  },
  {
    "value": "matão_sp",
    "label": "Matão - SP"
  },
  {
    "value": "matões_ma",
    "label": "Matões - MA"
  },
  {
    "value": "matões_do_norte_ma",
    "label": "Matões do Norte - MA"
  },
  {
    "value": "maurilândia_go",
    "label": "Maurilândia - GO"
  },
  {
    "value": "maurilândia_do_tocantins_to",
    "label": "Maurilândia do Tocantins - TO"
  },
  {
    "value": "mauriti_ce",
    "label": "Mauriti - CE"
  },
  {
    "value": "mauá_sp",
    "label": "Mauá - SP"
  },
  {
    "value": "mauá_da_serra_pr",
    "label": "Mauá da Serra - PR"
  },
  {
    "value": "maués_am",
    "label": "Maués - AM"
  },
  {
    "value": "maxaranguape_rn",
    "label": "Maxaranguape - RN"
  },
  {
    "value": "maximiliano_de_almeida_rs",
    "label": "Maximiliano de Almeida - RS"
  },
  {
    "value": "mazagão_ap",
    "label": "Mazagão - AP"
  },
  {
    "value": "maçambara_rs",
    "label": "Maçambara - RS"
  },
  {
    "value": "medeiros_mg",
    "label": "Medeiros - MG"
  },
  {
    "value": "medeiros_neto_ba",
    "label": "Medeiros Neto - BA"
  },
  {
    "value": "medianeira_pr",
    "label": "Medianeira - PR"
  },
  {
    "value": "medicilândia_pa",
    "label": "Medicilândia - PA"
  },
  {
    "value": "medina_mg",
    "label": "Medina - MG"
  },
  {
    "value": "meleiro_sc",
    "label": "Meleiro - SC"
  },
  {
    "value": "melgaço_pa",
    "label": "Melgaço - PA"
  },
  {
    "value": "mendes_rj",
    "label": "Mendes - RJ"
  },
  {
    "value": "mendes_pimentel_mg",
    "label": "Mendes Pimentel - MG"
  },
  {
    "value": "mendonça_sp",
    "label": "Mendonça - SP"
  },
  {
    "value": "mercedes_pr",
    "label": "Mercedes - PR"
  },
  {
    "value": "mercês_mg",
    "label": "Mercês - MG"
  },
  {
    "value": "meridiano_sp",
    "label": "Meridiano - SP"
  },
  {
    "value": "meruoca_ce",
    "label": "Meruoca - CE"
  },
  {
    "value": "mesquita_mg",
    "label": "Mesquita - MG"
  },
  {
    "value": "mesquita_rj",
    "label": "Mesquita - RJ"
  },
  {
    "value": "messias_al",
    "label": "Messias - AL"
  },
  {
    "value": "messias_targino_rn",
    "label": "Messias Targino - RN"
  },
  {
    "value": "mesópolis_sp",
    "label": "Mesópolis - SP"
  },
  {
    "value": "miguel_alves_pi",
    "label": "Miguel Alves - PI"
  },
  {
    "value": "miguel_calmon_ba",
    "label": "Miguel Calmon - BA"
  },
  {
    "value": "miguel_leão_pi",
    "label": "Miguel Leão - PI"
  },
  {
    "value": "miguel_pereira_rj",
    "label": "Miguel Pereira - RJ"
  },
  {
    "value": "miguelópolis_sp",
    "label": "Miguelópolis - SP"
  },
  {
    "value": "milagres_ba",
    "label": "Milagres - BA"
  },
  {
    "value": "milagres_ce",
    "label": "Milagres - CE"
  },
  {
    "value": "milagres_do_maranhão_ma",
    "label": "Milagres do Maranhão - MA"
  },
  {
    "value": "milhã_ce",
    "label": "Milhã - CE"
  },
  {
    "value": "milton_brandão_pi",
    "label": "Milton Brandão - PI"
  },
  {
    "value": "mimoso_de_goiás_go",
    "label": "Mimoso de Goiás - GO"
  },
  {
    "value": "mimoso_do_sul_es",
    "label": "Mimoso do Sul - ES"
  },
  {
    "value": "minador_do_negrão_al",
    "label": "Minador do Negrão - AL"
  },
  {
    "value": "minas_novas_mg",
    "label": "Minas Novas - MG"
  },
  {
    "value": "minas_do_leão_rs",
    "label": "Minas do Leão - RS"
  },
  {
    "value": "minaçu_go",
    "label": "Minaçu - GO"
  },
  {
    "value": "minduri_mg",
    "label": "Minduri - MG"
  },
  {
    "value": "mineiros_go",
    "label": "Mineiros - GO"
  },
  {
    "value": "mineiros_do_tietê_sp",
    "label": "Mineiros do Tietê - SP"
  },
  {
    "value": "ministro_andreazza_ro",
    "label": "Ministro Andreazza - RO"
  },
  {
    "value": "mira_estrela_sp",
    "label": "Mira Estrela - SP"
  },
  {
    "value": "mirabela_mg",
    "label": "Mirabela - MG"
  },
  {
    "value": "miracatu_sp",
    "label": "Miracatu - SP"
  },
  {
    "value": "miracema_rj",
    "label": "Miracema - RJ"
  },
  {
    "value": "miracema_do_tocantins_to",
    "label": "Miracema do Tocantins - TO"
  },
  {
    "value": "mirador_ma",
    "label": "Mirador - MA"
  },
  {
    "value": "mirador_pr",
    "label": "Mirador - PR"
  },
  {
    "value": "miradouro_mg",
    "label": "Miradouro - MG"
  },
  {
    "value": "miraguaí_rs",
    "label": "Miraguaí - RS"
  },
  {
    "value": "miranda_ms",
    "label": "Miranda - MS"
  },
  {
    "value": "miranda_do_norte_ma",
    "label": "Miranda do Norte - MA"
  },
  {
    "value": "mirandiba_pe",
    "label": "Mirandiba - PE"
  },
  {
    "value": "mirandópolis_sp",
    "label": "Mirandópolis - SP"
  },
  {
    "value": "mirangaba_ba",
    "label": "Mirangaba - BA"
  },
  {
    "value": "miranorte_to",
    "label": "Miranorte - TO"
  },
  {
    "value": "mirante_ba",
    "label": "Mirante - BA"
  },
  {
    "value": "mirante_da_serra_ro",
    "label": "Mirante da Serra - RO"
  },
  {
    "value": "mirante_do_paranapanema_sp",
    "label": "Mirante do Paranapanema - SP"
  },
  {
    "value": "miraselva_pr",
    "label": "Miraselva - PR"
  },
  {
    "value": "mirassol_sp",
    "label": "Mirassol - SP"
  },
  {
    "value": "mirassol_d'oeste_mt",
    "label": "Mirassol d'Oeste - MT"
  },
  {
    "value": "mirassolândia_sp",
    "label": "Mirassolândia - SP"
  },
  {
    "value": "miravânia_mg",
    "label": "Miravânia - MG"
  },
  {
    "value": "miraí_mg",
    "label": "Miraí - MG"
  },
  {
    "value": "miraíma_ce",
    "label": "Miraíma - CE"
  },
  {
    "value": "mirim_doce_sc",
    "label": "Mirim Doce - SC"
  },
  {
    "value": "mirinzal_ma",
    "label": "Mirinzal - MA"
  },
  {
    "value": "missal_pr",
    "label": "Missal - PR"
  },
  {
    "value": "missão_velha_ce",
    "label": "Missão Velha - CE"
  },
  {
    "value": "mocajuba_pa",
    "label": "Mocajuba - PA"
  },
  {
    "value": "mococa_sp",
    "label": "Mococa - SP"
  },
  {
    "value": "modelo_sc",
    "label": "Modelo - SC"
  },
  {
    "value": "moeda_mg",
    "label": "Moeda - MG"
  },
  {
    "value": "moema_mg",
    "label": "Moema - MG"
  },
  {
    "value": "mogeiro_pb",
    "label": "Mogeiro - PB"
  },
  {
    "value": "mogi_das_cruzes_sp",
    "label": "Mogi das Cruzes - SP"
  },
  {
    "value": "mogi-guaçu_sp",
    "label": "Mogi-Guaçu - SP"
  },
  {
    "value": "mogi-mirim_sp",
    "label": "Mogi-Mirim - SP"
  },
  {
    "value": "moiporá_go",
    "label": "Moiporá - GO"
  },
  {
    "value": "moita_bonita_se",
    "label": "Moita Bonita - SE"
  },
  {
    "value": "moju_pa",
    "label": "Moju - PA"
  },
  {
    "value": "mombaça_ce",
    "label": "Mombaça - CE"
  },
  {
    "value": "mombuca_sp",
    "label": "Mombuca - SP"
  },
  {
    "value": "mondaí_sc",
    "label": "Mondaí - SC"
  },
  {
    "value": "mongaguá_sp",
    "label": "Mongaguá - SP"
  },
  {
    "value": "monjolos_mg",
    "label": "Monjolos - MG"
  },
  {
    "value": "monsenhor_gil_pi",
    "label": "Monsenhor Gil - PI"
  },
  {
    "value": "monsenhor_hipólito_pi",
    "label": "Monsenhor Hipólito - PI"
  },
  {
    "value": "monsenhor_paulo_mg",
    "label": "Monsenhor Paulo - MG"
  },
  {
    "value": "monsenhor_tabosa_ce",
    "label": "Monsenhor Tabosa - CE"
  },
  {
    "value": "montadas_pb",
    "label": "Montadas - PB"
  },
  {
    "value": "montalvânia_mg",
    "label": "Montalvânia - MG"
  },
  {
    "value": "montanha_es",
    "label": "Montanha - ES"
  },
  {
    "value": "montanhas_rn",
    "label": "Montanhas - RN"
  },
  {
    "value": "montauri_rs",
    "label": "Montauri - RS"
  },
  {
    "value": "monte_alegre_pa",
    "label": "Monte Alegre - PA"
  },
  {
    "value": "monte_alegre_rn",
    "label": "Monte Alegre - RN"
  },
  {
    "value": "monte_alegre_de_goiás_go",
    "label": "Monte Alegre de Goiás - GO"
  },
  {
    "value": "monte_alegre_de_minas_mg",
    "label": "Monte Alegre de Minas - MG"
  },
  {
    "value": "monte_alegre_de_sergipe_se",
    "label": "Monte Alegre de Sergipe - SE"
  },
  {
    "value": "monte_alegre_do_piauí_pi",
    "label": "Monte Alegre do Piauí - PI"
  },
  {
    "value": "monte_alegre_do_sul_sp",
    "label": "Monte Alegre do Sul - SP"
  },
  {
    "value": "monte_alegre_dos_campos_rs",
    "label": "Monte Alegre dos Campos - RS"
  },
  {
    "value": "monte_alto_sp",
    "label": "Monte Alto - SP"
  },
  {
    "value": "monte_aprazível_sp",
    "label": "Monte Aprazível - SP"
  },
  {
    "value": "monte_azul_mg",
    "label": "Monte Azul - MG"
  },
  {
    "value": "monte_azul_paulista_sp",
    "label": "Monte Azul Paulista - SP"
  },
  {
    "value": "monte_belo_mg",
    "label": "Monte Belo - MG"
  },
  {
    "value": "monte_belo_do_sul_rs",
    "label": "Monte Belo do Sul - RS"
  },
  {
    "value": "monte_carlo_sc",
    "label": "Monte Carlo - SC"
  },
  {
    "value": "monte_carmelo_mg",
    "label": "Monte Carmelo - MG"
  },
  {
    "value": "monte_castelo_sc",
    "label": "Monte Castelo - SC"
  },
  {
    "value": "monte_castelo_sp",
    "label": "Monte Castelo - SP"
  },
  {
    "value": "monte_formoso_mg",
    "label": "Monte Formoso - MG"
  },
  {
    "value": "monte_horebe_pb",
    "label": "Monte Horebe - PB"
  },
  {
    "value": "monte_mor_sp",
    "label": "Monte Mor - SP"
  },
  {
    "value": "monte_negro_ro",
    "label": "Monte Negro - RO"
  },
  {
    "value": "monte_santo_ba",
    "label": "Monte Santo - BA"
  },
  {
    "value": "monte_santo_de_minas_mg",
    "label": "Monte Santo de Minas - MG"
  },
  {
    "value": "monte_santo_do_tocantins_to",
    "label": "Monte Santo do Tocantins - TO"
  },
  {
    "value": "monte_sião_mg",
    "label": "Monte Sião - MG"
  },
  {
    "value": "monte_das_gameleiras_rn",
    "label": "Monte das Gameleiras - RN"
  },
  {
    "value": "monte_do_carmo_to",
    "label": "Monte do Carmo - TO"
  },
  {
    "value": "monteiro_pb",
    "label": "Monteiro - PB"
  },
  {
    "value": "monteiro_lobato_sp",
    "label": "Monteiro Lobato - SP"
  },
  {
    "value": "monteirópolis_al",
    "label": "Monteirópolis - AL"
  },
  {
    "value": "montenegro_rs",
    "label": "Montenegro - RS"
  },
  {
    "value": "montes_altos_ma",
    "label": "Montes Altos - MA"
  },
  {
    "value": "montes_claros_mg",
    "label": "Montes Claros - MG"
  },
  {
    "value": "montes_claros_de_goiás_go",
    "label": "Montes Claros de Goiás - GO"
  },
  {
    "value": "montezuma_mg",
    "label": "Montezuma - MG"
  },
  {
    "value": "montividiu_go",
    "label": "Montividiu - GO"
  },
  {
    "value": "montividiu_do_norte_go",
    "label": "Montividiu do Norte - GO"
  },
  {
    "value": "monção_ma",
    "label": "Monção - MA"
  },
  {
    "value": "monções_sp",
    "label": "Monções - SP"
  },
  {
    "value": "morada_nova_ce",
    "label": "Morada Nova - CE"
  },
  {
    "value": "morada_nova_de_minas_mg",
    "label": "Morada Nova de Minas - MG"
  },
  {
    "value": "moraújo_ce",
    "label": "Moraújo - CE"
  },
  {
    "value": "moreilândia_pe",
    "label": "Moreilândia - PE"
  },
  {
    "value": "moreira_sales_pr",
    "label": "Moreira Sales - PR"
  },
  {
    "value": "moreno_pe",
    "label": "Moreno - PE"
  },
  {
    "value": "mormaço_rs",
    "label": "Mormaço - RS"
  },
  {
    "value": "morpará_ba",
    "label": "Morpará - BA"
  },
  {
    "value": "morretes_pr",
    "label": "Morretes - PR"
  },
  {
    "value": "morrinhos_ce",
    "label": "Morrinhos - CE"
  },
  {
    "value": "morrinhos_go",
    "label": "Morrinhos - GO"
  },
  {
    "value": "morrinhos_do_sul_rs",
    "label": "Morrinhos do Sul - RS"
  },
  {
    "value": "morro_agudo_sp",
    "label": "Morro Agudo - SP"
  },
  {
    "value": "morro_agudo_de_goiás_go",
    "label": "Morro Agudo de Goiás - GO"
  },
  {
    "value": "morro_cabeça_no_tempo_pi",
    "label": "Morro Cabeça no Tempo - PI"
  },
  {
    "value": "morro_grande_sc",
    "label": "Morro Grande - SC"
  },
  {
    "value": "morro_redondo_rs",
    "label": "Morro Redondo - RS"
  },
  {
    "value": "morro_reuter_rs",
    "label": "Morro Reuter - RS"
  },
  {
    "value": "morro_da_fumaça_sc",
    "label": "Morro da Fumaça - SC"
  },
  {
    "value": "morro_da_garça_mg",
    "label": "Morro da Garça - MG"
  },
  {
    "value": "morro_do_chapéu_ba",
    "label": "Morro do Chapéu - BA"
  },
  {
    "value": "morro_do_chapéu_do_piauí_pi",
    "label": "Morro do Chapéu do Piauí - PI"
  },
  {
    "value": "morro_do_pilar_mg",
    "label": "Morro do Pilar - MG"
  },
  {
    "value": "morros_ma",
    "label": "Morros - MA"
  },
  {
    "value": "mortugaba_ba",
    "label": "Mortugaba - BA"
  },
  {
    "value": "morungaba_sp",
    "label": "Morungaba - SP"
  },
  {
    "value": "mossoró_rn",
    "label": "Mossoró - RN"
  },
  {
    "value": "mossâmedes_go",
    "label": "Mossâmedes - GO"
  },
  {
    "value": "mostardas_rs",
    "label": "Mostardas - RS"
  },
  {
    "value": "motuca_sp",
    "label": "Motuca - SP"
  },
  {
    "value": "mozarlândia_go",
    "label": "Mozarlândia - GO"
  },
  {
    "value": "muaná_pa",
    "label": "Muaná - PA"
  },
  {
    "value": "mucajaí_rr",
    "label": "Mucajaí - RR"
  },
  {
    "value": "mucambo_ce",
    "label": "Mucambo - CE"
  },
  {
    "value": "mucugê_ba",
    "label": "Mucugê - BA"
  },
  {
    "value": "mucuri_ba",
    "label": "Mucuri - BA"
  },
  {
    "value": "mucurici_es",
    "label": "Mucurici - ES"
  },
  {
    "value": "muitos_capões_rs",
    "label": "Muitos Capões - RS"
  },
  {
    "value": "muliterno_rs",
    "label": "Muliterno - RS"
  },
  {
    "value": "mulungu_ce",
    "label": "Mulungu - CE"
  },
  {
    "value": "mulungu_pb",
    "label": "Mulungu - PB"
  },
  {
    "value": "mulungu_do_morro_ba",
    "label": "Mulungu do Morro - BA"
  },
  {
    "value": "mundo_novo_ba",
    "label": "Mundo Novo - BA"
  },
  {
    "value": "mundo_novo_go",
    "label": "Mundo Novo - GO"
  },
  {
    "value": "mundo_novo_ms",
    "label": "Mundo Novo - MS"
  },
  {
    "value": "munhoz_mg",
    "label": "Munhoz - MG"
  },
  {
    "value": "munhoz_de_melo_pr",
    "label": "Munhoz de Melo - PR"
  },
  {
    "value": "muniz_ferreira_ba",
    "label": "Muniz Ferreira - BA"
  },
  {
    "value": "muniz_freire_es",
    "label": "Muniz Freire - ES"
  },
  {
    "value": "muqui_es",
    "label": "Muqui - ES"
  },
  {
    "value": "muquém_de_são_francisco_ba",
    "label": "Muquém de São Francisco - BA"
  },
  {
    "value": "muriaé_mg",
    "label": "Muriaé - MG"
  },
  {
    "value": "muribeca_se",
    "label": "Muribeca - SE"
  },
  {
    "value": "murici_al",
    "label": "Murici - AL"
  },
  {
    "value": "murici_dos_portelas_pi",
    "label": "Murici dos Portelas - PI"
  },
  {
    "value": "muricilândia_to",
    "label": "Muricilândia - TO"
  },
  {
    "value": "muritiba_ba",
    "label": "Muritiba - BA"
  },
  {
    "value": "murutinga_do_sul_sp",
    "label": "Murutinga do Sul - SP"
  },
  {
    "value": "mutum_mg",
    "label": "Mutum - MG"
  },
  {
    "value": "mutunópolis_go",
    "label": "Mutunópolis - GO"
  },
  {
    "value": "mutuípe_ba",
    "label": "Mutuípe - BA"
  },
  {
    "value": "muzambinho_mg",
    "label": "Muzambinho - MG"
  },
  {
    "value": "muçum_rs",
    "label": "Muçum - RS"
  },
  {
    "value": "mário_campos_mg",
    "label": "Mário Campos - MG"
  },
  {
    "value": "mâncio_lima_ac",
    "label": "Mâncio Lima - AC"
  },
  {
    "value": "mãe_d'água_pb",
    "label": "Mãe d'Água - PB"
  },
  {
    "value": "mãe_do_rio_pa",
    "label": "Mãe do Rio - PA"
  },
  {
    "value": "nacip_raydan_mg",
    "label": "Nacip Raydan - MG"
  },
  {
    "value": "nantes_sp",
    "label": "Nantes - SP"
  },
  {
    "value": "nanuque_mg",
    "label": "Nanuque - MG"
  },
  {
    "value": "naque_mg",
    "label": "Naque - MG"
  },
  {
    "value": "narandiba_sp",
    "label": "Narandiba - SP"
  },
  {
    "value": "natal_rn",
    "label": "Natal - RN"
  },
  {
    "value": "natalândia_mg",
    "label": "Natalândia - MG"
  },
  {
    "value": "natividade_rj",
    "label": "Natividade - RJ"
  },
  {
    "value": "natividade_to",
    "label": "Natividade - TO"
  },
  {
    "value": "natividade_da_serra_sp",
    "label": "Natividade da Serra - SP"
  },
  {
    "value": "natuba_pb",
    "label": "Natuba - PB"
  },
  {
    "value": "natércia_mg",
    "label": "Natércia - MG"
  },
  {
    "value": "navegantes_sc",
    "label": "Navegantes - SC"
  },
  {
    "value": "naviraí_ms",
    "label": "Naviraí - MS"
  },
  {
    "value": "nazareno_mg",
    "label": "Nazareno - MG"
  },
  {
    "value": "nazarezinho_pb",
    "label": "Nazarezinho - PB"
  },
  {
    "value": "nazaré_ba",
    "label": "Nazaré - BA"
  },
  {
    "value": "nazaré_to",
    "label": "Nazaré - TO"
  },
  {
    "value": "nazaré_paulista_sp",
    "label": "Nazaré Paulista - SP"
  },
  {
    "value": "nazaré_da_mata_pe",
    "label": "Nazaré da Mata - PE"
  },
  {
    "value": "nazaré_do_piauí_pi",
    "label": "Nazaré do Piauí - PI"
  },
  {
    "value": "nazário_go",
    "label": "Nazário - GO"
  },
  {
    "value": "nepomuceno_mg",
    "label": "Nepomuceno - MG"
  },
  {
    "value": "nerópolis_go",
    "label": "Nerópolis - GO"
  },
  {
    "value": "neves_paulista_sp",
    "label": "Neves Paulista - SP"
  },
  {
    "value": "neópolis_se",
    "label": "Neópolis - SE"
  },
  {
    "value": "nhamundá_am",
    "label": "Nhamundá - AM"
  },
  {
    "value": "nhandeara_sp",
    "label": "Nhandeara - SP"
  },
  {
    "value": "nicolau_vergueiro_rs",
    "label": "Nicolau Vergueiro - RS"
  },
  {
    "value": "nilo_peçanha_ba",
    "label": "Nilo Peçanha - BA"
  },
  {
    "value": "nilópolis_rj",
    "label": "Nilópolis - RJ"
  },
  {
    "value": "nina_rodrigues_ma",
    "label": "Nina Rodrigues - MA"
  },
  {
    "value": "ninheira_mg",
    "label": "Ninheira - MG"
  },
  {
    "value": "nioaque_ms",
    "label": "Nioaque - MS"
  },
  {
    "value": "nipoã_sp",
    "label": "Nipoã - SP"
  },
  {
    "value": "niquelândia_go",
    "label": "Niquelândia - GO"
  },
  {
    "value": "niterói_rj",
    "label": "Niterói - RJ"
  },
  {
    "value": "nobres_mt",
    "label": "Nobres - MT"
  },
  {
    "value": "nonoai_rs",
    "label": "Nonoai - RS"
  },
  {
    "value": "nordestina_ba",
    "label": "Nordestina - BA"
  },
  {
    "value": "normandia_rr",
    "label": "Normandia - RR"
  },
  {
    "value": "nortelândia_mt",
    "label": "Nortelândia - MT"
  },
  {
    "value": "nossa_senhora_aparecida_se",
    "label": "Nossa Senhora Aparecida - SE"
  },
  {
    "value": "nossa_senhora_da_glória_se",
    "label": "Nossa Senhora da Glória - SE"
  },
  {
    "value": "nossa_senhora_das_dores_se",
    "label": "Nossa Senhora das Dores - SE"
  },
  {
    "value": "nossa_senhora_das_graças_pr",
    "label": "Nossa Senhora das Graças - PR"
  },
  {
    "value": "nossa_senhora_de_lourdes_se",
    "label": "Nossa Senhora de Lourdes - SE"
  },
  {
    "value": "nossa_senhora_de_nazaré_pi",
    "label": "Nossa Senhora de Nazaré - PI"
  },
  {
    "value": "nossa_senhora_do_livramento_mt",
    "label": "Nossa Senhora do Livramento - MT"
  },
  {
    "value": "nossa_senhora_do_socorro_se",
    "label": "Nossa Senhora do Socorro - SE"
  },
  {
    "value": "nossa_senhora_dos_remédios_pi",
    "label": "Nossa Senhora dos Remédios - PI"
  },
  {
    "value": "nova_aliança_sp",
    "label": "Nova Aliança - SP"
  },
  {
    "value": "nova_aliança_do_ivaí_pr",
    "label": "Nova Aliança do Ivaí - PR"
  },
  {
    "value": "nova_alvorada_rs",
    "label": "Nova Alvorada - RS"
  },
  {
    "value": "nova_alvorada_do_sul_ms",
    "label": "Nova Alvorada do Sul - MS"
  },
  {
    "value": "nova_américa_go",
    "label": "Nova América - GO"
  },
  {
    "value": "nova_américa_da_colina_pr",
    "label": "Nova América da Colina - PR"
  },
  {
    "value": "nova_andradina_ms",
    "label": "Nova Andradina - MS"
  },
  {
    "value": "nova_araçá_rs",
    "label": "Nova Araçá - RS"
  },
  {
    "value": "nova_aurora_go",
    "label": "Nova Aurora - GO"
  },
  {
    "value": "nova_aurora_pr",
    "label": "Nova Aurora - PR"
  },
  {
    "value": "nova_bandeirantes_mt",
    "label": "Nova Bandeirantes - MT"
  },
  {
    "value": "nova_bassano_rs",
    "label": "Nova Bassano - RS"
  },
  {
    "value": "nova_belém_mg",
    "label": "Nova Belém - MG"
  },
  {
    "value": "nova_boa_vista_rs",
    "label": "Nova Boa Vista - RS"
  },
  {
    "value": "nova_brasilândia_mt",
    "label": "Nova Brasilândia - MT"
  },
  {
    "value": "nova_brasilândia_d'oeste_ro",
    "label": "Nova Brasilândia d'Oeste - RO"
  },
  {
    "value": "nova_bréscia_rs",
    "label": "Nova Bréscia - RS"
  },
  {
    "value": "nova_campina_sp",
    "label": "Nova Campina - SP"
  },
  {
    "value": "nova_canaã_ba",
    "label": "Nova Canaã - BA"
  },
  {
    "value": "nova_canaã_paulista_sp",
    "label": "Nova Canaã Paulista - SP"
  },
  {
    "value": "nova_candelária_rs",
    "label": "Nova Candelária - RS"
  },
  {
    "value": "nova_cantu_pr",
    "label": "Nova Cantu - PR"
  },
  {
    "value": "nova_canãa_do_norte_mt",
    "label": "Nova Canãa do Norte - MT"
  },
  {
    "value": "nova_castilho_sp",
    "label": "Nova Castilho - SP"
  },
  {
    "value": "nova_colinas_ma",
    "label": "Nova Colinas - MA"
  },
  {
    "value": "nova_crixás_go",
    "label": "Nova Crixás - GO"
  },
  {
    "value": "nova_cruz_rn",
    "label": "Nova Cruz - RN"
  },
  {
    "value": "nova_era_mg",
    "label": "Nova Era - MG"
  },
  {
    "value": "nova_erechim_sc",
    "label": "Nova Erechim - SC"
  },
  {
    "value": "nova_esperança_pr",
    "label": "Nova Esperança - PR"
  },
  {
    "value": "nova_esperança_do_piriá_pa",
    "label": "Nova Esperança do Piriá - PA"
  },
  {
    "value": "nova_esperança_do_sudoeste_pr",
    "label": "Nova Esperança do Sudoeste - PR"
  },
  {
    "value": "nova_esperança_do_sul_rs",
    "label": "Nova Esperança do Sul - RS"
  },
  {
    "value": "nova_europa_sp",
    "label": "Nova Europa - SP"
  },
  {
    "value": "nova_floresta_pb",
    "label": "Nova Floresta - PB"
  },
  {
    "value": "nova_friburgo_rj",
    "label": "Nova Friburgo - RJ"
  },
  {
    "value": "nova_fátima_ba",
    "label": "Nova Fátima - BA"
  },
  {
    "value": "nova_fátima_pr",
    "label": "Nova Fátima - PR"
  },
  {
    "value": "nova_glória_go",
    "label": "Nova Glória - GO"
  },
  {
    "value": "nova_granada_sp",
    "label": "Nova Granada - SP"
  },
  {
    "value": "nova_guarita_mt",
    "label": "Nova Guarita - MT"
  },
  {
    "value": "nova_guataporanga_sp",
    "label": "Nova Guataporanga - SP"
  },
  {
    "value": "nova_hartz_rs",
    "label": "Nova Hartz - RS"
  },
  {
    "value": "nova_ibiá_ba",
    "label": "Nova Ibiá - BA"
  },
  {
    "value": "nova_iguaçu_rj",
    "label": "Nova Iguaçu - RJ"
  },
  {
    "value": "nova_iguaçu_de_goiás_go",
    "label": "Nova Iguaçu de Goiás - GO"
  },
  {
    "value": "nova_independência_sp",
    "label": "Nova Independência - SP"
  },
  {
    "value": "nova_iorque_ma",
    "label": "Nova Iorque - MA"
  },
  {
    "value": "nova_ipixuna_pa",
    "label": "Nova Ipixuna - PA"
  },
  {
    "value": "nova_itaberaba_sc",
    "label": "Nova Itaberaba - SC"
  },
  {
    "value": "nova_itarana_ba",
    "label": "Nova Itarana - BA"
  },
  {
    "value": "nova_lacerda_mt",
    "label": "Nova Lacerda - MT"
  },
  {
    "value": "nova_laranjeiras_pr",
    "label": "Nova Laranjeiras - PR"
  },
  {
    "value": "nova_lima_mg",
    "label": "Nova Lima - MG"
  },
  {
    "value": "nova_londrina_pr",
    "label": "Nova Londrina - PR"
  },
  {
    "value": "nova_luzitânia_sp",
    "label": "Nova Luzitânia - SP"
  },
  {
    "value": "nova_mamoré_ro",
    "label": "Nova Mamoré - RO"
  },
  {
    "value": "nova_marilândia_mt",
    "label": "Nova Marilândia - MT"
  },
  {
    "value": "nova_maringá_mt",
    "label": "Nova Maringá - MT"
  },
  {
    "value": "nova_monte_verde_mt",
    "label": "Nova Monte Verde - MT"
  },
  {
    "value": "nova_mutum_mt",
    "label": "Nova Mutum - MT"
  },
  {
    "value": "nova_módica_mg",
    "label": "Nova Módica - MG"
  },
  {
    "value": "nova_nazaré_mt",
    "label": "Nova Nazaré - MT"
  },
  {
    "value": "nova_odessa_sp",
    "label": "Nova Odessa - SP"
  },
  {
    "value": "nova_olinda_ce",
    "label": "Nova Olinda - CE"
  },
  {
    "value": "nova_olinda_pb",
    "label": "Nova Olinda - PB"
  },
  {
    "value": "nova_olinda_to",
    "label": "Nova Olinda - TO"
  },
  {
    "value": "nova_olinda_do_maranhão_ma",
    "label": "Nova Olinda do Maranhão - MA"
  },
  {
    "value": "nova_olinda_do_norte_am",
    "label": "Nova Olinda do Norte - AM"
  },
  {
    "value": "nova_olímpia_mt",
    "label": "Nova Olímpia - MT"
  },
  {
    "value": "nova_olímpia_pr",
    "label": "Nova Olímpia - PR"
  },
  {
    "value": "nova_palma_rs",
    "label": "Nova Palma - RS"
  },
  {
    "value": "nova_palmeira_pb",
    "label": "Nova Palmeira - PB"
  },
  {
    "value": "nova_petrópolis_rs",
    "label": "Nova Petrópolis - RS"
  },
  {
    "value": "nova_ponte_mg",
    "label": "Nova Ponte - MG"
  },
  {
    "value": "nova_porteirinha_mg",
    "label": "Nova Porteirinha - MG"
  },
  {
    "value": "nova_prata_rs",
    "label": "Nova Prata - RS"
  },
  {
    "value": "nova_prata_do_iguaçu_pr",
    "label": "Nova Prata do Iguaçu - PR"
  },
  {
    "value": "nova_pádua_rs",
    "label": "Nova Pádua - RS"
  },
  {
    "value": "nova_ramada_rs",
    "label": "Nova Ramada - RS"
  },
  {
    "value": "nova_redenção_ba",
    "label": "Nova Redenção - BA"
  },
  {
    "value": "nova_resende_mg",
    "label": "Nova Resende - MG"
  },
  {
    "value": "nova_roma_go",
    "label": "Nova Roma - GO"
  },
  {
    "value": "nova_roma_do_sul_rs",
    "label": "Nova Roma do Sul - RS"
  },
  {
    "value": "nova_rosalândia_to",
    "label": "Nova Rosalândia - TO"
  },
  {
    "value": "nova_russas_ce",
    "label": "Nova Russas - CE"
  },
  {
    "value": "nova_santa_bárbara_pr",
    "label": "Nova Santa Bárbara - PR"
  },
  {
    "value": "nova_santa_helena_mt",
    "label": "Nova Santa Helena - MT"
  },
  {
    "value": "nova_santa_rita_pi",
    "label": "Nova Santa Rita - PI"
  },
  {
    "value": "nova_santa_rita_rs",
    "label": "Nova Santa Rita - RS"
  },
  {
    "value": "nova_santa_rosa_pr",
    "label": "Nova Santa Rosa - PR"
  },
  {
    "value": "nova_serrana_mg",
    "label": "Nova Serrana - MG"
  },
  {
    "value": "nova_soure_ba",
    "label": "Nova Soure - BA"
  },
  {
    "value": "nova_tebas_pr",
    "label": "Nova Tebas - PR"
  },
  {
    "value": "nova_timboteua_pa",
    "label": "Nova Timboteua - PA"
  },
  {
    "value": "nova_trento_sc",
    "label": "Nova Trento - SC"
  },
  {
    "value": "nova_ubiratã_mt",
    "label": "Nova Ubiratã - MT"
  },
  {
    "value": "nova_união_mg",
    "label": "Nova União - MG"
  },
  {
    "value": "nova_união_ro",
    "label": "Nova União - RO"
  },
  {
    "value": "nova_veneza_go",
    "label": "Nova Veneza - GO"
  },
  {
    "value": "nova_veneza_sc",
    "label": "Nova Veneza - SC"
  },
  {
    "value": "nova_venécia_es",
    "label": "Nova Venécia - ES"
  },
  {
    "value": "nova_viçosa_ba",
    "label": "Nova Viçosa - BA"
  },
  {
    "value": "nova_xavantina_mt",
    "label": "Nova Xavantina - MT"
  },
  {
    "value": "novais_sp",
    "label": "Novais - SP"
  },
  {
    "value": "novo_acordo_to",
    "label": "Novo Acordo - TO"
  },
  {
    "value": "novo_airão_am",
    "label": "Novo Airão - AM"
  },
  {
    "value": "novo_alegre_to",
    "label": "Novo Alegre - TO"
  },
  {
    "value": "novo_aripuanã_am",
    "label": "Novo Aripuanã - AM"
  },
  {
    "value": "novo_barreiro_rs",
    "label": "Novo Barreiro - RS"
  },
  {
    "value": "novo_brasil_go",
    "label": "Novo Brasil - GO"
  },
  {
    "value": "novo_cabrais_rs",
    "label": "Novo Cabrais - RS"
  },
  {
    "value": "novo_cruzeiro_mg",
    "label": "Novo Cruzeiro - MG"
  },
  {
    "value": "novo_gama_go",
    "label": "Novo Gama - GO"
  },
  {
    "value": "novo_hamburgo_rs",
    "label": "Novo Hamburgo - RS"
  },
  {
    "value": "novo_horizonte_ba",
    "label": "Novo Horizonte - BA"
  },
  {
    "value": "novo_horizonte_sc",
    "label": "Novo Horizonte - SC"
  },
  {
    "value": "novo_horizonte_sp",
    "label": "Novo Horizonte - SP"
  },
  {
    "value": "novo_horizonte_do_norte_mt",
    "label": "Novo Horizonte do Norte - MT"
  },
  {
    "value": "novo_horizonte_do_oeste_ro",
    "label": "Novo Horizonte do Oeste - RO"
  },
  {
    "value": "novo_horizonte_do_sul_ms",
    "label": "Novo Horizonte do Sul - MS"
  },
  {
    "value": "novo_itacolomi_pr",
    "label": "Novo Itacolomi - PR"
  },
  {
    "value": "novo_jardim_to",
    "label": "Novo Jardim - TO"
  },
  {
    "value": "novo_lino_al",
    "label": "Novo Lino - AL"
  },
  {
    "value": "novo_machado_rs",
    "label": "Novo Machado - RS"
  },
  {
    "value": "novo_mundo_mt",
    "label": "Novo Mundo - MT"
  },
  {
    "value": "novo_oriente_ce",
    "label": "Novo Oriente - CE"
  },
  {
    "value": "novo_oriente_de_minas_mg",
    "label": "Novo Oriente de Minas - MG"
  },
  {
    "value": "novo_oriente_do_piauí_pi",
    "label": "Novo Oriente do Piauí - PI"
  },
  {
    "value": "novo_planalto_go",
    "label": "Novo Planalto - GO"
  },
  {
    "value": "novo_progresso_pa",
    "label": "Novo Progresso - PA"
  },
  {
    "value": "novo_repartimento_pa",
    "label": "Novo Repartimento - PA"
  },
  {
    "value": "novo_santo_antônio_mt",
    "label": "Novo Santo Antônio - MT"
  },
  {
    "value": "novo_santo_antônio_pi",
    "label": "Novo Santo Antônio - PI"
  },
  {
    "value": "novo_são_joaquim_mt",
    "label": "Novo São Joaquim - MT"
  },
  {
    "value": "novo_tiradentes_rs",
    "label": "Novo Tiradentes - RS"
  },
  {
    "value": "novo_triunfo_ba",
    "label": "Novo Triunfo - BA"
  },
  {
    "value": "novo_xingu_rs",
    "label": "Novo Xingu - RS"
  },
  {
    "value": "novorizonte_mg",
    "label": "Novorizonte - MG"
  },
  {
    "value": "nuporanga_sp",
    "label": "Nuporanga - SP"
  },
  {
    "value": "não-me-toque_rs",
    "label": "Não-Me-Toque - RS"
  },
  {
    "value": "nísia_floresta_rn",
    "label": "Nísia Floresta - RN"
  },
  {
    "value": "ocara_ce",
    "label": "Ocara - CE"
  },
  {
    "value": "ocauçu_sp",
    "label": "Ocauçu - SP"
  },
  {
    "value": "oeiras_pi",
    "label": "Oeiras - PI"
  },
  {
    "value": "oeiras_do_pará_pa",
    "label": "Oeiras do Pará - PA"
  },
  {
    "value": "oiapoque_ap",
    "label": "Oiapoque - AP"
  },
  {
    "value": "olaria_mg",
    "label": "Olaria - MG"
  },
  {
    "value": "olho_d'água_pb",
    "label": "Olho d'Água - PB"
  },
  {
    "value": "olho_d'água_grande_al",
    "label": "Olho d'Água Grande - AL"
  },
  {
    "value": "olho_d'água_das_cunhãs_ma",
    "label": "Olho d'Água das Cunhãs - MA"
  },
  {
    "value": "olho_d'água_das_flores_al",
    "label": "Olho d'Água das Flores - AL"
  },
  {
    "value": "olho_d'água_do_casado_al",
    "label": "Olho d'Água do Casado - AL"
  },
  {
    "value": "olho_d'água_do_piauí_pi",
    "label": "Olho d'Água do Piauí - PI"
  },
  {
    "value": "olho-d'água_do_borges_rn",
    "label": "Olho-d'Água do Borges - RN"
  },
  {
    "value": "olhos-d'água_mg",
    "label": "Olhos-d'Água - MG"
  },
  {
    "value": "olinda_pe",
    "label": "Olinda - PE"
  },
  {
    "value": "olinda_nova_do_maranhão_ma",
    "label": "Olinda Nova do Maranhão - MA"
  },
  {
    "value": "olindina_ba",
    "label": "Olindina - BA"
  },
  {
    "value": "olivedos_pb",
    "label": "Olivedos - PB"
  },
  {
    "value": "oliveira_mg",
    "label": "Oliveira - MG"
  },
  {
    "value": "oliveira_fortes_mg",
    "label": "Oliveira Fortes - MG"
  },
  {
    "value": "oliveira_de_fátima_to",
    "label": "Oliveira de Fátima - TO"
  },
  {
    "value": "oliveira_dos_brejinhos_ba",
    "label": "Oliveira dos Brejinhos - BA"
  },
  {
    "value": "olivença_al",
    "label": "Olivença - AL"
  },
  {
    "value": "olímpia_sp",
    "label": "Olímpia - SP"
  },
  {
    "value": "olímpio_noronha_mg",
    "label": "Olímpio Noronha - MG"
  },
  {
    "value": "onda_verde_sp",
    "label": "Onda Verde - SP"
  },
  {
    "value": "onça_de_pitangui_mg",
    "label": "Onça de Pitangui - MG"
  },
  {
    "value": "oratórios_mg",
    "label": "Oratórios - MG"
  },
  {
    "value": "oriente_sp",
    "label": "Oriente - SP"
  },
  {
    "value": "orindiúva_sp",
    "label": "Orindiúva - SP"
  },
  {
    "value": "oriximiná_pa",
    "label": "Oriximiná - PA"
  },
  {
    "value": "orizona_go",
    "label": "Orizona - GO"
  },
  {
    "value": "orizânia_mg",
    "label": "Orizânia - MG"
  },
  {
    "value": "orleans_sc",
    "label": "Orleans - SC"
  },
  {
    "value": "orlândia_sp",
    "label": "Orlândia - SP"
  },
  {
    "value": "orobó_pe",
    "label": "Orobó - PE"
  },
  {
    "value": "orocó_pe",
    "label": "Orocó - PE"
  },
  {
    "value": "ortigueira_pr",
    "label": "Ortigueira - PR"
  },
  {
    "value": "orós_ce",
    "label": "Orós - CE"
  },
  {
    "value": "osasco_sp",
    "label": "Osasco - SP"
  },
  {
    "value": "oscar_bressane_sp",
    "label": "Oscar Bressane - SP"
  },
  {
    "value": "osvaldo_cruz_sp",
    "label": "Osvaldo Cruz - SP"
  },
  {
    "value": "osório_rs",
    "label": "Osório - RS"
  },
  {
    "value": "otacílio_costa_sc",
    "label": "Otacílio Costa - SC"
  },
  {
    "value": "ouricuri_pe",
    "label": "Ouricuri - PE"
  },
  {
    "value": "ourilândia_do_norte_pa",
    "label": "Ourilândia do Norte - PA"
  },
  {
    "value": "ourinhos_sp",
    "label": "Ourinhos - SP"
  },
  {
    "value": "ourizona_pr",
    "label": "Ourizona - PR"
  },
  {
    "value": "ouriçangas_ba",
    "label": "Ouriçangas - BA"
  },
  {
    "value": "ouro_sc",
    "label": "Ouro - SC"
  },
  {
    "value": "ouro_branco_al",
    "label": "Ouro Branco - AL"
  },
  {
    "value": "ouro_branco_mg",
    "label": "Ouro Branco - MG"
  },
  {
    "value": "ouro_branco_rn",
    "label": "Ouro Branco - RN"
  },
  {
    "value": "ouro_fino_mg",
    "label": "Ouro Fino - MG"
  },
  {
    "value": "ouro_preto_mg",
    "label": "Ouro Preto - MG"
  },
  {
    "value": "ouro_preto_do_oeste_ro",
    "label": "Ouro Preto do Oeste - RO"
  },
  {
    "value": "ouro_velho_pb",
    "label": "Ouro Velho - PB"
  },
  {
    "value": "ouro_verde_sc",
    "label": "Ouro Verde - SC"
  },
  {
    "value": "ouro_verde_sp",
    "label": "Ouro Verde - SP"
  },
  {
    "value": "ouro_verde_de_goiás_go",
    "label": "Ouro Verde de Goiás - GO"
  },
  {
    "value": "ouro_verde_de_minas_mg",
    "label": "Ouro Verde de Minas - MG"
  },
  {
    "value": "ouro_verde_do_oeste_pr",
    "label": "Ouro Verde do Oeste - PR"
  },
  {
    "value": "ouroeste_sp",
    "label": "Ouroeste - SP"
  },
  {
    "value": "ourolândia_ba",
    "label": "Ourolândia - BA"
  },
  {
    "value": "ourém_pa",
    "label": "Ourém - PA"
  },
  {
    "value": "ouvidor_go",
    "label": "Ouvidor - GO"
  },
  {
    "value": "pacaembu_sp",
    "label": "Pacaembu - SP"
  },
  {
    "value": "pacajus_ce",
    "label": "Pacajus - CE"
  },
  {
    "value": "pacajá_pa",
    "label": "Pacajá - PA"
  },
  {
    "value": "pacaraima_rr",
    "label": "Pacaraima - RR"
  },
  {
    "value": "pacatuba_ce",
    "label": "Pacatuba - CE"
  },
  {
    "value": "pacatuba_se",
    "label": "Pacatuba - SE"
  },
  {
    "value": "pacoti_ce",
    "label": "Pacoti - CE"
  },
  {
    "value": "pacujá_ce",
    "label": "Pacujá - CE"
  },
  {
    "value": "padre_bernardo_go",
    "label": "Padre Bernardo - GO"
  },
  {
    "value": "padre_carvalho_mg",
    "label": "Padre Carvalho - MG"
  },
  {
    "value": "padre_marcos_pi",
    "label": "Padre Marcos - PI"
  },
  {
    "value": "padre_paraíso_mg",
    "label": "Padre Paraíso - MG"
  },
  {
    "value": "paes_landim_pi",
    "label": "Paes Landim - PI"
  },
  {
    "value": "pai_pedro_mg",
    "label": "Pai Pedro - MG"
  },
  {
    "value": "paial_sc",
    "label": "Paial - SC"
  },
  {
    "value": "paim_filho_rs",
    "label": "Paim Filho - RS"
  },
  {
    "value": "paineiras_mg",
    "label": "Paineiras - MG"
  },
  {
    "value": "painel_sc",
    "label": "Painel - SC"
  },
  {
    "value": "pains_mg",
    "label": "Pains - MG"
  },
  {
    "value": "paiva_mg",
    "label": "Paiva - MG"
  },
  {
    "value": "paiçandu_pr",
    "label": "Paiçandu - PR"
  },
  {
    "value": "pajeú_do_piauí_pi",
    "label": "Pajeú do Piauí - PI"
  },
  {
    "value": "palestina_al",
    "label": "Palestina - AL"
  },
  {
    "value": "palestina_sp",
    "label": "Palestina - SP"
  },
  {
    "value": "palestina_de_goiás_go",
    "label": "Palestina de Goiás - GO"
  },
  {
    "value": "palestina_do_pará_pa",
    "label": "Palestina do Pará - PA"
  },
  {
    "value": "palhano_ce",
    "label": "Palhano - CE"
  },
  {
    "value": "palhoça_sc",
    "label": "Palhoça - SC"
  },
  {
    "value": "palma_mg",
    "label": "Palma - MG"
  },
  {
    "value": "palma_sola_sc",
    "label": "Palma Sola - SC"
  },
  {
    "value": "palmares_pe",
    "label": "Palmares - PE"
  },
  {
    "value": "palmares_paulista_sp",
    "label": "Palmares Paulista - SP"
  },
  {
    "value": "palmares_do_sul_rs",
    "label": "Palmares do Sul - RS"
  },
  {
    "value": "palmas_pr",
    "label": "Palmas - PR"
  },
  {
    "value": "palmas_to",
    "label": "Palmas - TO"
  },
  {
    "value": "palmas_de_monte_alto_ba",
    "label": "Palmas de Monte Alto - BA"
  },
  {
    "value": "palmeira_pr",
    "label": "Palmeira - PR"
  },
  {
    "value": "palmeira_sc",
    "label": "Palmeira - SC"
  },
  {
    "value": "palmeira_d'oeste_sp",
    "label": "Palmeira d'Oeste - SP"
  },
  {
    "value": "palmeira_das_missões_rs",
    "label": "Palmeira das Missões - RS"
  },
  {
    "value": "palmeira_do_piauí_pi",
    "label": "Palmeira do Piauí - PI"
  },
  {
    "value": "palmeira_dos_índios_al",
    "label": "Palmeira dos Índios - AL"
  },
  {
    "value": "palmeirais_pi",
    "label": "Palmeirais - PI"
  },
  {
    "value": "palmeirante_to",
    "label": "Palmeirante - TO"
  },
  {
    "value": "palmeiras_ba",
    "label": "Palmeiras - BA"
  },
  {
    "value": "palmeiras_de_goiás_go",
    "label": "Palmeiras de Goiás - GO"
  },
  {
    "value": "palmeiras_do_tocantins_to",
    "label": "Palmeiras do Tocantins - TO"
  },
  {
    "value": "palmeirina_pe",
    "label": "Palmeirina - PE"
  },
  {
    "value": "palmeirândia_ma",
    "label": "Palmeirândia - MA"
  },
  {
    "value": "palmeirópolis_to",
    "label": "Palmeirópolis - TO"
  },
  {
    "value": "palmelo_go",
    "label": "Palmelo - GO"
  },
  {
    "value": "palminópolis_go",
    "label": "Palminópolis - GO"
  },
  {
    "value": "palmital_pr",
    "label": "Palmital - PR"
  },
  {
    "value": "palmital_sp",
    "label": "Palmital - SP"
  },
  {
    "value": "palmitinho_rs",
    "label": "Palmitinho - RS"
  },
  {
    "value": "palmitos_sc",
    "label": "Palmitos - SC"
  },
  {
    "value": "palmácia_ce",
    "label": "Palmácia - CE"
  },
  {
    "value": "palmópolis_mg",
    "label": "Palmópolis - MG"
  },
  {
    "value": "palotina_pr",
    "label": "Palotina - PR"
  },
  {
    "value": "panambi_rs",
    "label": "Panambi - RS"
  },
  {
    "value": "panamá_go",
    "label": "Panamá - GO"
  },
  {
    "value": "pancas_es",
    "label": "Pancas - ES"
  },
  {
    "value": "panelas_pe",
    "label": "Panelas - PE"
  },
  {
    "value": "panorama_sp",
    "label": "Panorama - SP"
  },
  {
    "value": "papagaios_mg",
    "label": "Papagaios - MG"
  },
  {
    "value": "papanduva_sc",
    "label": "Papanduva - SC"
  },
  {
    "value": "paquetá_pi",
    "label": "Paquetá - PI"
  },
  {
    "value": "paracambi_rj",
    "label": "Paracambi - RJ"
  },
  {
    "value": "paracatu_mg",
    "label": "Paracatu - MG"
  },
  {
    "value": "paracuru_ce",
    "label": "Paracuru - CE"
  },
  {
    "value": "paragominas_pa",
    "label": "Paragominas - PA"
  },
  {
    "value": "paraguaçu_mg",
    "label": "Paraguaçu - MG"
  },
  {
    "value": "paraguaçu_paulista_sp",
    "label": "Paraguaçu Paulista - SP"
  },
  {
    "value": "paraibano_ma",
    "label": "Paraibano - MA"
  },
  {
    "value": "paraibuna_sp",
    "label": "Paraibuna - SP"
  },
  {
    "value": "paraipaba_ce",
    "label": "Paraipaba - CE"
  },
  {
    "value": "paraisópolis_mg",
    "label": "Paraisópolis - MG"
  },
  {
    "value": "parambu_ce",
    "label": "Parambu - CE"
  },
  {
    "value": "paramirim_ba",
    "label": "Paramirim - BA"
  },
  {
    "value": "paramoti_ce",
    "label": "Paramoti - CE"
  },
  {
    "value": "paranacity_pr",
    "label": "Paranacity - PR"
  },
  {
    "value": "paranaguá_pr",
    "label": "Paranaguá - PR"
  },
  {
    "value": "paranaiguara_go",
    "label": "Paranaiguara - GO"
  },
  {
    "value": "paranapanema_sp",
    "label": "Paranapanema - SP"
  },
  {
    "value": "paranapoema_pr",
    "label": "Paranapoema - PR"
  },
  {
    "value": "paranapuã_sp",
    "label": "Paranapuã - SP"
  },
  {
    "value": "paranatama_pe",
    "label": "Paranatama - PE"
  },
  {
    "value": "paranatinga_mt",
    "label": "Paranatinga - MT"
  },
  {
    "value": "paranavaí_pr",
    "label": "Paranavaí - PR"
  },
  {
    "value": "paranaíba_ms",
    "label": "Paranaíba - MS"
  },
  {
    "value": "paranaíta_mt",
    "label": "Paranaíta - MT"
  },
  {
    "value": "paranhos_ms",
    "label": "Paranhos - MS"
  },
  {
    "value": "paraná_rn",
    "label": "Paraná - RN"
  },
  {
    "value": "paranã_to",
    "label": "Paranã - TO"
  },
  {
    "value": "paraopeba_mg",
    "label": "Paraopeba - MG"
  },
  {
    "value": "parapuã_sp",
    "label": "Parapuã - SP"
  },
  {
    "value": "parari_pb",
    "label": "Parari - PB"
  },
  {
    "value": "parati_rj",
    "label": "Parati - RJ"
  },
  {
    "value": "paratinga_ba",
    "label": "Paratinga - BA"
  },
  {
    "value": "parauapebas_pa",
    "label": "Parauapebas - PA"
  },
  {
    "value": "parazinho_rn",
    "label": "Parazinho - RN"
  },
  {
    "value": "paraí_rs",
    "label": "Paraí - RS"
  },
  {
    "value": "paraíba_do_sul_rj",
    "label": "Paraíba do Sul - RJ"
  },
  {
    "value": "paraíso_sc",
    "label": "Paraíso - SC"
  },
  {
    "value": "paraíso_sp",
    "label": "Paraíso - SP"
  },
  {
    "value": "paraíso_do_norte_pr",
    "label": "Paraíso do Norte - PR"
  },
  {
    "value": "paraíso_do_sul_rs",
    "label": "Paraíso do Sul - RS"
  },
  {
    "value": "paraíso_do_tocantins_to",
    "label": "Paraíso do Tocantins - TO"
  },
  {
    "value": "paraú_rn",
    "label": "Paraú - RN"
  },
  {
    "value": "paraúna_go",
    "label": "Paraúna - GO"
  },
  {
    "value": "pardinho_sp",
    "label": "Pardinho - SP"
  },
  {
    "value": "pareci_novo_rs",
    "label": "Pareci Novo - RS"
  },
  {
    "value": "parecis_ro",
    "label": "Parecis - RO"
  },
  {
    "value": "parelhas_rn",
    "label": "Parelhas - RN"
  },
  {
    "value": "pariconha_al",
    "label": "Pariconha - AL"
  },
  {
    "value": "parintins_am",
    "label": "Parintins - AM"
  },
  {
    "value": "paripiranga_ba",
    "label": "Paripiranga - BA"
  },
  {
    "value": "paripueira_al",
    "label": "Paripueira - AL"
  },
  {
    "value": "pariquera-açu_sp",
    "label": "Pariquera-Açu - SP"
  },
  {
    "value": "parisi_sp",
    "label": "Parisi - SP"
  },
  {
    "value": "parnaguá_pi",
    "label": "Parnaguá - PI"
  },
  {
    "value": "parnamirim_pe",
    "label": "Parnamirim - PE"
  },
  {
    "value": "parnamirim_rn",
    "label": "Parnamirim - RN"
  },
  {
    "value": "parnarama_ma",
    "label": "Parnarama - MA"
  },
  {
    "value": "parnaíba_pi",
    "label": "Parnaíba - PI"
  },
  {
    "value": "parobé_rs",
    "label": "Parobé - RS"
  },
  {
    "value": "pará_de_minas_mg",
    "label": "Pará de Minas - MG"
  },
  {
    "value": "passa_quatro_mg",
    "label": "Passa Quatro - MG"
  },
  {
    "value": "passa_sete_rs",
    "label": "Passa Sete - RS"
  },
  {
    "value": "passa_tempo_mg",
    "label": "Passa Tempo - MG"
  },
  {
    "value": "passa_e_fica_rn",
    "label": "Passa e Fica - RN"
  },
  {
    "value": "passa-vinte_mg",
    "label": "Passa-Vinte - MG"
  },
  {
    "value": "passabém_mg",
    "label": "Passabém - MG"
  },
  {
    "value": "passagem_pb",
    "label": "Passagem - PB"
  },
  {
    "value": "passagem_rn",
    "label": "Passagem - RN"
  },
  {
    "value": "passagem_franca_ma",
    "label": "Passagem Franca - MA"
  },
  {
    "value": "passagem_franca_do_piauí_pi",
    "label": "Passagem Franca do Piauí - PI"
  },
  {
    "value": "passira_pe",
    "label": "Passira - PE"
  },
  {
    "value": "passo_fundo_rs",
    "label": "Passo Fundo - RS"
  },
  {
    "value": "passo_de_camaragibe_al",
    "label": "Passo de Camaragibe - AL"
  },
  {
    "value": "passo_de_torres_sc",
    "label": "Passo de Torres - SC"
  },
  {
    "value": "passo_do_sobrado_rs",
    "label": "Passo do Sobrado - RS"
  },
  {
    "value": "passos_mg",
    "label": "Passos - MG"
  },
  {
    "value": "passos_maia_sc",
    "label": "Passos Maia - SC"
  },
  {
    "value": "pastos_bons_ma",
    "label": "Pastos Bons - MA"
  },
  {
    "value": "patis_mg",
    "label": "Patis - MG"
  },
  {
    "value": "pato_bragado_pr",
    "label": "Pato Bragado - PR"
  },
  {
    "value": "pato_branco_pr",
    "label": "Pato Branco - PR"
  },
  {
    "value": "patos_pb",
    "label": "Patos - PB"
  },
  {
    "value": "patos_de_minas_mg",
    "label": "Patos de Minas - MG"
  },
  {
    "value": "patos_do_piauí_pi",
    "label": "Patos do Piauí - PI"
  },
  {
    "value": "patrocínio_mg",
    "label": "Patrocínio - MG"
  },
  {
    "value": "patrocínio_paulista_sp",
    "label": "Patrocínio Paulista - SP"
  },
  {
    "value": "patrocínio_do_muriaé_mg",
    "label": "Patrocínio do Muriaé - MG"
  },
  {
    "value": "patu_rn",
    "label": "Patu - RN"
  },
  {
    "value": "paty_do_alferes_rj",
    "label": "Paty do Alferes - RJ"
  },
  {
    "value": "pau_brasil_ba",
    "label": "Pau Brasil - BA"
  },
  {
    "value": "pau_d'arco_pa",
    "label": "Pau d'Arco - PA"
  },
  {
    "value": "pau_d'arco_to",
    "label": "Pau d'Arco - TO"
  },
  {
    "value": "pau_d'arco_do_piauí_pi",
    "label": "Pau d'Arco do Piauí - PI"
  },
  {
    "value": "pau_dos_ferros_rn",
    "label": "Pau dos Ferros - RN"
  },
  {
    "value": "paudalho_pe",
    "label": "Paudalho - PE"
  },
  {
    "value": "pauini_am",
    "label": "Pauini - AM"
  },
  {
    "value": "paula_cândido_mg",
    "label": "Paula Cândido - MG"
  },
  {
    "value": "paula_freitas_pr",
    "label": "Paula Freitas - PR"
  },
  {
    "value": "paulicéia_sp",
    "label": "Paulicéia - SP"
  },
  {
    "value": "paulino_neves_ma",
    "label": "Paulino Neves - MA"
  },
  {
    "value": "paulista_pb",
    "label": "Paulista - PB"
  },
  {
    "value": "paulista_pe",
    "label": "Paulista - PE"
  },
  {
    "value": "paulistana_pi",
    "label": "Paulistana - PI"
  },
  {
    "value": "paulistas_mg",
    "label": "Paulistas - MG"
  },
  {
    "value": "paulistânia_sp",
    "label": "Paulistânia - SP"
  },
  {
    "value": "paulo_afonso_ba",
    "label": "Paulo Afonso - BA"
  },
  {
    "value": "paulo_bento_rs",
    "label": "Paulo Bento - RS"
  },
  {
    "value": "paulo_frontin_pr",
    "label": "Paulo Frontin - PR"
  },
  {
    "value": "paulo_jacinto',_'penedo_al",
    "label": "Paulo Jacinto', 'Penedo - AL"
  },
  {
    "value": "paulo_lopes_sc",
    "label": "Paulo Lopes - SC"
  },
  {
    "value": "paulo_ramos_ma",
    "label": "Paulo Ramos - MA"
  },
  {
    "value": "paulo_de_faria_sp",
    "label": "Paulo de Faria - SP"
  },
  {
    "value": "paulínia_sp",
    "label": "Paulínia - SP"
  },
  {
    "value": "paverama_rs",
    "label": "Paverama - RS"
  },
  {
    "value": "pavussu_pi",
    "label": "Pavussu - PI"
  },
  {
    "value": "pavão_mg",
    "label": "Pavão - MG"
  },
  {
    "value": "paço_do_lumiar_ma",
    "label": "Paço do Lumiar - MA"
  },
  {
    "value": "peabiru_pr",
    "label": "Peabiru - PR"
  },
  {
    "value": "pederneiras_sp",
    "label": "Pederneiras - SP"
  },
  {
    "value": "pedra_pe",
    "label": "Pedra - PE"
  },
  {
    "value": "pedra_azul_mg",
    "label": "Pedra Azul - MG"
  },
  {
    "value": "pedra_bela_sp",
    "label": "Pedra Bela - SP"
  },
  {
    "value": "pedra_bonita_mg",
    "label": "Pedra Bonita - MG"
  },
  {
    "value": "pedra_branca_ce",
    "label": "Pedra Branca - CE"
  },
  {
    "value": "pedra_branca_pb",
    "label": "Pedra Branca - PB"
  },
  {
    "value": "pedra_branca_do_amapari_ap",
    "label": "Pedra Branca do Amapari - AP"
  },
  {
    "value": "pedra_dourada_mg",
    "label": "Pedra Dourada - MG"
  },
  {
    "value": "pedra_grande_rn",
    "label": "Pedra Grande - RN"
  },
  {
    "value": "pedra_lavrada_pb",
    "label": "Pedra Lavrada - PB"
  },
  {
    "value": "pedra_mole_se",
    "label": "Pedra Mole - SE"
  },
  {
    "value": "pedra_preta_mt",
    "label": "Pedra Preta - MT"
  },
  {
    "value": "pedra_preta_rn",
    "label": "Pedra Preta - RN"
  },
  {
    "value": "pedra_do_anta_mg",
    "label": "Pedra do Anta - MG"
  },
  {
    "value": "pedra_do_indaiá_mg",
    "label": "Pedra do Indaiá - MG"
  },
  {
    "value": "pedralva_mg",
    "label": "Pedralva - MG"
  },
  {
    "value": "pedranópolis_sp",
    "label": "Pedranópolis - SP"
  },
  {
    "value": "pedras_altas_rs",
    "label": "Pedras Altas - RS"
  },
  {
    "value": "pedras_grandes_sc",
    "label": "Pedras Grandes - SC"
  },
  {
    "value": "pedras_de_fogo_pb",
    "label": "Pedras de Fogo - PB"
  },
  {
    "value": "pedras_de_maria_da_cruz_mg",
    "label": "Pedras de Maria da Cruz - MG"
  },
  {
    "value": "pedregulho_sp",
    "label": "Pedregulho - SP"
  },
  {
    "value": "pedreira_sp",
    "label": "Pedreira - SP"
  },
  {
    "value": "pedreiras_ma",
    "label": "Pedreiras - MA"
  },
  {
    "value": "pedrinhas_se",
    "label": "Pedrinhas - SE"
  },
  {
    "value": "pedrinhas_paulista_sp",
    "label": "Pedrinhas Paulista - SP"
  },
  {
    "value": "pedrinópolis_mg",
    "label": "Pedrinópolis - MG"
  },
  {
    "value": "pedro_afonso_to",
    "label": "Pedro Afonso - TO"
  },
  {
    "value": "pedro_alexandre_ba",
    "label": "Pedro Alexandre - BA"
  },
  {
    "value": "pedro_avelino_rn",
    "label": "Pedro Avelino - RN"
  },
  {
    "value": "pedro_canário_es",
    "label": "Pedro Canário - ES"
  },
  {
    "value": "pedro_gomes_ms",
    "label": "Pedro Gomes - MS"
  },
  {
    "value": "pedro_ii_pi",
    "label": "Pedro II - PI"
  },
  {
    "value": "pedro_laurentino_pi",
    "label": "Pedro Laurentino - PI"
  },
  {
    "value": "pedro_leopoldo_mg",
    "label": "Pedro Leopoldo - MG"
  },
  {
    "value": "pedro_osório_rs",
    "label": "Pedro Osório - RS"
  },
  {
    "value": "pedro_régis_pb",
    "label": "Pedro Régis - PB"
  },
  {
    "value": "pedro_teixeira_mg",
    "label": "Pedro Teixeira - MG"
  },
  {
    "value": "pedro_velho_rn",
    "label": "Pedro Velho - RN"
  },
  {
    "value": "pedro_de_toledo_sp",
    "label": "Pedro de Toledo - SP"
  },
  {
    "value": "pedro_do_rosário_ma",
    "label": "Pedro do Rosário - MA"
  },
  {
    "value": "pedrão_ba",
    "label": "Pedrão - BA"
  },
  {
    "value": "peixe_to",
    "label": "Peixe - TO"
  },
  {
    "value": "peixe-boi_pa",
    "label": "Peixe-Boi - PA"
  },
  {
    "value": "peixoto_de_azevedo_mt",
    "label": "Peixoto de Azevedo - MT"
  },
  {
    "value": "pejuçara_rs",
    "label": "Pejuçara - RS"
  },
  {
    "value": "pelotas_rs",
    "label": "Pelotas - RS"
  },
  {
    "value": "penaforte_ce",
    "label": "Penaforte - CE"
  },
  {
    "value": "penalva_ma",
    "label": "Penalva - MA"
  },
  {
    "value": "pendências_rn",
    "label": "Pendências - RN"
  },
  {
    "value": "penha_sc",
    "label": "Penha - SC"
  },
  {
    "value": "pentecoste_ce",
    "label": "Pentecoste - CE"
  },
  {
    "value": "penápolis_sp",
    "label": "Penápolis - SP"
  },
  {
    "value": "pequeri_mg",
    "label": "Pequeri - MG"
  },
  {
    "value": "pequi_mg",
    "label": "Pequi - MG"
  },
  {
    "value": "pequizeiro_to",
    "label": "Pequizeiro - TO"
  },
  {
    "value": "perdigão_mg",
    "label": "Perdigão - MG"
  },
  {
    "value": "perdizes_mg",
    "label": "Perdizes - MG"
  },
  {
    "value": "perdões_mg",
    "label": "Perdões - MG"
  },
  {
    "value": "pereira_barreto_sp",
    "label": "Pereira Barreto - SP"
  },
  {
    "value": "pereiras_sp",
    "label": "Pereiras - SP"
  },
  {
    "value": "pereiro_ce",
    "label": "Pereiro - CE"
  },
  {
    "value": "peri_mirim_ma",
    "label": "Peri Mirim - MA"
  },
  {
    "value": "periquito_mg",
    "label": "Periquito - MG"
  },
  {
    "value": "peritiba_sc",
    "label": "Peritiba - SC"
  },
  {
    "value": "peritoró_ma",
    "label": "Peritoró - MA"
  },
  {
    "value": "perobal_pr",
    "label": "Perobal - PR"
  },
  {
    "value": "perolândia_go",
    "label": "Perolândia - GO"
  },
  {
    "value": "peruíbe_sp",
    "label": "Peruíbe - SP"
  },
  {
    "value": "pescador_mg",
    "label": "Pescador - MG"
  },
  {
    "value": "pesqueira_pe",
    "label": "Pesqueira - PE"
  },
  {
    "value": "petrolina_pe",
    "label": "Petrolina - PE"
  },
  {
    "value": "petrolina_de_goiás_go",
    "label": "Petrolina de Goiás - GO"
  },
  {
    "value": "petrolândia_pe",
    "label": "Petrolândia - PE"
  },
  {
    "value": "petrolândia_sc",
    "label": "Petrolândia - SC"
  },
  {
    "value": "petrópolis_rj",
    "label": "Petrópolis - RJ"
  },
  {
    "value": "peçanha_mg",
    "label": "Peçanha - MG"
  },
  {
    "value": "piacatu_sp",
    "label": "Piacatu - SP"
  },
  {
    "value": "piancó_pb",
    "label": "Piancó - PB"
  },
  {
    "value": "piatã_ba",
    "label": "Piatã - BA"
  },
  {
    "value": "piau_mg",
    "label": "Piau - MG"
  },
  {
    "value": "piaçabuçu_al",
    "label": "Piaçabuçu - AL"
  },
  {
    "value": "picada_café_rs",
    "label": "Picada Café - RS"
  },
  {
    "value": "picos_pi",
    "label": "Picos - PI"
  },
  {
    "value": "picuí_pb",
    "label": "Picuí - PB"
  },
  {
    "value": "piedade_sp",
    "label": "Piedade - SP"
  },
  {
    "value": "piedade_de_caratinga_mg",
    "label": "Piedade de Caratinga - MG"
  },
  {
    "value": "piedade_de_ponte_nova_mg",
    "label": "Piedade de Ponte Nova - MG"
  },
  {
    "value": "piedade_do_rio_grande_mg",
    "label": "Piedade do Rio Grande - MG"
  },
  {
    "value": "piedade_dos_gerais_mg",
    "label": "Piedade dos Gerais - MG"
  },
  {
    "value": "pilar_al",
    "label": "Pilar - AL"
  },
  {
    "value": "pilar_pb",
    "label": "Pilar - PB"
  },
  {
    "value": "pilar_de_goiás_go",
    "label": "Pilar de Goiás - GO"
  },
  {
    "value": "pilar_do_sul_sp",
    "label": "Pilar do Sul - SP"
  },
  {
    "value": "pilão_arcado_ba",
    "label": "Pilão Arcado - BA"
  },
  {
    "value": "pilões_pb",
    "label": "Pilões - PB"
  },
  {
    "value": "pilões_rn",
    "label": "Pilões - RN"
  },
  {
    "value": "pilõezinhos_pb",
    "label": "Pilõezinhos - PB"
  },
  {
    "value": "pimenta_mg",
    "label": "Pimenta - MG"
  },
  {
    "value": "pimenta_bueno_ro",
    "label": "Pimenta Bueno - RO"
  },
  {
    "value": "pimenteiras_pi",
    "label": "Pimenteiras - PI"
  },
  {
    "value": "pimenteiras_do_oeste_ro",
    "label": "Pimenteiras do Oeste - RO"
  },
  {
    "value": "pindamonhangaba_sp",
    "label": "Pindamonhangaba - SP"
  },
  {
    "value": "pindaré_mirim_ma",
    "label": "Pindaré Mirim - MA"
  },
  {
    "value": "pindaí_ba",
    "label": "Pindaí - BA"
  },
  {
    "value": "pindoba_al",
    "label": "Pindoba - AL"
  },
  {
    "value": "pindobaçu_ba",
    "label": "Pindobaçu - BA"
  },
  {
    "value": "pindorama_sp",
    "label": "Pindorama - SP"
  },
  {
    "value": "pindorama_do_tocantins_to",
    "label": "Pindorama do Tocantins - TO"
  },
  {
    "value": "pindoretama_ce",
    "label": "Pindoretama - CE"
  },
  {
    "value": "pingo-d'água_mg",
    "label": "Pingo-d'Água - MG"
  },
  {
    "value": "pinhais_pr",
    "label": "Pinhais - PR"
  },
  {
    "value": "pinhal_rs",
    "label": "Pinhal - RS"
  },
  {
    "value": "pinhal_grande_rs",
    "label": "Pinhal Grande - RS"
  },
  {
    "value": "pinhal_da_serra_rs",
    "label": "Pinhal da Serra - RS"
  },
  {
    "value": "pinhal_de_são_bento_pr",
    "label": "Pinhal de São Bento - PR"
  },
  {
    "value": "pinhalzinho_sc",
    "label": "Pinhalzinho - SC"
  },
  {
    "value": "pinhalzinho_sp",
    "label": "Pinhalzinho - SP"
  },
  {
    "value": "pinhalão_pr",
    "label": "Pinhalão - PR"
  },
  {
    "value": "pinheiral_rj",
    "label": "Pinheiral - RJ"
  },
  {
    "value": "pinheirinho_do_vale_rs",
    "label": "Pinheirinho do Vale - RS"
  },
  {
    "value": "pinheiro_ma",
    "label": "Pinheiro - MA"
  },
  {
    "value": "pinheiro_machado_rs",
    "label": "Pinheiro Machado - RS"
  },
  {
    "value": "pinheiro_preto_sc",
    "label": "Pinheiro Preto - SC"
  },
  {
    "value": "pinheiros_es",
    "label": "Pinheiros - ES"
  },
  {
    "value": "pinhão_pr",
    "label": "Pinhão - PR"
  },
  {
    "value": "pinhão_se",
    "label": "Pinhão - SE"
  },
  {
    "value": "pintadas_ba",
    "label": "Pintadas - BA"
  },
  {
    "value": "pintópolis_mg",
    "label": "Pintópolis - MG"
  },
  {
    "value": "pio_ix_pi",
    "label": "Pio IX - PI"
  },
  {
    "value": "pio_xii_ma",
    "label": "Pio XII - MA"
  },
  {
    "value": "piquerobi_sp",
    "label": "Piquerobi - SP"
  },
  {
    "value": "piquet_carneiro_ce",
    "label": "Piquet Carneiro - CE"
  },
  {
    "value": "piquete_sp",
    "label": "Piquete - SP"
  },
  {
    "value": "piracaia_sp",
    "label": "Piracaia - SP"
  },
  {
    "value": "piracanjuba_go",
    "label": "Piracanjuba - GO"
  },
  {
    "value": "piracema_mg",
    "label": "Piracema - MG"
  },
  {
    "value": "piracicaba_sp",
    "label": "Piracicaba - SP"
  },
  {
    "value": "piracuruca_pi",
    "label": "Piracuruca - PI"
  },
  {
    "value": "piraju_sp",
    "label": "Piraju - SP"
  },
  {
    "value": "pirajuba_mg",
    "label": "Pirajuba - MG"
  },
  {
    "value": "pirajuí_sp",
    "label": "Pirajuí - SP"
  },
  {
    "value": "pirambu_se",
    "label": "Pirambu - SE"
  },
  {
    "value": "piranga_mg",
    "label": "Piranga - MG"
  },
  {
    "value": "pirangi_sp",
    "label": "Pirangi - SP"
  },
  {
    "value": "piranguinho_mg",
    "label": "Piranguinho - MG"
  },
  {
    "value": "piranguçu_mg",
    "label": "Piranguçu - MG"
  },
  {
    "value": "piranhas_al",
    "label": "Piranhas - AL"
  },
  {
    "value": "piranhas_go",
    "label": "Piranhas - GO"
  },
  {
    "value": "pirapemas_ma",
    "label": "Pirapemas - MA"
  },
  {
    "value": "pirapetinga_mg",
    "label": "Pirapetinga - MG"
  },
  {
    "value": "pirapora_mg",
    "label": "Pirapora - MG"
  },
  {
    "value": "pirapora_do_bom_jesus_sp",
    "label": "Pirapora do Bom Jesus - SP"
  },
  {
    "value": "pirapozinho_sp",
    "label": "Pirapozinho - SP"
  },
  {
    "value": "pirapó_rs",
    "label": "Pirapó - RS"
  },
  {
    "value": "piraquara_pr",
    "label": "Piraquara - PR"
  },
  {
    "value": "piraquê_to",
    "label": "Piraquê - TO"
  },
  {
    "value": "pirassununga_sp",
    "label": "Pirassununga - SP"
  },
  {
    "value": "piratini_rs",
    "label": "Piratini - RS"
  },
  {
    "value": "piratininga_sp",
    "label": "Piratininga - SP"
  },
  {
    "value": "piratuba_sc",
    "label": "Piratuba - SC"
  },
  {
    "value": "piraí_rj",
    "label": "Piraí - RJ"
  },
  {
    "value": "piraí_do_norte_ba",
    "label": "Piraí do Norte - BA"
  },
  {
    "value": "piraí_do_sul_pr",
    "label": "Piraí do Sul - PR"
  },
  {
    "value": "piraúba_mg",
    "label": "Piraúba - MG"
  },
  {
    "value": "pirenópolis_go",
    "label": "Pirenópolis - GO"
  },
  {
    "value": "pires_ferreira_ce",
    "label": "Pires Ferreira - CE"
  },
  {
    "value": "pires_do_rio_go",
    "label": "Pires do Rio - GO"
  },
  {
    "value": "piripiri_pi",
    "label": "Piripiri - PI"
  },
  {
    "value": "piripá_ba",
    "label": "Piripá - BA"
  },
  {
    "value": "piritiba_ba",
    "label": "Piritiba - BA"
  },
  {
    "value": "pirpirituba_pb",
    "label": "Pirpirituba - PB"
  },
  {
    "value": "pitanga_pr",
    "label": "Pitanga - PR"
  },
  {
    "value": "pitangueiras_pr",
    "label": "Pitangueiras - PR"
  },
  {
    "value": "pitangueiras_sp",
    "label": "Pitangueiras - SP"
  },
  {
    "value": "pitangui_mg",
    "label": "Pitangui - MG"
  },
  {
    "value": "pitimbu_pb",
    "label": "Pitimbu - PB"
  },
  {
    "value": "pium_to",
    "label": "Pium - TO"
  },
  {
    "value": "piumhi_mg",
    "label": "Piumhi - MG"
  },
  {
    "value": "piçarra_pa",
    "label": "Piçarra - PA"
  },
  {
    "value": "piçarras_sc",
    "label": "Piçarras - SC"
  },
  {
    "value": "piên_pr",
    "label": "Piên - PR"
  },
  {
    "value": "piúma_es",
    "label": "Piúma - ES"
  },
  {
    "value": "placas_pa",
    "label": "Placas - PA"
  },
  {
    "value": "planaltina_go",
    "label": "Planaltina - GO"
  },
  {
    "value": "planaltina_do_paraná_pr",
    "label": "Planaltina do Paraná - PR"
  },
  {
    "value": "planaltino_ba",
    "label": "Planaltino - BA"
  },
  {
    "value": "planalto_ba",
    "label": "Planalto - BA"
  },
  {
    "value": "planalto_pr",
    "label": "Planalto - PR"
  },
  {
    "value": "planalto_rs",
    "label": "Planalto - RS"
  },
  {
    "value": "planalto_sp",
    "label": "Planalto - SP"
  },
  {
    "value": "planalto_alegre_sc",
    "label": "Planalto Alegre - SC"
  },
  {
    "value": "planalto_da_serra_mt",
    "label": "Planalto da Serra - MT"
  },
  {
    "value": "planura_mg",
    "label": "Planura - MG"
  },
  {
    "value": "platina_sp",
    "label": "Platina - SP"
  },
  {
    "value": "plácido_de_castro_ac",
    "label": "Plácido de Castro - AC"
  },
  {
    "value": "pocinhos_pb",
    "label": "Pocinhos - PB"
  },
  {
    "value": "poconé_mt",
    "label": "Poconé - MT"
  },
  {
    "value": "pocrane_mg",
    "label": "Pocrane - MG"
  },
  {
    "value": "pojuca_ba",
    "label": "Pojuca - BA"
  },
  {
    "value": "poloni_sp",
    "label": "Poloni - SP"
  },
  {
    "value": "pombal_pb",
    "label": "Pombal - PB"
  },
  {
    "value": "pombos_pe",
    "label": "Pombos - PE"
  },
  {
    "value": "pomerode_sc",
    "label": "Pomerode - SC"
  },
  {
    "value": "pompéia_sp",
    "label": "Pompéia - SP"
  },
  {
    "value": "pompéu_mg",
    "label": "Pompéu - MG"
  },
  {
    "value": "pongaí_sp",
    "label": "Pongaí - SP"
  },
  {
    "value": "ponta_grossa_pr",
    "label": "Ponta Grossa - PR"
  },
  {
    "value": "ponta_porã_ms",
    "label": "Ponta Porã - MS"
  },
  {
    "value": "ponta_de_pedras_pa",
    "label": "Ponta de Pedras - PA"
  },
  {
    "value": "pontal_sp",
    "label": "Pontal - SP"
  },
  {
    "value": "pontal_do_araguaia_mt",
    "label": "Pontal do Araguaia - MT"
  },
  {
    "value": "pontal_do_paraná_pr",
    "label": "Pontal do Paraná - PR"
  },
  {
    "value": "pontalina_go",
    "label": "Pontalina - GO"
  },
  {
    "value": "pontalinda_sp",
    "label": "Pontalinda - SP"
  },
  {
    "value": "ponte_alta_sc",
    "label": "Ponte Alta - SC"
  },
  {
    "value": "ponte_alta_do_bom_jesus_to",
    "label": "Ponte Alta do Bom Jesus - TO"
  },
  {
    "value": "ponte_alta_do_norte_sc",
    "label": "Ponte Alta do Norte - SC"
  },
  {
    "value": "ponte_alta_do_tocantins_to",
    "label": "Ponte Alta do Tocantins - TO"
  },
  {
    "value": "ponte_branca_mt",
    "label": "Ponte Branca - MT"
  },
  {
    "value": "ponte_nova_mg",
    "label": "Ponte Nova - MG"
  },
  {
    "value": "ponte_preta_rs",
    "label": "Ponte Preta - RS"
  },
  {
    "value": "ponte_serrada_sc",
    "label": "Ponte Serrada - SC"
  },
  {
    "value": "pontes_gestal_sp",
    "label": "Pontes Gestal - SP"
  },
  {
    "value": "pontes_e_lacerda_mt",
    "label": "Pontes e Lacerda - MT"
  },
  {
    "value": "ponto_belo_es",
    "label": "Ponto Belo - ES"
  },
  {
    "value": "ponto_chique_mg",
    "label": "Ponto Chique - MG"
  },
  {
    "value": "ponto_novo_ba",
    "label": "Ponto Novo - BA"
  },
  {
    "value": "ponto_dos_volantes_mg",
    "label": "Ponto dos Volantes - MG"
  },
  {
    "value": "pontão_rs",
    "label": "Pontão - RS"
  },
  {
    "value": "populina_sp",
    "label": "Populina - SP"
  },
  {
    "value": "poranga_ce",
    "label": "Poranga - CE"
  },
  {
    "value": "porangaba_sp",
    "label": "Porangaba - SP"
  },
  {
    "value": "porangatu_go",
    "label": "Porangatu - GO"
  },
  {
    "value": "porciúncula_rj",
    "label": "Porciúncula - RJ"
  },
  {
    "value": "porecatu_pr",
    "label": "Porecatu - PR"
  },
  {
    "value": "portalegre_rn",
    "label": "Portalegre - RN"
  },
  {
    "value": "porteiras_ce",
    "label": "Porteiras - CE"
  },
  {
    "value": "porteirinha_mg",
    "label": "Porteirinha - MG"
  },
  {
    "value": "porteirão_go",
    "label": "Porteirão - GO"
  },
  {
    "value": "portel_pa",
    "label": "Portel - PA"
  },
  {
    "value": "portelândia_go",
    "label": "Portelândia - GO"
  },
  {
    "value": "porto_pi",
    "label": "Porto - PI"
  },
  {
    "value": "porto_acre_ac",
    "label": "Porto Acre - AC"
  },
  {
    "value": "porto_alegre_rs",
    "label": "Porto Alegre - RS"
  },
  {
    "value": "porto_alegre_do_norte_mt",
    "label": "Porto Alegre do Norte - MT"
  },
  {
    "value": "porto_alegre_do_piauí_pi",
    "label": "Porto Alegre do Piauí - PI"
  },
  {
    "value": "porto_alegre_do_tocantins_to",
    "label": "Porto Alegre do Tocantins - TO"
  },
  {
    "value": "porto_amazonas_pr",
    "label": "Porto Amazonas - PR"
  },
  {
    "value": "porto_barreiro_pr",
    "label": "Porto Barreiro - PR"
  },
  {
    "value": "porto_belo_sc",
    "label": "Porto Belo - SC"
  },
  {
    "value": "porto_calvo_al",
    "label": "Porto Calvo - AL"
  },
  {
    "value": "porto_esperidião_mt",
    "label": "Porto Esperidião - MT"
  },
  {
    "value": "porto_estrela_mt",
    "label": "Porto Estrela - MT"
  },
  {
    "value": "porto_feliz_sp",
    "label": "Porto Feliz - SP"
  },
  {
    "value": "porto_ferreira_sp",
    "label": "Porto Ferreira - SP"
  },
  {
    "value": "porto_firme_mg",
    "label": "Porto Firme - MG"
  },
  {
    "value": "porto_franco_ma",
    "label": "Porto Franco - MA"
  },
  {
    "value": "porto_grande_ap",
    "label": "Porto Grande - AP"
  },
  {
    "value": "porto_lucena_rs",
    "label": "Porto Lucena - RS"
  },
  {
    "value": "porto_mauá_rs",
    "label": "Porto Mauá - RS"
  },
  {
    "value": "porto_murtinho_ms",
    "label": "Porto Murtinho - MS"
  },
  {
    "value": "porto_nacional_to",
    "label": "Porto Nacional - TO"
  },
  {
    "value": "porto_real_rj",
    "label": "Porto Real - RJ"
  },
  {
    "value": "porto_real_do_colégio_al",
    "label": "Porto Real do Colégio - AL"
  },
  {
    "value": "porto_rico_pr",
    "label": "Porto Rico - PR"
  },
  {
    "value": "porto_rico_do_maranhão_ma",
    "label": "Porto Rico do Maranhão - MA"
  },
  {
    "value": "porto_seguro_ba",
    "label": "Porto Seguro - BA"
  },
  {
    "value": "porto_união_sc",
    "label": "Porto União - SC"
  },
  {
    "value": "porto_velho_ro",
    "label": "Porto Velho - RO"
  },
  {
    "value": "porto_vera_cruz_rs",
    "label": "Porto Vera Cruz - RS"
  },
  {
    "value": "porto_vitória_pr",
    "label": "Porto Vitória - PR"
  },
  {
    "value": "porto_walter_ac",
    "label": "Porto Walter - AC"
  },
  {
    "value": "porto_xavier_rs",
    "label": "Porto Xavier - RS"
  },
  {
    "value": "porto_da_folha_se",
    "label": "Porto da Folha - SE"
  },
  {
    "value": "porto_de_moz_pa",
    "label": "Porto de Moz - PA"
  },
  {
    "value": "porto_de_pedras_al",
    "label": "Porto de Pedras - AL"
  },
  {
    "value": "porto_do_mangue_rn",
    "label": "Porto do Mangue - RN"
  },
  {
    "value": "porto_dos_gaúchos_mt",
    "label": "Porto dos Gaúchos - MT"
  },
  {
    "value": "portão_rs",
    "label": "Portão - RS"
  },
  {
    "value": "posse_go",
    "label": "Posse - GO"
  },
  {
    "value": "potengi_ce",
    "label": "Potengi - CE"
  },
  {
    "value": "potim_sp",
    "label": "Potim - SP"
  },
  {
    "value": "potiraguá_ba",
    "label": "Potiraguá - BA"
  },
  {
    "value": "potirendaba_sp",
    "label": "Potirendaba - SP"
  },
  {
    "value": "potiretama_ce",
    "label": "Potiretama - CE"
  },
  {
    "value": "poté_mg",
    "label": "Poté - MG"
  },
  {
    "value": "pouso_alegre_mg",
    "label": "Pouso Alegre - MG"
  },
  {
    "value": "pouso_alto_mg",
    "label": "Pouso Alto - MG"
  },
  {
    "value": "pouso_novo_rs",
    "label": "Pouso Novo - RS"
  },
  {
    "value": "pouso_redondo_sc",
    "label": "Pouso Redondo - SC"
  },
  {
    "value": "poxoréo_mt",
    "label": "Poxoréo - MT"
  },
  {
    "value": "poá_sp",
    "label": "Poá - SP"
  },
  {
    "value": "poço_branco_rn",
    "label": "Poço Branco - RN"
  },
  {
    "value": "poço_dantas_pb",
    "label": "Poço Dantas - PB"
  },
  {
    "value": "poço_fundo_mg",
    "label": "Poço Fundo - MG"
  },
  {
    "value": "poço_redondo_se",
    "label": "Poço Redondo - SE"
  },
  {
    "value": "poço_verde_se",
    "label": "Poço Verde - SE"
  },
  {
    "value": "poço_das_antas_rs",
    "label": "Poço das Antas - RS"
  },
  {
    "value": "poço_das_trincheiras_al",
    "label": "Poço das Trincheiras - AL"
  },
  {
    "value": "poço_de_josé_de_moura_pb",
    "label": "Poço de José de Moura - PB"
  },
  {
    "value": "poços_de_caldas_mg",
    "label": "Poços de Caldas - MG"
  },
  {
    "value": "poção_pe",
    "label": "Poção - PE"
  },
  {
    "value": "poção_de_pedras_ma",
    "label": "Poção de Pedras - MA"
  },
  {
    "value": "poções_ba",
    "label": "Poções - BA"
  },
  {
    "value": "pracinha_sp",
    "label": "Pracinha - SP"
  },
  {
    "value": "pracuúba_ap",
    "label": "Pracuúba - AP"
  },
  {
    "value": "prado_ba",
    "label": "Prado - BA"
  },
  {
    "value": "prado_ferreira_pr",
    "label": "Prado Ferreira - PR"
  },
  {
    "value": "prados_mg",
    "label": "Prados - MG"
  },
  {
    "value": "pradópolis_sp",
    "label": "Pradópolis - SP"
  },
  {
    "value": "praia_grande_sc",
    "label": "Praia Grande - SC"
  },
  {
    "value": "praia_grande_sp",
    "label": "Praia Grande - SP"
  },
  {
    "value": "praia_norte_to",
    "label": "Praia Norte - TO"
  },
  {
    "value": "prainha_pa",
    "label": "Prainha - PA"
  },
  {
    "value": "pranchita_pr",
    "label": "Pranchita - PR"
  },
  {
    "value": "prata_mg",
    "label": "Prata - MG"
  },
  {
    "value": "prata_pb",
    "label": "Prata - PB"
  },
  {
    "value": "prata_do_piauí_pi",
    "label": "Prata do Piauí - PI"
  },
  {
    "value": "pratinha_mg",
    "label": "Pratinha - MG"
  },
  {
    "value": "pratápolis_mg",
    "label": "Pratápolis - MG"
  },
  {
    "value": "pratânia_sp",
    "label": "Pratânia - SP"
  },
  {
    "value": "presidente_alves_sp",
    "label": "Presidente Alves - SP"
  },
  {
    "value": "presidente_bernardes_mg",
    "label": "Presidente Bernardes - MG"
  },
  {
    "value": "presidente_bernardes_sp",
    "label": "Presidente Bernardes - SP"
  },
  {
    "value": "presidente_castelo_branco_pr",
    "label": "Presidente Castelo Branco - PR"
  },
  {
    "value": "presidente_castelo_branco_sc",
    "label": "Presidente Castelo Branco - SC"
  },
  {
    "value": "presidente_dutra_ba",
    "label": "Presidente Dutra - BA"
  },
  {
    "value": "presidente_dutra_ma",
    "label": "Presidente Dutra - MA"
  },
  {
    "value": "presidente_epitácio_sp",
    "label": "Presidente Epitácio - SP"
  },
  {
    "value": "presidente_figueiredo_am",
    "label": "Presidente Figueiredo - AM"
  },
  {
    "value": "presidente_getúlio_sc",
    "label": "Presidente Getúlio - SC"
  },
  {
    "value": "presidente_juscelino_ma",
    "label": "Presidente Juscelino - MA"
  },
  {
    "value": "presidente_juscelino_mg",
    "label": "Presidente Juscelino - MG"
  },
  {
    "value": "presidente_juscelino_rn",
    "label": "Presidente Juscelino - RN"
  },
  {
    "value": "presidente_jânio_quadros_ba",
    "label": "Presidente Jânio Quadros - BA"
  },
  {
    "value": "presidente_kennedy_es",
    "label": "Presidente Kennedy - ES"
  },
  {
    "value": "presidente_kennedy_to",
    "label": "Presidente Kennedy - TO"
  },
  {
    "value": "presidente_kubitschek_mg",
    "label": "Presidente Kubitschek - MG"
  },
  {
    "value": "presidente_lucena_rs",
    "label": "Presidente Lucena - RS"
  },
  {
    "value": "presidente_médici_ma",
    "label": "Presidente Médici - MA"
  },
  {
    "value": "presidente_médici_ro",
    "label": "Presidente Médici - RO"
  },
  {
    "value": "presidente_nereu_sc",
    "label": "Presidente Nereu - SC"
  },
  {
    "value": "presidente_olegário_mg",
    "label": "Presidente Olegário - MG"
  },
  {
    "value": "presidente_prudente_sp",
    "label": "Presidente Prudente - SP"
  },
  {
    "value": "presidente_sarney_ma",
    "label": "Presidente Sarney - MA"
  },
  {
    "value": "presidente_tancredo_neves_ba",
    "label": "Presidente Tancredo Neves - BA"
  },
  {
    "value": "presidente_vargas_ma",
    "label": "Presidente Vargas - MA"
  },
  {
    "value": "presidente_venceslau_sp",
    "label": "Presidente Venceslau - SP"
  },
  {
    "value": "primavera_pa",
    "label": "Primavera - PA"
  },
  {
    "value": "primavera_pe",
    "label": "Primavera - PE"
  },
  {
    "value": "primavera_de_rondônia_ro",
    "label": "Primavera de Rondônia - RO"
  },
  {
    "value": "primavera_do_leste_mt",
    "label": "Primavera do Leste - MT"
  },
  {
    "value": "primeira_cruz_ma",
    "label": "Primeira Cruz - MA"
  },
  {
    "value": "primeiro_de_maio_pr",
    "label": "Primeiro de Maio - PR"
  },
  {
    "value": "princesa_sc",
    "label": "Princesa - SC"
  },
  {
    "value": "princesa_isabel_pb",
    "label": "Princesa Isabel - PB"
  },
  {
    "value": "professor_jamil_go",
    "label": "Professor Jamil - GO"
  },
  {
    "value": "progresso_rs",
    "label": "Progresso - RS"
  },
  {
    "value": "promissão_sp",
    "label": "Promissão - SP"
  },
  {
    "value": "propriá_se",
    "label": "Propriá - SE"
  },
  {
    "value": "protásio_alves_rs",
    "label": "Protásio Alves - RS"
  },
  {
    "value": "prudente_de_morais_mg",
    "label": "Prudente de Morais - MG"
  },
  {
    "value": "prudentópolis_pr",
    "label": "Prudentópolis - PR"
  },
  {
    "value": "pugmil_to",
    "label": "Pugmil - TO"
  },
  {
    "value": "pureza_rn",
    "label": "Pureza - RN"
  },
  {
    "value": "putinga_rs",
    "label": "Putinga - RS"
  },
  {
    "value": "puxinanã_pb",
    "label": "Puxinanã - PB"
  },
  {
    "value": "pântano_grande_rs",
    "label": "Pântano Grande - RS"
  },
  {
    "value": "pão_de_açúcar_al",
    "label": "Pão de Açúcar - AL"
  },
  {
    "value": "pé_de_serra_ba",
    "label": "Pé de Serra - BA"
  },
  {
    "value": "pérola_pr",
    "label": "Pérola - PR"
  },
  {
    "value": "pérola_d'oeste_pr",
    "label": "Pérola d'Oeste - PR"
  },
  {
    "value": "quadra_sp",
    "label": "Quadra - SP"
  },
  {
    "value": "quaraí_rs",
    "label": "Quaraí - RS"
  },
  {
    "value": "quartel_geral_mg",
    "label": "Quartel Geral - MG"
  },
  {
    "value": "quarto_centenário_pr",
    "label": "Quarto Centenário - PR"
  },
  {
    "value": "quatiguá_pr",
    "label": "Quatiguá - PR"
  },
  {
    "value": "quatipuru_pa",
    "label": "Quatipuru - PA"
  },
  {
    "value": "quatis_rj",
    "label": "Quatis - RJ"
  },
  {
    "value": "quatro_barras_pr",
    "label": "Quatro Barras - PR"
  },
  {
    "value": "quatro_irmãos_rs",
    "label": "Quatro Irmãos - RS"
  },
  {
    "value": "quatro_pontes_pr",
    "label": "Quatro Pontes - PR"
  },
  {
    "value": "quatá_sp",
    "label": "Quatá - SP"
  },
  {
    "value": "quebrangulo_al",
    "label": "Quebrangulo - AL"
  },
  {
    "value": "quedas_do_iguaçu_pr",
    "label": "Quedas do Iguaçu - PR"
  },
  {
    "value": "queimada_nova_pi",
    "label": "Queimada Nova - PI"
  },
  {
    "value": "queimadas_ba",
    "label": "Queimadas - BA"
  },
  {
    "value": "queimadas_pb",
    "label": "Queimadas - PB"
  },
  {
    "value": "queimados_rj",
    "label": "Queimados - RJ"
  },
  {
    "value": "queiroz_sp",
    "label": "Queiroz - SP"
  },
  {
    "value": "queluz_sp",
    "label": "Queluz - SP"
  },
  {
    "value": "queluzito_mg",
    "label": "Queluzito - MG"
  },
  {
    "value": "querência_mt",
    "label": "Querência - MT"
  },
  {
    "value": "querência_do_norte_pr",
    "label": "Querência do Norte - PR"
  },
  {
    "value": "quevedos_rs",
    "label": "Quevedos - RS"
  },
  {
    "value": "quijingue_ba",
    "label": "Quijingue - BA"
  },
  {
    "value": "quilombo_sc",
    "label": "Quilombo - SC"
  },
  {
    "value": "quinta_do_sol_pr",
    "label": "Quinta do Sol - PR"
  },
  {
    "value": "quintana_sp",
    "label": "Quintana - SP"
  },
  {
    "value": "quinze_de_novembro_rs",
    "label": "Quinze de Novembro - RS"
  },
  {
    "value": "quipapá_pe",
    "label": "Quipapá - PE"
  },
  {
    "value": "quirinópolis_go",
    "label": "Quirinópolis - GO"
  },
  {
    "value": "quissamã_rj",
    "label": "Quissamã - RJ"
  },
  {
    "value": "quitandinha_pr",
    "label": "Quitandinha - PR"
  },
  {
    "value": "quiterianópolis_ce",
    "label": "Quiterianópolis - CE"
  },
  {
    "value": "quixaba_pe",
    "label": "Quixaba - PE"
  },
  {
    "value": "quixabeira_ba",
    "label": "Quixabeira - BA"
  },
  {
    "value": "quixabá_pb",
    "label": "Quixabá - PB"
  },
  {
    "value": "quixadá_ce",
    "label": "Quixadá - CE"
  },
  {
    "value": "quixelô_ce",
    "label": "Quixelô - CE"
  },
  {
    "value": "quixeramobim_ce",
    "label": "Quixeramobim - CE"
  },
  {
    "value": "quixeré_ce",
    "label": "Quixeré - CE"
  },
  {
    "value": "rafael_fernandes_rn",
    "label": "Rafael Fernandes - RN"
  },
  {
    "value": "rafael_godeiro_rn",
    "label": "Rafael Godeiro - RN"
  },
  {
    "value": "rafael_jambeiro_ba",
    "label": "Rafael Jambeiro - BA"
  },
  {
    "value": "rafard_sp",
    "label": "Rafard - SP"
  },
  {
    "value": "ramilândia_pr",
    "label": "Ramilândia - PR"
  },
  {
    "value": "rancharia_sp",
    "label": "Rancharia - SP"
  },
  {
    "value": "rancho_alegre_pr",
    "label": "Rancho Alegre - PR"
  },
  {
    "value": "rancho_alegre_d'oeste_pr",
    "label": "Rancho Alegre d'Oeste - PR"
  },
  {
    "value": "rancho_queimado_sc",
    "label": "Rancho Queimado - SC"
  },
  {
    "value": "raposa_ma",
    "label": "Raposa - MA"
  },
  {
    "value": "raposos_mg",
    "label": "Raposos - MG"
  },
  {
    "value": "raul_soares_mg",
    "label": "Raul Soares - MG"
  },
  {
    "value": "realeza_pr",
    "label": "Realeza - PR"
  },
  {
    "value": "rebouças_pr",
    "label": "Rebouças - PR"
  },
  {
    "value": "recife_pe",
    "label": "Recife - PE"
  },
  {
    "value": "recreio_mg",
    "label": "Recreio - MG"
  },
  {
    "value": "recursolândia_to",
    "label": "Recursolândia - TO"
  },
  {
    "value": "redentora_rs",
    "label": "Redentora - RS"
  },
  {
    "value": "redenção_ce",
    "label": "Redenção - CE"
  },
  {
    "value": "redenção_pa",
    "label": "Redenção - PA"
  },
  {
    "value": "redenção_da_serra_sp",
    "label": "Redenção da Serra - SP"
  },
  {
    "value": "redenção_do_gurguéia_pi",
    "label": "Redenção do Gurguéia - PI"
  },
  {
    "value": "reduto_mg",
    "label": "Reduto - MG"
  },
  {
    "value": "regeneração_pi",
    "label": "Regeneração - PI"
  },
  {
    "value": "regente_feijó_sp",
    "label": "Regente Feijó - SP"
  },
  {
    "value": "reginópolis_sp",
    "label": "Reginópolis - SP"
  },
  {
    "value": "registro_sp",
    "label": "Registro - SP"
  },
  {
    "value": "relvado_rs",
    "label": "Relvado - RS"
  },
  {
    "value": "remanso_ba",
    "label": "Remanso - BA"
  },
  {
    "value": "remígio_pb",
    "label": "Remígio - PB"
  },
  {
    "value": "renascença_pr",
    "label": "Renascença - PR"
  },
  {
    "value": "reriutaba_ce",
    "label": "Reriutaba - CE"
  },
  {
    "value": "resende_rj",
    "label": "Resende - RJ"
  },
  {
    "value": "resende_costa_mg",
    "label": "Resende Costa - MG"
  },
  {
    "value": "reserva_pr",
    "label": "Reserva - PR"
  },
  {
    "value": "reserva_do_cabaçal_mt",
    "label": "Reserva do Cabaçal - MT"
  },
  {
    "value": "reserva_do_iguaçu_pr",
    "label": "Reserva do Iguaçu - PR"
  },
  {
    "value": "resplendor_mg",
    "label": "Resplendor - MG"
  },
  {
    "value": "ressaquinha_mg",
    "label": "Ressaquinha - MG"
  },
  {
    "value": "restinga_sp",
    "label": "Restinga - SP"
  },
  {
    "value": "restinga_seca_rs",
    "label": "Restinga Seca - RS"
  },
  {
    "value": "retirolândia_ba",
    "label": "Retirolândia - BA"
  },
  {
    "value": "riachinho_mg",
    "label": "Riachinho - MG"
  },
  {
    "value": "riachinho_to",
    "label": "Riachinho - TO"
  },
  {
    "value": "riacho_frio_pi",
    "label": "Riacho Frio - PI"
  },
  {
    "value": "riacho_da_cruz_rn",
    "label": "Riacho da Cruz - RN"
  },
  {
    "value": "riacho_das_almas_pe",
    "label": "Riacho das Almas - PE"
  },
  {
    "value": "riacho_de_santana_ba",
    "label": "Riacho de Santana - BA"
  },
  {
    "value": "riacho_de_santana_rn",
    "label": "Riacho de Santana - RN"
  },
  {
    "value": "riacho_de_santo_antônio_pb",
    "label": "Riacho de Santo Antônio - PB"
  },
  {
    "value": "riacho_dos_cavalos_pb",
    "label": "Riacho dos Cavalos - PB"
  },
  {
    "value": "riacho_dos_machados_mg",
    "label": "Riacho dos Machados - MG"
  },
  {
    "value": "riachuelo_rn",
    "label": "Riachuelo - RN"
  },
  {
    "value": "riachuelo_se",
    "label": "Riachuelo - SE"
  },
  {
    "value": "riachão_ma",
    "label": "Riachão - MA"
  },
  {
    "value": "riachão_pb",
    "label": "Riachão - PB"
  },
  {
    "value": "riachão_das_neves_ba",
    "label": "Riachão das Neves - BA"
  },
  {
    "value": "riachão_do_bacamarte_pb",
    "label": "Riachão do Bacamarte - PB"
  },
  {
    "value": "riachão_do_dantas_se",
    "label": "Riachão do Dantas - SE"
  },
  {
    "value": "riachão_do_jacuípe_ba",
    "label": "Riachão do Jacuípe - BA"
  },
  {
    "value": "riachão_do_poço_pb",
    "label": "Riachão do Poço - PB"
  },
  {
    "value": "rialma_go",
    "label": "Rialma - GO"
  },
  {
    "value": "rianápolis_go",
    "label": "Rianápolis - GO"
  },
  {
    "value": "ribamar_fiquene_ma",
    "label": "Ribamar Fiquene - MA"
  },
  {
    "value": "ribas_do_rio_pardo_ms",
    "label": "Ribas do Rio Pardo - MS"
  },
  {
    "value": "ribeira_sp",
    "label": "Ribeira - SP"
  },
  {
    "value": "ribeira_do_amparo_ba",
    "label": "Ribeira do Amparo - BA"
  },
  {
    "value": "ribeira_do_piauí_pi",
    "label": "Ribeira do Piauí - PI"
  },
  {
    "value": "ribeira_do_pombal_ba",
    "label": "Ribeira do Pombal - BA"
  },
  {
    "value": "ribeiro_gonçalves_pi",
    "label": "Ribeiro Gonçalves - PI"
  },
  {
    "value": "ribeirão_pe",
    "label": "Ribeirão - PE"
  },
  {
    "value": "ribeirão_bonito_sp",
    "label": "Ribeirão Bonito - SP"
  },
  {
    "value": "ribeirão_branco_sp",
    "label": "Ribeirão Branco - SP"
  },
  {
    "value": "ribeirão_cascalheira_mt",
    "label": "Ribeirão Cascalheira - MT"
  },
  {
    "value": "ribeirão_claro_pr",
    "label": "Ribeirão Claro - PR"
  },
  {
    "value": "ribeirão_corrente_sp",
    "label": "Ribeirão Corrente - SP"
  },
  {
    "value": "ribeirão_grande_sp",
    "label": "Ribeirão Grande - SP"
  },
  {
    "value": "ribeirão_pires_sp",
    "label": "Ribeirão Pires - SP"
  },
  {
    "value": "ribeirão_preto_sp",
    "label": "Ribeirão Preto - SP"
  },
  {
    "value": "ribeirão_vermelho_mg",
    "label": "Ribeirão Vermelho - MG"
  },
  {
    "value": "ribeirão_das_neves_mg",
    "label": "Ribeirão das Neves - MG"
  },
  {
    "value": "ribeirão_do_largo_ba",
    "label": "Ribeirão do Largo - BA"
  },
  {
    "value": "ribeirão_do_pinhal_pr",
    "label": "Ribeirão do Pinhal - PR"
  },
  {
    "value": "ribeirão_do_sul_sp",
    "label": "Ribeirão do Sul - SP"
  },
  {
    "value": "ribeirão_dos_índios_sp",
    "label": "Ribeirão dos Índios - SP"
  },
  {
    "value": "ribeirãozinho_mt",
    "label": "Ribeirãozinho - MT"
  },
  {
    "value": "ribeirópolis_se",
    "label": "Ribeirópolis - SE"
  },
  {
    "value": "rifaina_sp",
    "label": "Rifaina - SP"
  },
  {
    "value": "rincão_sp",
    "label": "Rincão - SP"
  },
  {
    "value": "rinópolis_sp",
    "label": "Rinópolis - SP"
  },
  {
    "value": "rio_acima_mg",
    "label": "Rio Acima - MG"
  },
  {
    "value": "rio_azul_pr",
    "label": "Rio Azul - PR"
  },
  {
    "value": "rio_bananal_es",
    "label": "Rio Bananal - ES"
  },
  {
    "value": "rio_bom_pr",
    "label": "Rio Bom - PR"
  },
  {
    "value": "rio_bonito_rj",
    "label": "Rio Bonito - RJ"
  },
  {
    "value": "rio_bonito_do_iguaçu_pr",
    "label": "Rio Bonito do Iguaçu - PR"
  },
  {
    "value": "rio_branco_ac",
    "label": "Rio Branco - AC"
  },
  {
    "value": "rio_branco_mt",
    "label": "Rio Branco - MT"
  },
  {
    "value": "rio_branco_do_ivaí_pr",
    "label": "Rio Branco do Ivaí - PR"
  },
  {
    "value": "rio_branco_do_sul_pr",
    "label": "Rio Branco do Sul - PR"
  },
  {
    "value": "rio_brilhante_ms",
    "label": "Rio Brilhante - MS"
  },
  {
    "value": "rio_casca_mg",
    "label": "Rio Casca - MG"
  },
  {
    "value": "rio_claro_rj",
    "label": "Rio Claro - RJ"
  },
  {
    "value": "rio_claro_sp",
    "label": "Rio Claro - SP"
  },
  {
    "value": "rio_crespo_ro",
    "label": "Rio Crespo - RO"
  },
  {
    "value": "rio_doce_mg",
    "label": "Rio Doce - MG"
  },
  {
    "value": "rio_espera_mg",
    "label": "Rio Espera - MG"
  },
  {
    "value": "rio_formoso_pe",
    "label": "Rio Formoso - PE"
  },
  {
    "value": "rio_fortuna_sc",
    "label": "Rio Fortuna - SC"
  },
  {
    "value": "rio_grande_rs",
    "label": "Rio Grande - RS"
  },
  {
    "value": "rio_grande_da_serra_sp",
    "label": "Rio Grande da Serra - SP"
  },
  {
    "value": "rio_grande_do_piauí_pi",
    "label": "Rio Grande do Piauí - PI"
  },
  {
    "value": "rio_largo_al",
    "label": "Rio Largo - AL"
  },
  {
    "value": "rio_manso_mg",
    "label": "Rio Manso - MG"
  },
  {
    "value": "rio_maria_pa",
    "label": "Rio Maria - PA"
  },
  {
    "value": "rio_negrinho_sc",
    "label": "Rio Negrinho - SC"
  },
  {
    "value": "rio_negro_ms",
    "label": "Rio Negro - MS"
  },
  {
    "value": "rio_negro_pr",
    "label": "Rio Negro - PR"
  },
  {
    "value": "rio_novo_mg",
    "label": "Rio Novo - MG"
  },
  {
    "value": "rio_novo_do_sul_es",
    "label": "Rio Novo do Sul - ES"
  },
  {
    "value": "rio_paranaíba_mg",
    "label": "Rio Paranaíba - MG"
  },
  {
    "value": "rio_pardo_rs",
    "label": "Rio Pardo - RS"
  },
  {
    "value": "rio_pardo_de_minas_mg",
    "label": "Rio Pardo de Minas - MG"
  },
  {
    "value": "rio_piracicaba_mg",
    "label": "Rio Piracicaba - MG"
  },
  {
    "value": "rio_pomba_mg",
    "label": "Rio Pomba - MG"
  },
  {
    "value": "rio_preto_mg",
    "label": "Rio Preto - MG"
  },
  {
    "value": "rio_preto_da_eva_am",
    "label": "Rio Preto da Eva - AM"
  },
  {
    "value": "rio_quente_go",
    "label": "Rio Quente - GO"
  },
  {
    "value": "rio_real_ba",
    "label": "Rio Real - BA"
  },
  {
    "value": "rio_rufino_sc",
    "label": "Rio Rufino - SC"
  },
  {
    "value": "rio_sono_to",
    "label": "Rio Sono - TO"
  },
  {
    "value": "rio_tinto_pb",
    "label": "Rio Tinto - PB"
  },
  {
    "value": "rio_verde_go",
    "label": "Rio Verde - GO"
  },
  {
    "value": "rio_verde_de_mato_grosso_ms",
    "label": "Rio Verde de Mato Grosso - MS"
  },
  {
    "value": "rio_vermelho_mg",
    "label": "Rio Vermelho - MG"
  },
  {
    "value": "rio_da_conceição_to",
    "label": "Rio da Conceição - TO"
  },
  {
    "value": "rio_das_antas_sc",
    "label": "Rio das Antas - SC"
  },
  {
    "value": "rio_das_flores_rj",
    "label": "Rio das Flores - RJ"
  },
  {
    "value": "rio_das_ostras_rj",
    "label": "Rio das Ostras - RJ"
  },
  {
    "value": "rio_das_pedras_sp",
    "label": "Rio das Pedras - SP"
  },
  {
    "value": "rio_de_contas_ba",
    "label": "Rio de Contas - BA"
  },
  {
    "value": "rio_de_janeiro_rj",
    "label": "Rio de Janeiro - RJ"
  },
  {
    "value": "rio_do_antônio_ba",
    "label": "Rio do Antônio - BA"
  },
  {
    "value": "rio_do_campo_sc",
    "label": "Rio do Campo - SC"
  },
  {
    "value": "rio_do_fogo_rn",
    "label": "Rio do Fogo - RN"
  },
  {
    "value": "rio_do_oeste_sc",
    "label": "Rio do Oeste - SC"
  },
  {
    "value": "rio_do_pires_ba",
    "label": "Rio do Pires - BA"
  },
  {
    "value": "rio_do_prado_mg",
    "label": "Rio do Prado - MG"
  },
  {
    "value": "rio_do_sul_sc",
    "label": "Rio do Sul - SC"
  },
  {
    "value": "rio_dos_bois_to",
    "label": "Rio dos Bois - TO"
  },
  {
    "value": "rio_dos_cedros_sc",
    "label": "Rio dos Cedros - SC"
  },
  {
    "value": "rio_dos_índios_rs",
    "label": "Rio dos Índios - RS"
  },
  {
    "value": "riolândia_sp",
    "label": "Riolândia - SP"
  },
  {
    "value": "riozinho_rs",
    "label": "Riozinho - RS"
  },
  {
    "value": "riqueza_sc",
    "label": "Riqueza - SC"
  },
  {
    "value": "ritápolis_mg",
    "label": "Ritápolis - MG"
  },
  {
    "value": "riversul_sp",
    "label": "Riversul - SP"
  },
  {
    "value": "roca_sales_rs",
    "label": "Roca Sales - RS"
  },
  {
    "value": "rochedo_ms",
    "label": "Rochedo - MS"
  },
  {
    "value": "rochedo_de_minas_mg",
    "label": "Rochedo de Minas - MG"
  },
  {
    "value": "rodeio_sc",
    "label": "Rodeio - SC"
  },
  {
    "value": "rodeio_bonito_rs",
    "label": "Rodeio Bonito - RS"
  },
  {
    "value": "rodeiro_mg",
    "label": "Rodeiro - MG"
  },
  {
    "value": "rodelas_ba",
    "label": "Rodelas - BA"
  },
  {
    "value": "rodolfo_fernandes_rn",
    "label": "Rodolfo Fernandes - RN"
  },
  {
    "value": "rodrigues_alves_ac",
    "label": "Rodrigues Alves - AC"
  },
  {
    "value": "rolador_rs",
    "label": "Rolador - RS"
  },
  {
    "value": "rolante_rs",
    "label": "Rolante - RS"
  },
  {
    "value": "rolim_de_moura_ro",
    "label": "Rolim de Moura - RO"
  },
  {
    "value": "rolândia_pr",
    "label": "Rolândia - PR"
  },
  {
    "value": "romaria_mg",
    "label": "Romaria - MG"
  },
  {
    "value": "romelândia_sc",
    "label": "Romelândia - SC"
  },
  {
    "value": "roncador_pr",
    "label": "Roncador - PR"
  },
  {
    "value": "ronda_alta_rs",
    "label": "Ronda Alta - RS"
  },
  {
    "value": "rondinha_rs",
    "label": "Rondinha - RS"
  },
  {
    "value": "rondolândia_mt",
    "label": "Rondolândia - MT"
  },
  {
    "value": "rondon_pr",
    "label": "Rondon - PR"
  },
  {
    "value": "rondon_do_pará_pa",
    "label": "Rondon do Pará - PA"
  },
  {
    "value": "rondonópolis_mt",
    "label": "Rondonópolis - MT"
  },
  {
    "value": "roque_gonzales_rs",
    "label": "Roque Gonzales - RS"
  },
  {
    "value": "rorainópolis_rr",
    "label": "Rorainópolis - RR"
  },
  {
    "value": "rosana_sp",
    "label": "Rosana - SP"
  },
  {
    "value": "roseira_sp",
    "label": "Roseira - SP"
  },
  {
    "value": "rosário_ma",
    "label": "Rosário - MA"
  },
  {
    "value": "rosário_oeste_mt",
    "label": "Rosário Oeste - MT"
  },
  {
    "value": "rosário_da_limeira_mg",
    "label": "Rosário da Limeira - MG"
  },
  {
    "value": "rosário_do_catete_se",
    "label": "Rosário do Catete - SE"
  },
  {
    "value": "rosário_do_ivaí_pr",
    "label": "Rosário do Ivaí - PR"
  },
  {
    "value": "rosário_do_sul_rs",
    "label": "Rosário do Sul - RS"
  },
  {
    "value": "roteiro_al",
    "label": "Roteiro - AL"
  },
  {
    "value": "rubelita_mg",
    "label": "Rubelita - MG"
  },
  {
    "value": "rubiataba_go",
    "label": "Rubiataba - GO"
  },
  {
    "value": "rubim_mg",
    "label": "Rubim - MG"
  },
  {
    "value": "rubinéia_sp",
    "label": "Rubinéia - SP"
  },
  {
    "value": "rubiácea_sp",
    "label": "Rubiácea - SP"
  },
  {
    "value": "rurópolis_pa",
    "label": "Rurópolis - PA"
  },
  {
    "value": "russas_ce",
    "label": "Russas - CE"
  },
  {
    "value": "ruy_barbosa_ba",
    "label": "Ruy Barbosa - BA"
  },
  {
    "value": "ruy_barbosa_rn",
    "label": "Ruy Barbosa - RN"
  },
  {
    "value": "sabará_mg",
    "label": "Sabará - MG"
  },
  {
    "value": "sabino_sp",
    "label": "Sabino - SP"
  },
  {
    "value": "sabinópolis_mg",
    "label": "Sabinópolis - MG"
  },
  {
    "value": "saboeiro_ce",
    "label": "Saboeiro - CE"
  },
  {
    "value": "sabáudia_pr",
    "label": "Sabáudia - PR"
  },
  {
    "value": "sacramento_mg",
    "label": "Sacramento - MG"
  },
  {
    "value": "sagrada_família_rs",
    "label": "Sagrada Família - RS"
  },
  {
    "value": "sagres_sp",
    "label": "Sagres - SP"
  },
  {
    "value": "sairé_pe",
    "label": "Sairé - PE"
  },
  {
    "value": "saldanha_marinho_rs",
    "label": "Saldanha Marinho - RS"
  },
  {
    "value": "sales_sp",
    "label": "Sales - SP"
  },
  {
    "value": "sales_oliveira_sp",
    "label": "Sales Oliveira - SP"
  },
  {
    "value": "salesópolis_sp",
    "label": "Salesópolis - SP"
  },
  {
    "value": "salete_sc",
    "label": "Salete - SC"
  },
  {
    "value": "salgadinho_pb",
    "label": "Salgadinho - PB"
  },
  {
    "value": "salgadinho_pe",
    "label": "Salgadinho - PE"
  },
  {
    "value": "salgado_se",
    "label": "Salgado - SE"
  },
  {
    "value": "salgado_filho_pr",
    "label": "Salgado Filho - PR"
  },
  {
    "value": "salgado_de_são_félix_pb",
    "label": "Salgado de São Félix - PB"
  },
  {
    "value": "salgueiro_pe",
    "label": "Salgueiro - PE"
  },
  {
    "value": "salinas_mg",
    "label": "Salinas - MG"
  },
  {
    "value": "salinas_da_margarida_ba",
    "label": "Salinas da Margarida - BA"
  },
  {
    "value": "salinópolis_pa",
    "label": "Salinópolis - PA"
  },
  {
    "value": "salitre_ce",
    "label": "Salitre - CE"
  },
  {
    "value": "salmourão_sp",
    "label": "Salmourão - SP"
  },
  {
    "value": "saloá_pe",
    "label": "Saloá - PE"
  },
  {
    "value": "saltinho_sc",
    "label": "Saltinho - SC"
  },
  {
    "value": "saltinho_sp",
    "label": "Saltinho - SP"
  },
  {
    "value": "salto_sp",
    "label": "Salto - SP"
  },
  {
    "value": "salto_grande_sp",
    "label": "Salto Grande - SP"
  },
  {
    "value": "salto_veloso_sc",
    "label": "Salto Veloso - SC"
  },
  {
    "value": "salto_da_divisa_mg",
    "label": "Salto da Divisa - MG"
  },
  {
    "value": "salto_de_pirapora_sp",
    "label": "Salto de Pirapora - SP"
  },
  {
    "value": "salto_do_céu_mt",
    "label": "Salto do Céu - MT"
  },
  {
    "value": "salto_do_itararé_pr",
    "label": "Salto do Itararé - PR"
  },
  {
    "value": "salto_do_jacuí_rs",
    "label": "Salto do Jacuí - RS"
  },
  {
    "value": "salto_do_lontra_pr",
    "label": "Salto do Lontra - PR"
  },
  {
    "value": "salvador_ba",
    "label": "Salvador - BA"
  },
  {
    "value": "salvador_das_missões_rs",
    "label": "Salvador das Missões - RS"
  },
  {
    "value": "salvador_do_sul_rs",
    "label": "Salvador do Sul - RS"
  },
  {
    "value": "salvaterra_pa",
    "label": "Salvaterra - PA"
  },
  {
    "value": "sambaíba_ma",
    "label": "Sambaíba - MA"
  },
  {
    "value": "sampaio_to",
    "label": "Sampaio - TO"
  },
  {
    "value": "sananduva_rs",
    "label": "Sananduva - RS"
  },
  {
    "value": "sanclerlândia_go",
    "label": "Sanclerlândia - GO"
  },
  {
    "value": "sandolândia_to",
    "label": "Sandolândia - TO"
  },
  {
    "value": "sandovalina_sp",
    "label": "Sandovalina - SP"
  },
  {
    "value": "sangão_sc",
    "label": "Sangão - SC"
  },
  {
    "value": "sanharó_pe",
    "label": "Sanharó - PE"
  },
  {
    "value": "santa_adélia_sp",
    "label": "Santa Adélia - SP"
  },
  {
    "value": "santa_albertina_sp",
    "label": "Santa Albertina - SP"
  },
  {
    "value": "santa_amélia_pr",
    "label": "Santa Amélia - PR"
  },
  {
    "value": "santa_branca_sp",
    "label": "Santa Branca - SP"
  },
  {
    "value": "santa_brígida_ba",
    "label": "Santa Brígida - BA"
  },
  {
    "value": "santa_bárbara_ba",
    "label": "Santa Bárbara - BA"
  },
  {
    "value": "santa_bárbara_mg",
    "label": "Santa Bárbara - MG"
  },
  {
    "value": "santa_bárbara_d'oeste_sp",
    "label": "Santa Bárbara d'Oeste - SP"
  },
  {
    "value": "santa_bárbara_de_goiás_go",
    "label": "Santa Bárbara de Goiás - GO"
  },
  {
    "value": "santa_bárbara_do_leste_mg",
    "label": "Santa Bárbara do Leste - MG"
  },
  {
    "value": "santa_bárbara_do_monte_verde_mg",
    "label": "Santa Bárbara do Monte Verde - MG"
  },
  {
    "value": "santa_bárbara_do_pará_pa",
    "label": "Santa Bárbara do Pará - PA"
  },
  {
    "value": "santa_bárbara_do_sul_rs",
    "label": "Santa Bárbara do Sul - RS"
  },
  {
    "value": "santa_bárbara_do_tugúrio_mg",
    "label": "Santa Bárbara do Tugúrio - MG"
  },
  {
    "value": "santa_carmem_mt",
    "label": "Santa Carmem - MT"
  },
  {
    "value": "santa_cecília_pb",
    "label": "Santa Cecília - PB"
  },
  {
    "value": "santa_cecília_sc",
    "label": "Santa Cecília - SC"
  },
  {
    "value": "santa_cecília_do_pavão_pr",
    "label": "Santa Cecília do Pavão - PR"
  },
  {
    "value": "santa_cecília_do_sul_rs",
    "label": "Santa Cecília do Sul - RS"
  },
  {
    "value": "santa_clara_d'oeste_sp",
    "label": "Santa Clara d'Oeste - SP"
  },
  {
    "value": "santa_clara_do_sul_rs",
    "label": "Santa Clara do Sul - RS"
  },
  {
    "value": "santa_cruz_pb",
    "label": "Santa Cruz - PB"
  },
  {
    "value": "santa_cruz_pe",
    "label": "Santa Cruz - PE"
  },
  {
    "value": "santa_cruz_rn",
    "label": "Santa Cruz - RN"
  },
  {
    "value": "santa_cruz_cabrália_ba",
    "label": "Santa Cruz Cabrália - BA"
  },
  {
    "value": "santa_cruz_monte_castelo_pr",
    "label": "Santa Cruz Monte Castelo - PR"
  },
  {
    "value": "santa_cruz_da_baixa_verde_pe",
    "label": "Santa Cruz da Baixa Verde - PE"
  },
  {
    "value": "santa_cruz_da_conceição_sp",
    "label": "Santa Cruz da Conceição - SP"
  },
  {
    "value": "santa_cruz_da_esperança_sp",
    "label": "Santa Cruz da Esperança - SP"
  },
  {
    "value": "santa_cruz_da_vitória_ba",
    "label": "Santa Cruz da Vitória - BA"
  },
  {
    "value": "santa_cruz_das_palmeiras_sp",
    "label": "Santa Cruz das Palmeiras - SP"
  },
  {
    "value": "santa_cruz_de_goiás_go",
    "label": "Santa Cruz de Goiás - GO"
  },
  {
    "value": "santa_cruz_de_minas_mg",
    "label": "Santa Cruz de Minas - MG"
  },
  {
    "value": "santa_cruz_de_salinas_mg",
    "label": "Santa Cruz de Salinas - MG"
  },
  {
    "value": "santa_cruz_do_arari_pa",
    "label": "Santa Cruz do Arari - PA"
  },
  {
    "value": "santa_cruz_do_capibaribe_pe",
    "label": "Santa Cruz do Capibaribe - PE"
  },
  {
    "value": "santa_cruz_do_escalvado_mg",
    "label": "Santa Cruz do Escalvado - MG"
  },
  {
    "value": "santa_cruz_do_piauí_pi",
    "label": "Santa Cruz do Piauí - PI"
  },
  {
    "value": "santa_cruz_do_rio_pardo_sp",
    "label": "Santa Cruz do Rio Pardo - SP"
  },
  {
    "value": "santa_cruz_do_sul_rs",
    "label": "Santa Cruz do Sul - RS"
  },
  {
    "value": "santa_cruz_do_xingu_mt",
    "label": "Santa Cruz do Xingu - MT"
  },
  {
    "value": "santa_cruz_dos_milagres_pi",
    "label": "Santa Cruz dos Milagres - PI"
  },
  {
    "value": "santa_efigênia_de_minas_mg",
    "label": "Santa Efigênia de Minas - MG"
  },
  {
    "value": "santa_ernestina_sp",
    "label": "Santa Ernestina - SP"
  },
  {
    "value": "santa_filomena_pe",
    "label": "Santa Filomena - PE"
  },
  {
    "value": "santa_filomena_pi",
    "label": "Santa Filomena - PI"
  },
  {
    "value": "santa_filomena_do_maranhão_ma",
    "label": "Santa Filomena do Maranhão - MA"
  },
  {
    "value": "santa_fé_pr",
    "label": "Santa Fé - PR"
  },
  {
    "value": "santa_fé_de_goiás_go",
    "label": "Santa Fé de Goiás - GO"
  },
  {
    "value": "santa_fé_de_minas_mg",
    "label": "Santa Fé de Minas - MG"
  },
  {
    "value": "santa_fé_do_araguaia_to",
    "label": "Santa Fé do Araguaia - TO"
  },
  {
    "value": "santa_fé_do_sul_sp",
    "label": "Santa Fé do Sul - SP"
  },
  {
    "value": "santa_gertrudes_sp",
    "label": "Santa Gertrudes - SP"
  },
  {
    "value": "santa_helena_ma",
    "label": "Santa Helena - MA"
  },
  {
    "value": "santa_helena_pb",
    "label": "Santa Helena - PB"
  },
  {
    "value": "santa_helena_pr",
    "label": "Santa Helena - PR"
  },
  {
    "value": "santa_helena_sc",
    "label": "Santa Helena - SC"
  },
  {
    "value": "santa_helena_de_goiás_go",
    "label": "Santa Helena de Goiás - GO"
  },
  {
    "value": "santa_helena_de_minas_mg",
    "label": "Santa Helena de Minas - MG"
  },
  {
    "value": "santa_inês_ba",
    "label": "Santa Inês - BA"
  },
  {
    "value": "santa_inês_ma",
    "label": "Santa Inês - MA"
  },
  {
    "value": "santa_inês_pb",
    "label": "Santa Inês - PB"
  },
  {
    "value": "santa_inês_pr",
    "label": "Santa Inês - PR"
  },
  {
    "value": "santa_isabel_go",
    "label": "Santa Isabel - GO"
  },
  {
    "value": "santa_isabel_sp",
    "label": "Santa Isabel - SP"
  },
  {
    "value": "santa_isabel_do_ivaí_pr",
    "label": "Santa Isabel do Ivaí - PR"
  },
  {
    "value": "santa_isabel_do_pará_pa",
    "label": "Santa Isabel do Pará - PA"
  },
  {
    "value": "santa_isabel_do_rio_negro_am",
    "label": "Santa Isabel do Rio Negro - AM"
  },
  {
    "value": "santa_izabel_do_oeste_pr",
    "label": "Santa Izabel do Oeste - PR"
  },
  {
    "value": "santa_juliana_mg",
    "label": "Santa Juliana - MG"
  },
  {
    "value": "santa_leopoldina_es",
    "label": "Santa Leopoldina - ES"
  },
  {
    "value": "santa_luz_pi",
    "label": "Santa Luz - PI"
  },
  {
    "value": "santa_luzia_ba",
    "label": "Santa Luzia - BA"
  },
  {
    "value": "santa_luzia_ma",
    "label": "Santa Luzia - MA"
  },
  {
    "value": "santa_luzia_mg",
    "label": "Santa Luzia - MG"
  },
  {
    "value": "santa_luzia_pb",
    "label": "Santa Luzia - PB"
  },
  {
    "value": "santa_luzia_d'oeste_ro",
    "label": "Santa Luzia d'Oeste - RO"
  },
  {
    "value": "santa_luzia_do_itanhy_se",
    "label": "Santa Luzia do Itanhy - SE"
  },
  {
    "value": "santa_luzia_do_norte_al",
    "label": "Santa Luzia do Norte - AL"
  },
  {
    "value": "santa_luzia_do_paruá_ma",
    "label": "Santa Luzia do Paruá - MA"
  },
  {
    "value": "santa_luzia_do_pará_pa",
    "label": "Santa Luzia do Pará - PA"
  },
  {
    "value": "santa_lúcia_pr",
    "label": "Santa Lúcia - PR"
  },
  {
    "value": "santa_lúcia_sp",
    "label": "Santa Lúcia - SP"
  },
  {
    "value": "santa_margarida_mg",
    "label": "Santa Margarida - MG"
  },
  {
    "value": "santa_margarida_do_sul_rs",
    "label": "Santa Margarida do Sul - RS"
  },
  {
    "value": "santa_maria_rn",
    "label": "Santa Maria - RN"
  },
  {
    "value": "santa_maria_rs",
    "label": "Santa Maria - RS"
  },
  {
    "value": "santa_maria_madalena_rj",
    "label": "Santa Maria Madalena - RJ"
  },
  {
    "value": "santa_maria_da_boa_vista_pe",
    "label": "Santa Maria da Boa Vista - PE"
  },
  {
    "value": "santa_maria_da_serra_sp",
    "label": "Santa Maria da Serra - SP"
  },
  {
    "value": "santa_maria_da_vitória_ba",
    "label": "Santa Maria da Vitória - BA"
  },
  {
    "value": "santa_maria_das_barreiras_pa",
    "label": "Santa Maria das Barreiras - PA"
  },
  {
    "value": "santa_maria_de_itabira_mg",
    "label": "Santa Maria de Itabira - MG"
  },
  {
    "value": "santa_maria_de_jetibá_es",
    "label": "Santa Maria de Jetibá - ES"
  },
  {
    "value": "santa_maria_do_cambucá_pe",
    "label": "Santa Maria do Cambucá - PE"
  },
  {
    "value": "santa_maria_do_herval_rs",
    "label": "Santa Maria do Herval - RS"
  },
  {
    "value": "santa_maria_do_oeste_pr",
    "label": "Santa Maria do Oeste - PR"
  },
  {
    "value": "santa_maria_do_pará_pa",
    "label": "Santa Maria do Pará - PA"
  },
  {
    "value": "santa_maria_do_salto_mg",
    "label": "Santa Maria do Salto - MG"
  },
  {
    "value": "santa_maria_do_suaçuí_mg",
    "label": "Santa Maria do Suaçuí - MG"
  },
  {
    "value": "santa_maria_do_tocantins_to",
    "label": "Santa Maria do Tocantins - TO"
  },
  {
    "value": "santa_mariana_pr",
    "label": "Santa Mariana - PR"
  },
  {
    "value": "santa_mercedes_sp",
    "label": "Santa Mercedes - SP"
  },
  {
    "value": "santa_mônica_pr",
    "label": "Santa Mônica - PR"
  },
  {
    "value": "santa_quitéria_ce",
    "label": "Santa Quitéria - CE"
  },
  {
    "value": "santa_quitéria_do_maranhão_ma",
    "label": "Santa Quitéria do Maranhão - MA"
  },
  {
    "value": "santa_rita_ma",
    "label": "Santa Rita - MA"
  },
  {
    "value": "santa_rita_pb",
    "label": "Santa Rita - PB"
  },
  {
    "value": "santa_rita_d'oeste_sp",
    "label": "Santa Rita d'Oeste - SP"
  },
  {
    "value": "santa_rita_de_caldas_mg",
    "label": "Santa Rita de Caldas - MG"
  },
  {
    "value": "santa_rita_de_cássia_ba",
    "label": "Santa Rita de Cássia - BA"
  },
  {
    "value": "santa_rita_de_ibitipoca_mg",
    "label": "Santa Rita de Ibitipoca - MG"
  },
  {
    "value": "santa_rita_de_jacutinga_mg",
    "label": "Santa Rita de Jacutinga - MG"
  },
  {
    "value": "santa_rita_de_minas_mg",
    "label": "Santa Rita de Minas - MG"
  },
  {
    "value": "santa_rita_do_araguaia_go",
    "label": "Santa Rita do Araguaia - GO"
  },
  {
    "value": "santa_rita_do_itueto_mg",
    "label": "Santa Rita do Itueto - MG"
  },
  {
    "value": "santa_rita_do_novo_destino_go",
    "label": "Santa Rita do Novo Destino - GO"
  },
  {
    "value": "santa_rita_do_pardo_ms",
    "label": "Santa Rita do Pardo - MS"
  },
  {
    "value": "santa_rita_do_passa_quatro_sp",
    "label": "Santa Rita do Passa Quatro - SP"
  },
  {
    "value": "santa_rita_do_sapucaí_mg",
    "label": "Santa Rita do Sapucaí - MG"
  },
  {
    "value": "santa_rita_do_tocantins_to",
    "label": "Santa Rita do Tocantins - TO"
  },
  {
    "value": "santa_rita_do_trivelato_mt",
    "label": "Santa Rita do Trivelato - MT"
  },
  {
    "value": "santa_rosa_rs",
    "label": "Santa Rosa - RS"
  },
  {
    "value": "santa_rosa_da_serra_mg",
    "label": "Santa Rosa da Serra - MG"
  },
  {
    "value": "santa_rosa_de_goiás_go",
    "label": "Santa Rosa de Goiás - GO"
  },
  {
    "value": "santa_rosa_de_lima_sc",
    "label": "Santa Rosa de Lima - SC"
  },
  {
    "value": "santa_rosa_de_lima_se",
    "label": "Santa Rosa de Lima - SE"
  },
  {
    "value": "santa_rosa_de_viterbo_sp",
    "label": "Santa Rosa de Viterbo - SP"
  },
  {
    "value": "santa_rosa_do_piauí_pi",
    "label": "Santa Rosa do Piauí - PI"
  },
  {
    "value": "santa_rosa_do_purus_ac",
    "label": "Santa Rosa do Purus - AC"
  },
  {
    "value": "santa_rosa_do_sul_sc",
    "label": "Santa Rosa do Sul - SC"
  },
  {
    "value": "santa_rosa_do_tocantins_to",
    "label": "Santa Rosa do Tocantins - TO"
  },
  {
    "value": "santa_salete_sp",
    "label": "Santa Salete - SP"
  },
  {
    "value": "santa_teresa_es",
    "label": "Santa Teresa - ES"
  },
  {
    "value": "santa_teresinha_ba",
    "label": "Santa Teresinha - BA"
  },
  {
    "value": "santa_teresinha_pb",
    "label": "Santa Teresinha - PB"
  },
  {
    "value": "santa_tereza_rs",
    "label": "Santa Tereza - RS"
  },
  {
    "value": "santa_tereza_de_goiás_go",
    "label": "Santa Tereza de Goiás - GO"
  },
  {
    "value": "santa_tereza_do_oeste_pr",
    "label": "Santa Tereza do Oeste - PR"
  },
  {
    "value": "santa_tereza_do_tocantins_to",
    "label": "Santa Tereza do Tocantins - TO"
  },
  {
    "value": "santa_terezinha_mt",
    "label": "Santa Terezinha - MT"
  },
  {
    "value": "santa_terezinha_pe",
    "label": "Santa Terezinha - PE"
  },
  {
    "value": "santa_terezinha_sc",
    "label": "Santa Terezinha - SC"
  },
  {
    "value": "santa_terezinha_tocantins_to",
    "label": "Santa Terezinha Tocantins - TO"
  },
  {
    "value": "santa_terezinha_de_goiás_go",
    "label": "Santa Terezinha de Goiás - GO"
  },
  {
    "value": "santa_terezinha_de_itaipu_pr",
    "label": "Santa Terezinha de Itaipu - PR"
  },
  {
    "value": "santa_terezinha_do_progresso_sc",
    "label": "Santa Terezinha do Progresso - SC"
  },
  {
    "value": "santa_vitória_mg",
    "label": "Santa Vitória - MG"
  },
  {
    "value": "santa_vitória_do_palmar_rs",
    "label": "Santa Vitória do Palmar - RS"
  },
  {
    "value": "santaluz_ba",
    "label": "Santaluz - BA"
  },
  {
    "value": "santana_ap",
    "label": "Santana - AP"
  },
  {
    "value": "santana_ba",
    "label": "Santana - BA"
  },
  {
    "value": "santana_da_boa_vista_rs",
    "label": "Santana da Boa Vista - RS"
  },
  {
    "value": "santana_da_ponte_pensa_sp",
    "label": "Santana da Ponte Pensa - SP"
  },
  {
    "value": "santana_da_vargem_mg",
    "label": "Santana da Vargem - MG"
  },
  {
    "value": "santana_de_cataguases_mg",
    "label": "Santana de Cataguases - MG"
  },
  {
    "value": "santana_de_mangueira_pb",
    "label": "Santana de Mangueira - PB"
  },
  {
    "value": "santana_de_parnaíba_sp",
    "label": "Santana de Parnaíba - SP"
  },
  {
    "value": "santana_de_pirapama_mg",
    "label": "Santana de Pirapama - MG"
  },
  {
    "value": "santana_do_acaraú_ce",
    "label": "Santana do Acaraú - CE"
  },
  {
    "value": "santana_do_araguaia_pa",
    "label": "Santana do Araguaia - PA"
  },
  {
    "value": "santana_do_cariri_ce",
    "label": "Santana do Cariri - CE"
  },
  {
    "value": "santana_do_deserto_mg",
    "label": "Santana do Deserto - MG"
  },
  {
    "value": "santana_do_garambéu_mg",
    "label": "Santana do Garambéu - MG"
  },
  {
    "value": "santana_do_ipanema_al",
    "label": "Santana do Ipanema - AL"
  },
  {
    "value": "santana_do_itararé_pr",
    "label": "Santana do Itararé - PR"
  },
  {
    "value": "santana_do_jacaré_mg",
    "label": "Santana do Jacaré - MG"
  },
  {
    "value": "santana_do_livramento_rs",
    "label": "Santana do Livramento - RS"
  },
  {
    "value": "santana_do_manhuaçu_mg",
    "label": "Santana do Manhuaçu - MG"
  },
  {
    "value": "santana_do_maranhão_ma",
    "label": "Santana do Maranhão - MA"
  },
  {
    "value": "santana_do_matos_rn",
    "label": "Santana do Matos - RN"
  },
  {
    "value": "santana_do_mundaú_al",
    "label": "Santana do Mundaú - AL"
  },
  {
    "value": "santana_do_paraíso_mg",
    "label": "Santana do Paraíso - MG"
  },
  {
    "value": "santana_do_piauí_pi",
    "label": "Santana do Piauí - PI"
  },
  {
    "value": "santana_do_riacho_mg",
    "label": "Santana do Riacho - MG"
  },
  {
    "value": "santana_do_seridó_rn",
    "label": "Santana do Seridó - RN"
  },
  {
    "value": "santana_do_são_francisco_se",
    "label": "Santana do São Francisco - SE"
  },
  {
    "value": "santana_dos_garrotes_pb",
    "label": "Santana dos Garrotes - PB"
  },
  {
    "value": "santana_dos_montes_mg",
    "label": "Santana dos Montes - MG"
  },
  {
    "value": "santanópolis_ba",
    "label": "Santanópolis - BA"
  },
  {
    "value": "santarém_pa",
    "label": "Santarém - PA"
  },
  {
    "value": "santarém_pb",
    "label": "Santarém - PB"
  },
  {
    "value": "santarém_novo_pa",
    "label": "Santarém Novo - PA"
  },
  {
    "value": "santiago_rs",
    "label": "Santiago - RS"
  },
  {
    "value": "santiago_do_sul_sc",
    "label": "Santiago do Sul - SC"
  },
  {
    "value": "santo_afonso_mt",
    "label": "Santo Afonso - MT"
  },
  {
    "value": "santo_amaro_ba",
    "label": "Santo Amaro - BA"
  },
  {
    "value": "santo_amaro_da_imperatriz_sc",
    "label": "Santo Amaro da Imperatriz - SC"
  },
  {
    "value": "santo_amaro_das_brotas_se",
    "label": "Santo Amaro das Brotas - SE"
  },
  {
    "value": "santo_amaro_do_maranhão_ma",
    "label": "Santo Amaro do Maranhão - MA"
  },
  {
    "value": "santo_anastácio_sp",
    "label": "Santo Anastácio - SP"
  },
  {
    "value": "santo_andré_pb",
    "label": "Santo André - PB"
  },
  {
    "value": "santo_andré_sp",
    "label": "Santo André - SP"
  },
  {
    "value": "santo_antônio_rn",
    "label": "Santo Antônio - RN"
  },
  {
    "value": "santo_antônio_da_alegria_sp",
    "label": "Santo Antônio da Alegria - SP"
  },
  {
    "value": "santo_antônio_da_barra_go",
    "label": "Santo Antônio da Barra - GO"
  },
  {
    "value": "santo_antônio_da_patrulha_rs",
    "label": "Santo Antônio da Patrulha - RS"
  },
  {
    "value": "santo_antônio_da_platina_pr",
    "label": "Santo Antônio da Platina - PR"
  },
  {
    "value": "santo_antônio_das_missões_rs",
    "label": "Santo Antônio das Missões - RS"
  },
  {
    "value": "santo_antônio_de_goiás_go",
    "label": "Santo Antônio de Goiás - GO"
  },
  {
    "value": "santo_antônio_de_jesus_ba",
    "label": "Santo Antônio de Jesus - BA"
  },
  {
    "value": "santo_antônio_de_lisboa_pi",
    "label": "Santo Antônio de Lisboa - PI"
  },
  {
    "value": "santo_antônio_de_posse_sp",
    "label": "Santo Antônio de Posse - SP"
  },
  {
    "value": "santo_antônio_de_pádua_rj",
    "label": "Santo Antônio de Pádua - RJ"
  },
  {
    "value": "santo_antônio_do_amparo_mg",
    "label": "Santo Antônio do Amparo - MG"
  },
  {
    "value": "santo_antônio_do_aracanguá_sp",
    "label": "Santo Antônio do Aracanguá - SP"
  },
  {
    "value": "santo_antônio_do_aventureiro_mg",
    "label": "Santo Antônio do Aventureiro - MG"
  },
  {
    "value": "santo_antônio_do_caiuá_pr",
    "label": "Santo Antônio do Caiuá - PR"
  },
  {
    "value": "santo_antônio_do_descoberto_go",
    "label": "Santo Antônio do Descoberto - GO"
  },
  {
    "value": "santo_antônio_do_grama_mg",
    "label": "Santo Antônio do Grama - MG"
  },
  {
    "value": "santo_antônio_do_itambé_mg",
    "label": "Santo Antônio do Itambé - MG"
  },
  {
    "value": "santo_antônio_do_içá_am",
    "label": "Santo Antônio do Içá - AM"
  },
  {
    "value": "santo_antônio_do_jacinto_mg",
    "label": "Santo Antônio do Jacinto - MG"
  },
  {
    "value": "santo_antônio_do_jardim_sp",
    "label": "Santo Antônio do Jardim - SP"
  },
  {
    "value": "santo_antônio_do_leste_mt",
    "label": "Santo Antônio do Leste - MT"
  },
  {
    "value": "santo_antônio_do_leverger_mt",
    "label": "Santo Antônio do Leverger - MT"
  },
  {
    "value": "santo_antônio_do_monte_mg",
    "label": "Santo Antônio do Monte - MG"
  },
  {
    "value": "santo_antônio_do_palma_rs",
    "label": "Santo Antônio do Palma - RS"
  },
  {
    "value": "santo_antônio_do_paraíso_pr",
    "label": "Santo Antônio do Paraíso - PR"
  },
  {
    "value": "santo_antônio_do_pinhal_sp",
    "label": "Santo Antônio do Pinhal - SP"
  },
  {
    "value": "santo_antônio_do_planalto_rs",
    "label": "Santo Antônio do Planalto - RS"
  },
  {
    "value": "santo_antônio_do_retiro_mg",
    "label": "Santo Antônio do Retiro - MG"
  },
  {
    "value": "santo_antônio_do_rio_abaixo_mg",
    "label": "Santo Antônio do Rio Abaixo - MG"
  },
  {
    "value": "santo_antônio_do_sudoeste_pr",
    "label": "Santo Antônio do Sudoeste - PR"
  },
  {
    "value": "santo_antônio_do_tauá_pa",
    "label": "Santo Antônio do Tauá - PA"
  },
  {
    "value": "santo_antônio_dos_lopes_ma",
    "label": "Santo Antônio dos Lopes - MA"
  },
  {
    "value": "santo_antônio_dos_milagres_pi",
    "label": "Santo Antônio dos Milagres - PI"
  },
  {
    "value": "santo_augusto_rs",
    "label": "Santo Augusto - RS"
  },
  {
    "value": "santo_cristo_rs",
    "label": "Santo Cristo - RS"
  },
  {
    "value": "santo_estêvão_ba",
    "label": "Santo Estêvão - BA"
  },
  {
    "value": "santo_expedito_sp",
    "label": "Santo Expedito - SP"
  },
  {
    "value": "santo_expedito_do_sul_rs",
    "label": "Santo Expedito do Sul - RS"
  },
  {
    "value": "santo_hipólito_mg",
    "label": "Santo Hipólito - MG"
  },
  {
    "value": "santo_inácio_pr",
    "label": "Santo Inácio - PR"
  },
  {
    "value": "santo_inácio_do_piauí_pi",
    "label": "Santo Inácio do Piauí - PI"
  },
  {
    "value": "santo_ângelo_rs",
    "label": "Santo Ângelo - RS"
  },
  {
    "value": "santos_sp",
    "label": "Santos - SP"
  },
  {
    "value": "santos_dumont_mg",
    "label": "Santos Dumont - MG"
  },
  {
    "value": "santópolis_do_aguapeí_sp",
    "label": "Santópolis do Aguapeí - SP"
  },
  {
    "value": "sapeaçu_ba",
    "label": "Sapeaçu - BA"
  },
  {
    "value": "sapezal_mt",
    "label": "Sapezal - MT"
  },
  {
    "value": "sapiranga_rs",
    "label": "Sapiranga - RS"
  },
  {
    "value": "sapopema_pr",
    "label": "Sapopema - PR"
  },
  {
    "value": "sapucaia_pa",
    "label": "Sapucaia - PA"
  },
  {
    "value": "sapucaia_rj",
    "label": "Sapucaia - RJ"
  },
  {
    "value": "sapucaia_do_sul_rs",
    "label": "Sapucaia do Sul - RS"
  },
  {
    "value": "sapucaí-mirim_mg",
    "label": "Sapucaí-Mirim - MG"
  },
  {
    "value": "sapé_pb",
    "label": "Sapé - PB"
  },
  {
    "value": "saquarema_rj",
    "label": "Saquarema - RJ"
  },
  {
    "value": "sarandi_pr",
    "label": "Sarandi - PR"
  },
  {
    "value": "sarandi_rs",
    "label": "Sarandi - RS"
  },
  {
    "value": "sarapuí_sp",
    "label": "Sarapuí - SP"
  },
  {
    "value": "sardoá_mg",
    "label": "Sardoá - MG"
  },
  {
    "value": "sarutaiá_sp",
    "label": "Sarutaiá - SP"
  },
  {
    "value": "sarzedo_mg",
    "label": "Sarzedo - MG"
  },
  {
    "value": "satuba_al",
    "label": "Satuba - AL"
  },
  {
    "value": "satubinha_ma",
    "label": "Satubinha - MA"
  },
  {
    "value": "saubara_ba",
    "label": "Saubara - BA"
  },
  {
    "value": "saudade_do_iguaçu_pr",
    "label": "Saudade do Iguaçu - PR"
  },
  {
    "value": "saudades_sc",
    "label": "Saudades - SC"
  },
  {
    "value": "saúde_ba",
    "label": "Saúde - BA"
  },
  {
    "value": "schroeder_sc",
    "label": "Schroeder - SC"
  },
  {
    "value": "seabra_ba",
    "label": "Seabra - BA"
  },
  {
    "value": "seara_sc",
    "label": "Seara - SC"
  },
  {
    "value": "sebastianópolis_do_sul_sp",
    "label": "Sebastianópolis do Sul - SP"
  },
  {
    "value": "sebastião_barros_pi",
    "label": "Sebastião Barros - PI"
  },
  {
    "value": "sebastião_laranjeiras_ba",
    "label": "Sebastião Laranjeiras - BA"
  },
  {
    "value": "sebastião_leal_pi",
    "label": "Sebastião Leal - PI"
  },
  {
    "value": "seberi_rs",
    "label": "Seberi - RS"
  },
  {
    "value": "sede_nova_rs",
    "label": "Sede Nova - RS"
  },
  {
    "value": "segredo_rs",
    "label": "Segredo - RS"
  },
  {
    "value": "selbach_rs",
    "label": "Selbach - RS"
  },
  {
    "value": "selvíria_ms",
    "label": "Selvíria - MS"
  },
  {
    "value": "sem-peixe_mg",
    "label": "Sem-Peixe - MG"
  },
  {
    "value": "sena_madureira_ac",
    "label": "Sena Madureira - AC"
  },
  {
    "value": "senador_alexandre_costa_ma",
    "label": "Senador Alexandre Costa - MA"
  },
  {
    "value": "senador_amaral_mg",
    "label": "Senador Amaral - MG"
  },
  {
    "value": "senador_canedo_go",
    "label": "Senador Canedo - GO"
  },
  {
    "value": "senador_cortes_mg",
    "label": "Senador Cortes - MG"
  },
  {
    "value": "senador_elói_de_souza_rn",
    "label": "Senador Elói de Souza - RN"
  },
  {
    "value": "senador_firmino_mg",
    "label": "Senador Firmino - MG"
  },
  {
    "value": "senador_georgino_avelino_rn",
    "label": "Senador Georgino Avelino - RN"
  },
  {
    "value": "senador_guiomard_ac",
    "label": "Senador Guiomard - AC"
  },
  {
    "value": "senador_josé_bento_mg",
    "label": "Senador José Bento - MG"
  },
  {
    "value": "senador_josé_porfírio_pa",
    "label": "Senador José Porfírio - PA"
  },
  {
    "value": "senador_la_rocque_ma",
    "label": "Senador La Rocque - MA"
  },
  {
    "value": "senador_modestino_gonçalves_mg",
    "label": "Senador Modestino Gonçalves - MG"
  },
  {
    "value": "senador_pompeu_ce",
    "label": "Senador Pompeu - CE"
  },
  {
    "value": "senador_rui_palmeira_al",
    "label": "Senador Rui Palmeira - AL"
  },
  {
    "value": "senador_salgado_filho_rs",
    "label": "Senador Salgado Filho - RS"
  },
  {
    "value": "senador_sá_ce",
    "label": "Senador Sá - CE"
  },
  {
    "value": "sengés_pr",
    "label": "Sengés - PR"
  },
  {
    "value": "senhor_do_bonfim_ba",
    "label": "Senhor do Bonfim - BA"
  },
  {
    "value": "senhora_de_oliveira_mg",
    "label": "Senhora de Oliveira - MG"
  },
  {
    "value": "senhora_do_porto_mg",
    "label": "Senhora do Porto - MG"
  },
  {
    "value": "senhora_dos_remédios_mg",
    "label": "Senhora dos Remédios - MG"
  },
  {
    "value": "sentinela_do_sul_rs",
    "label": "Sentinela do Sul - RS"
  },
  {
    "value": "sento_sé_ba",
    "label": "Sento Sé - BA"
  },
  {
    "value": "serafina_corrêa_rs",
    "label": "Serafina Corrêa - RS"
  },
  {
    "value": "sericita_mg",
    "label": "Sericita - MG"
  },
  {
    "value": "seridó_pb",
    "label": "Seridó - PB"
  },
  {
    "value": "seringueiras_ro",
    "label": "Seringueiras - RO"
  },
  {
    "value": "seritinga_mg",
    "label": "Seritinga - MG"
  },
  {
    "value": "seropédica_rj",
    "label": "Seropédica - RJ"
  },
  {
    "value": "serra_es",
    "label": "Serra - ES"
  },
  {
    "value": "serra_alta_sc",
    "label": "Serra Alta - SC"
  },
  {
    "value": "serra_azul_sp",
    "label": "Serra Azul - SP"
  },
  {
    "value": "serra_azul_de_minas_mg",
    "label": "Serra Azul de Minas - MG"
  },
  {
    "value": "serra_branca_pb",
    "label": "Serra Branca - PB"
  },
  {
    "value": "serra_dourada_ba",
    "label": "Serra Dourada - BA"
  },
  {
    "value": "serra_grande_pb",
    "label": "Serra Grande - PB"
  },
  {
    "value": "serra_negra_sp",
    "label": "Serra Negra - SP"
  },
  {
    "value": "serra_negra_do_norte_rn",
    "label": "Serra Negra do Norte - RN"
  },
  {
    "value": "serra_nova_dourada_mt",
    "label": "Serra Nova Dourada - MT"
  },
  {
    "value": "serra_preta_ba",
    "label": "Serra Preta - BA"
  },
  {
    "value": "serra_redonda_pb",
    "label": "Serra Redonda - PB"
  },
  {
    "value": "serra_talhada_pe",
    "label": "Serra Talhada - PE"
  },
  {
    "value": "serra_da_raiz_pb",
    "label": "Serra da Raiz - PB"
  },
  {
    "value": "serra_da_saudade_mg",
    "label": "Serra da Saudade - MG"
  },
  {
    "value": "serra_de_são_bento_rn",
    "label": "Serra de São Bento - RN"
  },
  {
    "value": "serra_do_mel_rn",
    "label": "Serra do Mel - RN"
  },
  {
    "value": "serra_do_navio_ap",
    "label": "Serra do Navio - AP"
  },
  {
    "value": "serra_do_ramalho_ba",
    "label": "Serra do Ramalho - BA"
  },
  {
    "value": "serra_do_salitre_mg",
    "label": "Serra do Salitre - MG"
  },
  {
    "value": "serra_dos_aimorés_mg",
    "label": "Serra dos Aimorés - MG"
  },
  {
    "value": "serrana_sp",
    "label": "Serrana - SP"
  },
  {
    "value": "serrania_mg",
    "label": "Serrania - MG"
  },
  {
    "value": "serrano_do_maranhão_ma",
    "label": "Serrano do Maranhão - MA"
  },
  {
    "value": "serranos_mg",
    "label": "Serranos - MG"
  },
  {
    "value": "serranópolis_go",
    "label": "Serranópolis - GO"
  },
  {
    "value": "serranópolis_de_minas_mg",
    "label": "Serranópolis de Minas - MG"
  },
  {
    "value": "serranópolis_do_iguaçu_pr",
    "label": "Serranópolis do Iguaçu - PR"
  },
  {
    "value": "serraria_pb",
    "label": "Serraria - PB"
  },
  {
    "value": "serrinha_ba",
    "label": "Serrinha - BA"
  },
  {
    "value": "serrinha_rn",
    "label": "Serrinha - RN"
  },
  {
    "value": "serrinha_dos_pintos_rn",
    "label": "Serrinha dos Pintos - RN"
  },
  {
    "value": "serrita_pe",
    "label": "Serrita - PE"
  },
  {
    "value": "serro_mg",
    "label": "Serro - MG"
  },
  {
    "value": "serrolândia_ba",
    "label": "Serrolândia - BA"
  },
  {
    "value": "sertaneja_pr",
    "label": "Sertaneja - PR"
  },
  {
    "value": "sertanópolis_pr",
    "label": "Sertanópolis - PR"
  },
  {
    "value": "sertânia_pe",
    "label": "Sertânia - PE"
  },
  {
    "value": "sertão_rs",
    "label": "Sertão - RS"
  },
  {
    "value": "sertão_santana_rs",
    "label": "Sertão Santana - RS"
  },
  {
    "value": "sertãozinho_pb",
    "label": "Sertãozinho - PB"
  },
  {
    "value": "sertãozinho_sp",
    "label": "Sertãozinho - SP"
  },
  {
    "value": "sete_barras_sp",
    "label": "Sete Barras - SP"
  },
  {
    "value": "sete_lagoas_mg",
    "label": "Sete Lagoas - MG"
  },
  {
    "value": "sete_quedas_ms",
    "label": "Sete Quedas - MS"
  },
  {
    "value": "sete_de_setembro_rs",
    "label": "Sete de Setembro - RS"
  },
  {
    "value": "setubinha_mg",
    "label": "Setubinha - MG"
  },
  {
    "value": "severiano_melo_rn",
    "label": "Severiano Melo - RN"
  },
  {
    "value": "severiano_de_almeida_rs",
    "label": "Severiano de Almeida - RS"
  },
  {
    "value": "severínia_sp",
    "label": "Severínia - SP"
  },
  {
    "value": "siderópolis_sc",
    "label": "Siderópolis - SC"
  },
  {
    "value": "sidrolândia_ms",
    "label": "Sidrolândia - MS"
  },
  {
    "value": "sigefredo_pacheco_pi",
    "label": "Sigefredo Pacheco - PI"
  },
  {
    "value": "silva_jardim_rj",
    "label": "Silva Jardim - RJ"
  },
  {
    "value": "silvanópolis_to",
    "label": "Silvanópolis - TO"
  },
  {
    "value": "silveira_martins_rs",
    "label": "Silveira Martins - RS"
  },
  {
    "value": "silveiras_sp",
    "label": "Silveiras - SP"
  },
  {
    "value": "silveirânia_mg",
    "label": "Silveirânia - MG"
  },
  {
    "value": "silves_am",
    "label": "Silves - AM"
  },
  {
    "value": "silvianópolis_mg",
    "label": "Silvianópolis - MG"
  },
  {
    "value": "silvânia_go",
    "label": "Silvânia - GO"
  },
  {
    "value": "simolândia_go",
    "label": "Simolândia - GO"
  },
  {
    "value": "simonésia_mg",
    "label": "Simonésia - MG"
  },
  {
    "value": "simplício_mendes_pi",
    "label": "Simplício Mendes - PI"
  },
  {
    "value": "simão_dias_se",
    "label": "Simão Dias - SE"
  },
  {
    "value": "simão_pereira_mg",
    "label": "Simão Pereira - MG"
  },
  {
    "value": "simões_pi",
    "label": "Simões - PI"
  },
  {
    "value": "simões_filho_ba",
    "label": "Simões Filho - BA"
  },
  {
    "value": "sinimbu_rs",
    "label": "Sinimbu - RS"
  },
  {
    "value": "sinop_mt",
    "label": "Sinop - MT"
  },
  {
    "value": "siqueira_campos_pr",
    "label": "Siqueira Campos - PR"
  },
  {
    "value": "sirinhaém_pe",
    "label": "Sirinhaém - PE"
  },
  {
    "value": "siriri_se",
    "label": "Siriri - SE"
  },
  {
    "value": "sobradinho_ba",
    "label": "Sobradinho - BA"
  },
  {
    "value": "sobradinho_rs",
    "label": "Sobradinho - RS"
  },
  {
    "value": "sobrado_pb",
    "label": "Sobrado - PB"
  },
  {
    "value": "sobral_ce",
    "label": "Sobral - CE"
  },
  {
    "value": "sobrália_mg",
    "label": "Sobrália - MG"
  },
  {
    "value": "socorro_sp",
    "label": "Socorro - SP"
  },
  {
    "value": "socorro_do_piauí_pi",
    "label": "Socorro do Piauí - PI"
  },
  {
    "value": "soledade_pb",
    "label": "Soledade - PB"
  },
  {
    "value": "soledade_rs",
    "label": "Soledade - RS"
  },
  {
    "value": "soledade_de_minas_mg",
    "label": "Soledade de Minas - MG"
  },
  {
    "value": "solidão_pe",
    "label": "Solidão - PE"
  },
  {
    "value": "solonópole_ce",
    "label": "Solonópole - CE"
  },
  {
    "value": "solânea_pb",
    "label": "Solânea - PB"
  },
  {
    "value": "sombrio_sc",
    "label": "Sombrio - SC"
  },
  {
    "value": "sonora_ms",
    "label": "Sonora - MS"
  },
  {
    "value": "sooretama_es",
    "label": "Sooretama - ES"
  },
  {
    "value": "sorocaba_sp",
    "label": "Sorocaba - SP"
  },
  {
    "value": "sorriso_mt",
    "label": "Sorriso - MT"
  },
  {
    "value": "sossêgo_pb",
    "label": "Sossêgo - PB"
  },
  {
    "value": "soure_pa",
    "label": "Soure - PA"
  },
  {
    "value": "sousa_pb",
    "label": "Sousa - PB"
  },
  {
    "value": "souto_soares_ba",
    "label": "Souto Soares - BA"
  },
  {
    "value": "sucupira_to",
    "label": "Sucupira - TO"
  },
  {
    "value": "sucupira_do_norte_ma",
    "label": "Sucupira do Norte - MA"
  },
  {
    "value": "sucupira_do_riachão_ma",
    "label": "Sucupira do Riachão - MA"
  },
  {
    "value": "sud_mennucci_sp",
    "label": "Sud Mennucci - SP"
  },
  {
    "value": "sul_brasil_sc",
    "label": "Sul Brasil - SC"
  },
  {
    "value": "sulina_pr",
    "label": "Sulina - PR"
  },
  {
    "value": "sumaré_sp",
    "label": "Sumaré - SP"
  },
  {
    "value": "sumidouro_rj",
    "label": "Sumidouro - RJ"
  },
  {
    "value": "sumé_pb",
    "label": "Sumé - PB"
  },
  {
    "value": "surubim_pe",
    "label": "Surubim - PE"
  },
  {
    "value": "sussuapara_pi",
    "label": "Sussuapara - PI"
  },
  {
    "value": "suzano_sp",
    "label": "Suzano - SP"
  },
  {
    "value": "suzanápolis_sp",
    "label": "Suzanápolis - SP"
  },
  {
    "value": "sátiro_dias_ba",
    "label": "Sátiro Dias - BA"
  },
  {
    "value": "são_benedito_ce",
    "label": "São Benedito - CE"
  },
  {
    "value": "são_benedito_do_rio_preto_ma",
    "label": "São Benedito do Rio Preto - MA"
  },
  {
    "value": "são_benedito_do_sul_pe",
    "label": "São Benedito do Sul - PE"
  },
  {
    "value": "são_bentinho_pb",
    "label": "São Bentinho - PB"
  },
  {
    "value": "são_bento_ma",
    "label": "São Bento - MA"
  },
  {
    "value": "são_bento_pb",
    "label": "São Bento - PB"
  },
  {
    "value": "são_bento_abade_mg",
    "label": "São Bento Abade - MG"
  },
  {
    "value": "são_bento_do_norte_rn",
    "label": "São Bento do Norte - RN"
  },
  {
    "value": "são_bento_do_sapucaí_sp",
    "label": "São Bento do Sapucaí - SP"
  },
  {
    "value": "são_bento_do_sul_sc",
    "label": "São Bento do Sul - SC"
  },
  {
    "value": "são_bento_do_tocantins_to",
    "label": "São Bento do Tocantins - TO"
  },
  {
    "value": "são_bento_do_trairí_rn",
    "label": "São Bento do Trairí - RN"
  },
  {
    "value": "são_bento_do_una_pe",
    "label": "São Bento do Una - PE"
  },
  {
    "value": "são_bernardino_sc",
    "label": "São Bernardino - SC"
  },
  {
    "value": "são_bernardo_ma",
    "label": "São Bernardo - MA"
  },
  {
    "value": "são_bernardo_do_campo_sp",
    "label": "São Bernardo do Campo - SP"
  },
  {
    "value": "são_bonifácio_sc",
    "label": "São Bonifácio - SC"
  },
  {
    "value": "são_borja_rs",
    "label": "São Borja - RS"
  },
  {
    "value": "são_braz_do_piauí_pi",
    "label": "São Braz do Piauí - PI"
  },
  {
    "value": "são_brás_al",
    "label": "São Brás - AL"
  },
  {
    "value": "são_brás_do_suaçuí_mg",
    "label": "São Brás do Suaçuí - MG"
  },
  {
    "value": "são_caetano_de_odivela_pa",
    "label": "São Caetano de Odivela - PA"
  },
  {
    "value": "são_caetano_do_sul_sp",
    "label": "São Caetano do Sul - SP"
  },
  {
    "value": "são_caitano_pe",
    "label": "São Caitano - PE"
  },
  {
    "value": "são_carlos_sc",
    "label": "São Carlos - SC"
  },
  {
    "value": "são_carlos_sp",
    "label": "São Carlos - SP"
  },
  {
    "value": "são_carlos_do_ivaí_pr",
    "label": "São Carlos do Ivaí - PR"
  },
  {
    "value": "são_cristovão_do_sul_sc",
    "label": "São Cristovão do Sul - SC"
  },
  {
    "value": "são_cristóvão_se",
    "label": "São Cristóvão - SE"
  },
  {
    "value": "são_desidério_ba",
    "label": "São Desidério - BA"
  },
  {
    "value": "são_domingos_ba",
    "label": "São Domingos - BA"
  },
  {
    "value": "são_domingos_go",
    "label": "São Domingos - GO"
  },
  {
    "value": "são_domingos_sc",
    "label": "São Domingos - SC"
  },
  {
    "value": "são_domingos_se",
    "label": "São Domingos - SE"
  },
  {
    "value": "são_domingos_das_dores_mg",
    "label": "São Domingos das Dores - MG"
  },
  {
    "value": "são_domingos_de_pombal_pb",
    "label": "São Domingos de Pombal - PB"
  },
  {
    "value": "são_domingos_do_araguaia_pa",
    "label": "São Domingos do Araguaia - PA"
  },
  {
    "value": "são_domingos_do_azeitão_ma",
    "label": "São Domingos do Azeitão - MA"
  },
  {
    "value": "são_domingos_do_capim_pa",
    "label": "São Domingos do Capim - PA"
  },
  {
    "value": "são_domingos_do_cariri_pb",
    "label": "São Domingos do Cariri - PB"
  },
  {
    "value": "são_domingos_do_maranhão_ma",
    "label": "São Domingos do Maranhão - MA"
  },
  {
    "value": "são_domingos_do_norte_es",
    "label": "São Domingos do Norte - ES"
  },
  {
    "value": "são_domingos_do_prata_mg",
    "label": "São Domingos do Prata - MG"
  },
  {
    "value": "são_domingos_do_sul_rs",
    "label": "São Domingos do Sul - RS"
  },
  {
    "value": "são_felipe_ba",
    "label": "São Felipe - BA"
  },
  {
    "value": "são_felipe_d'oeste_ro",
    "label": "São Felipe d'Oeste - RO"
  },
  {
    "value": "são_fernando_rn",
    "label": "São Fernando - RN"
  },
  {
    "value": "são_fidélis_rj",
    "label": "São Fidélis - RJ"
  },
  {
    "value": "são_francisco_mg",
    "label": "São Francisco - MG"
  },
  {
    "value": "são_francisco_pb",
    "label": "São Francisco - PB"
  },
  {
    "value": "são_francisco_se",
    "label": "São Francisco - SE"
  },
  {
    "value": "são_francisco_sp",
    "label": "São Francisco - SP"
  },
  {
    "value": "são_francisco_de_assis_rs",
    "label": "São Francisco de Assis - RS"
  },
  {
    "value": "são_francisco_de_assis_do_piauí_pi",
    "label": "São Francisco de Assis do Piauí - PI"
  },
  {
    "value": "são_francisco_de_goiás_go",
    "label": "São Francisco de Goiás - GO"
  },
  {
    "value": "são_francisco_de_itabapoana_rj",
    "label": "São Francisco de Itabapoana - RJ"
  },
  {
    "value": "são_francisco_de_paula_mg",
    "label": "São Francisco de Paula - MG"
  },
  {
    "value": "são_francisco_de_paula_rs",
    "label": "São Francisco de Paula - RS"
  },
  {
    "value": "são_francisco_de_sales_mg",
    "label": "São Francisco de Sales - MG"
  },
  {
    "value": "são_francisco_do_brejão_ma",
    "label": "São Francisco do Brejão - MA"
  },
  {
    "value": "são_francisco_do_conde_ba",
    "label": "São Francisco do Conde - BA"
  },
  {
    "value": "são_francisco_do_glória_mg",
    "label": "São Francisco do Glória - MG"
  },
  {
    "value": "são_francisco_do_guaporé_ro",
    "label": "São Francisco do Guaporé - RO"
  },
  {
    "value": "são_francisco_do_maranhão_ma",
    "label": "São Francisco do Maranhão - MA"
  },
  {
    "value": "são_francisco_do_oeste_rn",
    "label": "São Francisco do Oeste - RN"
  },
  {
    "value": "são_francisco_do_pará_pa",
    "label": "São Francisco do Pará - PA"
  },
  {
    "value": "são_francisco_do_piauí_pi",
    "label": "São Francisco do Piauí - PI"
  },
  {
    "value": "são_francisco_do_sul_sc",
    "label": "São Francisco do Sul - SC"
  },
  {
    "value": "são_félix_ba",
    "label": "São Félix - BA"
  },
  {
    "value": "são_félix_de_balsas_ma",
    "label": "São Félix de Balsas - MA"
  },
  {
    "value": "são_félix_de_minas_mg",
    "label": "São Félix de Minas - MG"
  },
  {
    "value": "são_félix_do_araguaia_mt",
    "label": "São Félix do Araguaia - MT"
  },
  {
    "value": "são_félix_do_coribe_ba",
    "label": "São Félix do Coribe - BA"
  },
  {
    "value": "são_félix_do_piauí_pi",
    "label": "São Félix do Piauí - PI"
  },
  {
    "value": "são_félix_do_tocantins_to",
    "label": "São Félix do Tocantins - TO"
  },
  {
    "value": "são_félix_do_xingu_pa",
    "label": "São Félix do Xingu - PA"
  },
  {
    "value": "são_gabriel_ba",
    "label": "São Gabriel - BA"
  },
  {
    "value": "são_gabriel_rs",
    "label": "São Gabriel - RS"
  },
  {
    "value": "são_gabriel_da_cachoeira_am",
    "label": "São Gabriel da Cachoeira - AM"
  },
  {
    "value": "são_gabriel_da_palha_es",
    "label": "São Gabriel da Palha - ES"
  },
  {
    "value": "são_gabriel_do_oeste_ms",
    "label": "São Gabriel do Oeste - MS"
  },
  {
    "value": "são_geraldo_mg",
    "label": "São Geraldo - MG"
  },
  {
    "value": "são_geraldo_da_piedade_mg",
    "label": "São Geraldo da Piedade - MG"
  },
  {
    "value": "são_geraldo_do_araguaia_pa",
    "label": "São Geraldo do Araguaia - PA"
  },
  {
    "value": "são_geraldo_do_baixio_mg",
    "label": "São Geraldo do Baixio - MG"
  },
  {
    "value": "são_gonçalo_rj",
    "label": "São Gonçalo - RJ"
  },
  {
    "value": "são_gonçalo_do_abaeté_mg",
    "label": "São Gonçalo do Abaeté - MG"
  },
  {
    "value": "são_gonçalo_do_amarante_ce",
    "label": "São Gonçalo do Amarante - CE"
  },
  {
    "value": "são_gonçalo_do_amarante_rn",
    "label": "São Gonçalo do Amarante - RN"
  },
  {
    "value": "são_gonçalo_do_gurguéia_pi",
    "label": "São Gonçalo do Gurguéia - PI"
  },
  {
    "value": "são_gonçalo_do_pará_mg",
    "label": "São Gonçalo do Pará - MG"
  },
  {
    "value": "são_gonçalo_do_piauí_pi",
    "label": "São Gonçalo do Piauí - PI"
  },
  {
    "value": "são_gonçalo_do_rio_abaixo_mg",
    "label": "São Gonçalo do Rio Abaixo - MG"
  },
  {
    "value": "são_gonçalo_do_rio_preto_mg",
    "label": "São Gonçalo do Rio Preto - MG"
  },
  {
    "value": "são_gonçalo_do_sapucaí_mg",
    "label": "São Gonçalo do Sapucaí - MG"
  },
  {
    "value": "são_gonçalo_dos_campos_ba",
    "label": "São Gonçalo dos Campos - BA"
  },
  {
    "value": "são_gotardo_mg",
    "label": "São Gotardo - MG"
  },
  {
    "value": "são_jerônimo_rs",
    "label": "São Jerônimo - RS"
  },
  {
    "value": "são_jerônimo_da_serra_pr",
    "label": "São Jerônimo da Serra - PR"
  },
  {
    "value": "são_joaquim_sc",
    "label": "São Joaquim - SC"
  },
  {
    "value": "são_joaquim_da_barra_sp",
    "label": "São Joaquim da Barra - SP"
  },
  {
    "value": "são_joaquim_de_bicas_mg",
    "label": "São Joaquim de Bicas - MG"
  },
  {
    "value": "são_joaquim_do_monte_pe",
    "label": "São Joaquim do Monte - PE"
  },
  {
    "value": "são_jorge_rs",
    "label": "São Jorge - RS"
  },
  {
    "value": "são_jorge_d'oeste_pr",
    "label": "São Jorge d'Oeste - PR"
  },
  {
    "value": "são_jorge_do_ivaí_pr",
    "label": "São Jorge do Ivaí - PR"
  },
  {
    "value": "são_jorge_do_patrocínio_pr",
    "label": "São Jorge do Patrocínio - PR"
  },
  {
    "value": "são_josé_sc",
    "label": "São José - SC"
  },
  {
    "value": "são_josé_da_barra_mg",
    "label": "São José da Barra - MG"
  },
  {
    "value": "são_josé_da_bela_vista_sp",
    "label": "São José da Bela Vista - SP"
  },
  {
    "value": "são_josé_da_boa_vista_pr",
    "label": "São José da Boa Vista - PR"
  },
  {
    "value": "são_josé_da_coroa_grande_pe",
    "label": "São José da Coroa Grande - PE"
  },
  {
    "value": "são_josé_da_lagoa_tapada_pb",
    "label": "São José da Lagoa Tapada - PB"
  },
  {
    "value": "são_josé_da_laje_al",
    "label": "São José da Laje - AL"
  },
  {
    "value": "são_josé_da_lapa_mg",
    "label": "São José da Lapa - MG"
  },
  {
    "value": "são_josé_da_safira_mg",
    "label": "São José da Safira - MG"
  },
  {
    "value": "são_josé_da_tapera_al",
    "label": "São José da Tapera - AL"
  },
  {
    "value": "são_josé_da_varginha_mg",
    "label": "São José da Varginha - MG"
  },
  {
    "value": "são_josé_da_vitória_ba",
    "label": "São José da Vitória - BA"
  },
  {
    "value": "são_josé_das_missões_rs",
    "label": "São José das Missões - RS"
  },
  {
    "value": "são_josé_das_palmeiras_pr",
    "label": "São José das Palmeiras - PR"
  },
  {
    "value": "são_josé_de_caiana_pb",
    "label": "São José de Caiana - PB"
  },
  {
    "value": "são_josé_de_espinharas_pb",
    "label": "São José de Espinharas - PB"
  },
  {
    "value": "são_josé_de_mipibu_rn",
    "label": "São José de Mipibu - RN"
  },
  {
    "value": "são_josé_de_piranhas_pb",
    "label": "São José de Piranhas - PB"
  },
  {
    "value": "são_josé_de_princesa_pb",
    "label": "São José de Princesa - PB"
  },
  {
    "value": "são_josé_de_ribamar_ma",
    "label": "São José de Ribamar - MA"
  },
  {
    "value": "são_josé_de_ubá_rj",
    "label": "São José de Ubá - RJ"
  },
  {
    "value": "são_josé_do_alegre_mg",
    "label": "São José do Alegre - MG"
  },
  {
    "value": "são_josé_do_barreiro_sp",
    "label": "São José do Barreiro - SP"
  },
  {
    "value": "são_josé_do_belmonte_pe",
    "label": "São José do Belmonte - PE"
  },
  {
    "value": "são_josé_do_bonfim_pb",
    "label": "São José do Bonfim - PB"
  },
  {
    "value": "são_josé_do_brejo_do_cruz_pb",
    "label": "São José do Brejo do Cruz - PB"
  },
  {
    "value": "são_josé_do_calçado_es",
    "label": "São José do Calçado - ES"
  },
  {
    "value": "são_josé_do_campestre_rn",
    "label": "São José do Campestre - RN"
  },
  {
    "value": "são_josé_do_cedro_sc",
    "label": "São José do Cedro - SC"
  },
  {
    "value": "são_josé_do_cerrito_sc",
    "label": "São José do Cerrito - SC"
  },
  {
    "value": "são_josé_do_divino_mg",
    "label": "São José do Divino - MG"
  },
  {
    "value": "são_josé_do_divino_pi",
    "label": "São José do Divino - PI"
  },
  {
    "value": "são_josé_do_egito_pe",
    "label": "São José do Egito - PE"
  },
  {
    "value": "são_josé_do_goiabal_mg",
    "label": "São José do Goiabal - MG"
  },
  {
    "value": "são_josé_do_herval_rs",
    "label": "São José do Herval - RS"
  },
  {
    "value": "são_josé_do_hortêncio_rs",
    "label": "São José do Hortêncio - RS"
  },
  {
    "value": "são_josé_do_inhacorá_rs",
    "label": "São José do Inhacorá - RS"
  },
  {
    "value": "são_josé_do_jacuri_mg",
    "label": "São José do Jacuri - MG"
  },
  {
    "value": "são_josé_do_jacuípe_ba",
    "label": "São José do Jacuípe - BA"
  },
  {
    "value": "são_josé_do_mantimento_mg",
    "label": "São José do Mantimento - MG"
  },
  {
    "value": "são_josé_do_norte_rs",
    "label": "São José do Norte - RS"
  },
  {
    "value": "são_josé_do_ouro_rs",
    "label": "São José do Ouro - RS"
  },
  {
    "value": "são_josé_do_peixe_pi",
    "label": "São José do Peixe - PI"
  },
  {
    "value": "são_josé_do_piauí_pi",
    "label": "São José do Piauí - PI"
  },
  {
    "value": "são_josé_do_povo_mt",
    "label": "São José do Povo - MT"
  },
  {
    "value": "são_josé_do_rio_claro_mt",
    "label": "São José do Rio Claro - MT"
  },
  {
    "value": "são_josé_do_rio_pardo_sp",
    "label": "São José do Rio Pardo - SP"
  },
  {
    "value": "são_josé_do_rio_preto_sp",
    "label": "São José do Rio Preto - SP"
  },
  {
    "value": "são_josé_do_sabugi_pb",
    "label": "São José do Sabugi - PB"
  },
  {
    "value": "são_josé_do_seridó_rn",
    "label": "São José do Seridó - RN"
  },
  {
    "value": "são_josé_do_sul_rs",
    "label": "São José do Sul - RS"
  },
  {
    "value": "são_josé_do_vale_do_rio_preto_rj",
    "label": "São José do Vale do Rio Preto - RJ"
  },
  {
    "value": "são_josé_do_xingu_mt",
    "label": "São José do Xingu - MT"
  },
  {
    "value": "são_josé_dos_ausentes_rs",
    "label": "São José dos Ausentes - RS"
  },
  {
    "value": "são_josé_dos_basílios_ma",
    "label": "São José dos Basílios - MA"
  },
  {
    "value": "são_josé_dos_campos_sp",
    "label": "São José dos Campos - SP"
  },
  {
    "value": "são_josé_dos_cordeiros_pb",
    "label": "São José dos Cordeiros - PB"
  },
  {
    "value": "são_josé_dos_pinhais_pr",
    "label": "São José dos Pinhais - PR"
  },
  {
    "value": "são_josé_dos_quatro_marcos_mt",
    "label": "São José dos Quatro Marcos - MT"
  },
  {
    "value": "são_josé_dos_ramos_pb",
    "label": "São José dos Ramos - PB"
  },
  {
    "value": "são_joão_pe",
    "label": "São João - PE"
  },
  {
    "value": "são_joão_pr",
    "label": "São João - PR"
  },
  {
    "value": "são_joão_batista_ma",
    "label": "São João Batista - MA"
  },
  {
    "value": "são_joão_batista_sc",
    "label": "São João Batista - SC"
  },
  {
    "value": "são_joão_batista_do_glória_mg",
    "label": "São João Batista do Glória - MG"
  },
  {
    "value": "são_joão_evangelista_mg",
    "label": "São João Evangelista - MG"
  },
  {
    "value": "são_joão_nepomuceno_mg",
    "label": "São João Nepomuceno - MG"
  },
  {
    "value": "são_joão_d'aliança_go",
    "label": "São João d'Aliança - GO"
  },
  {
    "value": "são_joão_da_baliza_rr",
    "label": "São João da Baliza - RR"
  },
  {
    "value": "são_joão_da_barra_rj",
    "label": "São João da Barra - RJ"
  },
  {
    "value": "são_joão_da_boa_vista_sp",
    "label": "São João da Boa Vista - SP"
  },
  {
    "value": "são_joão_da_canabrava_pi",
    "label": "São João da Canabrava - PI"
  },
  {
    "value": "são_joão_da_fronteira_pi",
    "label": "São João da Fronteira - PI"
  },
  {
    "value": "são_joão_da_lagoa_mg",
    "label": "São João da Lagoa - MG"
  },
  {
    "value": "são_joão_da_mata_mg",
    "label": "São João da Mata - MG"
  },
  {
    "value": "são_joão_da_paraúna_go",
    "label": "São João da Paraúna - GO"
  },
  {
    "value": "são_joão_da_ponta_pa",
    "label": "São João da Ponta - PA"
  },
  {
    "value": "são_joão_da_ponte_mg",
    "label": "São João da Ponte - MG"
  },
  {
    "value": "são_joão_da_serra_pi",
    "label": "São João da Serra - PI"
  },
  {
    "value": "são_joão_da_urtiga_rs",
    "label": "São João da Urtiga - RS"
  },
  {
    "value": "são_joão_da_varjota_pi",
    "label": "São João da Varjota - PI"
  },
  {
    "value": "são_joão_das_duas_pontes_sp",
    "label": "São João das Duas Pontes - SP"
  },
  {
    "value": "são_joão_das_missões_mg",
    "label": "São João das Missões - MG"
  },
  {
    "value": "são_joão_de_iracema_sp",
    "label": "São João de Iracema - SP"
  },
  {
    "value": "são_joão_de_meriti_rj",
    "label": "São João de Meriti - RJ"
  },
  {
    "value": "são_joão_de_pirabas_pa",
    "label": "São João de Pirabas - PA"
  },
  {
    "value": "são_joão_del_rei_mg",
    "label": "São João del Rei - MG"
  },
  {
    "value": "são_joão_do_araguaia_pa",
    "label": "São João do Araguaia - PA"
  },
  {
    "value": "são_joão_do_arraial_pi",
    "label": "São João do Arraial - PI"
  },
  {
    "value": "são_joão_do_caiuá_pr",
    "label": "São João do Caiuá - PR"
  },
  {
    "value": "são_joão_do_cariri_pb",
    "label": "São João do Cariri - PB"
  },
  {
    "value": "são_joão_do_carú_ma",
    "label": "São João do Carú - MA"
  },
  {
    "value": "são_joão_do_itaperiú_sc",
    "label": "São João do Itaperiú - SC"
  },
  {
    "value": "são_joão_do_ivaí_pr",
    "label": "São João do Ivaí - PR"
  },
  {
    "value": "são_joão_do_jaguaribe_ce",
    "label": "São João do Jaguaribe - CE"
  },
  {
    "value": "são_joão_do_manhuaçu_mg",
    "label": "São João do Manhuaçu - MG"
  },
  {
    "value": "são_joão_do_manteninha_mg",
    "label": "São João do Manteninha - MG"
  },
  {
    "value": "são_joão_do_oeste_sc",
    "label": "São João do Oeste - SC"
  },
  {
    "value": "são_joão_do_oriente_mg",
    "label": "São João do Oriente - MG"
  },
  {
    "value": "são_joão_do_pacuí_mg",
    "label": "São João do Pacuí - MG"
  },
  {
    "value": "são_joão_do_paraíso_ma",
    "label": "São João do Paraíso - MA"
  },
  {
    "value": "são_joão_do_paraíso_mg",
    "label": "São João do Paraíso - MG"
  },
  {
    "value": "são_joão_do_pau_d'alho_sp",
    "label": "São João do Pau d'Alho - SP"
  },
  {
    "value": "são_joão_do_piauí_pi",
    "label": "São João do Piauí - PI"
  },
  {
    "value": "são_joão_do_polêsine_rs",
    "label": "São João do Polêsine - RS"
  },
  {
    "value": "são_joão_do_rio_do_peixe_pb",
    "label": "São João do Rio do Peixe - PB"
  },
  {
    "value": "são_joão_do_sabugi_rn",
    "label": "São João do Sabugi - RN"
  },
  {
    "value": "são_joão_do_soter_ma",
    "label": "São João do Soter - MA"
  },
  {
    "value": "são_joão_do_sul_sc",
    "label": "São João do Sul - SC"
  },
  {
    "value": "são_joão_do_tigre_pb",
    "label": "São João do Tigre - PB"
  },
  {
    "value": "são_joão_do_triunfo_pr",
    "label": "São João do Triunfo - PR"
  },
  {
    "value": "são_joão_dos_patos_ma",
    "label": "São João dos Patos - MA"
  },
  {
    "value": "são_julião_pi",
    "label": "São Julião - PI"
  },
  {
    "value": "são_leopoldo_rs",
    "label": "São Leopoldo - RS"
  },
  {
    "value": "são_lourenço_mg",
    "label": "São Lourenço - MG"
  },
  {
    "value": "são_lourenço_da_mata_pe",
    "label": "São Lourenço da Mata - PE"
  },
  {
    "value": "são_lourenço_da_serra_sp",
    "label": "São Lourenço da Serra - SP"
  },
  {
    "value": "são_lourenço_do_oeste_sc",
    "label": "São Lourenço do Oeste - SC"
  },
  {
    "value": "são_lourenço_do_piauí_pi",
    "label": "São Lourenço do Piauí - PI"
  },
  {
    "value": "são_lourenço_do_sul_rs",
    "label": "São Lourenço do Sul - RS"
  },
  {
    "value": "são_ludgero_sc",
    "label": "São Ludgero - SC"
  },
  {
    "value": "são_luis_do_piauí_pi",
    "label": "São Luis do Piauí - PI"
  },
  {
    "value": "são_luiz_rr",
    "label": "São Luiz - RR"
  },
  {
    "value": "são_luiz_gonzaga_rs",
    "label": "São Luiz Gonzaga - RS"
  },
  {
    "value": "são_luís_ma",
    "label": "São Luís - MA"
  },
  {
    "value": "são_luís_gonzaga_do_maranhão_ma",
    "label": "São Luís Gonzaga do Maranhão - MA"
  },
  {
    "value": "são_luís_de_montes_belos_go",
    "label": "São Luís de Montes Belos - GO"
  },
  {
    "value": "são_luís_do_curu_ce",
    "label": "São Luís do Curu - CE"
  },
  {
    "value": "são_luís_do_paraitinga_sp",
    "label": "São Luís do Paraitinga - SP"
  },
  {
    "value": "são_luís_do_quitunde_al",
    "label": "São Luís do Quitunde - AL"
  },
  {
    "value": "são_luíz_do_norte_go",
    "label": "São Luíz do Norte - GO"
  },
  {
    "value": "são_mamede_pb",
    "label": "São Mamede - PB"
  },
  {
    "value": "são_manoel_do_paraná_pr",
    "label": "São Manoel do Paraná - PR"
  },
  {
    "value": "são_manuel_sp",
    "label": "São Manuel - SP"
  },
  {
    "value": "são_marcos_rs",
    "label": "São Marcos - RS"
  },
  {
    "value": "são_martinho_rs",
    "label": "São Martinho - RS"
  },
  {
    "value": "são_martinho_sc",
    "label": "São Martinho - SC"
  },
  {
    "value": "são_martinho_da_serra_rs",
    "label": "São Martinho da Serra - RS"
  },
  {
    "value": "são_mateus_es",
    "label": "São Mateus - ES"
  },
  {
    "value": "são_mateus_do_maranhão_ma",
    "label": "São Mateus do Maranhão - MA"
  },
  {
    "value": "são_mateus_do_sul_pr",
    "label": "São Mateus do Sul - PR"
  },
  {
    "value": "são_miguel_rn",
    "label": "São Miguel - RN"
  },
  {
    "value": "são_miguel_arcanjo_sp",
    "label": "São Miguel Arcanjo - SP"
  },
  {
    "value": "são_miguel_da_baixa_grande_pi",
    "label": "São Miguel da Baixa Grande - PI"
  },
  {
    "value": "são_miguel_da_boa_vista_sc",
    "label": "São Miguel da Boa Vista - SC"
  },
  {
    "value": "são_miguel_das_matas_ba",
    "label": "São Miguel das Matas - BA"
  },
  {
    "value": "são_miguel_das_missões_rs",
    "label": "São Miguel das Missões - RS"
  },
  {
    "value": "são_miguel_de_taipu_pb",
    "label": "São Miguel de Taipu - PB"
  },
  {
    "value": "são_miguel_de_touros_rn",
    "label": "São Miguel de Touros - RN"
  },
  {
    "value": "são_miguel_do_aleixo_se",
    "label": "São Miguel do Aleixo - SE"
  },
  {
    "value": "são_miguel_do_anta_mg",
    "label": "São Miguel do Anta - MG"
  },
  {
    "value": "são_miguel_do_araguaia_go",
    "label": "São Miguel do Araguaia - GO"
  },
  {
    "value": "são_miguel_do_fidalgo_pi",
    "label": "São Miguel do Fidalgo - PI"
  },
  {
    "value": "são_miguel_do_guamá_pa",
    "label": "São Miguel do Guamá - PA"
  },
  {
    "value": "são_miguel_do_guaporé_ro",
    "label": "São Miguel do Guaporé - RO"
  },
  {
    "value": "são_miguel_do_iguaçu_pr",
    "label": "São Miguel do Iguaçu - PR"
  },
  {
    "value": "são_miguel_do_oeste_sc",
    "label": "São Miguel do Oeste - SC"
  },
  {
    "value": "são_miguel_do_passa_quatro_go",
    "label": "São Miguel do Passa Quatro - GO"
  },
  {
    "value": "são_miguel_do_tapuio_pi",
    "label": "São Miguel do Tapuio - PI"
  },
  {
    "value": "são_miguel_do_tocantins_to",
    "label": "São Miguel do Tocantins - TO"
  },
  {
    "value": "são_miguel_dos_campos_al",
    "label": "São Miguel dos Campos - AL"
  },
  {
    "value": "são_miguel_dos_milagres_al",
    "label": "São Miguel dos Milagres - AL"
  },
  {
    "value": "são_nicolau_rs",
    "label": "São Nicolau - RS"
  },
  {
    "value": "são_patrício_go",
    "label": "São Patrício - GO"
  },
  {
    "value": "são_paulo_sp",
    "label": "São Paulo - SP"
  },
  {
    "value": "são_paulo_das_missões_rs",
    "label": "São Paulo das Missões - RS"
  },
  {
    "value": "são_paulo_de_olivença_am",
    "label": "São Paulo de Olivença - AM"
  },
  {
    "value": "são_paulo_do_potengi_rn",
    "label": "São Paulo do Potengi - RN"
  },
  {
    "value": "são_pedro_rn",
    "label": "São Pedro - RN"
  },
  {
    "value": "são_pedro_sp",
    "label": "São Pedro - SP"
  },
  {
    "value": "são_pedro_da_aldeia_rj",
    "label": "São Pedro da Aldeia - RJ"
  },
  {
    "value": "são_pedro_da_cipa_mt",
    "label": "São Pedro da Cipa - MT"
  },
  {
    "value": "são_pedro_da_serra_rs",
    "label": "São Pedro da Serra - RS"
  },
  {
    "value": "são_pedro_da_união_mg",
    "label": "São Pedro da União - MG"
  },
  {
    "value": "são_pedro_da_água_branca_ma",
    "label": "São Pedro da Água Branca - MA"
  },
  {
    "value": "são_pedro_das_missões_rs",
    "label": "São Pedro das Missões - RS"
  },
  {
    "value": "são_pedro_de_alcântara_sc",
    "label": "São Pedro de Alcântara - SC"
  },
  {
    "value": "são_pedro_do_butiá_rs",
    "label": "São Pedro do Butiá - RS"
  },
  {
    "value": "são_pedro_do_iguaçu_pr",
    "label": "São Pedro do Iguaçu - PR"
  },
  {
    "value": "são_pedro_do_ivaí_pr",
    "label": "São Pedro do Ivaí - PR"
  },
  {
    "value": "são_pedro_do_paraná_pr",
    "label": "São Pedro do Paraná - PR"
  },
  {
    "value": "são_pedro_do_piauí_pi",
    "label": "São Pedro do Piauí - PI"
  },
  {
    "value": "são_pedro_do_suaçuí_mg",
    "label": "São Pedro do Suaçuí - MG"
  },
  {
    "value": "são_pedro_do_sul_rs",
    "label": "São Pedro do Sul - RS"
  },
  {
    "value": "são_pedro_do_turvo_sp",
    "label": "São Pedro do Turvo - SP"
  },
  {
    "value": "são_pedro_dos_crentes_ma",
    "label": "São Pedro dos Crentes - MA"
  },
  {
    "value": "são_pedro_dos_ferros_mg",
    "label": "São Pedro dos Ferros - MG"
  },
  {
    "value": "são_rafael_rn",
    "label": "São Rafael - RN"
  },
  {
    "value": "são_raimundo_nonato_pi",
    "label": "São Raimundo Nonato - PI"
  },
  {
    "value": "são_raimundo_das_mangabeiras_ma",
    "label": "São Raimundo das Mangabeiras - MA"
  },
  {
    "value": "são_raimundo_do_doca_bezerra_ma",
    "label": "São Raimundo do Doca Bezerra - MA"
  },
  {
    "value": "são_roberto_ma",
    "label": "São Roberto - MA"
  },
  {
    "value": "são_romão_mg",
    "label": "São Romão - MG"
  },
  {
    "value": "são_roque_sp",
    "label": "São Roque - SP"
  },
  {
    "value": "são_roque_de_minas_mg",
    "label": "São Roque de Minas - MG"
  },
  {
    "value": "são_roque_do_canaã_es",
    "label": "São Roque do Canaã - ES"
  },
  {
    "value": "são_salvador_do_tocantins_to",
    "label": "São Salvador do Tocantins - TO"
  },
  {
    "value": "são_sebastião_al",
    "label": "São Sebastião - AL"
  },
  {
    "value": "são_sebastião_sp",
    "label": "São Sebastião - SP"
  },
  {
    "value": "são_sebastião_da_amoreira_pr",
    "label": "São Sebastião da Amoreira - PR"
  },
  {
    "value": "são_sebastião_da_bela_vista_mg",
    "label": "São Sebastião da Bela Vista - MG"
  },
  {
    "value": "são_sebastião_da_boa_vista_pa",
    "label": "São Sebastião da Boa Vista - PA"
  },
  {
    "value": "são_sebastião_da_grama_sp",
    "label": "São Sebastião da Grama - SP"
  },
  {
    "value": "são_sebastião_da_vargem_alegre_mg",
    "label": "São Sebastião da Vargem Alegre - MG"
  },
  {
    "value": "são_sebastião_de_lagoa_de_roça_pb",
    "label": "São Sebastião de Lagoa de Roça - PB"
  },
  {
    "value": "são_sebastião_do_alto_rj",
    "label": "São Sebastião do Alto - RJ"
  },
  {
    "value": "são_sebastião_do_anta_mg",
    "label": "São Sebastião do Anta - MG"
  },
  {
    "value": "são_sebastião_do_caí_rs",
    "label": "São Sebastião do Caí - RS"
  },
  {
    "value": "são_sebastião_do_maranhão_mg",
    "label": "São Sebastião do Maranhão - MG"
  },
  {
    "value": "são_sebastião_do_oeste_mg",
    "label": "São Sebastião do Oeste - MG"
  },
  {
    "value": "são_sebastião_do_paraíso_mg",
    "label": "São Sebastião do Paraíso - MG"
  },
  {
    "value": "são_sebastião_do_passé_ba",
    "label": "São Sebastião do Passé - BA"
  },
  {
    "value": "são_sebastião_do_rio_preto_mg",
    "label": "São Sebastião do Rio Preto - MG"
  },
  {
    "value": "são_sebastião_do_rio_verde_mg",
    "label": "São Sebastião do Rio Verde - MG"
  },
  {
    "value": "são_sebastião_do_tocantins_to",
    "label": "São Sebastião do Tocantins - TO"
  },
  {
    "value": "são_sebastião_do_uatumã_am",
    "label": "São Sebastião do Uatumã - AM"
  },
  {
    "value": "são_sebastião_do_umbuzeiro_pb",
    "label": "São Sebastião do Umbuzeiro - PB"
  },
  {
    "value": "são_sepé_rs",
    "label": "São Sepé - RS"
  },
  {
    "value": "são_simão_go",
    "label": "São Simão - GO"
  },
  {
    "value": "são_simão_sp",
    "label": "São Simão - SP"
  },
  {
    "value": "são_thomé_das_letras_mg",
    "label": "São Thomé das Letras - MG"
  },
  {
    "value": "são_tiago_mg",
    "label": "São Tiago - MG"
  },
  {
    "value": "são_tomás_de_aquino_mg",
    "label": "São Tomás de Aquino - MG"
  },
  {
    "value": "são_tomé_pr",
    "label": "São Tomé - PR"
  },
  {
    "value": "são_tomé_rn",
    "label": "São Tomé - RN"
  },
  {
    "value": "são_valentim_rs",
    "label": "São Valentim - RS"
  },
  {
    "value": "são_valentim_do_sul_rs",
    "label": "São Valentim do Sul - RS"
  },
  {
    "value": "são_valério_da_natividade_to",
    "label": "São Valério da Natividade - TO"
  },
  {
    "value": "são_valério_do_sul_rs",
    "label": "São Valério do Sul - RS"
  },
  {
    "value": "são_vendelino_rs",
    "label": "São Vendelino - RS"
  },
  {
    "value": "são_vicente_rn",
    "label": "São Vicente - RN"
  },
  {
    "value": "são_vicente_sp",
    "label": "São Vicente - SP"
  },
  {
    "value": "são_vicente_ferrer_ma",
    "label": "São Vicente Ferrer - MA"
  },
  {
    "value": "são_vicente_ferrer_pe",
    "label": "São Vicente Ferrer - PE"
  },
  {
    "value": "são_vicente_de_minas_mg",
    "label": "São Vicente de Minas - MG"
  },
  {
    "value": "são_vicente_do_sul_rs",
    "label": "São Vicente do Sul - RS"
  },
  {
    "value": "sério_rs",
    "label": "Sério - RS"
  },
  {
    "value": "sítio_novo_ma",
    "label": "Sítio Novo - MA"
  },
  {
    "value": "sítio_novo_rn",
    "label": "Sítio Novo - RN"
  },
  {
    "value": "sítio_novo_do_tocantins_to",
    "label": "Sítio Novo do Tocantins - TO"
  },
  {
    "value": "sítio_d'abadia_go",
    "label": "Sítio d'Abadia - GO"
  },
  {
    "value": "sítio_do_mato_ba",
    "label": "Sítio do Mato - BA"
  },
  {
    "value": "sítio_do_quinto_ba",
    "label": "Sítio do Quinto - BA"
  },
  {
    "value": "tabaporã_mt",
    "label": "Tabaporã - MT"
  },
  {
    "value": "tabapuã_sp",
    "label": "Tabapuã - SP"
  },
  {
    "value": "tabatinga_am",
    "label": "Tabatinga - AM"
  },
  {
    "value": "tabatinga_sp",
    "label": "Tabatinga - SP"
  },
  {
    "value": "tabaí_rs",
    "label": "Tabaí - RS"
  },
  {
    "value": "tabira_pe",
    "label": "Tabira - PE"
  },
  {
    "value": "tabocas_do_brejo_velho_ba",
    "label": "Tabocas do Brejo Velho - BA"
  },
  {
    "value": "taboleiro_grande_rn",
    "label": "Taboleiro Grande - RN"
  },
  {
    "value": "taboão_da_serra_sp",
    "label": "Taboão da Serra - SP"
  },
  {
    "value": "tabuleiro_mg",
    "label": "Tabuleiro - MG"
  },
  {
    "value": "tabuleiro_do_norte_ce",
    "label": "Tabuleiro do Norte - CE"
  },
  {
    "value": "tacaimbó_pe",
    "label": "Tacaimbó - PE"
  },
  {
    "value": "tacaratu_pe",
    "label": "Tacaratu - PE"
  },
  {
    "value": "taciba_sp",
    "label": "Taciba - SP"
  },
  {
    "value": "tacuru_ms",
    "label": "Tacuru - MS"
  },
  {
    "value": "taguatinga_to",
    "label": "Taguatinga - TO"
  },
  {
    "value": "taguaí_sp",
    "label": "Taguaí - SP"
  },
  {
    "value": "taiaçu_sp",
    "label": "Taiaçu - SP"
  },
  {
    "value": "tailândia_pa",
    "label": "Tailândia - PA"
  },
  {
    "value": "taiobeiras_mg",
    "label": "Taiobeiras - MG"
  },
  {
    "value": "taipas_do_tocantins_to",
    "label": "Taipas do Tocantins - TO"
  },
  {
    "value": "taipu_rn",
    "label": "Taipu - RN"
  },
  {
    "value": "taió_sc",
    "label": "Taió - SC"
  },
  {
    "value": "taiúva_sp",
    "label": "Taiúva - SP"
  },
  {
    "value": "talismã_to",
    "label": "Talismã - TO"
  },
  {
    "value": "tamandaré_pe",
    "label": "Tamandaré - PE"
  },
  {
    "value": "tamarana_pr",
    "label": "Tamarana - PR"
  },
  {
    "value": "tambaú_sp",
    "label": "Tambaú - SP"
  },
  {
    "value": "tamboara_pr",
    "label": "Tamboara - PR"
  },
  {
    "value": "tamboril_ce",
    "label": "Tamboril - CE"
  },
  {
    "value": "tamboril_do_piauí_pi",
    "label": "Tamboril do Piauí - PI"
  },
  {
    "value": "tanabi_sp",
    "label": "Tanabi - SP"
  },
  {
    "value": "tangará_rn",
    "label": "Tangará - RN"
  },
  {
    "value": "tangará_sc",
    "label": "Tangará - SC"
  },
  {
    "value": "tangará_da_serra_mt",
    "label": "Tangará da Serra - MT"
  },
  {
    "value": "tanguá_rj",
    "label": "Tanguá - RJ"
  },
  {
    "value": "tanhaçu_ba",
    "label": "Tanhaçu - BA"
  },
  {
    "value": "tanque_novo_ba",
    "label": "Tanque Novo - BA"
  },
  {
    "value": "tanque_d'arca_al",
    "label": "Tanque d'Arca - AL"
  },
  {
    "value": "tanque_do_piauí_pi",
    "label": "Tanque do Piauí - PI"
  },
  {
    "value": "tanquinho_ba",
    "label": "Tanquinho - BA"
  },
  {
    "value": "taparuba_mg",
    "label": "Taparuba - MG"
  },
  {
    "value": "tapauá_am",
    "label": "Tapauá - AM"
  },
  {
    "value": "tapejara_pr",
    "label": "Tapejara - PR"
  },
  {
    "value": "tapejara_rs",
    "label": "Tapejara - RS"
  },
  {
    "value": "tapera_rs",
    "label": "Tapera - RS"
  },
  {
    "value": "taperoá_ba",
    "label": "Taperoá - BA"
  },
  {
    "value": "taperoá_pb",
    "label": "Taperoá - PB"
  },
  {
    "value": "tapes_rs",
    "label": "Tapes - RS"
  },
  {
    "value": "tapira_mg",
    "label": "Tapira - MG"
  },
  {
    "value": "tapira_pr",
    "label": "Tapira - PR"
  },
  {
    "value": "tapiramutá_ba",
    "label": "Tapiramutá - BA"
  },
  {
    "value": "tapiratiba_sp",
    "label": "Tapiratiba - SP"
  },
  {
    "value": "tapiraí_mg",
    "label": "Tapiraí - MG"
  },
  {
    "value": "tapiraí_sp",
    "label": "Tapiraí - SP"
  },
  {
    "value": "tapurah_mt",
    "label": "Tapurah - MT"
  },
  {
    "value": "taquara_rs",
    "label": "Taquara - RS"
  },
  {
    "value": "taquaral_sp",
    "label": "Taquaral - SP"
  },
  {
    "value": "taquaral_de_goiás_go",
    "label": "Taquaral de Goiás - GO"
  },
  {
    "value": "taquarana_al",
    "label": "Taquarana - AL"
  },
  {
    "value": "taquaraçu_de_minas_mg",
    "label": "Taquaraçu de Minas - MG"
  },
  {
    "value": "taquari_rs",
    "label": "Taquari - RS"
  },
  {
    "value": "taquaritinga_sp",
    "label": "Taquaritinga - SP"
  },
  {
    "value": "taquaritinga_do_norte_pe",
    "label": "Taquaritinga do Norte - PE"
  },
  {
    "value": "taquarituba_sp",
    "label": "Taquarituba - SP"
  },
  {
    "value": "taquarivaí_sp",
    "label": "Taquarivaí - SP"
  },
  {
    "value": "taquarussu_ms",
    "label": "Taquarussu - MS"
  },
  {
    "value": "taquaruçu_do_sul_rs",
    "label": "Taquaruçu do Sul - RS"
  },
  {
    "value": "tarabai_sp",
    "label": "Tarabai - SP"
  },
  {
    "value": "tarauacá_ac",
    "label": "Tarauacá - AC"
  },
  {
    "value": "tarrafas_ce",
    "label": "Tarrafas - CE"
  },
  {
    "value": "tartarugalzinho_ap",
    "label": "Tartarugalzinho - AP"
  },
  {
    "value": "tarumirim_mg",
    "label": "Tarumirim - MG"
  },
  {
    "value": "tarumã_sp",
    "label": "Tarumã - SP"
  },
  {
    "value": "tasso_fragoso_ma",
    "label": "Tasso Fragoso - MA"
  },
  {
    "value": "tatuí_sp",
    "label": "Tatuí - SP"
  },
  {
    "value": "taubaté_sp",
    "label": "Taubaté - SP"
  },
  {
    "value": "tauá_ce",
    "label": "Tauá - CE"
  },
  {
    "value": "tavares_pb",
    "label": "Tavares - PB"
  },
  {
    "value": "tavares_rs",
    "label": "Tavares - RS"
  },
  {
    "value": "tefé_am",
    "label": "Tefé - AM"
  },
  {
    "value": "teixeira_pb",
    "label": "Teixeira - PB"
  },
  {
    "value": "teixeira_soares_pr",
    "label": "Teixeira Soares - PR"
  },
  {
    "value": "teixeira_de_freitas_ba",
    "label": "Teixeira de Freitas - BA"
  },
  {
    "value": "teixeiras_mg",
    "label": "Teixeiras - MG"
  },
  {
    "value": "teixeirópolis_ro",
    "label": "Teixeirópolis - RO"
  },
  {
    "value": "tejupá_sp",
    "label": "Tejupá - SP"
  },
  {
    "value": "tejuçuoca_ce",
    "label": "Tejuçuoca - CE"
  },
  {
    "value": "telha_se",
    "label": "Telha - SE"
  },
  {
    "value": "telêmaco_borba_pr",
    "label": "Telêmaco Borba - PR"
  },
  {
    "value": "tenente_ananias_rn",
    "label": "Tenente Ananias - RN"
  },
  {
    "value": "tenente_laurentino_cruz_rn",
    "label": "Tenente Laurentino Cruz - RN"
  },
  {
    "value": "tenente_portela_rs",
    "label": "Tenente Portela - RS"
  },
  {
    "value": "tenório_pb",
    "label": "Tenório - PB"
  },
  {
    "value": "teodoro_sampaio_ba",
    "label": "Teodoro Sampaio - BA"
  },
  {
    "value": "teodoro_sampaio_sp",
    "label": "Teodoro Sampaio - SP"
  },
  {
    "value": "teofilândia_ba",
    "label": "Teofilândia - BA"
  },
  {
    "value": "teolândia_ba",
    "label": "Teolândia - BA"
  },
  {
    "value": "teotônio_vilela_al",
    "label": "Teotônio Vilela - AL"
  },
  {
    "value": "terenos_ms",
    "label": "Terenos - MS"
  },
  {
    "value": "teresina_pi",
    "label": "Teresina - PI"
  },
  {
    "value": "teresina_de_goiás_go",
    "label": "Teresina de Goiás - GO"
  },
  {
    "value": "teresópolis_rj",
    "label": "Teresópolis - RJ"
  },
  {
    "value": "terezinha_pe",
    "label": "Terezinha - PE"
  },
  {
    "value": "terezópolis_de_goiás_go",
    "label": "Terezópolis de Goiás - GO"
  },
  {
    "value": "terra_alta_pa",
    "label": "Terra Alta - PA"
  },
  {
    "value": "terra_boa_pr",
    "label": "Terra Boa - PR"
  },
  {
    "value": "terra_nova_ba",
    "label": "Terra Nova - BA"
  },
  {
    "value": "terra_nova_pe",
    "label": "Terra Nova - PE"
  },
  {
    "value": "terra_nova_do_norte_mt",
    "label": "Terra Nova do Norte - MT"
  },
  {
    "value": "terra_rica_pr",
    "label": "Terra Rica - PR"
  },
  {
    "value": "terra_roxa_pr",
    "label": "Terra Roxa - PR"
  },
  {
    "value": "terra_roxa_sp",
    "label": "Terra Roxa - SP"
  },
  {
    "value": "terra_santa_pa",
    "label": "Terra Santa - PA"
  },
  {
    "value": "terra_de_areia_rs",
    "label": "Terra de Areia - RS"
  },
  {
    "value": "tesouro_mt",
    "label": "Tesouro - MT"
  },
  {
    "value": "teutônia_rs",
    "label": "Teutônia - RS"
  },
  {
    "value": "teófilo_otoni_mg",
    "label": "Teófilo Otoni - MG"
  },
  {
    "value": "theobroma_ro",
    "label": "Theobroma - RO"
  },
  {
    "value": "tianguá_ce",
    "label": "Tianguá - CE"
  },
  {
    "value": "tibagi_pr",
    "label": "Tibagi - PR"
  },
  {
    "value": "tibau_rn",
    "label": "Tibau - RN"
  },
  {
    "value": "tibau_do_sul_rn",
    "label": "Tibau do Sul - RN"
  },
  {
    "value": "tietê_sp",
    "label": "Tietê - SP"
  },
  {
    "value": "tigrinhos_sc",
    "label": "Tigrinhos - SC"
  },
  {
    "value": "tijucas_sc",
    "label": "Tijucas - SC"
  },
  {
    "value": "tijucas_do_sul_pr",
    "label": "Tijucas do Sul - PR"
  },
  {
    "value": "timbaúba_pe",
    "label": "Timbaúba - PE"
  },
  {
    "value": "timbaúba_dos_batistas_rn",
    "label": "Timbaúba dos Batistas - RN"
  },
  {
    "value": "timbiras_ma",
    "label": "Timbiras - MA"
  },
  {
    "value": "timburi_sp",
    "label": "Timburi - SP"
  },
  {
    "value": "timbé_do_sul_sc",
    "label": "Timbé do Sul - SC"
  },
  {
    "value": "timbó_sc",
    "label": "Timbó - SC"
  },
  {
    "value": "timbó_grande_sc",
    "label": "Timbó Grande - SC"
  },
  {
    "value": "timon_ma",
    "label": "Timon - MA"
  },
  {
    "value": "timóteo_mg",
    "label": "Timóteo - MG"
  },
  {
    "value": "tio_hugo_rs",
    "label": "Tio Hugo - RS"
  },
  {
    "value": "tiradentes_mg",
    "label": "Tiradentes - MG"
  },
  {
    "value": "tiradentes_do_sul_rs",
    "label": "Tiradentes do Sul - RS"
  },
  {
    "value": "tiros_mg",
    "label": "Tiros - MG"
  },
  {
    "value": "tobias_barreto_se",
    "label": "Tobias Barreto - SE"
  },
  {
    "value": "tocantins_mg",
    "label": "Tocantins - MG"
  },
  {
    "value": "tocantinópolis_to",
    "label": "Tocantinópolis - TO"
  },
  {
    "value": "tocantínia_to",
    "label": "Tocantínia - TO"
  },
  {
    "value": "tocos_do_moji_mg",
    "label": "Tocos do Moji - MG"
  },
  {
    "value": "toledo_mg",
    "label": "Toledo - MG"
  },
  {
    "value": "toledo_pr",
    "label": "Toledo - PR"
  },
  {
    "value": "tomar_do_geru_se",
    "label": "Tomar do Geru - SE"
  },
  {
    "value": "tomazina_pr",
    "label": "Tomazina - PR"
  },
  {
    "value": "tombos_mg",
    "label": "Tombos - MG"
  },
  {
    "value": "tomé-açu_pa",
    "label": "Tomé-Açu - PA"
  },
  {
    "value": "tonantins_am",
    "label": "Tonantins - AM"
  },
  {
    "value": "toritama_pe",
    "label": "Toritama - PE"
  },
  {
    "value": "torixoréu_mt",
    "label": "Torixoréu - MT"
  },
  {
    "value": "toropi_rs",
    "label": "Toropi - RS"
  },
  {
    "value": "torre_de_pedra_sp",
    "label": "Torre de Pedra - SP"
  },
  {
    "value": "torres_rs",
    "label": "Torres - RS"
  },
  {
    "value": "torrinha_sp",
    "label": "Torrinha - SP"
  },
  {
    "value": "touros_rn",
    "label": "Touros - RN"
  },
  {
    "value": "trabiju_sp",
    "label": "Trabiju - SP"
  },
  {
    "value": "tracuateua_pa",
    "label": "Tracuateua - PA"
  },
  {
    "value": "tracunhaém_pe",
    "label": "Tracunhaém - PE"
  },
  {
    "value": "traipu_al",
    "label": "Traipu - AL"
  },
  {
    "value": "trairi_ce",
    "label": "Trairi - CE"
  },
  {
    "value": "trairão_pa",
    "label": "Trairão - PA"
  },
  {
    "value": "trajano_de_morais_rj",
    "label": "Trajano de Morais - RJ"
  },
  {
    "value": "tramandaí_rs",
    "label": "Tramandaí - RS"
  },
  {
    "value": "travesseiro_rs",
    "label": "Travesseiro - RS"
  },
  {
    "value": "tremedal_ba",
    "label": "Tremedal - BA"
  },
  {
    "value": "tremembé_sp",
    "label": "Tremembé - SP"
  },
  {
    "value": "treviso_sc",
    "label": "Treviso - SC"
  },
  {
    "value": "treze_tílias_sc",
    "label": "Treze Tílias - SC"
  },
  {
    "value": "treze_de_maio_sc",
    "label": "Treze de Maio - SC"
  },
  {
    "value": "trindade_go",
    "label": "Trindade - GO"
  },
  {
    "value": "trindade_pe",
    "label": "Trindade - PE"
  },
  {
    "value": "trindade_do_sul_rs",
    "label": "Trindade do Sul - RS"
  },
  {
    "value": "triunfo_pb",
    "label": "Triunfo - PB"
  },
  {
    "value": "triunfo_pe",
    "label": "Triunfo - PE"
  },
  {
    "value": "triunfo_rs",
    "label": "Triunfo - RS"
  },
  {
    "value": "triunfo_potiguar_rn",
    "label": "Triunfo Potiguar - RN"
  },
  {
    "value": "trizidela_do_vale_ma",
    "label": "Trizidela do Vale - MA"
  },
  {
    "value": "trombas_go",
    "label": "Trombas - GO"
  },
  {
    "value": "trombudo_central_sc",
    "label": "Trombudo Central - SC"
  },
  {
    "value": "três_arroios_rs",
    "label": "Três Arroios - RS"
  },
  {
    "value": "três_barras_sc",
    "label": "Três Barras - SC"
  },
  {
    "value": "três_barras_do_paraná_pr",
    "label": "Três Barras do Paraná - PR"
  },
  {
    "value": "três_cachoeiras_rs",
    "label": "Três Cachoeiras - RS"
  },
  {
    "value": "três_corações_mg",
    "label": "Três Corações - MG"
  },
  {
    "value": "três_coroas_rs",
    "label": "Três Coroas - RS"
  },
  {
    "value": "três_forquilhas_rs",
    "label": "Três Forquilhas - RS"
  },
  {
    "value": "três_fronteiras_sp",
    "label": "Três Fronteiras - SP"
  },
  {
    "value": "três_lagoas_ms",
    "label": "Três Lagoas - MS"
  },
  {
    "value": "três_marias_mg",
    "label": "Três Marias - MG"
  },
  {
    "value": "três_palmeiras_rs",
    "label": "Três Palmeiras - RS"
  },
  {
    "value": "três_passos_rs",
    "label": "Três Passos - RS"
  },
  {
    "value": "três_pontas_mg",
    "label": "Três Pontas - MG"
  },
  {
    "value": "três_ranchos_go",
    "label": "Três Ranchos - GO"
  },
  {
    "value": "três_rios_rj",
    "label": "Três Rios - RJ"
  },
  {
    "value": "três_de_maio_rs",
    "label": "Três de Maio - RS"
  },
  {
    "value": "tubarão_sc",
    "label": "Tubarão - SC"
  },
  {
    "value": "tucano_ba",
    "label": "Tucano - BA"
  },
  {
    "value": "tucumã_pa",
    "label": "Tucumã - PA"
  },
  {
    "value": "tucunduva_rs",
    "label": "Tucunduva - RS"
  },
  {
    "value": "tucuruí_pa",
    "label": "Tucuruí - PA"
  },
  {
    "value": "tufilândia_ma",
    "label": "Tufilândia - MA"
  },
  {
    "value": "tuiuti_sp",
    "label": "Tuiuti - SP"
  },
  {
    "value": "tumiritinga_mg",
    "label": "Tumiritinga - MG"
  },
  {
    "value": "tunas_rs",
    "label": "Tunas - RS"
  },
  {
    "value": "tunas_do_paraná_pr",
    "label": "Tunas do Paraná - PR"
  },
  {
    "value": "tuneiras_do_oeste_pr",
    "label": "Tuneiras do Oeste - PR"
  },
  {
    "value": "tuntum_ma",
    "label": "Tuntum - MA"
  },
  {
    "value": "tunápolis_sc",
    "label": "Tunápolis - SC"
  },
  {
    "value": "tupaciguara_mg",
    "label": "Tupaciguara - MG"
  },
  {
    "value": "tupanatinga_pe",
    "label": "Tupanatinga - PE"
  },
  {
    "value": "tupanci_do_sul_rs",
    "label": "Tupanci do Sul - RS"
  },
  {
    "value": "tupanciretã_rs",
    "label": "Tupanciretã - RS"
  },
  {
    "value": "tupandi_rs",
    "label": "Tupandi - RS"
  },
  {
    "value": "tuparendi_rs",
    "label": "Tuparendi - RS"
  },
  {
    "value": "tuparetama_pe",
    "label": "Tuparetama - PE"
  },
  {
    "value": "tupi_paulista_sp",
    "label": "Tupi Paulista - SP"
  },
  {
    "value": "tupirama_to",
    "label": "Tupirama - TO"
  },
  {
    "value": "tupiratins_to",
    "label": "Tupiratins - TO"
  },
  {
    "value": "tupã_sp",
    "label": "Tupã - SP"
  },
  {
    "value": "tupãssi_pr",
    "label": "Tupãssi - PR"
  },
  {
    "value": "turiaçu_ma",
    "label": "Turiaçu - MA"
  },
  {
    "value": "turilândia_ma",
    "label": "Turilândia - MA"
  },
  {
    "value": "turiúba_sp",
    "label": "Turiúba - SP"
  },
  {
    "value": "turmalina_mg",
    "label": "Turmalina - MG"
  },
  {
    "value": "turmalina_sp",
    "label": "Turmalina - SP"
  },
  {
    "value": "tururu_ce",
    "label": "Tururu - CE"
  },
  {
    "value": "turuçu_rs",
    "label": "Turuçu - RS"
  },
  {
    "value": "turvelândia_go",
    "label": "Turvelândia - GO"
  },
  {
    "value": "turvo_pr",
    "label": "Turvo - PR"
  },
  {
    "value": "turvo_sc",
    "label": "Turvo - SC"
  },
  {
    "value": "turvolândia_mg",
    "label": "Turvolândia - MG"
  },
  {
    "value": "turvânia_go",
    "label": "Turvânia - GO"
  },
  {
    "value": "tutóia_ma",
    "label": "Tutóia - MA"
  },
  {
    "value": "uarini_am",
    "label": "Uarini - AM"
  },
  {
    "value": "uauá_ba",
    "label": "Uauá - BA"
  },
  {
    "value": "ubaitaba_ba",
    "label": "Ubaitaba - BA"
  },
  {
    "value": "ubajara_ce",
    "label": "Ubajara - CE"
  },
  {
    "value": "ubaporanga_mg",
    "label": "Ubaporanga - MG"
  },
  {
    "value": "ubarana_sp",
    "label": "Ubarana - SP"
  },
  {
    "value": "ubatuba_sp",
    "label": "Ubatuba - SP"
  },
  {
    "value": "ubatã_ba",
    "label": "Ubatã - BA"
  },
  {
    "value": "ubaí_mg",
    "label": "Ubaí - MG"
  },
  {
    "value": "ubaíra_ba",
    "label": "Ubaíra - BA"
  },
  {
    "value": "uberaba_mg",
    "label": "Uberaba - MG"
  },
  {
    "value": "uberlândia_mg",
    "label": "Uberlândia - MG"
  },
  {
    "value": "ubirajara_sp",
    "label": "Ubirajara - SP"
  },
  {
    "value": "ubiratã_pr",
    "label": "Ubiratã - PR"
  },
  {
    "value": "ubiretama_rs",
    "label": "Ubiretama - RS"
  },
  {
    "value": "ubá_mg",
    "label": "Ubá - MG"
  },
  {
    "value": "uchoa_sp",
    "label": "Uchoa - SP"
  },
  {
    "value": "uibaí_ba",
    "label": "Uibaí - BA"
  },
  {
    "value": "uiramutã_rr",
    "label": "Uiramutã - RR"
  },
  {
    "value": "uirapuru_go",
    "label": "Uirapuru - GO"
  },
  {
    "value": "uiraúna_pb",
    "label": "Uiraúna - PB"
  },
  {
    "value": "ulianópolis_pa",
    "label": "Ulianópolis - PA"
  },
  {
    "value": "umari_ce",
    "label": "Umari - CE"
  },
  {
    "value": "umarizal_rn",
    "label": "Umarizal - RN"
  },
  {
    "value": "umbaúba_se",
    "label": "Umbaúba - SE"
  },
  {
    "value": "umburanas_ba",
    "label": "Umburanas - BA"
  },
  {
    "value": "umburatiba_mg",
    "label": "Umburatiba - MG"
  },
  {
    "value": "umbuzeiro_pb",
    "label": "Umbuzeiro - PB"
  },
  {
    "value": "umirim_ce",
    "label": "Umirim - CE"
  },
  {
    "value": "umuarama_pr",
    "label": "Umuarama - PR"
  },
  {
    "value": "una_ba",
    "label": "Una - BA"
  },
  {
    "value": "unaí_mg",
    "label": "Unaí - MG"
  },
  {
    "value": "uniflor_pr",
    "label": "Uniflor - PR"
  },
  {
    "value": "unistalda_rs",
    "label": "Unistalda - RS"
  },
  {
    "value": "união_pi",
    "label": "União - PI"
  },
  {
    "value": "união_paulista_sp",
    "label": "União Paulista - SP"
  },
  {
    "value": "união_da_serra_rs",
    "label": "União da Serra - RS"
  },
  {
    "value": "união_da_vitória_pr",
    "label": "União da Vitória - PR"
  },
  {
    "value": "união_de_minas_mg",
    "label": "União de Minas - MG"
  },
  {
    "value": "união_do_oeste_sc",
    "label": "União do Oeste - SC"
  },
  {
    "value": "união_do_sul_mt",
    "label": "União do Sul - MT"
  },
  {
    "value": "união_dos_palmares_al",
    "label": "União dos Palmares - AL"
  },
  {
    "value": "upanema_rn",
    "label": "Upanema - RN"
  },
  {
    "value": "urandi_ba",
    "label": "Urandi - BA"
  },
  {
    "value": "uraí_pr",
    "label": "Uraí - PR"
  },
  {
    "value": "urbano_santos_ma",
    "label": "Urbano Santos - MA"
  },
  {
    "value": "uru_sp",
    "label": "Uru - SP"
  },
  {
    "value": "uruana_go",
    "label": "Uruana - GO"
  },
  {
    "value": "uruana_de_minas_mg",
    "label": "Uruana de Minas - MG"
  },
  {
    "value": "uruará_pa",
    "label": "Uruará - PA"
  },
  {
    "value": "uruaçu_go",
    "label": "Uruaçu - GO"
  },
  {
    "value": "urubici_sc",
    "label": "Urubici - SC"
  },
  {
    "value": "uruburetama_ce",
    "label": "Uruburetama - CE"
  },
  {
    "value": "urucará_am",
    "label": "Urucará - AM"
  },
  {
    "value": "urucuia_mg",
    "label": "Urucuia - MG"
  },
  {
    "value": "urucurituba_am",
    "label": "Urucurituba - AM"
  },
  {
    "value": "urucânia_mg",
    "label": "Urucânia - MG"
  },
  {
    "value": "uruguaiana_rs",
    "label": "Uruguaiana - RS"
  },
  {
    "value": "uruoca_ce",
    "label": "Uruoca - CE"
  },
  {
    "value": "urupema_sc",
    "label": "Urupema - SC"
  },
  {
    "value": "urupá_ro",
    "label": "Urupá - RO"
  },
  {
    "value": "urupês_sp",
    "label": "Urupês - SP"
  },
  {
    "value": "urussanga_sc",
    "label": "Urussanga - SC"
  },
  {
    "value": "urutaí_go",
    "label": "Urutaí - GO"
  },
  {
    "value": "uruçuca_ba",
    "label": "Uruçuca - BA"
  },
  {
    "value": "uruçuí_pi",
    "label": "Uruçuí - PI"
  },
  {
    "value": "urânia_sp",
    "label": "Urânia - SP"
  },
  {
    "value": "utinga_ba",
    "label": "Utinga - BA"
  },
  {
    "value": "vacaria_rs",
    "label": "Vacaria - RS"
  },
  {
    "value": "vale_real_rs",
    "label": "Vale Real - RS"
  },
  {
    "value": "vale_verde_rs",
    "label": "Vale Verde - RS"
  },
  {
    "value": "vale_de_são_domingos_mt",
    "label": "Vale de São Domingos - MT"
  },
  {
    "value": "vale_do_anari_ro",
    "label": "Vale do Anari - RO"
  },
  {
    "value": "vale_do_paraíso_ro",
    "label": "Vale do Paraíso - RO"
  },
  {
    "value": "vale_do_sol_rs",
    "label": "Vale do Sol - RS"
  },
  {
    "value": "valente_ba",
    "label": "Valente - BA"
  },
  {
    "value": "valentim_gentil_sp",
    "label": "Valentim Gentil - SP"
  },
  {
    "value": "valença_ba",
    "label": "Valença - BA"
  },
  {
    "value": "valença_rj",
    "label": "Valença - RJ"
  },
  {
    "value": "valença_do_piauí_pi",
    "label": "Valença do Piauí - PI"
  },
  {
    "value": "valinhos_sp",
    "label": "Valinhos - SP"
  },
  {
    "value": "valparaíso_sp",
    "label": "Valparaíso - SP"
  },
  {
    "value": "valparaíso_de_goiás_go",
    "label": "Valparaíso de Goiás - GO"
  },
  {
    "value": "vanini_rs",
    "label": "Vanini - RS"
  },
  {
    "value": "vargem_sc",
    "label": "Vargem - SC"
  },
  {
    "value": "vargem_sp",
    "label": "Vargem - SP"
  },
  {
    "value": "vargem_alegre_mg",
    "label": "Vargem Alegre - MG"
  },
  {
    "value": "vargem_alta_es",
    "label": "Vargem Alta - ES"
  },
  {
    "value": "vargem_bonita_mg",
    "label": "Vargem Bonita - MG"
  },
  {
    "value": "vargem_bonita_sc",
    "label": "Vargem Bonita - SC"
  },
  {
    "value": "vargem_grande_ma",
    "label": "Vargem Grande - MA"
  },
  {
    "value": "vargem_grande_paulista_sp",
    "label": "Vargem Grande Paulista - SP"
  },
  {
    "value": "vargem_grande_do_rio_pardo_mg",
    "label": "Vargem Grande do Rio Pardo - MG"
  },
  {
    "value": "vargem_grande_do_sul_sp",
    "label": "Vargem Grande do Sul - SP"
  },
  {
    "value": "vargeão_sc",
    "label": "Vargeão - SC"
  },
  {
    "value": "varginha_mg",
    "label": "Varginha - MG"
  },
  {
    "value": "varjota_ce",
    "label": "Varjota - CE"
  },
  {
    "value": "varjão_go",
    "label": "Varjão - GO"
  },
  {
    "value": "varjão_de_minas_mg",
    "label": "Varjão de Minas - MG"
  },
  {
    "value": "varre-sai_rj",
    "label": "Varre-Sai - RJ"
  },
  {
    "value": "varzedo_ba",
    "label": "Varzedo - BA"
  },
  {
    "value": "varzelândia_mg",
    "label": "Varzelândia - MG"
  },
  {
    "value": "vassouras_rj",
    "label": "Vassouras - RJ"
  },
  {
    "value": "vazante_mg",
    "label": "Vazante - MG"
  },
  {
    "value": "venda_nova_do_imigrante_es",
    "label": "Venda Nova do Imigrante - ES"
  },
  {
    "value": "venha-ver_rn",
    "label": "Venha-Ver - RN"
  },
  {
    "value": "ventania_pr",
    "label": "Ventania - PR"
  },
  {
    "value": "venturosa_pe",
    "label": "Venturosa - PE"
  },
  {
    "value": "venâncio_aires_rs",
    "label": "Venâncio Aires - RS"
  },
  {
    "value": "vera_mt",
    "label": "Vera - MT"
  },
  {
    "value": "vera_cruz_ba",
    "label": "Vera Cruz - BA"
  },
  {
    "value": "vera_cruz_rn",
    "label": "Vera Cruz - RN"
  },
  {
    "value": "vera_cruz_rs",
    "label": "Vera Cruz - RS"
  },
  {
    "value": "vera_cruz_sp",
    "label": "Vera Cruz - SP"
  },
  {
    "value": "vera_cruz_do_oeste_pr",
    "label": "Vera Cruz do Oeste - PR"
  },
  {
    "value": "vera_mendes_pi",
    "label": "Vera Mendes - PI"
  },
  {
    "value": "veranópolis_rs",
    "label": "Veranópolis - RS"
  },
  {
    "value": "verdejante_pe",
    "label": "Verdejante - PE"
  },
  {
    "value": "verdelândia_mg",
    "label": "Verdelândia - MG"
  },
  {
    "value": "vereda_ba",
    "label": "Vereda - BA"
  },
  {
    "value": "veredinha_mg",
    "label": "Veredinha - MG"
  },
  {
    "value": "vermelho_novo_mg",
    "label": "Vermelho Novo - MG"
  },
  {
    "value": "vertente_do_lério_pe",
    "label": "Vertente do Lério - PE"
  },
  {
    "value": "vertentes_pe",
    "label": "Vertentes - PE"
  },
  {
    "value": "verê_pr",
    "label": "Verê - PR"
  },
  {
    "value": "veríssimo_mg",
    "label": "Veríssimo - MG"
  },
  {
    "value": "vespasiano_mg",
    "label": "Vespasiano - MG"
  },
  {
    "value": "vespasiano_correa_rs",
    "label": "Vespasiano Correa - RS"
  },
  {
    "value": "viadutos_rs",
    "label": "Viadutos - RS"
  },
  {
    "value": "viamão_rs",
    "label": "Viamão - RS"
  },
  {
    "value": "viana_es",
    "label": "Viana - ES"
  },
  {
    "value": "viana_ma",
    "label": "Viana - MA"
  },
  {
    "value": "vianópolis_go",
    "label": "Vianópolis - GO"
  },
  {
    "value": "vicente_dutra_rs",
    "label": "Vicente Dutra - RS"
  },
  {
    "value": "vicentina_ms",
    "label": "Vicentina - MS"
  },
  {
    "value": "vicentinópolis_go",
    "label": "Vicentinópolis - GO"
  },
  {
    "value": "victor_graeff_rs",
    "label": "Victor Graeff - RS"
  },
  {
    "value": "vicência_pe",
    "label": "Vicência - PE"
  },
  {
    "value": "vidal_ramos_sc",
    "label": "Vidal Ramos - SC"
  },
  {
    "value": "videira_sc",
    "label": "Videira - SC"
  },
  {
    "value": "vieiras_mg",
    "label": "Vieiras - MG"
  },
  {
    "value": "vieirópolis_pb",
    "label": "Vieirópolis - PB"
  },
  {
    "value": "vigia_pa",
    "label": "Vigia - PA"
  },
  {
    "value": "vila_alta_pr",
    "label": "Vila Alta - PR"
  },
  {
    "value": "vila_bela_da_santíssima_trindade_mt",
    "label": "Vila Bela da Santíssima Trindade - MT"
  },
  {
    "value": "vila_boa_go",
    "label": "Vila Boa - GO"
  },
  {
    "value": "vila_flor_rn",
    "label": "Vila Flor - RN"
  },
  {
    "value": "vila_flores_rs",
    "label": "Vila Flores - RS"
  },
  {
    "value": "vila_lângaro_rs",
    "label": "Vila Lângaro - RS"
  },
  {
    "value": "vila_maria_rs",
    "label": "Vila Maria - RS"
  },
  {
    "value": "vila_nova_do_piauí_pi",
    "label": "Vila Nova do Piauí - PI"
  },
  {
    "value": "vila_nova_do_sul_rs",
    "label": "Vila Nova do Sul - RS"
  },
  {
    "value": "vila_nova_dos_martírios_ma",
    "label": "Vila Nova dos Martírios - MA"
  },
  {
    "value": "vila_pavão_es",
    "label": "Vila Pavão - ES"
  },
  {
    "value": "vila_propício_go",
    "label": "Vila Propício - GO"
  },
  {
    "value": "vila_rica_mt",
    "label": "Vila Rica - MT"
  },
  {
    "value": "vila_valério_es",
    "label": "Vila Valério - ES"
  },
  {
    "value": "vila_velha_es",
    "label": "Vila Velha - ES"
  },
  {
    "value": "vilhena_ro",
    "label": "Vilhena - RO"
  },
  {
    "value": "vinhedo_sp",
    "label": "Vinhedo - SP"
  },
  {
    "value": "viradouro_sp",
    "label": "Viradouro - SP"
  },
  {
    "value": "virgem_da_lapa_mg",
    "label": "Virgem da Lapa - MG"
  },
  {
    "value": "virginópolis_mg",
    "label": "Virginópolis - MG"
  },
  {
    "value": "virgolândia_mg",
    "label": "Virgolândia - MG"
  },
  {
    "value": "virgínia_mg",
    "label": "Virgínia - MG"
  },
  {
    "value": "virmond_pr",
    "label": "Virmond - PR"
  },
  {
    "value": "visconde_do_rio_branco_mg",
    "label": "Visconde do Rio Branco - MG"
  },
  {
    "value": "viseu_pa",
    "label": "Viseu - PA"
  },
  {
    "value": "vista_alegre_rs",
    "label": "Vista Alegre - RS"
  },
  {
    "value": "vista_alegre_do_alto_sp",
    "label": "Vista Alegre do Alto - SP"
  },
  {
    "value": "vista_alegre_do_prata_rs",
    "label": "Vista Alegre do Prata - RS"
  },
  {
    "value": "vista_gaúcha_rs",
    "label": "Vista Gaúcha - RS"
  },
  {
    "value": "vista_serrana_pb",
    "label": "Vista Serrana - PB"
  },
  {
    "value": "vitor_meireles_sc",
    "label": "Vitor Meireles - SC"
  },
  {
    "value": "vitorino_pr",
    "label": "Vitorino - PR"
  },
  {
    "value": "vitorino_freire_ma",
    "label": "Vitorino Freire - MA"
  },
  {
    "value": "vitória_es",
    "label": "Vitória - ES"
  },
  {
    "value": "vitória_brasil_sp",
    "label": "Vitória Brasil - SP"
  },
  {
    "value": "vitória_da_conquista_ba",
    "label": "Vitória da Conquista - BA"
  },
  {
    "value": "vitória_das_missões_rs",
    "label": "Vitória das Missões - RS"
  },
  {
    "value": "vitória_de_santo_antão_pe",
    "label": "Vitória de Santo Antão - PE"
  },
  {
    "value": "vitória_do_jari_ap",
    "label": "Vitória do Jari - AP"
  },
  {
    "value": "vitória_do_mearim_ma",
    "label": "Vitória do Mearim - MA"
  },
  {
    "value": "vitória_do_xingu_pa",
    "label": "Vitória do Xingu - PA"
  },
  {
    "value": "viçosa_mg",
    "label": "Viçosa - MG"
  },
  {
    "value": "viçosa_rn",
    "label": "Viçosa - RN"
  },
  {
    "value": "viçosa_do_ceará_ce",
    "label": "Viçosa do Ceará - CE"
  },
  {
    "value": "volta_grande_mg",
    "label": "Volta Grande - MG"
  },
  {
    "value": "volta_redonda_rj",
    "label": "Volta Redonda - RJ"
  },
  {
    "value": "votorantim_sp",
    "label": "Votorantim - SP"
  },
  {
    "value": "votuporanga_sp",
    "label": "Votuporanga - SP"
  },
  {
    "value": "várzea_pb",
    "label": "Várzea - PB"
  },
  {
    "value": "várzea_rn",
    "label": "Várzea - RN"
  },
  {
    "value": "várzea_alegre_ce",
    "label": "Várzea Alegre - CE"
  },
  {
    "value": "várzea_branca_pi",
    "label": "Várzea Branca - PI"
  },
  {
    "value": "várzea_grande_mt",
    "label": "Várzea Grande - MT"
  },
  {
    "value": "várzea_grande_pi",
    "label": "Várzea Grande - PI"
  },
  {
    "value": "várzea_nova_ba",
    "label": "Várzea Nova - BA"
  },
  {
    "value": "várzea_paulista_sp",
    "label": "Várzea Paulista - SP"
  },
  {
    "value": "várzea_da_palma_mg",
    "label": "Várzea da Palma - MG"
  },
  {
    "value": "várzea_da_roça_ba",
    "label": "Várzea da Roça - BA"
  },
  {
    "value": "várzea_do_poço_ba",
    "label": "Várzea do Poço - BA"
  },
  {
    "value": "wagner_ba",
    "label": "Wagner - BA"
  },
  {
    "value": "wall_ferraz_pi",
    "label": "Wall Ferraz - PI"
  },
  {
    "value": "wanderley_ba",
    "label": "Wanderley - BA"
  },
  {
    "value": "wanderlândia_to",
    "label": "Wanderlândia - TO"
  },
  {
    "value": "wenceslau_braz_mg",
    "label": "Wenceslau Braz - MG"
  },
  {
    "value": "wenceslau_braz_pr",
    "label": "Wenceslau Braz - PR"
  },
  {
    "value": "wenceslau_guimarães_ba",
    "label": "Wenceslau Guimarães - BA"
  },
  {
    "value": "westfália_rs",
    "label": "Westfália - RS"
  },
  {
    "value": "witmarsum_sc",
    "label": "Witmarsum - SC"
  },
  {
    "value": "xambioá_to",
    "label": "Xambioá - TO"
  },
  {
    "value": "xambrê_pr",
    "label": "Xambrê - PR"
  },
  {
    "value": "xangri-lá_rs",
    "label": "Xangri-lá - RS"
  },
  {
    "value": "xanxerê_sc",
    "label": "Xanxerê - SC"
  },
  {
    "value": "xapuri_ac",
    "label": "Xapuri - AC"
  },
  {
    "value": "xavantina_sc",
    "label": "Xavantina - SC"
  },
  {
    "value": "xaxim_sc",
    "label": "Xaxim - SC"
  },
  {
    "value": "xexéu_pe",
    "label": "Xexéu - PE"
  },
  {
    "value": "xinguara_pa",
    "label": "Xinguara - PA"
  },
  {
    "value": "xique-xique_ba",
    "label": "Xique-Xique - BA"
  },
  {
    "value": "zabelê_pb",
    "label": "Zabelê - PB"
  },
  {
    "value": "zacarias_sp",
    "label": "Zacarias - SP"
  },
  {
    "value": "zortéa_sc",
    "label": "Zortéa - SC"
  },
  {
    "value": "zé_doca_ma",
    "label": "Zé Doca - MA"
  },
  {
    "value": "água_azul_do_norte_pa",
    "label": "Água Azul do Norte - PA"
  },
  {
    "value": "água_boa_mg",
    "label": "Água Boa - MG"
  },
  {
    "value": "água_boa_mt",
    "label": "Água Boa - MT"
  },
  {
    "value": "água_branca_al",
    "label": "Água Branca - AL"
  },
  {
    "value": "água_branca_pb",
    "label": "Água Branca - PB"
  },
  {
    "value": "água_branca_pi",
    "label": "Água Branca - PI"
  },
  {
    "value": "água_clara_ms",
    "label": "Água Clara - MS"
  },
  {
    "value": "água_comprida_mg",
    "label": "Água Comprida - MG"
  },
  {
    "value": "água_doce_sc",
    "label": "Água Doce - SC"
  },
  {
    "value": "água_doce_do_maranhão_ma",
    "label": "Água Doce do Maranhão - MA"
  },
  {
    "value": "água_doce_do_norte_es",
    "label": "Água Doce do Norte - ES"
  },
  {
    "value": "água_fria_ba",
    "label": "Água Fria - BA"
  },
  {
    "value": "água_fria_de_goiás_go",
    "label": "Água Fria de Goiás - GO"
  },
  {
    "value": "água_limpa_go",
    "label": "Água Limpa - GO"
  },
  {
    "value": "água_nova_rn",
    "label": "Água Nova - RN"
  },
  {
    "value": "água_preta_pe",
    "label": "Água Preta - PE"
  },
  {
    "value": "água_santa_rs",
    "label": "Água Santa - RS"
  },
  {
    "value": "águas_belas_pe",
    "label": "Águas Belas - PE"
  },
  {
    "value": "águas_formosas_mg",
    "label": "Águas Formosas - MG"
  },
  {
    "value": "águas_frias_sc",
    "label": "Águas Frias - SC"
  },
  {
    "value": "águas_lindas_de_goiás_go",
    "label": "Águas Lindas de Goiás - GO"
  },
  {
    "value": "águas_mornas_sc",
    "label": "Águas Mornas - SC"
  },
  {
    "value": "águas_vermelhas_mg",
    "label": "Águas Vermelhas - MG"
  },
  {
    "value": "águas_da_prata_sp",
    "label": "Águas da Prata - SP"
  },
  {
    "value": "águas_de_chapecó_sc",
    "label": "Águas de Chapecó - SC"
  },
  {
    "value": "águas_de_lindóia_sp",
    "label": "Águas de Lindóia - SP"
  },
  {
    "value": "águas_de_santa_bárbara_sp",
    "label": "Águas de Santa Bárbara - SP"
  },
  {
    "value": "águas_de_são_pedro_sp",
    "label": "Águas de São Pedro - SP"
  },
  {
    "value": "águia_branca_es",
    "label": "Águia Branca - ES"
  },
  {
    "value": "álvares_florence_sp",
    "label": "Álvares Florence - SP"
  },
  {
    "value": "álvares_machado_sp",
    "label": "Álvares Machado - SP"
  },
  {
    "value": "álvaro_de_carvalho_sp",
    "label": "Álvaro de Carvalho - SP"
  },
  {
    "value": "áurea_rs",
    "label": "Áurea - RS"
  },
  {
    "value": "ângulo_pr",
    "label": "Ângulo - PR"
  },
  {
    "value": "érico_cardoso_ba",
    "label": "Érico Cardoso - BA"
  },
  {
    "value": "óbidos_pa",
    "label": "Óbidos - PA"
  },
  {
    "value": "óleo_sp",
    "label": "Óleo - SP"
  }
];

  return { cities, loading };
};